var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _polygon, _polygon2, _polygon3, _polygon4, _polygon5, _polygon6, _polygon7, _polygon8, _polygon9, _polygon0, _polygon1, _polygon10, _path126, _polygon11, _polygon12, _polygon13, _polygon14, _polygon15, _polygon16, _polygon17, _path127, _path128, _path129, _polygon18, _polygon19, _polygon20, _path130, _path131, _polygon21, _path132, _path133, _path134, _polygon22, _polygon23, _polygon24, _polygon25, _polygon26, _polygon27, _polygon28, _polygon29, _path135, _path136, _path137, _path138, _polygon30, _path139, _path140, _polygon31, _path141, _path142, _path143, _path144, _path145, _path146, _polygon32, _polygon33, _path147, _path148, _path149, _path150, _path151, _polygon34, _polygon35, _polygon36, _path152, _path153, _path154, _polygon37, _path155, _path156, _path157, _path158, _path159, _polygon38, _polygon39, _polygon40, _polygon41, _polygon42, _polygon43, _polygon44, _polygon45, _polygon46, _polygon47, _polygon48, _polygon49, _polygon50, _polygon51, _polygon52, _polygon53, _polygon54, _polygon55, _polygon56, _polygon57, _path160, _polygon58, _polygon59, _path161, _polygon60, _path162, _path163, _polygon61, _path164, _path165, _polygon62, _polygon63, _path166, _polygon64, _path167, _polygon65, _polygon66, _path168, _polygon67, _polygon68, _polygon69, _polygon70, _polygon71, _path169, _polygon72, _polygon73, _polygon74, _polygon75, _polygon76, _polygon77, _polygon78, _polygon79, _polygon80, _polygon81, _polygon82, _polygon83, _polygon84, _polygon85, _polygon86, _polygon87, _path170, _polygon88, _rect, _polygon89, _path171, _path172, _path173, _polygon90, _polygon91, _polygon92, _polygon93, _polygon94, _polygon95, _path174, _path175, _path176, _path177, _path178, _path179, _polygon96, _polygon97, _path180, _path181, _polygon98, _polygon99, _path182, _path183, _path184, _path185, _path186, _path187, _polygon100, _polygon101, _polygon102, _polygon103, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _polygon104, _polygon105, _polygon106, _polygon107, _polygon108, _polygon109, _path202, _path203, _polygon110, _polygon111, _polygon112, _polygon113, _polygon114, _polygon115, _path204, _path205, _path206, _path207, _path208, _path209, _polygon116, _polygon117, _polygon118, _polygon119, _polygon120, _polygon121, _polygon122, _path210, _path211, _path212, _path213, _path214, _path215, _polygon123, _path216, _path217, _path218, _path219, _path220, _polygon124, _path221, _path222, _path223, _polygon125, _polygon126, _path224, _path225, _path226, _path227, _polygon127, _polygon128, _polygon129, _polygon130, _polygon131, _path228, _path229, _path230, _polygon132, _path231, _polygon133, _polygon134, _polygon135, _path232, _polygon136, _path233, _polygon137, _polygon138, _polygon139, _polygon140, _path234, _path235, _path236, _polygon141, _polygon142, _polygon143, _polygon144, _path237, _polygon145, _polygon146, _polygon147, _polygon148, _polygon149, _polygon150, _polygon151, _path238, _path239, _path240, _polygon152, _polygon153, _path241, _path242, _polygon154, _polygon155, _rect2, _polygon156, _polygon157, _polygon158, _path243, _polygon159, _polygon160, _polygon161, _polygon162, _polygon163, _polygon164, _polygon165, _polygon166, _polygon167, _path244, _polygon168, _polygon169, _polygon170, _polygon171, _polygon172, _path245, _polygon173, _path246, _path247, _path248, _path249, _polygon174, _polygon175, _path250, _path251, _path252, _path253, _path254, _path255, _polygon176, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _polygon177, _path263, _polygon178, _path264, _polygon179, _polygon180, _polygon181, _polygon182, _path265, _polygon183, _path266, _polygon184, _polygon185, _path267, _polygon186, _polygon187, _polygon188, _path268, _polygon189, _path269, _polygon190, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _polygon191, _polygon192, _polygon193, _polygon194, _polygon195, _polygon196, _path278, _path279, _path280, _path281, _polygon197, _polygon198, _path282, _path283, _path284, _path285, _path286, _path287, _polygon199, _polygon200, _path288, _path289, _path290, _path291, _path292, _path293, _polygon201, _polygon202, _polygon203, _polygon204, _polygon205, _polygon206, _polygon207, _polygon208, _polygon209, _polygon210, _polygon211, _polygon212, _polygon213, _polygon214, _polygon215, _polygon216, _polygon217, _polygon218, _polygon219, _polygon220, _polygon221, _polygon222, _polygon223, _polygon224, _polygon225, _polygon226, _polygon227, _polygon228, _polygon229, _polygon230, _path294, _path295, _path296, _path297, _path298, _path299, _path300, _path301, _path302, _path303, _path304, _path305, _path306, _path307, _path308, _path309, _path310, _path311, _path312, _path313, _polygon231, _polygon232, _polygon233, _polygon234, _path314, _path315, _polygon235, _polygon236, _path316, _path317, _path318, _path319, _polygon237, _polygon238, _polygon239, _polygon240, _polygon241, _polygon242, _polygon243, _polygon244, _polygon245, _polygon246, _polygon247, _polygon248, _polygon249, _polygon250, _polygon251, _polygon252, _polygon253, _polygon254, _polygon255, _polygon256, _polygon257, _polygon258, _polygon259, _polygon260, _polygon261, _polygon262, _path320, _path321, _path322, _path323, _path324, _path325, _path326, _path327, _path328, _path329, _path330, _path331, _path332, _path333, _path334, _path335, _path336, _path337, _path338, _path339, _polygon263, _polygon264, _path340, _path341, _path342, _path343, _path344, _path345, _path346, _path347, _path348, _path349, _polygon265, _polygon266, _path350, _path351, _polygon267, _polygon268, _polygon269, _polygon270, _polygon271, _polygon272, _path352, _path353, _polygon273, _polygon274, _polygon275, _polygon276, _polygon277, _polygon278, _path354, _path355, _path356, _path357, _path358, _path359, _path360, _path361, _polygon279, _polygon280, _path362, _path363, _path364, _path365, _path366, _path367, _path368, _path369, _polygon281, _polygon282, _polygon283, _polygon284, _path370, _path371, _path372, _path373, _path374, _path375, _path376, _path377, _polygon285, _polygon286, _path378, _path379, _path380, _path381, _path382, _path383, _polygon287, _polygon288, _polygon289, _polygon290, _polygon291, _polygon292, _polygon293, _polygon294, _path384, _path385, _polygon295, _polygon296, _polygon297, _polygon298, _polygon299, _polygon300, _polygon301, _polygon302, _path386, _path387, _path388, _path389, _path390, _path391, _path392, _path393, _polygon303, _polygon304, _polygon305, _polygon306, _polygon307, _polygon308, _polygon309, _polygon310, _polygon311, _polygon312, _polygon313, _polygon314, _polygon315, _polygon316, _polygon317, _polygon318, _polygon319, _polygon320, _polygon321, _polygon322, _polygon323, _polygon324, _path394, _path395, _polygon325, _polygon326, _polygon327, _polygon328, _polygon329, _polygon330, _polygon331, _polygon332, _polygon333, _polygon334, _polygon335, _polygon336, _polygon337, _polygon338, _polygon339, _polygon340, _polygon341, _polygon342, _polygon343, _polygon344, _polygon345, _polygon346, _polygon347, _polygon348, _polygon349, _polygon350, _polygon351, _polygon352, _polygon353, _polygon354, _polygon355, _polygon356, _polygon357, _polygon358, _polygon359, _polygon360, _polygon361, _polygon362, _polygon363, _polygon364, _polygon365, _polygon366, _polygon367, _polygon368, _polygon369, _polygon370, _path396, _path397, _polygon371, _polygon372, _polygon373, _polygon374, _polygon375, _polygon376, _polygon377, _polygon378, _polygon379, _polygon380, _polygon381, _polygon382, _polygon383, _polygon384, _path398, _path399, _polygon385, _polygon386, _polygon387, _polygon388, _polygon389, _polygon390, _polygon391, _polygon392, _polygon393, _polygon394, _path400, _path401, _path402, _path403, _path404, _path405, _polygon395, _polygon396, _polygon397, _polygon398, _polygon399, _polygon400, _path406, _path407, _path408, _path409, _polygon401, _polygon402, _path410, _path411, _polygon403, _polygon404, _polygon405, _polygon406, _polygon407, _polygon408, _polygon409, _polygon410, _polygon411, _polygon412, _polygon413, _polygon414, _polygon415, _polygon416, _polygon417, _polygon418, _polygon419, _polygon420, _polygon421, _polygon422, _polygon423, _polygon424, _polygon425, _polygon426, _polygon427, _polygon428, _polygon429, _polygon430, _path412, _path413, _polygon431, _polygon432, _polygon433, _polygon434, _polygon435, _polygon436, _polygon437, _polygon438, _polygon439, _polygon440, _polygon441, _polygon442, _polygon443, _polygon444, _polygon445, _polygon446, _polygon447, _polygon448, _polygon449, _polygon450, _polygon451, _polygon452, _polygon453, _polygon454, _polygon455, _polygon456, _polygon457, _polygon458, _path414, _path415, _path416, _path417, _path418, _path419, _path420, _path421, _path422, _path423, _path424, _path425, _path426, _path427, _polygon459, _polygon460, _polygon461, _polygon462, _rect3, _rect4, _polygon463, _polygon464, _polygon465, _polygon466, _path428, _path429, _path430, _path431, _polygon467, _polygon468, _path432, _path433, _polygon469, _polygon470, _polygon471, _polygon472, _polygon473, _polygon474, _polygon475, _polygon476, _path434, _path435, _path436, _path437, _path438, _path439, _path440, _path441, _path442, _path443, _path444, _path445, _path446, _path447, _polygon477, _polygon478, _polygon479, _polygon480, _polygon481, _polygon482, _polygon483, _polygon484, _polygon485, _polygon486, _polygon487, _polygon488, _polygon489, _polygon490, _path448, _path449, _polygon491, _polygon492, _path450, _path451, _polygon493, _polygon494, _path452, _path453, _polygon495, _polygon496, _path454, _path455, _path456, _path457, _path458, _path459, _polygon497, _polygon498, _path460, _path461, _polygon499, _polygon500, _polygon501, _polygon502, _path462, _path463, _polygon503, _polygon504, _polygon505, _polygon506, _path464, _path465, _path466, _path467, _path468, _path469, _path470, _path471, _polygon507, _polygon508, _polygon509, _polygon510, _path472, _path473, _path474, _path475, _polygon511, _polygon512, _path476, _path477, _path478, _path479, _path480, _path481, _polygon513, _polygon514, _polygon515, _polygon516, _polygon517, _polygon518, _path482, _path483, _path484, _path485, _polygon519, _polygon520, _polygon521, _polygon522, _polygon523, _polygon524, _polygon525, _polygon526, _polygon527, _polygon528, _polygon529, _polygon530, _polygon531, _polygon532, _polygon533, _polygon534, _polygon535, _polygon536, _polygon537, _polygon538, _polygon539, _polygon540, _polygon541, _polygon542, _path486, _path487, _polygon543, _polygon544, _polygon545, _polygon546, _polygon547, _polygon548, _polygon549, _polygon550, _polygon551, _polygon552, _polygon553, _polygon554, _polygon555, _polygon556, _polygon557, _polygon558, _polygon559, _polygon560, _polygon561, _polygon562, _path488, _path489, _polygon563, _polygon564, _polygon565, _polygon566, _path490, _path491, _polygon567, _polygon568, _polygon569, _polygon570, _polygon571, _polygon572, _polygon573, _polygon574, _polygon575, _polygon576, _polygon577, _polygon578, _polygon579, _polygon580, _polygon581, _polygon582, _polygon583, _polygon584, _polygon585, _polygon586, _polygon587, _polygon588, _polygon589, _polygon590, _polygon591, _polygon592, _polygon593, _polygon594, _polygon595, _polygon596, _polygon597, _polygon598, _polygon599, _polygon600, _path492, _path493, _polygon601, _polygon602, _polygon603, _polygon604, _polygon605, _polygon606, _polygon607, _polygon608, _polygon609, _polygon610, _polygon611, _polygon612, _polygon613, _polygon614, _polygon615, _polygon616, _path494, _path495, _path496, _path497, _path498, _path499, _path500, _path501, _path502, _path503, _path504, _path505, _path506, _path507, _path508, _path509, _path510, _path511, _polygon617, _polygon618, _path512, _path513, _path514, _path515, _polygon619, _polygon620, _polygon621, _polygon622, _path516, _path517, _path518, _path519, _polygon623, _polygon624, _polygon625, _polygon626, _polygon627, _polygon628, _path520, _path521, _polygon629, _polygon630, _polygon631, _polygon632, _polygon633, _polygon634, _polygon635, _polygon636, _polygon637, _polygon638, _path522, _path523, _path524, _path525, _polygon639, _polygon640, _polygon641, _polygon642, _polygon643, _polygon644, _polygon645, _polygon646, _polygon647, _polygon648, _polygon649, _polygon650, _polygon651, _polygon652, _polygon653, _polygon654, _polygon655, _polygon656, _polygon657, _polygon658, _polygon659, _polygon660, _polygon661, _polygon662, _polygon663, _polygon664, _polygon665, _polygon666, _polygon667, _polygon668, _polygon669, _polygon670, _path526, _path527, _path528, _path529, _path530, _path531, _path532, _path533, _path534, _path535, _path536, _path537, _path538, _path539, _path540, _path541, _path542, _polygon671, _polygon672, _path543, _path544, _polygon673, _polygon674, _polygon675, _polygon676, _polygon677, _polygon678, _path545, _path546, _path547, _path548, _path549, _path550, _polygon679, _polygon680, _polygon681, _polygon682, _path551, _path552, _path553, _path554, _path555, _path556, _polygon683, _polygon684, _polygon685, _polygon686, _polygon687, _polygon688, _polygon689, _polygon690, _path557, _path558, _path559, _path560, _path561, _path562, _path563, _path564, _polygon691, _polygon692, _path565, _path566, _path567, _path568, _path569, _path570, _path571, _path572, _path573, _path574, _polygon693, _polygon694, _polygon695, _polygon696, _path575, _path576, _polygon697, _polygon698, _polygon699, _polygon700, _polygon701, _polygon702, _polygon703, _polygon704, _path577, _path578, _path579, _path580, _path581, _path582, _polygon705, _polygon706, _polygon707, _polygon708, _polygon709, _polygon710, _polygon711, _polygon712, _polygon713, _polygon714, _polygon715, _polygon716, _path583, _path584, _polygon717, _polygon718, _polygon719, _polygon720, _polygon721, _polygon722, _polygon723, _polygon724, _path585, _path586, _polygon725, _polygon726, _path587, _path588, _polygon727, _polygon728, _polygon729, _polygon730, _polygon731, _polygon732, _polygon733, _polygon734, _path589, _path590, _path591, _path592, _path593, _path594, _path595, _path596, _path597, _path598, _path599, _path600, _polygon735, _polygon736, _path601, _path602, _path603, _path604, _path605, _path606, _path607, _path608, _path609, _path610, _polygon737, _polygon738, _path611, _path612, _path613, _path614, _path615, _path616, _path617, _path618, _polygon739, _polygon740, _polygon741, _polygon742, _polygon743, _polygon744, _polygon745, _polygon746, _polygon747, _polygon748, _path619, _path620, _path621, _path622, _path623, _path624, _polygon749, _polygon750, _polygon751, _polygon752, _path625, _path626, _path627, _path628, _polygon753, _polygon754, _polygon755, _polygon756, _polygon757, _polygon758, _polygon759, _polygon760, _polygon761, _polygon762, _polygon763, _polygon764, _path629, _path630, _path631, _path632, _polygon765, _polygon766, _polygon767, _polygon768, _polygon769, _polygon770, _polygon771, _polygon772, _polygon773, _polygon774, _polygon775, _polygon776, _polygon777, _polygon778, _polygon779, _polygon780, _polygon781, _polygon782, _polygon783, _polygon784, _polygon785, _polygon786, _path633, _path634, _path635, _path636, _polygon787, _polygon788, _path637, _path638, _path639, _path640, _path641, _path642, _polygon789, _polygon790, _path643, _path644, _path645, _path646, _path647, _path648, _polygon791, _polygon792, _polygon793, _polygon794, _polygon795, _polygon796, _path649, _path650, _polygon797, _polygon798, _path651, _path652, _path653, _path654, _path655, _path656, _path657, _path658, _path659, _path660, _path661, _path662, _path663, _path664, _polygon799, _polygon800, _path665, _path666, _path667, _path668, _path669, _path670, _polygon801, _polygon802, _polygon803, _polygon804, _path671, _path672, _path673, _path674, _polygon805, _path675, _path676, _path677, _path678, _path679, _polygon806, _path680, _path681, _path682, _path683, _path684, _polygon807, _path685, _path686, _path687, _polygon808, _path688, _path689, _path690, _path691, _path692, _path693, _path694, _path695, _path696, _path697, _path698, _path699, _polygon809, _polygon810, _polygon811, _polygon812, _path700, _path701, _polygon813, _polygon814, _polygon815, _polygon816, _polygon817, _polygon818, _polygon819, _polygon820, _polygon821, _polygon822, _polygon823, _polygon824, _polygon825, _polygon826, _polygon827, _polygon828, _polygon829, _polygon830, _polygon831, _polygon832, _polygon833, _polygon834, _polygon835, _polygon836, _path702, _path703, _path704, _path705, _polygon837, _polygon838, _polygon839, _polygon840, _path706, _path707;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 724.86 724.86",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#cecece;}.cls-10,.cls-12,.cls-13,.cls-2,.cls-4,.cls-8{fill:none;}.cls-2,.cls-4{stroke:#8e8e8e;}.cls-2{stroke-width:4.86px;}.cls-3{fill:#fff;}.cls-12,.cls-4{stroke-width:2.43px;}.cls-5{fill:#ccc;}.cls-6{fill:#bebebe;}.cls-7{fill:#bdbdbd;}.cls-8{stroke:#bdbdbd;stroke-width:1.62px;}.cls-9{fill:#555;}.cls-10{stroke:#555;}.cls-10,.cls-13{stroke-width:0.24px;}.cls-11{fill:#5e5e5e;}.cls-12,.cls-13{stroke:#000;}.cls-14{fill:#636363;}.cls-15{fill:#505050;}.cls-16{fill:#b4b4b4;}.cls-17{fill:#c6c6c6;}.cls-18{fill:#646464;}.cls-19{fill:#e0e0e0;}.cls-20{fill:silver;}.cls-21{fill:#8e8e8e;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "logo") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M362.4,722.4c198.8,0,360-161.2,360-360s-161.2-360-360-360-360,161.2-360,360,161.2,360,360,360Z",
    transform: "translate(0.03 0.03)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M362.4,722.4c198.8,0,360-161.2,360-360s-161.2-360-360-360-360,161.2-360,360,161.2,360,360,360Z",
    transform: "translate(0.03 0.03)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M362.4,712.4c193.3,0,349.9-156.7,349.9-349.9S555.6,12.6,362.4,12.6,12.5,169.3,12.5,362.5,169.2,712.4,362.4,712.4Z",
    transform: "translate(0.03 0.03)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M362.4,712.4c193.3,0,349.9-156.7,349.9-349.9S555.6,12.6,362.4,12.6,12.5,169.3,12.5,362.5,169.2,712.4,362.4,712.4Z",
    transform: "translate(0.03 0.03)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M362.4,90a5.3,5.3,0,1,0-5.3-5.3A5.34,5.34,0,0,0,362.4,90Z",
    transform: "translate(0.03 0.03)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M347.9,90.3a5.31,5.31,0,0,0-.6-10.6,5.31,5.31,0,1,0,.6,10.6Z",
    transform: "translate(0.03 0.03)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M333.5,91.5a5.28,5.28,0,1,0-5.8-4.7A5.28,5.28,0,0,0,333.5,91.5Z",
    transform: "translate(0.03 0.03)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M319.1,93.4a5.32,5.32,0,1,0-1.7-10.5A5.39,5.39,0,0,0,313,89,5.31,5.31,0,0,0,319.1,93.4Z",
    transform: "translate(0.03 0.03)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M304.9,96.1a5.32,5.32,0,1,0-6.3-4.1,5.28,5.28,0,0,0,6.3,4.1Z",
    transform: "translate(0.03 0.03)"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M290.8,99.5a5.29,5.29,0,1,0-6.5-3.7A5.3,5.3,0,0,0,290.8,99.5Z",
    transform: "translate(0.03 0.03)"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M276.9,103.7a5.31,5.31,0,1,0-6.7-3.4,5.23,5.23,0,0,0,6.7,3.4Z",
    transform: "translate(0.03 0.03)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M263.2,108.7a5.32,5.32,0,1,0-3.9-9.9,5.23,5.23,0,0,0-3,6.9A5.44,5.44,0,0,0,263.2,108.7Z",
    transform: "translate(0.03 0.03)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M249.9,114.3a5.28,5.28,0,0,0-4.4-9.6,5.15,5.15,0,0,0-2.6,7A5.32,5.32,0,0,0,249.9,114.3Z",
    transform: "translate(0.03 0.03)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M236.8,120.6a5.28,5.28,0,1,0-7.1-2.3A5.12,5.12,0,0,0,236.8,120.6Z",
    transform: "translate(0.03 0.03)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M224.1,127.7a5.35,5.35,0,0,0,1.9-7.3,5.26,5.26,0,0,0-7.2-1.9,5.31,5.31,0,0,0,5.3,9.2Z",
    transform: "translate(0.03 0.03)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M211.9,135.4a5.27,5.27,0,1,0-7.3-1.5,5.3,5.3,0,0,0,7.3,1.5Z",
    transform: "translate(0.03 0.03)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M200,143.7a5.37,5.37,0,0,0,1.1-7.4,5.29,5.29,0,0,0-8.5,6.3,5.36,5.36,0,0,0,7.4,1.1Z",
    transform: "translate(0.03 0.03)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M188.6,152.6a5.33,5.33,0,1,0-7.5-.7A5.27,5.27,0,0,0,188.6,152.6Z",
    transform: "translate(0.03 0.03)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M177.7,162.2a5.31,5.31,0,0,0-7.2-7.8,5.31,5.31,0,1,0,7.2,7.8Z",
    transform: "translate(0.03 0.03)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M167.3,172.3a5.3,5.3,0,1,0-7.6-7.4,5.25,5.25,0,0,0,.1,7.5A5.34,5.34,0,0,0,167.3,172.3Z",
    transform: "translate(0.03 0.03)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M157.4,183a5.32,5.32,0,1,0-7.5.5,5.36,5.36,0,0,0,7.5-.5Z",
    transform: "translate(0.03 0.03)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M148.2,194.1a5.27,5.27,0,1,0-7.4.9,5.26,5.26,0,0,0,7.4-.9Z",
    transform: "translate(0.03 0.03)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M139.5,205.8a5.31,5.31,0,1,0-7.4,1.3A5.49,5.49,0,0,0,139.5,205.8Z",
    transform: "translate(0.03 0.03)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M131.5,217.8a5.3,5.3,0,1,0-7.3,1.7,5.23,5.23,0,0,0,7.3-1.7Z",
    transform: "translate(0.03 0.03)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M124.1,230.3a5.3,5.3,0,1,0-7.2,2.1A5.27,5.27,0,0,0,124.1,230.3Z",
    transform: "translate(0.03 0.03)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M117.4,243.2a5.3,5.3,0,1,0-7.1,2.4,5.27,5.27,0,0,0,7.1-2.4Z",
    transform: "translate(0.03 0.03)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M111.4,256.4a5.27,5.27,0,1,0-6.9,2.8A5.18,5.18,0,0,0,111.4,256.4Z",
    transform: "translate(0.03 0.03)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M106.2,269.9a5.31,5.31,0,1,0-6.8,3.2A5.3,5.3,0,0,0,106.2,269.9Z",
    transform: "translate(0.03 0.03)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M101.6,283.7a5.28,5.28,0,1,0-6.6,3.5A5.21,5.21,0,0,0,101.6,283.7Z",
    transform: "translate(0.03 0.03)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M97.8,297.7a5.3,5.3,0,1,0-6.4,3.9A5.43,5.43,0,0,0,97.8,297.7Z",
    transform: "translate(0.03 0.03)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M94.7,311.8a5.3,5.3,0,1,0-10.4-2,5.3,5.3,0,0,0,10.4,2Z",
    transform: "translate(0.03 0.03)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M92.4,326.2a5.31,5.31,0,0,0-4.5-6,5.25,5.25,0,1,0,4.5,6Z",
    transform: "translate(0.03 0.03)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M90.9,340.6a5.28,5.28,0,0,0-4.9-5.7,5.23,5.23,0,0,0-5.7,4.9,5.28,5.28,0,0,0,4.9,5.7A5.41,5.41,0,0,0,90.9,340.6Z",
    transform: "translate(0.03 0.03)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M90.1,355.1a5.3,5.3,0,1,0-5.5,5.1A5.28,5.28,0,0,0,90.1,355.1Z",
    transform: "translate(0.03 0.03)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M90.1,369.6a5.3,5.3,0,1,0-10.6.2,5.3,5.3,0,0,0,10.6-.2Z",
    transform: "translate(0.03 0.03)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M90.8,384a5.32,5.32,0,1,0-4.9,5.7A5.16,5.16,0,0,0,90.8,384Z",
    transform: "translate(0.03 0.03)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M92.4,398.5a5.41,5.41,0,0,0-5.9-4.6,5.31,5.31,0,0,0-4.5,6,5.25,5.25,0,1,0,10.4-1.4Z",
    transform: "translate(0.03 0.03)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M94.7,412.8a5.3,5.3,0,1,0-4.2,6.2A5.46,5.46,0,0,0,94.7,412.8Z",
    transform: "translate(0.03 0.03)"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M97.7,427a5.3,5.3,0,1,0-3.9,6.4A5.27,5.27,0,0,0,97.7,427Z",
    transform: "translate(0.03 0.03)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M101.5,440.9a5.28,5.28,0,1,0-3.5,6.6A5.21,5.21,0,0,0,101.5,440.9Z",
    transform: "translate(0.03 0.03)"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M106.1,454.7a5.31,5.31,0,1,0-3.2,6.8A5.27,5.27,0,0,0,106.1,454.7Z",
    transform: "translate(0.03 0.03)"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M111.4,468.2a5.27,5.27,0,1,0-2.8,6.9A5.34,5.34,0,0,0,111.4,468.2Z",
    transform: "translate(0.03 0.03)"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M117.3,481.4a5.42,5.42,0,0,0-7.1-2.5,5.3,5.3,0,0,0-2.4,7.1,5.42,5.42,0,0,0,7.1,2.5A5.3,5.3,0,0,0,117.3,481.4Z",
    transform: "translate(0.03 0.03)"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M124,494.3a5.3,5.3,0,1,0-2.1,7.2,5.27,5.27,0,0,0,2.1-7.2Z",
    transform: "translate(0.03 0.03)"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M131.4,506.8a5.3,5.3,0,1,0-1.7,7.3,5.34,5.34,0,0,0,1.7-7.3Z",
    transform: "translate(0.03 0.03)"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M139.4,518.9a5.31,5.31,0,1,0-1.3,7.4A5.3,5.3,0,0,0,139.4,518.9Z",
    transform: "translate(0.03 0.03)"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M148,530.5a5.27,5.27,0,1,0-.9,7.4,5.26,5.26,0,0,0,.9-7.4Z",
    transform: "translate(0.03 0.03)"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M157.3,541.7a5.32,5.32,0,1,0-.5,7.5,5.35,5.35,0,0,0,.5-7.5Z",
    transform: "translate(0.03 0.03)"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M167.1,552.4a5.3,5.3,0,1,0-.1,7.5A5.25,5.25,0,0,0,167.1,552.4Z",
    transform: "translate(0.03 0.03)"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M177.5,562.5a5.31,5.31,0,1,0,.3,7.5,5.34,5.34,0,0,0-.3-7.5Z",
    transform: "translate(0.03 0.03)"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M188.4,572a5.33,5.33,0,1,0,.7,7.5A5.27,5.27,0,0,0,188.4,572Z",
    transform: "translate(0.03 0.03)"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M199.8,581a5.29,5.29,0,1,0,1.1,7.4,5.28,5.28,0,0,0-1.1-7.4Z",
    transform: "translate(0.03 0.03)"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M211.7,589.3a5.27,5.27,0,1,0,1.5,7.3A5.32,5.32,0,0,0,211.7,589.3Z",
    transform: "translate(0.03 0.03)"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M224,597a5.27,5.27,0,1,0-5.3,9.1,5.29,5.29,0,0,0,7.3-1.9A5.5,5.5,0,0,0,224,597Z",
    transform: "translate(0.03 0.03)"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M236.6,604.1a5.2,5.2,0,0,0-7.1,2.3,5.29,5.29,0,0,0,2.3,7.1,5.2,5.2,0,0,0,7.1-2.3A5.29,5.29,0,0,0,236.6,604.1Z",
    transform: "translate(0.03 0.03)"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M249.7,610.4a5.28,5.28,0,1,0,2.6,7A5.32,5.32,0,0,0,249.7,610.4Z",
    transform: "translate(0.03 0.03)"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M263,616.1a5.32,5.32,0,1,0,3,6.9A5.28,5.28,0,0,0,263,616.1Z",
    transform: "translate(0.03 0.03)"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M276.7,621a5.31,5.31,0,1,0,3.4,6.7A5.39,5.39,0,0,0,276.7,621Z",
    transform: "translate(0.03 0.03)"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M290.5,625.2a5.29,5.29,0,1,0,3.7,6.5A5.22,5.22,0,0,0,290.5,625.2Z",
    transform: "translate(0.03 0.03)"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M304.6,628.7a5.28,5.28,0,1,0,4,6.2A5.09,5.09,0,0,0,304.6,628.7Z",
    transform: "translate(0.03 0.03)"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M318.9,631.4a5.32,5.32,0,1,0,4.4,6.1A5.31,5.31,0,0,0,318.9,631.4Z",
    transform: "translate(0.03 0.03)"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M333.2,633.3a5.28,5.28,0,1,0,4.7,5.8A5.21,5.21,0,0,0,333.2,633.3Z",
    transform: "translate(0.03 0.03)"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M347.7,634.5a5.31,5.31,0,1,0,5,5.6A5.22,5.22,0,0,0,347.7,634.5Z",
    transform: "translate(0.03 0.03)"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M362.2,634.9a5.3,5.3,0,1,0,5.3,5.3A5.27,5.27,0,0,0,362.2,634.9Z",
    transform: "translate(0.03 0.03)"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M376.7,634.5a5.31,5.31,0,0,0,.6,10.6,5.22,5.22,0,0,0,5-5.6A5.34,5.34,0,0,0,376.7,634.5Z",
    transform: "translate(0.03 0.03)"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M391.1,633.3a5.28,5.28,0,1,0,5.8,4.7A5.22,5.22,0,0,0,391.1,633.3Z",
    transform: "translate(0.03 0.03)"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M405.5,631.4a5.32,5.32,0,1,0,6.1,4.4A5.39,5.39,0,0,0,405.5,631.4Z",
    transform: "translate(0.03 0.03)"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M419.8,628.7a5.32,5.32,0,1,0,6.3,4.1A5.46,5.46,0,0,0,419.8,628.7Z",
    transform: "translate(0.03 0.03)"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M433.9,625.3a5.29,5.29,0,1,0,6.5,3.7A5.38,5.38,0,0,0,433.9,625.3Z",
    transform: "translate(0.03 0.03)"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M447.7,621.1a5.31,5.31,0,1,0,6.7,3.4A5.3,5.3,0,0,0,447.7,621.1Z",
    transform: "translate(0.03 0.03)"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M461.4,616.2a5.32,5.32,0,0,0,3.9,9.9,5.23,5.23,0,0,0,3-6.9A5.44,5.44,0,0,0,461.4,616.2Z",
    transform: "translate(0.03 0.03)"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M474.8,610.6a5.28,5.28,0,1,0,7,2.6A5.35,5.35,0,0,0,474.8,610.6Z",
    transform: "translate(0.03 0.03)"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M487.8,604.3a5.28,5.28,0,1,0,7.1,2.3,5.2,5.2,0,0,0-7.1-2.3Z",
    transform: "translate(0.03 0.03)"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M500.5,597.3a5.27,5.27,0,1,0,7.2,1.9A5.15,5.15,0,0,0,500.5,597.3Z",
    transform: "translate(0.03 0.03)"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M512.8,589.6a5.27,5.27,0,1,0,7.3,1.5A5.22,5.22,0,0,0,512.8,589.6Z",
    transform: "translate(0.03 0.03)"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M524.7,581.3a5.29,5.29,0,0,0,6.3,8.5,5.37,5.37,0,0,0,1.1-7.4A5.21,5.21,0,0,0,524.7,581.3Z",
    transform: "translate(0.03 0.03)"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M536.1,572.3a5.33,5.33,0,1,0,7.5.7A5.47,5.47,0,0,0,536.1,572.3Z",
    transform: "translate(0.03 0.03)"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M547,562.8a5.31,5.31,0,1,0,7.5.3A5.25,5.25,0,0,0,547,562.8Z",
    transform: "translate(0.03 0.03)"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M557.4,552.7a5.25,5.25,0,0,0,.1,7.5,5.3,5.3,0,1,0-.1-7.5Z",
    transform: "translate(0.03 0.03)"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M567.3,542a5.32,5.32,0,1,0,7.5-.5A5.36,5.36,0,0,0,567.3,542Z",
    transform: "translate(0.03 0.03)"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M576.5,530.9a5.27,5.27,0,1,0,7.4-.9A5.26,5.26,0,0,0,576.5,530.9Z",
    transform: "translate(0.03 0.03)"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M585.2,519.3a5.31,5.31,0,1,0,7.4-1.3A5.3,5.3,0,0,0,585.2,519.3Z",
    transform: "translate(0.03 0.03)"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M593.2,507.2a5.25,5.25,0,0,0,1.7,7.3,5.32,5.32,0,0,0,7.3-1.7,5.25,5.25,0,0,0-1.7-7.3A5.34,5.34,0,0,0,593.2,507.2Z",
    transform: "translate(0.03 0.03)"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M600.6,494.7a5.3,5.3,0,1,0,7.2-2.1A5.27,5.27,0,0,0,600.6,494.7Z",
    transform: "translate(0.03 0.03)"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M607.3,481.8a5.3,5.3,0,1,0,7.1-2.4A5.33,5.33,0,0,0,607.3,481.8Z",
    transform: "translate(0.03 0.03)"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M613.3,468.6a5.27,5.27,0,1,0,6.9-2.8A5.34,5.34,0,0,0,613.3,468.6Z",
    transform: "translate(0.03 0.03)"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M618.6,455.1a5.31,5.31,0,1,0,6.8-3.2A5.3,5.3,0,0,0,618.6,455.1Z",
    transform: "translate(0.03 0.03)"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M623.2,441.4a5.21,5.21,0,0,0,3.5,6.6,5.28,5.28,0,1,0,3.1-10.1A5.21,5.21,0,0,0,623.2,441.4Z",
    transform: "translate(0.03 0.03)"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M627,427.4a5.3,5.3,0,1,0,6.4-3.9A5.27,5.27,0,0,0,627,427.4Z",
    transform: "translate(0.03 0.03)"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M630.1,413.2a5.3,5.3,0,1,0,6.2-4.2A5.32,5.32,0,0,0,630.1,413.2Z",
    transform: "translate(0.03 0.03)"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M632.4,398.9a5.3,5.3,0,1,0,6-4.5A5.31,5.31,0,0,0,632.4,398.9Z",
    transform: "translate(0.03 0.03)"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M634,384.5a5.27,5.27,0,1,0,5.7-4.9A5.27,5.27,0,0,0,634,384.5Z",
    transform: "translate(0.03 0.03)"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M634.7,370a5.25,5.25,0,1,0,5.4-5.1A5.31,5.31,0,0,0,634.7,370Z",
    transform: "translate(0.03 0.03)"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M634.8,355.5a5.3,5.3,0,0,0,10.6-.2,5.34,5.34,0,0,0-5.4-5.2A5.27,5.27,0,0,0,634.8,355.5Z",
    transform: "translate(0.03 0.03)"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M634,341a5.32,5.32,0,1,0,4.9-5.7A5.41,5.41,0,0,0,634,341Z",
    transform: "translate(0.03 0.03)"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M632.5,326.6a5.29,5.29,0,0,0,10.5-1.3,5.41,5.41,0,0,0-5.9-4.6A5.21,5.21,0,0,0,632.5,326.6Z",
    transform: "translate(0.03 0.03)"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M630.2,312.3a5.3,5.3,0,1,0,4.2-6.2A5.4,5.4,0,0,0,630.2,312.3Z",
    transform: "translate(0.03 0.03)"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M627.1,298.1a5.3,5.3,0,1,0,3.9-6.4A5.3,5.3,0,0,0,627.1,298.1Z",
    transform: "translate(0.03 0.03)"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M623.4,284.1a5.28,5.28,0,0,0,10.1-3.1,5.35,5.35,0,0,0-6.6-3.6A5.4,5.4,0,0,0,623.4,284.1Z",
    transform: "translate(0.03 0.03)"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M618.8,270.4a5.35,5.35,0,0,0,6.8,3.2,5.27,5.27,0,0,0,3.2-6.8,5.31,5.31,0,1,0-10,3.6Z",
    transform: "translate(0.03 0.03)"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M613.6,256.9a5.27,5.27,0,1,0,2.8-6.9A5.18,5.18,0,0,0,613.6,256.9Z",
    transform: "translate(0.03 0.03)"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M607.6,243.6a5.42,5.42,0,0,0,7.1,2.5,5.3,5.3,0,0,0,2.5-7.1,5.42,5.42,0,0,0-7.1-2.5A5.31,5.31,0,0,0,607.6,243.6Z",
    transform: "translate(0.03 0.03)"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M600.9,230.8a5.3,5.3,0,1,0,2.1-7.2,5.27,5.27,0,0,0-2.1,7.2Z",
    transform: "translate(0.03 0.03)"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M593.6,218.3a5.3,5.3,0,1,0,1.7-7.3A5.23,5.23,0,0,0,593.6,218.3Z",
    transform: "translate(0.03 0.03)"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M585.6,206.2a5.31,5.31,0,1,0,1.3-7.4A5.3,5.3,0,0,0,585.6,206.2Z",
    transform: "translate(0.03 0.03)"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M576.9,194.5a5.27,5.27,0,1,0,.9-7.4A5.26,5.26,0,0,0,576.9,194.5Z",
    transform: "translate(0.03 0.03)"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M567.7,183.4a5.32,5.32,0,1,0,.5-7.5A5.35,5.35,0,0,0,567.7,183.4Z",
    transform: "translate(0.03 0.03)"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M557.9,172.7a5.3,5.3,0,1,0,.1-7.5A5.34,5.34,0,0,0,557.9,172.7Z",
    transform: "translate(0.03 0.03)"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M547.5,162.5a5.31,5.31,0,1,0-.3-7.5A5.34,5.34,0,0,0,547.5,162.5Z",
    transform: "translate(0.03 0.03)"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M536.6,153a5.33,5.33,0,1,0-.7-7.5A5.46,5.46,0,0,0,536.6,153Z",
    transform: "translate(0.03 0.03)"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M525.2,144a5.29,5.29,0,1,0-1.1-7.4A5.36,5.36,0,0,0,525.2,144Z",
    transform: "translate(0.03 0.03)"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M513.4,135.7a5.27,5.27,0,1,0-1.5-7.3A5.22,5.22,0,0,0,513.4,135.7Z",
    transform: "translate(0.03 0.03)"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M501.1,128a5.27,5.27,0,1,0,5.3-9.1,5.29,5.29,0,0,0-7.3,1.9,5.4,5.4,0,0,0,2,7.2Z",
    transform: "translate(0.03 0.03)"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M488.4,120.9a5.23,5.23,0,1,0,4.8-9.3,5.17,5.17,0,0,0-7.1,2.2A5.29,5.29,0,0,0,488.4,120.9Z",
    transform: "translate(0.03 0.03)"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M475.4,114.6a5.28,5.28,0,1,0-2.6-7A5.32,5.32,0,0,0,475.4,114.6Z",
    transform: "translate(0.03 0.03)"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M462,108.9a5.32,5.32,0,1,0-3-6.9A5.44,5.44,0,0,0,462,108.9Z",
    transform: "translate(0.03 0.03)"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M448.4,104a5.27,5.27,0,1,0-3.4-6.6,5.24,5.24,0,0,0,3.4,6.6Z",
    transform: "translate(0.03 0.03)"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M434.5,99.7a5.29,5.29,0,1,0-3.7-6.5A5.3,5.3,0,0,0,434.5,99.7Z",
    transform: "translate(0.03 0.03)"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M420.5,96.3a5.28,5.28,0,1,0-4-6.3A5.29,5.29,0,0,0,420.5,96.3Z",
    transform: "translate(0.03 0.03)"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M406.2,93.6a5.32,5.32,0,1,0-4.4-6.1A5.31,5.31,0,0,0,406.2,93.6Z",
    transform: "translate(0.03 0.03)"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M391.9,91.6a5.28,5.28,0,1,0-4.7-5.8,5.14,5.14,0,0,0,4.7,5.8Z",
    transform: "translate(0.03 0.03)"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M377.4,90.4a5.31,5.31,0,1,0-5-5.6A5.22,5.22,0,0,0,377.4,90.4Z",
    transform: "translate(0.03 0.03)"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M120,255.5l11.2,2.9,2.8-1.6,4.9,2.8,8.5-5.7,34-9.7,34.4-11.7s19.4-6.9,34.8-6.1a96.06,96.06,0,0,1,10.9,2s14.2-11.7,25.5-13,18.6.4,36,14.6c0,0,7.7-8.1,21.5-7.3s19.4,4,26.3,10.5l8.1-.4s4.4,6.5,4.9,6.5,16.6-3.2,16.6-3.2l7.7-6.5,22.7-3.6,19,6.9-3.2,12.5-2.8,10.9,26.3,6.9,12.5,4.5,2.8,6.1s6.9,8.1,47.8,17l42.1,8.9L589.9,311l10.9,4.4,3.6-7.3,17.7,2.1C598,188.8,490.9,97.2,362.5,97.2,254.1,97.3,161,162.4,120,255.5Z",
    transform: "translate(0.03 0.03)"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M622.1,310.3a266.85,266.85,0,0,1,5.1,51.8c0,146.2-118.5,264.7-264.7,264.7S97.7,508.2,97.7,362A264.42,264.42,0,0,1,120,255.5l11.2,2.9,2.8-1.6,4.9,2.8,8.5-5.7,34-9.7,34.4-11.7s19.4-6.9,34.8-6.1a96.06,96.06,0,0,1,10.9,2s14.2-11.7,25.5-13,18.6.4,36,14.6c0,0,7.7-8.1,21.5-7.3s19.4,4,26.3,10.5l8.1-.4s4.4,6.5,4.9,6.5,16.6-3.2,16.6-3.2l7.7-6.5,22.7-3.6,19,6.9-3.2,12.5-2.8,10.9,26.3,6.9,12.5,4.5,2.8,6.1s6.9,8.1,47.8,17l42.1,8.9L589.9,311l10.9,4.4,3.6-7.3,17.7,2.2Z",
    transform: "translate(0.03 0.03)"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M273.7,219s2.2-7.9-1.5-12.7-7.5-7.5-14.6-7.1-13.5,4.1-15.7,10.5-1.5,12.3,1.5,16a41.74,41.74,0,0,1,9.5-.1c4.3.6,9.3,1.6,9.3,1.6A104,104,0,0,1,273.7,219Z",
    transform: "translate(0.03 0.03)"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M273.7,219s2.3-7.9-1.5-12.7-7.5-7.5-14.6-7.1-13.5,4.1-15.7,10.5-1.5,12.3,1.5,16a41.74,41.74,0,0,1,9.5-.1c4.3.6,9.3,1.6,9.3,1.6A104,104,0,0,1,273.7,219Z",
    transform: "translate(0.03 0.03)"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M233.3,220.5c-.4,0-24,2.3-24,2.3l1.1,1.9,21.3-1.9Z",
    transform: "translate(0.03 0.03)"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "234.03 212.33 200.03 211.63 202.23 213.83 233.73 214.23 234.03 212.33"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "211.93 190.23 235.53 204.53 236.73 203.03 211.93 188.03 211.93 190.23"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "208.63 167.03 241.13 198.83 243.03 198.13 211.23 167.03 208.63 167.03"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "229.93 171.13 244.13 195.53 245.33 193.63 232.23 170.83 229.93 171.13"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "234.43 147.93 249.03 192.13 250.93 192.13 236.73 148.33 234.43 147.93"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "255.43 159.23 255.03 192.83 256.53 192.13 256.93 159.23 255.43 159.23"
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "277.53 125.83 263.63 193.63 265.53 193.23 279.03 125.83 277.53 125.83"
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "290.93 152.43 270.03 195.53 271.53 195.53 292.43 153.93 290.93 152.43"
  })), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "318.33 145.73 275.63 201.53 276.33 203.03 319.43 148.73 318.33 145.73"
  })), _polygon0 || (_polygon0 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "278.63 208.23 278.23 206.73 324.63 172.63 327.23 173.43 326.13 175.23 278.63 208.23"
  })), _polygon1 || (_polygon1 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "279.33 211.23 353.83 183.93 355.73 185.73 282.03 211.63 279.33 211.23"
  })), _polygon10 || (_polygon10 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "295.43 213.83 335.13 201.53 336.23 203.33 298.03 214.63 295.43 213.83"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M382.6,279.3l.8,4.1,3.7-.4.8-2.6,3.4.4-.4-2.6S386.8,278.6,382.6,279.3Z",
    transform: "translate(0.03 0.03)"
  })), _polygon11 || (_polygon11 = /*#__PURE__*/React.createElement("polygon", {
    points: "414.53 265.53 412.63 269.63 414.53 270.03 417.13 265.83 414.53 265.53"
  })), _polygon12 || (_polygon12 = /*#__PURE__*/React.createElement("polygon", {
    points: "419.73 267.03 417.13 270.73 419.03 271.13 421.63 267.73 419.73 267.03"
  })), _polygon13 || (_polygon13 = /*#__PURE__*/React.createElement("polygon", {
    points: "438.03 272.63 441.03 277.83 442.23 276.33 439.23 271.13 438.03 272.63"
  })), _polygon14 || (_polygon14 = /*#__PURE__*/React.createElement("polygon", {
    points: "440.73 269.63 442.93 274.83 444.03 273.33 441.83 268.53 440.73 269.63"
  })), _polygon15 || (_polygon15 = /*#__PURE__*/React.createElement("polygon", {
    points: "449.33 274.83 454.23 279.33 453.83 280.83 449.33 277.13 449.33 274.83"
  })), _polygon16 || (_polygon16 = /*#__PURE__*/React.createElement("polygon", {
    points: "446.73 279.33 446.33 281.63 449.73 283.43 449.73 281.93 446.73 279.33"
  })), _polygon17 || (_polygon17 = /*#__PURE__*/React.createElement("polygon", {
    points: "433.63 264.33 436.63 268.83 438.03 267.73 435.13 263.63 433.63 264.33"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M323.1,230.7c-5.3,0,11.2-10.1,21-9.4s19.1,3.4,25.5,9l-.4,2.6s-3.8-4.1-7.9-5.6l-4.1,4.9h-2.3l4.1-5.6-3.4-.8a67.8,67.8,0,0,0-6,9h-1.5l5.6-9.7-2.6-1.1-5.6,9-1.9.4,5.3-9.7h-3.4l-5.6,9.4h-1.5l4.9-9.4-3,.4-4.9,8.2h-1.9l4.9-8.6s-4.5,0-7.5,2.6-6.7,5.6-6.7,5.6-.7-1.2-1.1-1.2Z",
    transform: "translate(0.03 0.03)"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M262.5,227.3c5.6-4.5,16.1-12.4,24.3-13.5s13.1.4,18.3,3a87.16,87.16,0,0,1,19.8,13.5c6.4,6,15.7,15,28.8,21.7l.8,3s-6-3.4-9-5.2l-1.9,3.4-1.5-1.5,1.1-3-1.5-1.9a8.58,8.58,0,0,0-2.6,4.1l-1.5-.8a25.81,25.81,0,0,1,1.9-4.5l-2.3-1.5-2.3,4.1-1.5-1.1,1.9-3.7-3-3.8-2.6,4.9-1.1-.7,2.3-5.2-2.3-2.6a23.15,23.15,0,0,0-4.9,6.4l-1.1-1.1s2.6-4.5,4.1-6.4l-3-1.9a13.08,13.08,0,0,0-5.2,7.9l-1.5-1.5s2.2-6,5.2-7.9l-3-3a37.82,37.82,0,0,0-9,13.5l-1.5-1.1s4.1-10.5,8.6-13.8l-3.4-2.3s-5.2,4.5-9.7,15.7l-1.9-.4S306.4,230,312,224l-4.5-3.4a47.23,47.23,0,0,0-5.6,9.4c-1.8,4.5-3.4,9.7-3.4,9.7l-2.3-.4s2.6-7.5,4.1-10.5,5.2-9,5.2-9-2.3-1.5-3.7-2.2c0,0-7.1,9.4-8.6,15l-2.2.4a45.19,45.19,0,0,1,8.6-15.7l-3-1.5a38.28,38.28,0,0,0-7.9,12.7h-1.9s2.6-8.2,6.7-12.4l-3.7-.4a36.75,36.75,0,0,1-3.8,6.4l-1.9,3.7h-1.9l1.9-3.7-3.4.8a11.59,11.59,0,0,1,1.5-5.6l-3,1.5-1.1,3.7a20,20,0,0,0-3.7,5.2l-1.5.4A33.69,33.69,0,0,1,277,221l-4.5,1.9-.4,2.2-2.3,1.1-1.1,4.1-2.3-.4,1.5-4.1s-2.3-.4-4.5,2.6l-.9-1.1Z",
    transform: "translate(0.03 0.03)"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M337,283.8c-7.5-4.9-22.5-16.5-32.2-27.7s-23.6-21.7-34.1-25.8-21.3-7.1-40.4-2.6-44.5,13.1-58,19.1l-.8,2.6s9.7-4.5,14.6-6l-1.9,4.1,2.3-.4,3.4-5.6,6.4-1.5s-3.4,3.4-4.5,6.4h1.9s3.4-6,5.6-7.9l6-1.9s1.5,3-3,7.5l1.9.8s2.6-4.1,3.4-5.6a4.47,4.47,0,0,0,0-3.4l7.5-2.6s0,3.7-3.4,7.9l1.1,1.5a36.34,36.34,0,0,0,3.4-4.5,12.74,12.74,0,0,0,1.1-5.2l6.4-1.9s1.1,3.7-3.7,7.9l1.1.7a18.44,18.44,0,0,0,4.1-4.1,9.7,9.7,0,0,0,.8-4.9,69.32,69.32,0,0,1,7.1-1.5,87.62,87.62,0,0,1-5.2,8.2l1.1,1.1s4.5-6.4,6.4-9.7l4.1-.8a7,7,0,0,1-1.9,4.5c-1.9,1.9-3.8,3.4-4.5,6.7l1.9-.4a29,29,0,0,1,3.7-4.9c2.2-2.3,3.4-4.1,3-6.4h3.4s2.6,1.5,1.1,3.4-8.6,9.7-9.7,16.5l1.5,1.1s1.9-6.4,3.7-9,5.6-6,6.4-8.6-.4-3.7-.4-3.7,4.5-.4,7.5.7c0,0-3.8,5.2-5.6,7.9a65.22,65.22,0,0,0-6,10.5l1.5-.4s4.5-7.5,6.7-10.5a84.45,84.45,0,0,1,6-6.7s3.8.8,6,1.5a62.23,62.23,0,0,0-6,7.1,67.62,67.62,0,0,0-4.9,8.6h1.5a27.92,27.92,0,0,1,4.5-7.1c3-3.4,4.9-6,7.1-7.5a12.08,12.08,0,0,1,5.3,1.5s-5.3,6.7-7.9,12.4l.8,1.1a92.93,92.93,0,0,1,9-12.7,26.58,26.58,0,0,1,5.6,3.4,33.86,33.86,0,0,0-7.9,10.5l.8,1.5s3.4-7.1,8.6-10.9a9.21,9.21,0,0,1,4.1,2.6,32.09,32.09,0,0,0-6,8.6h1.5s2.6-4.9,5.6-7.5l3,2.2s-2.6,4.1-4.9,7.9l1.9.4a50.32,50.32,0,0,1,4.9-7.1l4.9,4.1a24.62,24.62,0,0,0-5.6,6.7l1.5.4a11.67,11.67,0,0,1,5.6-5.6l2.3,2.2s-3.4,3.4-4.1,7.1l.7,1.5a26.47,26.47,0,0,1,4.5-7.1l2.6,3a20.89,20.89,0,0,0-4.1,7.9l1.9-.4a37.63,37.63,0,0,1,3.4-6,11.48,11.48,0,0,0,3.8,3,20.36,20.36,0,0,0-3.4,5.6h1.5a11.86,11.86,0,0,1,3-4.1l2.2,1.5s1.1,1.9-.8,4.5v1.9a5,5,0,0,0,2.6-3.7l3,2.3a9.81,9.81,0,0,0-1.1,4.5l1.1,1.5a14.7,14.7,0,0,1,1.1-4.1l3,1.9v2.6l2.3,1.5v-2.3s9.7,7.5,14.6,9.7l.1-1.5Z",
    transform: "translate(0.03 0.03)"
  })), _polygon18 || (_polygon18 = /*#__PURE__*/React.createElement("polygon", {
    points: "351.23 262.53 348.23 262.53 348.23 259.13 355.73 258.43 356.13 265.83 353.13 265.83 351.23 262.53"
  })), _polygon19 || (_polygon19 = /*#__PURE__*/React.createElement("polygon", {
    points: "357.63 255.43 358.73 265.83 360.23 265.83 360.23 258.03 357.63 255.43"
  })), _polygon20 || (_polygon20 = /*#__PURE__*/React.createElement("polygon", {
    points: "354.93 270.33 352.33 270.73 350.53 269.23 350.13 274.83 351.93 273.33 354.93 274.53 354.93 270.33"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M404.4,316.8c3.4,1.1,9,2.2,9,2.2l-1.5,1.1-6.7-1.9Z",
    transform: "translate(0.03 0.03)"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M416.7,320.1l1.1,2.2s7.1,0,9.7.8,2.2,2.6-2.6,3l-1.5,1.1a47.08,47.08,0,0,0,8.6-.8c3.4-.8,3.8-2.2,0-3.7S422.7,320.5,416.7,320.1Z",
    transform: "translate(0.03 0.03)"
  })), _polygon21 || (_polygon21 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "413.03 326.13 414.13 328.43 417.83 328.43 417.13 325.73 413.03 326.13"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M523.8,392s-.4,5.6-1.5,8.2l1.1.4s1.9-5.2,1.9-8.2C525.3,392,523.8,392,523.8,392Z",
    transform: "translate(0.03 0.03)"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M527.5,390.1a21.78,21.78,0,0,1-1.9,9l1.5-.8s2.6-6,2.3-7.9Z",
    transform: "translate(0.03 0.03)"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M468.7,396.5c.4,5.2-1.1,9-1.5,11.6l1.9-.4s1.9-8.2,1.5-11.2Z",
    transform: "translate(0.03 0.03)"
  })), _polygon22 || (_polygon22 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "473.23 398.73 472.93 405.13 474.43 405.13 474.73 397.23 473.23 398.73"
  })), _polygon23 || (_polygon23 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "441.83 403.63 441.43 406.63 442.53 407.73 442.93 404.43 441.83 403.63"
  })), _polygon24 || (_polygon24 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "445.93 406.23 446.33 408.13 447.43 408.83 447.43 406.23 445.93 406.23"
  })), _polygon25 || (_polygon25 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "450.43 409.23 450.03 411.13 451.23 411.53 451.53 409.23 450.43 409.23"
  })), _polygon26 || (_polygon26 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "445.93 368.43 446.33 373.33 448.23 373.73 447.83 368.43 445.93 368.43"
  })), _polygon27 || (_polygon27 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "450.43 368.43 450.03 372.53 451.53 372.53 452.33 368.43 450.43 368.43"
  })), _polygon28 || (_polygon28 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "454.53 369.53 453.83 373.33 454.93 372.93 456.03 369.53 454.53 369.53"
  })), _polygon29 || (_polygon29 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "458.33 369.23 457.53 372.93 458.63 372.53 459.43 369.23 458.33 369.23"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M465,430.2c1.5,3,2.2,6.4,2.2,11.6l1.9,3s.4-6.7-.4-9.4-1.1-5.2-3-6.4l-.7,1.2Z",
    transform: "translate(0.03 0.03)"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M457.1,441.4c2.3,3.4,3.4,5.2,3.8,9l1.5.4s-.4-7.5-3.8-10.1Z",
    transform: "translate(0.03 0.03)"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M462.8,439.2a32.65,32.65,0,0,1,1.9,9.4h1.1s0-6.7-1.5-10.1Z",
    transform: "translate(0.03 0.03)"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M445.9,445.5s.4,4.9,2.3,5.6l.4-3.4,1.9,1.5.4-1.9-1.9-3.7Z",
    transform: "translate(0.03 0.03)"
  })), _polygon30 || (_polygon30 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "454.93 442.53 453.83 443.73 454.23 447.43 455.63 450.03 456.03 448.13 454.93 442.53"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M433.9,475.1c3-3,6.4-6,6.4-6s1.1,4.9.4,7.1-1.9,6-1.9,6l-1.1-1.5a38.78,38.78,0,0,0,1.9-7.9l-4.5,4.1Z",
    transform: "translate(0.03 0.03)"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M443.3,463.5c1.9,6.4,2.2,12.7,2.2,18.7l1.9-1.5s0-6.7-.8-9.7-1.5-7.1-1.5-7.1l-1.8-.4Z",
    transform: "translate(0.03 0.03)"
  })), _polygon31 || (_polygon31 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "438.83 448.93 439.93 451.13 442.93 451.13 442.23 448.53 438.83 448.93"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M447,454.5a34.29,34.29,0,0,1,6.4,21l-1.1.8a34.29,34.29,0,0,0-6.4-21Z",
    transform: "translate(0.03 0.03)"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M454.9,453a179.37,179.37,0,0,1,1.9,23.2l-1.5.4a163.24,163.24,0,0,0-1.9-23.2Z",
    transform: "translate(0.03 0.03)"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M459.4,457.9c.4,6,.8,12.4.4,17.2l1.5-3.7-.4-13.1Z",
    transform: "translate(0.03 0.03)"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M465,464.2a28.56,28.56,0,0,0-1.9,10.5,11.78,11.78,0,0,1,5.2-.8c2.6.4,5.2.4,7.5,1.5l-1.1-3.4a7,7,0,0,0-4.5-1.1l.8-2.6s-4.1,1.5-5.2,3.4a13.85,13.85,0,0,1,1.1-7.9Z",
    transform: "translate(0.03 0.03)"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M476.6,463.1s3.4,6.4,8.6,7.1l3.8-1.5-9.7-6.7Z",
    transform: "translate(0.03 0.03)"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M479.6,474l1.9,2.6,4.5,1.5s.4-3.4-1.9-4.1A7.5,7.5,0,0,0,479.6,474Z",
    transform: "translate(0.03 0.03)"
  })), _polygon32 || (_polygon32 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "487.83 475.53 489.03 478.83 490.83 479.23 490.13 476.23 487.83 475.53"
  })), _polygon33 || (_polygon33 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "474.03 489.33 473.63 496.13 475.13 494.63 475.53 488.63 474.03 489.33"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M478.5,500.9a96.91,96.91,0,0,0,2.3-13.8h-1.5a81.14,81.14,0,0,1-2.3,13.8Z",
    transform: "translate(0.03 0.03)"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M484.1,485.6c-.4,6-2.2,12.4-3.7,17.2l1.5-.8a54.4,54.4,0,0,0,3.4-15Z",
    transform: "translate(0.03 0.03)"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M490.5,486c-1.1,9.4-4.5,18-8.2,25.8h2.2s5.2-12,6.4-17.6l.8-6Z",
    transform: "translate(0.03 0.03)"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M496.1,485.2a46.3,46.3,0,0,0-3,13.1,15.43,15.43,0,0,1-3,7.5l1.1,1.5s3.4-5.6,3.7-9.4,1.1-9,2.3-11.2Z",
    transform: "translate(0.03 0.03)"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M499.1,492.7c-1.1,3.4-.8,5.2-1.5,6.7a21.88,21.88,0,0,1-2.6,3.7l.8,2.6s3-3.4,3.4-6,1.1-6.4,1.1-6.4Z",
    transform: "translate(0.03 0.03)"
  })), _polygon34 || (_polygon34 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "503.23 497.93 501.33 503.63 502.43 505.43 504.33 499.83 503.23 497.93"
  })), _polygon35 || (_polygon35 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "509.23 499.83 508.83 503.23 511.43 503.93 511.43 500.23 509.23 499.83"
  })), _polygon36 || (_polygon36 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "518.53 501.73 523.03 503.93 520.83 504.73 518.23 503.63 518.53 501.73"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M477,523.4l2.3,1.1s6-1.1,9.7-4.1l-2.6-.4A29.25,29.25,0,0,1,477,523.4Z",
    transform: "translate(0.03 0.03)"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M492.7,511.8a85.06,85.06,0,0,1-3,11.6l1.5-.8s2.6-7.5,3.4-10.9l-1.9.1Z",
    transform: "translate(0.03 0.03)"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M497.9,509.9a55.37,55.37,0,0,1-3,10.9l2.6-1.9a29.94,29.94,0,0,0,1.9-9Z",
    transform: "translate(0.03 0.03)"
  })), _polygon37 || (_polygon37 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "502.43 511.03 499.83 521.93 502.13 519.33 503.93 509.93 502.43 511.03"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M372.9,489.3c.4,6.4.4,12-1.9,19.1l1.1,1.1a40.37,40.37,0,0,0,2.3-9.7,37.33,37.33,0,0,0-.4-9Z",
    transform: "translate(0.03 0.03)"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M377.4,491.2c0,5.6-.8,13.9-2.3,18l.8,1.9a40.37,40.37,0,0,0,2.3-9.7c.4-4.9.7-9,.7-9Z",
    transform: "translate(0.03 0.03)"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M383.8,499.1s-4.1,7.9-4.5,12l4.9-.8.4-6.7,1.5-4.9-2.3.4Z",
    transform: "translate(0.03 0.03)"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M388.3,505.1a42.63,42.63,0,0,0-2.2,9l1.5.8a10.5,10.5,0,0,1,1.5-5.2l-.8-4.6Z",
    transform: "translate(0.03 0.03)"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M392.4,509.2a19.06,19.06,0,0,0-1.9,6l1.5,1.1,1.1-4.1-.7-3Z",
    transform: "translate(0.03 0.03)"
  })), _polygon38 || (_polygon38 = /*#__PURE__*/React.createElement("polygon", {
    points: "394.33 517.03 396.93 517.83 395.73 512.23 394.33 517.03"
  })), _polygon39 || (_polygon39 = /*#__PURE__*/React.createElement("polygon", {
    points: "399.13 513.33 401.03 518.13 402.53 518.13 400.63 512.93 399.13 513.33"
  })), _polygon40 || (_polygon40 = /*#__PURE__*/React.createElement("polygon", {
    points: "319.43 495.73 317.53 502.13 319.03 502.83 321.63 495.33 319.43 495.73"
  })), _polygon41 || (_polygon41 = /*#__PURE__*/React.createElement("polygon", {
    points: "315.33 494.93 313.43 501.33 314.93 501.73 317.13 495.33 315.33 494.93"
  })), _polygon42 || (_polygon42 = /*#__PURE__*/React.createElement("polygon", {
    points: "304.43 488.23 304.43 499.83 305.93 498.33 306.33 487.53 304.43 488.23"
  })), _polygon43 || (_polygon43 = /*#__PURE__*/React.createElement("polygon", {
    points: "309.33 487.53 308.23 494.63 310.03 493.13 311.13 486.73 309.33 487.53"
  })), _polygon44 || (_polygon44 = /*#__PURE__*/React.createElement("polygon", {
    points: "301.83 488.63 301.43 498.33 302.23 499.83 302.93 488.63 301.83 488.63"
  })), _polygon45 || (_polygon45 = /*#__PURE__*/React.createElement("polygon", {
    points: "295.03 484.83 295.03 497.63 297.33 497.93 296.93 486.73 295.03 484.83"
  })), _polygon46 || (_polygon46 = /*#__PURE__*/React.createElement("polygon", {
    points: "290.63 483.03 290.23 494.93 291.73 494.93 291.73 484.13 290.63 483.03"
  })), _polygon47 || (_polygon47 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "461.63 368.83 461.63 373.13 462.83 372.73 462.83 368.83 461.63 368.83"
  })), _polygon48 || (_polygon48 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "464.83 369.23 464.83 373.53 465.93 373.13 465.93 369.23 464.83 369.23"
  })), _polygon49 || (_polygon49 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "468.93 368.23 468.93 372.53 470.13 372.23 470.13 368.23 468.93 368.23"
  })), _polygon50 || (_polygon50 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "474.23 368.43 473.83 371.03 474.93 370.73 475.33 368.43 474.23 368.43"
  })), _polygon51 || (_polygon51 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "415.83 400.03 415.83 404.43 416.93 404.03 416.93 400.03 415.83 400.03"
  })), _polygon52 || (_polygon52 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "420.33 403.83 420.53 407.03 421.63 406.63 421.43 403.83 420.33 403.83"
  })), _polygon53 || (_polygon53 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "425.33 404.73 425.53 407.93 426.63 407.53 426.53 404.73 425.33 404.73"
  })), _polygon54 || (_polygon54 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "429.63 404.53 429.63 406.63 430.73 406.23 430.73 404.53 429.63 404.53"
  })), _polygon55 || (_polygon55 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "412.63 403.23 412.63 407.53 413.73 407.23 413.73 403.23 412.63 403.23"
  })), _polygon56 || (_polygon56 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "409.83 404.73 409.83 409.03 410.93 408.73 410.93 404.73 409.83 404.73"
  })), _polygon57 || (_polygon57 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "404.73 405.13 404.73 409.43 405.93 409.03 405.93 405.13 404.73 405.13"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M98.5,341.1h14.2l9.4,2.2-.8,1.5-5.2-.8-4.1,7.1,1.5,1.1,5.6-5.6h9l-6.4-6.7,1.5-.8,10.9,8.6-2.2,1.5-.4,2.2-3.7.8-.4,2.3-3-1.1a63.25,63.25,0,0,1-6.7,10.1l-.4-2.6a33.26,33.26,0,0,0,4.9-8.2l-1.5-1.5s-3,6.4-6,9l-.8-1.9,4.1-4.9h-2.6l-1.5,2.3a30.08,30.08,0,0,0-6.7-3c-3.7-1.1-4.5,0-4.5,0l-.8,2.3s7.1,1.1,9.7,2.2l.4,1.1s-6.8-1.5-9.7-1.5v3s6,0,9,1.9l.8,3,3.7.4-.4,1.9s-6.4,8.2-7.5,11.2l-.4,3-4.5,9.4,7.5-10.1.4-3.7,14.2-20.6,1.9.4-8.6,12.7,10.5.8.4,2.6s-8.6-1.5-12-1.5l-4.5,6.7-.4,4.5L100,396.9s-1.9-16.5-2.3-28.5.8-27.3.8-27.3Z",
    transform: "translate(0.03 0.03)"
  })), _polygon58 || (_polygon58 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "115.03 380.43 109.03 389.43 111.63 389.03 116.53 380.83 115.03 380.43"
  })), _polygon59 || (_polygon59 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "121.43 383.03 118.43 387.93 121.03 387.13 124.73 382.33 127.03 383.03 124.73 386.43 126.23 387.53 129.23 382.33 124.73 378.93 116.53 378.13 119.13 380.83 113.93 387.93 115.43 389.03 120.63 380.83 121.43 383.03"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M119.1,374l6,.4s3,2.3,5.6,2.6l1.1-4.5,2.2.8a48.41,48.41,0,0,0,8.2-13.9l1.1,1.9a20.91,20.91,0,0,0-2.6,9l-1.9,3-1.9.4-2.3,2.2-1.5,4.5-2.2-.4a26.67,26.67,0,0,0-6.7-3.4,43.2,43.2,0,0,0-6-1.1l.9-1.5Z",
    transform: "translate(0.03 0.03)"
  })), _polygon60 || (_polygon60 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "129.23 362.03 131.13 362.03 128.53 366.53 128.53 368.43 130.03 369.23 130.73 366.23 134.53 359.83 128.13 360.23 123.63 365.43 124.03 367.33 125.53 367.33 129.23 362.03"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M138.2,356.1l.4,2.6-4.9,8.6.8,1.5,6.7-12S138.6,356.1,138.2,356.1Z",
    transform: "translate(0.03 0.03)"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M141.6,351.9c-.4,0-1.9,1.9-1.9,1.9l2.6.8,1.5-1.5Z",
    transform: "translate(0.03 0.03)"
  })), _polygon61 || (_polygon61 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "143.13 349.73 145.33 350.43 149.13 347.13 146.83 346.73 143.13 349.73"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M124.7,337.3a16.33,16.33,0,0,0,2.3.7c.4,0,1.9-1.9,1.9-1.9l-2.6-.8Z",
    transform: "translate(0.03 0.03)"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M128.1,334l2.6.8,4.5-6-.4-12,5.6-4.9s1.1,4.1,3.4,4.9,7.5-.8,10.9-2.6a24,24,0,0,1,5.3-1.9l-.4,21.3-2.3,1.5,3,1.9,1.5-4.5,1.9.4V311.2s4.9-.8,6.8.4,6.4,3.7,9.4,4.1,4.1-1.1,4.5-4.5-2.3-6.4-5.2-8.2l2.6-4.1-.4-3s2.6-3.4,2.6-6.4-2.3-4.9-6.4-6c0,0,1.9-1.5,1.9-3s-2.3-3-2.3-3,3.4-6,3.4-10.1-4.1-6.7-7.1-7.5a5.34,5.34,0,0,0,2.3-4.1,3.57,3.57,0,0,0-1.9-3.4s3-3.4,1.1-4.9-4.1-3-7.1-3c0,0,.8-6-2.3-7.9a7.91,7.91,0,0,0-8.6-.4s-3.7-1.5-5.6-.7-2.6,5.2-1.1,7.9c0,0-6.4-.8-6.7,3s.8,5.6,2.6,6.7a36.48,36.48,0,0,0-6.7,4.9l-5.2-3.4-3,1.9a16.58,16.58,0,0,0-10.1-3s-8.6,21-12,31.8-6.4,26.2-6.4,26.2,4.1,6.4,7.5,7.1,7.1-1.1,7.1-1.1a15.78,15.78,0,0,0,6.4,1.9c3,0,6-2.2,6-2.2s1.9.7,2.3,5.2a32.63,32.63,0,0,1,0,7.1l-4,4.5Z",
    transform: "translate(0.03 0.03)"
  })), _polygon62 || (_polygon62 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "155.83 337.03 159.23 338.53 157.33 339.63 154.33 338.53 155.83 337.03"
  })), _polygon63 || (_polygon63 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "152.43 339.63 155.43 341.53 151.33 344.53 149.13 344.13 152.43 339.63"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M147.2,359.4s-4.1,4.5-4.9,9.4l2.3.4s1.1-3,3-7.9Z",
    transform: "translate(0.03 0.03)"
  })), _polygon64 || (_polygon64 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "152.83 358.73 148.73 366.53 150.63 366.53 152.83 360.93 152.83 358.73"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M145.3,391.2c3-1.9,5.2-2.6,7.1-1.5v1.9s-4.5-.4-6.4.8l-.7-1.2Z",
    transform: "translate(0.03 0.03)"
  })), _polygon65 || (_polygon65 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "155.03 383.43 155.43 391.23 156.93 391.23 156.93 384.13 155.03 383.43"
  })), _polygon66 || (_polygon66 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "159.23 383.43 159.23 390.53 161.03 389.73 160.73 381.53 159.23 383.43"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M163.3,383.4l-.4,5.6s1.9-1.9,4.1-1.1,3,.7,4.9,2.6l-.4-2.6s-3.4-3.4-6.4-2.6v-3.7Z",
    transform: "translate(0.03 0.03)"
  })), _polygon67 || (_polygon67 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "177.93 390.13 177.53 392.73 180.13 394.63 180.53 392.43 177.93 390.13"
  })), _polygon68 || (_polygon68 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "241.13 348.23 241.13 352.73 239.63 353.13 239.63 348.63 241.13 348.23"
  })), _polygon69 || (_polygon69 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "243.83 345.23 243.83 351.63 245.33 350.83 245.33 346.73 243.83 345.23"
  })), _polygon70 || (_polygon70 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "249.43 343.03 249.03 349.73 250.93 348.93 250.93 342.23 249.43 343.03"
  })), _polygon71 || (_polygon71 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "253.13 345.63 253.13 349.33 254.23 348.23 254.23 344.53 253.13 345.63"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M256.5,345.2l-.4,3s1.9-.4,1.5-.4,0-3.7,0-3.7Z",
    transform: "translate(0.03 0.03)"
  })), _polygon72 || (_polygon72 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "261.23 344.63 261.23 346.73 262.33 346.33 262.33 344.63 261.23 344.63"
  })), _polygon73 || (_polygon73 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "269.43 345.03 269.43 347.13 270.53 346.73 270.53 345.03 269.43 345.03"
  })), _polygon74 || (_polygon74 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "418.43 364.53 418.43 368.83 419.53 368.43 419.53 364.53 418.43 364.53"
  })), _polygon75 || (_polygon75 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "414.73 363.03 414.73 367.33 415.83 366.93 415.83 363.03 414.73 363.03"
  })), _polygon76 || (_polygon76 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "411.33 363.73 411.33 368.03 412.43 367.73 412.43 363.73 411.33 363.73"
  })), _polygon77 || (_polygon77 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "407.53 364.13 407.53 368.43 408.73 368.03 408.73 364.13 407.53 364.13"
  })), _polygon78 || (_polygon78 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "404.23 362.23 404.23 370.33 405.33 369.93 405.33 362.23 404.23 362.23"
  })), _polygon79 || (_polygon79 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "398.93 368.03 398.63 370.73 399.73 370.33 400.13 368.03 398.93 368.03"
  })), _polygon80 || (_polygon80 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "379.83 383.23 379.83 387.53 381.03 387.13 381.03 383.23 379.83 383.23"
  })), _polygon81 || (_polygon81 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "383.63 381.33 383.63 387.93 384.73 387.53 384.73 381.33 383.63 381.33"
  })), _polygon82 || (_polygon82 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "388.83 379.83 388.83 386.43 390.03 386.03 390.03 379.83 388.83 379.83"
  })), _polygon83 || (_polygon83 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "392.63 381.33 392.63 386.03 393.73 385.63 393.73 381.33 392.63 381.33"
  })), _polygon84 || (_polygon84 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "407.53 381.73 407.53 386.43 408.73 386.03 408.73 381.73 407.53 381.73"
  })), _polygon85 || (_polygon85 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "411.33 379.83 411.33 384.53 412.43 384.13 412.43 379.83 411.33 379.83"
  })), _polygon86 || (_polygon86 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "415.03 379.83 415.03 384.53 416.23 384.13 416.23 379.83 415.03 379.83"
  })), _polygon87 || (_polygon87 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "419.93 381.73 419.93 384.93 421.03 384.53 421.03 381.73 419.93 381.73"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M422.3,368.8a35.84,35.84,0,0,0,10.5,5.6l-1.5-1.9s-7.1-4.1-9.4-6.4Z",
    transform: "translate(0.03 0.03)"
  })), _polygon88 || (_polygon88 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "107.53 322.43 129.63 322.43 127.03 324.63 106.43 324.63 107.53 322.43"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 138.23,
    y: 321.23,
    width: 17.2,
    height: 1.5
  })), _polygon89 || (_polygon89 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "172.63 320.53 170.83 319.03 197.43 319.03 194.43 320.13 179.03 320.93 172.63 320.53"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M201.5,318.6l-2.2,1.9h33.3c-.4,0,.8,1.1.8,1.1l10.1-.4-4.5-2.6Z",
    transform: "translate(0.03 0.03)"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M267.7,319.7c.4.4,8.6.4,8.6.4l7.5,1.9-.8,1.1s-6.8-.8-10.5-1.1Z",
    transform: "translate(0.03 0.03)"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M297.3,320.1h41.2s1.9,1.5,1.5,1.5H299.6Z",
    transform: "translate(0.03 0.03)"
  })), _polygon90 || (_polygon90 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "200.03 253.93 200.03 256.93 198.53 257.23 198.53 254.23 200.03 253.93"
  })), _polygon91 || (_polygon91 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "205.63 252.43 205.63 255.43 204.13 255.73 204.13 252.73 205.63 252.43"
  })), _polygon92 || (_polygon92 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "212.33 251.63 212.33 254.63 210.83 255.03 210.83 252.03 212.33 251.63"
  })), _polygon93 || (_polygon93 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "218.73 250.13 218.73 253.13 217.23 253.53 217.23 250.53 218.73 250.13"
  })), _polygon94 || (_polygon94 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "225.43 250.13 225.43 253.13 223.93 253.53 223.93 250.53 225.43 250.13"
  })), _polygon95 || (_polygon95 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "232.53 248.23 232.53 251.23 231.03 251.63 231.03 248.63 232.53 248.23"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M116.9,292.8c-.4,0-6.4,3.4-6.4,3.4v4.9l1.9,1.5a14.94,14.94,0,0,0-3,5.6l.8,1.1a53.84,53.84,0,0,1,4.5-6.4H117s-4.5,7.1-6.4,10.9l.8,2.3s5.2-9,7.5-12l2.3,2.6a17.51,17.51,0,0,0,6.4,3.4l2.6-4.5-1.5-4.5s-4.1,0-5.6,2.6l-.7-1.1,1.5-6,1.5,2.3,1.9-.4,1.1-2.6H134l-1.1-1.9-3.7-1.1-.4-5.6-2.3.8-1.9,1.9s-4.1,2.6-4.5,5.6a33.28,33.28,0,0,0,0,6.7l-2.6-2.2-.6-7.3Z",
    transform: "translate(0.03 0.03)"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M116.9,292.8c-.4,0-6.4,3.4-6.4,3.4v4.9l1.9,1.5a14.94,14.94,0,0,0-3,5.6l.8,1.1a53.84,53.84,0,0,1,4.5-6.4H117s-4.5,7.1-6.4,10.9l.8,2.3s5.2-9,7.5-12l2.3,2.6a17.51,17.51,0,0,0,6.4,3.4l2.6-4.5-1.5-4.5s-4.1,0-5.6,2.6l-.8-1.1,1.5-6,1.5,2.3,1.9-.4,1.1-2.6h5.6l-1.1-1.9-3.7-1.1-.4-5.6-2.3.8-1.9,1.9s-4.1,2.6-4.5,5.6a33.28,33.28,0,0,0,0,6.7l-2.6-2.2-.5-7.3Z",
    transform: "translate(0.03 0.03)"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M133.3,299.5l.8,10.5,2.3-.4-3,2.6v2.6s6.4-3.7,7.9-6,1.9-6.4,1.9-6.4l-2.2.4-.8,3.7h-2.3s1.9-2.6,1.5-4.9-3.1-2.4-6.1-2.1Z",
    transform: "translate(0.03 0.03)"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M133.3,299.5l.8,10.5,2.3-.4-3,2.6v2.6s6.4-3.7,7.9-6,1.9-6.4,1.9-6.4l-2.2.4-.8,3.7h-2.3s1.9-2.6,1.5-4.9-3.1-2.4-6.1-2.1Z",
    transform: "translate(0.03 0.03)"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M138.6,292v4.1s1.9,1.9,1.9,1.5.4-5.2.4-5.2S138.9,292,138.6,292Z",
    transform: "translate(0.03 0.03)"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M138.6,292v4.1s1.9,1.9,1.9,1.5.4-5.2.4-5.2S138.9,292,138.6,292Z",
    transform: "translate(0.03 0.03)"
  })), _polygon96 || (_polygon96 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "144.23 298.43 144.63 287.93 142.73 288.73 142.33 299.23 144.63 302.93 146.83 302.23 144.23 298.43"
  })), _polygon97 || (_polygon97 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "144.23 298.43 144.63 287.93 142.73 288.73 142.33 299.23 144.63 302.93 146.83 302.23 144.23 298.43"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M142.3,279.7v4.1l1.5,3h1.5l.7,10.5,2.3,3.7-1.1,3.4v3l4.5-6.4,1.9.8-6,10.5.8,2.2,8.2-13.5.8,1.5-4.1,7.5h2.2l4.5-7.5-.4-3s0-4.1-2.6-6.4l-.8-4.1-1.5-2.3v8.6l-2.6-1.1.4-9.4s-2.6-3.7-4.9-4.9c-2.3-1-4.9-.2-5.3-.2Z",
    transform: "translate(0.03 0.03)"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M142.3,279.7v4.1l1.5,3h1.5l.7,10.5,2.3,3.7-1.1,3.4v3l4.5-6.4,1.9.8-6,10.5.8,2.2,8.2-13.5.8,1.5-4.1,7.5h2.2l4.5-7.5-.4-3s0-4.1-2.6-6.4l-.8-4.1-1.5-2.3v8.6l-2.6-1.1.4-9.4s-2.6-3.7-4.9-4.9c-2.3-1-4.9-.2-5.3-.2Z",
    transform: "translate(0.03 0.03)"
  })), _polygon98 || (_polygon98 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "150.93 279.73 156.23 285.33 157.33 283.13 154.73 279.73 150.93 279.73"
  })), _polygon99 || (_polygon99 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "150.93 279.73 156.23 285.33 157.33 283.13 154.73 279.73 150.93 279.73"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M144.6,277.8h2.2s6.4-3.4,10.9-4.1l-1.1-2.6s-3.4,1.5-6.4,3A32.26,32.26,0,0,0,144.6,277.8Z",
    transform: "translate(0.03 0.03)"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M144.6,277.8h2.2s6.4-3.4,10.9-4.1l-1.1-2.6s-3.4,1.5-6.4,3A32.26,32.26,0,0,0,144.6,277.8Z",
    transform: "translate(0.03 0.03)"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M158.4,266.6s1.5,8.2,1.5,11.6c0,0,8.2-2.3,11.6-2.3l-1.9-1.9-7.1,1.5-.4-1.5,3.4-.8-.8-8.6-2.6.4,1.1,7.5h-1.9l-1.1-6.7-1.8.8Z",
    transform: "translate(0.03 0.03)"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M158.4,266.6s1.5,8.2,1.5,11.6c0,0,8.2-2.3,11.6-2.3l-1.9-1.9-7.1,1.5-.4-1.5,3.4-.8-.8-8.6-2.6.4,1.1,7.5h-1.9l-1.1-6.7-1.8.8Z",
    transform: "translate(0.03 0.03)"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M158.8,293.2v-6.7l2.3-2.2.7-3.4s1.1-.4,3.4-1.1a45.49,45.49,0,0,0,4.9-1.9l-.4,16.8-2.6-.7-.4-7.1-1.9,1.5v8.2s-3,1.1-2.6.8.4-11.2.4-11.2l-1.5,1.5v4.9l-2.3.6Z",
    transform: "translate(0.03 0.03)"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M158.8,293.2v-6.7l2.3-2.2.7-3.4s1.1-.4,3.4-1.1a45.49,45.49,0,0,0,4.9-1.9l-.4,16.8-2.6-.7-.4-7.1-1.9,1.5v8.2s-3,1.1-2.6.8.4-11.2.4-11.2l-1.5,1.5v4.9l-2.3.6Z",
    transform: "translate(0.03 0.03)"
  })), _polygon100 || (_polygon100 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "171.93 278.63 171.53 293.53 173.43 292.43 174.53 278.63 171.93 278.63"
  })), _polygon101 || (_polygon101 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "171.93 278.63 171.53 293.53 173.43 292.43 174.53 278.63 171.93 278.63"
  })), _polygon102 || (_polygon102 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "176.03 286.83 175.33 294.33 177.53 293.53 178.33 286.13 176.03 286.83"
  })), _polygon103 || (_polygon103 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "176.03 286.83 175.33 294.33 177.53 293.53 178.33 286.13 176.03 286.83"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M162.1,301.4a11.45,11.45,0,0,1,8.6-3.7h8.6s-2.3,4.1-4.9,5.2l-.4,2.2,2.6,2.6,3.4-1.5.7,2.6-4.1,3.7a10.74,10.74,0,0,0-3.8-3.4,10.49,10.49,0,0,0-5.2-.7l.8-1.5,3.4-.4-1.1-1.9a10.5,10.5,0,0,0-5.2,1.5c-2.2,1.5-4.1,3.4-6.7,3.4l1.1-2.2a7.55,7.55,0,0,0,3.4-1.9Z",
    transform: "translate(0.03 0.03)"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M162.1,301.4a11.45,11.45,0,0,1,8.6-3.7h8.6s-2.3,4.1-4.9,5.2l-.4,2.2,2.6,2.6,3.4-1.5.7,2.6-4.1,3.7a10.74,10.74,0,0,0-3.8-3.4,10.49,10.49,0,0,0-5.2-.7l.8-1.5,3.4-.4-1.1-1.9a10.5,10.5,0,0,0-5.2,1.5c-2.2,1.5-4.1,3.4-6.7,3.4l1.1-2.2a7.55,7.55,0,0,0,3.4-1.9Z",
    transform: "translate(0.03 0.03)"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M142.3,273.3a33.17,33.17,0,0,1,10.5-5.2l1.5,1.5s-6,3.4-8.6,4.9Z",
    transform: "translate(0.03 0.03)"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M142.3,273.3a33.17,33.17,0,0,1,10.5-5.2l1.5,1.5s-6,3.4-8.6,4.9Z",
    transform: "translate(0.03 0.03)"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M171.9,262.8v9.4l3-2.6v-4.9Z",
    transform: "translate(0.03 0.03)"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M171.9,262.8v9.4l3-2.6v-4.9Z",
    transform: "translate(0.03 0.03)"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M170.4,248.6c-.4,4.9-.4,18.7-.4,22.1l-1.5,1.5-1.5-7.1a5.79,5.79,0,0,0-3.8-1.5c-2.2,0-4.5,1.5-6.4,2.6,0,0-5.2.4-8.2,2.2a64.66,64.66,0,0,1-7.9,3.7l-1.9-1.9s8.6-4.9,12-6,6.4-1.1,8.6-1.9,5.2-1.5,6.7-3,1.9-9.7,1.5-12.4l2.8,1.7Z",
    transform: "translate(0.03 0.03)"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M170.4,248.6c-.4,4.9-.4,18.7-.4,22.1l-1.5,1.5-1.5-7.1a5.79,5.79,0,0,0-3.8-1.5c-2.2,0-4.5,1.5-6.4,2.6,0,0-5.2.4-8.2,2.2a64.66,64.66,0,0,1-7.9,3.7l-1.9-1.9s8.6-4.9,12-6,6.4-1.1,8.6-1.9,5.2-1.5,6.7-3,1.9-9.7,1.5-12.4l2.8,1.7Z",
    transform: "translate(0.03 0.03)"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M130.5,270.1c-2.6.7-6.4,1.5-6.4,1.5a96.54,96.54,0,0,1-.3-12.7l-3.9,1.2.4,18.5-3-1.9-.8,3.4-2.6,4.5a61.78,61.78,0,0,0,8.2-1.1c2.6-.7,6.4-1.1,6.4-3s-3-2.3-4.9-2.3l-.8-1.9a47.65,47.65,0,0,0,6-.4,12.18,12.18,0,0,0,4.9-2.2Z",
    transform: "translate(0.03 0.03)"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M130.5,270.1c-2.6.7-6.4,1.5-6.4,1.5a96.54,96.54,0,0,1-.3-12.7l-3.9,1.2.4,18.5-3-1.9-.8,3.4-2.6,4.5a61.78,61.78,0,0,0,8.2-1.1c2.6-.7,6.4-1.1,6.4-3s-3-2.3-4.9-2.3l-.7-1.9a47.65,47.65,0,0,0,6-.4,12.18,12.18,0,0,0,4.9-2.2Z",
    transform: "translate(0.03 0.03)"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M159.5,238.5a53.13,53.13,0,0,1,1.1,8.2l-1.9.8s-.4-6.4-1.9-9c0,0-3-1.1-2.6,3s1.1,6.4,2.3,8.2l-2.3-.4s0-5.2-2.2-4.9-2.2,3.4-.7,5.2a8.56,8.56,0,0,0,3.7,2.6l.4,8.6s5.3-.4,6.4-1.9,1.5-10.5,1.5-10.5l1.5-.8-.4,10.9,1.9-2.3.8-12-3,.8s1.1-5.2-.4-6.7c-1.6-1.3-4.2.2-4.2.2Z",
    transform: "translate(0.03 0.03)"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M159.5,238.5a53.13,53.13,0,0,1,1.1,8.2l-1.9.8s-.4-6.4-1.9-9c0,0-3-1.1-2.6,3s1.1,6.4,2.3,8.2l-2.3-.4s0-5.2-2.2-4.9-2.2,3.4-.7,5.2a8.56,8.56,0,0,0,3.7,2.6l.4,8.6s5.3-.4,6.4-1.9,1.5-10.5,1.5-10.5l1.5-.8-.4,10.9,1.9-2.3.8-12-3,.8s1.1-5.2-.4-6.7c-1.6-1.3-4.2.2-4.2.2Z",
    transform: "translate(0.03 0.03)"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M148.7,246c0,3,1.1,6.7,3.4,7.9a19.27,19.27,0,0,1,1.5,6.7l-3.4,2.2s-1.1-4.9-.4-7.5c0,0-1.5-5.2-3-7.1l-.4,2.3-1.5-1.1L146,246Z",
    transform: "translate(0.03 0.03)"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M148.7,246c0,3,1.1,6.7,3.4,7.9a19.27,19.27,0,0,1,1.5,6.7l-3.4,2.2s-1.1-4.9-.4-7.5c0,0-1.5-5.2-3-7.1l-.4,2.3-1.5-1.1L146,246Z",
    transform: "translate(0.03 0.03)"
  })), _polygon104 || (_polygon104 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "145.33 256.33 145.73 265.13 148.33 264.33 147.53 254.53 145.33 256.33"
  })), _polygon105 || (_polygon105 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "145.33 256.33 145.73 265.13 148.33 264.33 147.53 254.53 145.33 256.33"
  })), _polygon106 || (_polygon106 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "140.83 268.13 144.63 266.23 144.63 255.93 141.93 257.83 140.83 262.53 142.33 263.63 141.23 266.23 140.83 268.13"
  })), _polygon107 || (_polygon107 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "140.83 268.13 144.63 266.23 144.63 255.93 141.93 257.83 140.83 262.53 142.33 263.63 141.23 266.23 140.83 268.13"
  })), _polygon108 || (_polygon108 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "139.43 260.13 132.13 269.63 133.73 271.53 138.63 265.83 139.43 260.13"
  })), _polygon109 || (_polygon109 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "139.43 260.13 132.13 269.63 133.73 271.53 138.63 265.83 139.43 260.13"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M125.8,259.5v6.4l4.1,1.9a41.91,41.91,0,0,1,7.1-7.9l-2.6-1.5-3,1.1Z",
    transform: "translate(0.03 0.03)"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M125.8,259.5v6.4l4.1,1.9a41.91,41.91,0,0,1,7.1-7.9l-2.6-1.5-3,1.1Z",
    transform: "translate(0.03 0.03)"
  })), _polygon110 || (_polygon110 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "137.53 271.53 134.13 276.73 133.73 280.43 137.83 274.83 137.53 271.53"
  })), _polygon111 || (_polygon111 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "137.53 271.53 134.13 276.73 133.73 280.43 137.83 274.83 137.53 271.53"
  })), _polygon112 || (_polygon112 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "139.73 275.63 134.83 281.93 134.53 284.93 140.13 278.93 139.73 275.63"
  })), _polygon113 || (_polygon113 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "139.73 275.63 134.83 281.93 134.53 284.93 140.13 278.93 139.73 275.63"
  })), _polygon114 || (_polygon114 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "140.13 283.13 135.63 287.63 135.63 289.43 140.83 286.13 140.13 283.13"
  })), _polygon115 || (_polygon115 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "140.13 283.13 135.63 287.63 135.63 289.43 140.83 286.13 140.13 283.13"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M113.9,286.1a24.51,24.51,0,0,0,10.5-1.1l-.4,1.9a9.69,9.69,0,0,1-4.9,1.5,9.81,9.81,0,0,1-4.5-1.1Z",
    transform: "translate(0.03 0.03)"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M113.9,286.1a24.51,24.51,0,0,0,10.5-1.1l-.4,1.9a9.69,9.69,0,0,1-4.9,1.5,9.81,9.81,0,0,1-4.5-1.1Z",
    transform: "translate(0.03 0.03)"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M119.5,311.9a11.1,11.1,0,0,1,6.7.8,9.93,9.93,0,0,1,3,3l-2.6.8s-1.5-2.6-3.4-3a24.53,24.53,0,0,0-5.6,0Z",
    transform: "translate(0.03 0.03)"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M119.5,311.9a11.1,11.1,0,0,1,6.7.8,9.93,9.93,0,0,1,3,3l-2.6.8s-1.5-2.6-3.4-3a24.53,24.53,0,0,0-5.6,0l1.9-1.6Z",
    transform: "translate(0.03 0.03)"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M109.4,366.9l3.4.4a65.79,65.79,0,0,0-4.9,6.7,40.72,40.72,0,0,0-3.4,8.2l-2.6,1.1s.4-6,3-9.4A43.77,43.77,0,0,0,109.4,366.9Z",
    transform: "translate(0.03 0.03)"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M109.4,366.9l3.4.4a65.79,65.79,0,0,0-4.9,6.7,40.72,40.72,0,0,0-3.4,8.2l-2.6,1.1s.4-6,3-9.4A43.77,43.77,0,0,0,109.4,366.9Z",
    transform: "translate(0.03 0.03)"
  })), _polygon116 || (_polygon116 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "105.63 366.93 100.83 372.93 103.43 373.33 106.43 368.83 105.63 366.93"
  })), _polygon117 || (_polygon117 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "105.63 366.93 100.83 372.93 103.43 373.33 106.43 368.83 105.63 366.93"
  })), _polygon118 || (_polygon118 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "101.93 363.23 101.13 365.43 107.93 365.43 106.43 363.23 101.93 363.23"
  })), _polygon119 || (_polygon119 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "101.93 363.23 101.13 365.43 107.93 365.43 106.43 363.23 101.93 363.23"
  })), _polygon120 || (_polygon120 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "101.93 348.23 109.43 351.23 112.73 347.43 104.53 346.73 101.93 348.23"
  })), _polygon121 || (_polygon121 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "101.93 348.23 109.43 351.23 112.73 347.43 104.53 346.73 101.93 348.23"
  })), _polygon122 || (_polygon122 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "191.43 194.73 234.43 207.43 233.33 208.63 192.13 197.03 191.43 194.73"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M405.9,273.7c10.9,7.9,21,13.5,31.1,16.8a63,63,0,0,1,15,6.7l-3.4.8a130,130,0,0,0-12.7-5.6c-5.3-1.9-21.7-8.6-31.8-18.3Z",
    transform: "translate(0.03 0.03)"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M357.9,295.8c-5.6-3-14.2-7.9-14.2-7.9l-3.7-.4s10.9,7.1,15,9.4l2.9-1.1Z",
    transform: "translate(0.03 0.03)"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M534.8,165s-16.6-15.8-50.2-33.2S424.7,112,424.7,112l-10.5,45.3-32.4,12.1.8,13-6.1,4-2.4-.4-4,13.8-6.5-1.6,1.2,3.6,4.5,2.8v29.1l-3.6,5.7,4,11.7-1.6,19.4,8.5,3.2,32.4-7.3,2.8-10.5,5.3-2,5.3,2.4,7.7,4.5,6.1-.8,4-.4,1.2-3.6,28.7,8.1,4.4,3.6,6.9-4,.4-3.2s14.3-6.6,23.1-10.1c19-7.7,29.9-8.5,29.9-8.5V200.2l3.6-3.6h13.4V184l-17-19Z",
    transform: "translate(0.03 0.03)"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M522.6,253.1a22.88,22.88,0,0,0-7.5,1.5l.8,1.5,2.6-.4,2.6,4.9h2.2Z",
    transform: "translate(0.03 0.03)"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M523.4,248.6c-4.5.4-7.1,1.9-10.5,3.4l2.6.7s6.4-2.2,9-2.2Z",
    transform: "translate(0.03 0.03)"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M438.8,170.4l-4.5,4.1,3.4,1.5-2.2,3,1.9,1.1,5.2-5.2,3.4,1.9,2.6-.8,3.4,2.2,3.4-3,3,3.7,3-3.4,2.6,1.9s9-12.7,12-19.5l-1.9-.4s-3.7,7.9-6.7,11.6l-2.2-.4s7.1-10.5,10.1-16.1l-1.5-13.1.8-1.5-.4-6.7-6.4,2.6-1.5-1.9a40.21,40.21,0,0,1-7.1,1.5,37.77,37.77,0,0,0-7.1,1.5l-1.5-1.5s-3.4,2.6-4.5,5.6l1.5.4,1.9-2.6,2.3.7a4.32,4.32,0,0,0-1.9,3.7l-2.3,1.1-.4,1.9,2.6-.8.4,3-1.9,4.5,3,.8v4.1l-3,1.5s-2.3,1.1-1.9-4.9a14.35,14.35,0,0,1-3.7-8.6l-3,3a11.69,11.69,0,0,1,1.1-4.9l-1.9.4a43.89,43.89,0,0,0-2.6,8.2l3,1.9.4,2.6,4.5,7.9-.4,2.6a18.21,18.21,0,0,1-6.7-7.9l-1.5.8,3.7,6.7,3,1.5-3.5,3.7Z",
    transform: "translate(0.03 0.03)"
  })), _polygon123 || (_polygon123 = /*#__PURE__*/React.createElement("polygon", {
    points: "541.83 262.83 538.43 262.83 538.43 266.63 540.63 268.13 542.53 267.33 541.83 262.83"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M545.4,171.1c50.2,48.2,81.8,115.9,81.8,191,0,146.2-118.5,264.7-264.7,264.7-113.3,0-209.9-71.5-247.6-171.6l4.3-5.9.4-5.6h1.9a49.65,49.65,0,0,0,.8,7.9l1.9,4.1h-3.4l-1.5,3a19.84,19.84,0,0,0,2.2,5.6l1.5-1.9a18.15,18.15,0,0,0,4.5,4.1l.8,6.4,1.9-3,5.2-1.5,2.3-3.8,1.9-.4-1.1-2.6-.4-2.6-5.2-.8.4-3.7c2.6-1.1,9-4.5,9-4.5l-2.6-2.6,1.5-7.1c2.2,2.6,7.9,3,7.9,3l3,1.5,2.6.4s2.6,2.3,4.5,3.8,6,1.9,6,1.9l3.4,1.5,5.2-4.5v-6.4l2.3-1.5,1.5-1.9,1.5,4.5.8-3.4,1.9,3v20.6h3l1.1,2.2h3.8v2.6l3.7-2.6,1.1,4.5,1.5-1.9h1.5l.4,2.6,2.6-.8.4,1.9,2.6.4s.4,2.6,0,2.6c-2.3,0,5.6,1.1,5.6,1.1l1.5,2.6,3.4.8-.8,7.5c5.2,3.4,14.2,3.7,14.2,3.7l1.5-2.6a8.5,8.5,0,0,1,5.2,1.5l2.3-.8,1.9,1.1-2.6,2.6,1.5,4.5h2.6l-.4-4.1,1.1-2.6,8.6,7.9,2.3,1.1.4,3.7h3l-.8-7.5,1.5-.8a7.55,7.55,0,0,0,2.6,6l1.5-1.5-1.1-2.2,1.1-3.8,1.5,1.5,2.3-3.7,2.6-.8.4-7.9,5.3,2.6c3.8,3.4,13.5,6.7,19.1,9.4s16.8,5.6,20.6,6.7,12,2.6,12,2.6l1.1-8.6,2.2,2.6.4,4.9,3.4-2.2-.4,3-3,1.5,4.5,1.9.8-2.6.4-3.7,1.1-.8c.7,2.6,0,7.5,0,7.5l6,.8s6.7-10.1,8.2-13.1,4.9-7.5,9-6.7,4.5,7.5,4.5,7.5l2.6,2.6c2.3,8.6,11.2,16.5,11.2,16.5s6.7-.7,10.9,0,8.6,3,12.4,3.7,14.2,1.5,14.2,1.5v-1.9l-4.5-1.5.4-3,6-3-1.1-3a98.26,98.26,0,0,0-10.5-1.9l-6.7-4.9a13.09,13.09,0,0,1,6-3l.8-6,3.4-.8,2.6,3,2.6.8,7.1,6.7h2.6L456.8,525l4.1.7,21.3,9.4,3.4-1.5,2.3,3.4,2.6-3,.8,3.8,1.9,1.5c.7,4.9.4,11.2,0,17.2a120.47,120.47,0,0,1-3,18.3c-1.1,4.5,1.1,3,2.6-.8s4.1-12.4,4.5-16.8-1.1-11.6-1.1-11.6l.8-2.6c1.1,3,1.9,9.4,1.9,14.2s-2.6,12-4.1,17.2a45.2,45.2,0,0,0-1.5,10.9c2.6-2.2,4.5-7.9,4.5-7.9v4.9a23,23,0,0,0,4.9-6.7c1.5-3,2.6-11.2,2.6-15.3V543.1l1.1-2.3s.4,6.7.4,11.2v10.9l2.6-1.1c2.6-3.4,3-12.4,3-12.4l3.4-4.1v-8.6l1.9.4c0,7.5,2.6,1.9,2.6,1.9l.4-6.4a20.61,20.61,0,0,0-3.4-4.9V526l3,2.3v-4.5l1.9.4a37.88,37.88,0,0,0,0,7.1c.4,3,4.1,5.6,4.1,0s-3.7-12-3.7-12l1.5-.4a12.59,12.59,0,0,1,3,6.7c.4,2.6,1.5,4.1,3,4.1s1.9-1.9,1.9-4.1-4.5-7.1-4.5-7.1a3.45,3.45,0,0,0-2.6-3l-1.1,1.1a16,16,0,0,0-8.6-1.1,83.77,83.77,0,0,0-9,1.9l-.7-2.6,1.1-4.1,1.5-.8-.4,4.9a5.65,5.65,0,0,0,4.1,0c2.6-.8,6.4-1.9,9.4-1.9a41.36,41.36,0,0,1,5.6.4l2.3-2.3H531a41.92,41.92,0,0,0,.8,9.4c.7,3.4,2.6-1.9,2.6-1.9a6.79,6.79,0,0,0-1.5-3.7v-1.9a11.66,11.66,0,0,0,3.8-1.1,14.93,14.93,0,0,0-1.1-4.9l2.6-1.9-1.5-2.6.8-5.6-2.3.4-3-1.5a6.42,6.42,0,0,0-1.9-4.1l-1.9-.4-2.6-3.7-4.1-.4.8-2.3-1.9-1.5H517l-.8-3.4-3.4-.8-.4-2.2a41.18,41.18,0,0,0-10.9-9.7l-.4-3h-2.6l-1.9-1.5-3-.4-1.9-1.9h4.1a25.63,25.63,0,0,0-5.2-3.7l-.4-1.9-4.1.4-.4-3.7h-2.2l-1.9-2.2-2.6-.4.8-3c-2.3-1.1-7.1-.4-7.1-.4l-.4-2.2,6.7.8-.8-1.9-5.2-.4.4-2.2a5.41,5.41,0,0,0,3,.8c1.9,0,2.3-1.1,2.3-1.1l-.4-1.9h1.5l.8,1.9h2.6V437h1.1l.8,2.3,3-.8-.4,4.9,2.2,1.9,2.3-1.9v-4.1l1.5-1.5c.4,4.9.4,10.5.4,10.5l2.3.8,4.1,2.2,3.4-3-1.9-3.4,7.1.4a7.25,7.25,0,0,0,6,3c2.6,0,5.6-2.3,8.6-3s6.4-5.2,6.4-5.2l.4-5.2,2.2-1.5-2.2-1.9V416.9s1.9-4.5,6-6,7.1-2.6,10.1-2.3L535.7,395s-4.1.8-4.5-1.5a24,24,0,0,1,0-5.6l1.5,1.1.8,3.4,1.9-.8s-3-90.6-3.4-100.3c0,0-4.1-9-7.1-12s-12-6-20.6-6.7c0,0-5.6-.8-7.9-3.7s-10.1-9.7-10.1-9.7l-3.7,2.6,3,4.1v5.6l-2.3,2.3s-1.9-.4-1.9-3.4l-2.6,2.6-1.5-1.1.8-1.5-4.1.7s.4,4.1.4,6.4a3.15,3.15,0,0,1-3.4,3.4c-1.9,0-4.1-2.3-4.1-6.7l3-1.9.4,4.1,1.9-.4.4-7.5s-2.3-1.5-2.3-3.4L468,267l-2.6-.4a66.47,66.47,0,0,1-1.1,7.1s-2.3-1.1-1.9-1.1-1.9-4.5-1.9-4.5l-1.1,3-2.6-2.6-1.5,1.9,2.3,2.6-1.5,3.4-2.2-.8-2.3-3.7-.8-3.7,1.9-.4.4,2.3,3.4-3.4-2.6-2.6s-2.6.8-6.8-1.9l-.4,1.9-4.1-3.7V258H441l-.8,3.8,1.5,2.6-1.5.4-1.9-2.6,1.5-7.1,2.3-.4a18.22,18.22,0,0,1,2.6-7.1,18.86,18.86,0,0,0,1.5-6.4c0-3,1.5-4.9,2.3-6.4H450a33.5,33.5,0,0,0-1.9,6.7,22.65,22.65,0,0,1-3.4,9.7l1.5,1.1,1.5,2.3,6.4.4,2.2,2.6h1.5l-.4-4.5s3.8,4.9,6.4,6a7.81,7.81,0,0,0,4.9.4,3.12,3.12,0,0,1,2.3,2.3l2.2.8,1.5,1.9,2.6-1.9,2.6-.4,1.1-1.9,3-2.3-.4-2.2a57.25,57.25,0,0,1-6.4,4.5l-3.7-.8,2.6-1.9,3-.4s1.1-3,3.4-3.7c0,0-.4-1.9-.4-2.2s-3.4-.8-3.4-.8l-2.3-.8s-6-.8-7.5,0,0,3.7,0,3.7l-3.4,2.3s-2.2-3-1.5-5.2l-1.1-4.5,1.9.4,1.1,2.2,1.5-1.5,4.1-.4-1.1-1.9s-3.8,0-4.9-1.5l6.7-.8,3.4-1.9.4-3-2.2-.4,1.9-2.2,2.3.4v4.5l2.6-4.1,1.5.4a14.75,14.75,0,0,0-1.5,4.9c0,1.9.4,4.1,2.2,5.2s5.2,3.4,5.2,3.4l41.2-13.9-1.5-2.2-2.6-.4-1.1-3-1.9,1.9H520v-1.5l-3.8,3.4-.4-3.7-1.5,4.1h-1.9l.4-5.2a34.11,34.11,0,0,0,3-12l1.1-2.6a78.7,78.7,0,0,1-1.1,12.7h1.5s.4-9.4,4.1-13.9l-4.9-7.5,1.5-.8,3,4.9,2.6.8-3.4-6h1.9l3.4,4.9,1.1-3s-4.1-7.9-4.1-8.2,1.1-.8,1.1-.8l4.1,4.5.4-2.6-3.4-4.9,1.5-.8.8-2.6,1.9-1.9a14.51,14.51,0,0,0-9.4-1.5,42.57,42.57,0,0,0-10.5,4.5l-.4-2.6s10.1-4.9,13.8-4.5,9.4,3,9.4,3h2.6L540,195l7.9-.8,1.9-2.3-4.9-.8.4-1.5,3-.8a8.69,8.69,0,0,1-5.3-5.6l-3.4,3.4s-7.5-4.5-15-4.9-17.6,4.5-21,5.6l-.8-2.2s7.9-3.4,12.3-4.1,8.2-1.5,12.7-1.9l1.5-3.4,3.7-2.3,3,.8,4.1-2.3,5.3-.8Z",
    transform: "translate(0.03 0.03)"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M473.6,179.4c-1.9,4.5-5.2,12-6.7,16.1l2.3-.4-1.1,2.2-3,1.9-1.5,3-1.9.4.4-2.3a45.64,45.64,0,0,0-6.8,1.1l-1.5,5.2,3-.4s0,3.7,3.8,7.9a68.72,68.72,0,0,0-2.3,6.7,21.57,21.57,0,0,0-.4,6.7l-1.9.8s-1.1-5.6-.4-8.2a12,12,0,0,1,3-5.6l-5.2-6-3,2.6s-3.8-1.5-6.4-.4-5.6,6.7-7.5,10.9l-3.8.8s0-5.6,1.9-9.4a47.15,47.15,0,0,1,4.5-7.1l-3.7.4-3,5.2s-1.9,1.1-1.9.8,2.6-5.2,2.6-5.2a6,6,0,0,0-6,2.6l-1.9.4,6-7.9-3.7-.4s-7.9,10.5-7.9,10.1S423,213,423,213l2.6,2.6a12.74,12.74,0,0,0,6.4-1.1s-.8,3-1.1,3-.8,6.7-.8,6.7,2.3.8,1.5,2.3-5.2.8-7.9,1.1-6,2.3-8.6,3-6.4,0-6.4,0v-1.5s4.1.4,6.4-.4,7.9-4.1,10.9-4.5l-6-1.1s-4.5-9-6.4-11.6-2.3-4.9.4-8.2,4.5-8.2,12-9l.8,3.4s2.2.4,2.2,0a31.46,31.46,0,0,1,1.9-3.7s3,.8,7.1-1.5c0,0,4.9,0,7.1-1.9s3.4-6.7,3.7-10.9l1.5-1.1s-.4,7.5-2.3,10.9l2.6-.4,3-7.5,1.9-.4-.4,2.2,8.6-.8.7-2.2,2.2-1.1v3s3.4-.7,4.1-2.6l2.9-.3Z",
    transform: "translate(0.03 0.03)"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M472.9,227.7l-2.6,6,11.6,3,2.6-.8-.4,3.7h1.5s.8-3,3-3.7l-1.5-2.2,1.9-4.1,3.4,1.5a32.63,32.63,0,0,0-3,9.7h1.5s.8-6,3-9.4h1.9l-1.5,5.6,1.9.4,1.1-5.6,1.5,3s7.5,0,9.7-.8l.4,1.9,2.6-1.5.7-9.4,3.4-.4.4-1.5h-3.4l1.9-6.4-1.5-.4-1.9,6a2.59,2.59,0,0,1-1.5-3.4c.8-2.6,2.3-3.7,4.5-4.9a17.54,17.54,0,0,1,7.1-1.9l-2.6-4.9-2.3,2.6a11.75,11.75,0,0,1-3.7-3.4,6.75,6.75,0,0,1-.4-4.5,26.34,26.34,0,0,0-7.1,1.9c-3.3,1.5-8.2,3-11.6,5.6a27,27,0,0,0-8.6,1.5l-1.1,6h1.5l1.1-4.5h1.9l.4,4.9h1.5v-4.9h1.9s-.4,4.5.4,6.7c0,0,4.5-1.1,4.9,3l-2.3,1.1a25.31,25.31,0,0,0-5.2-2.2c-2.6-.8-6,.4-9.7-1.9l-1.5,5.6,2.3-.4s0,4.1-.4,4.1a11.45,11.45,0,0,1-2.3-1.5l-1.9,1.5s1.1,3.7-1.5,3.7l-2.2-.4,1.9-4.1-1.7.1Z",
    transform: "translate(0.03 0.03)"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M483,273c6.4,5.6,20.2,10.9,26.6,12.7s21,6.4,24,6.7l-1.1-3.4a41.75,41.75,0,0,1-11.6-2.3c-7.1-2.2-22.1-4.9-35.9-15Z",
    transform: "translate(0.03 0.03)"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "M371.8,268.1l-.4,7.9,1.5-1.1.4-4.5,1.9-.4v6l2.3-1.5a10.1,10.1,0,0,0,6.4-.8s6,.8,9.7-.4,6.7-3.4,10.1-4.1a31.28,31.28,0,0,1,6.4-.8l3-6,.4-7.1-4.9-12.4-2.6-3.7-1.5.4.4,2.6H403l-.4-4.9,3.4-1.9v-2.6l3.7-1.9.4-3.4,7.5-3s-2.6-9-6.7-13.5l-1.5.4v2.3l-1.9,2.2.4-8.2-3-.8-.8,3.4-1.5-.7-.4-3.4-3.7-.7-.4,4.5-2.3,2.3v20.6l2.6,1.1-3,2.2-1.5-2.2-2.3,1.1-1.9-1.1-1.9,1.5-.4-2.3-1.5-.4-1.5,3.4h-1.9s0-4.5-.4-9c0,0,2.3-.8,3,1.1l2.2.4-1.9-5.6a24.56,24.56,0,0,0-4.5,1.5c-1.5.8-4.9.8-7.1,1.1l-.4,6.7h-2.3v-5.6l-3,1.5-.8,7.1a38.07,38.07,0,0,1,6.7-.8l1.1,3.4,1.9.4s-.4,4.9-3.4,5.2a47.53,47.53,0,0,1-5.6.4s-.8-4.9-3.4-6.7l-.8,1.5a28.1,28.1,0,0,1,2.6,6.7,25.88,25.88,0,0,1,.4,6.7l-1.9,1.5s0-7.9-1.5-10.9l-1.1,1.5s.8,4.5.4,6.7l-1.9-.4s1.5,7.5,1.5,10.1a5.07,5.07,0,0,1,3,2.2l-.8,6.4,1.9-.4.4,4.1h1.5l3-11.6,1.5.4.4,3.4,1.1-.8v-2.2s3,2.6,6,2.6l-.4,1.9a18.9,18.9,0,0,1-4.1.8,22.7,22.7,0,0,0-4,.6Z",
    transform: "translate(0.03 0.03)"
  })), _polygon124 || (_polygon124 = /*#__PURE__*/React.createElement("polygon", {
    points: "410.03 216.43 409.63 225.03 414.53 222.83 411.13 215.33 410.03 216.43"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "M410,241.1s2.6,6.7,3.7,10.9l1.9-.4.4,3.4,2.2-.4-.4-3.7a24.32,24.32,0,0,0,5.2-9l-.8-1.5s-3,6-5.2,8.2l-.4-2.2s1.5-2.6,3-6l2.3-.8.4-3s.8,3.4,3.4,4.5l.8-2.2,3.7,3,.4-1.1-1.9-3,2.6-.4,2.6,3.7,1.1-.8-2.3-3.4,3-.4,1.9,3.7h1.5l-1.1-4.5a25,25,0,0,1,5.3-1.5,56.39,56.39,0,0,1,8.6-.4l1.5-1.9a66.46,66.46,0,0,1,6.7,1.1,90.62,90.62,0,0,1,4.9-16.8h-1.5s-3.4,9.4-4.5,13.5a51.35,51.35,0,0,1-12-.8c-5.6-1.1-9.7-2.6-13.1-2.2l-1.5,4.1a80.68,80.68,0,0,0-8.6,1.5l-1.5-1.9h-1.5v3l-2.2-.4s0-2.6-.4-2.6a9,9,0,0,0-1.9.8v3l-3.8.4,3.8,4.5,1.9-.4-2.6,5.2-1.1-1.5-1.9,1.5-1.5-4.1-1.1,1.3Z",
    transform: "translate(0.03 0.03)"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M424.6,245.6l-1.1.8-.4,2.6a24.91,24.91,0,0,0-3.4,7.1l5.3,4.1v3.7h1.5s1.5-7.1.8-10.5a45.56,45.56,0,0,0-2.7-7.8Z",
    transform: "translate(0.03 0.03)"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "M426.8,244.1c.4,3,3.4,7.1,3.4,7.1l2.3-3a14.93,14.93,0,0,1-1.1-4.9h-1.9l1.1,3.4-2.6-3.4-1.2.8Z",
    transform: "translate(0.03 0.03)"
  })), _polygon125 || (_polygon125 = /*#__PURE__*/React.createElement("polygon", {
    points: "438.03 246.03 436.23 250.93 437.73 251.23 439.53 246.73 438.03 246.03"
  })), _polygon126 || (_polygon126 = /*#__PURE__*/React.createElement("polygon", {
    points: "440.33 238.53 438.83 243.03 440.33 243.43 441.83 238.53 440.33 238.53"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "M441.4,248.2l-1.9,4.1,1.9.4s2.3-4.5,1.9-4.5Z",
    transform: "translate(0.03 0.03)"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "M453,216.8a25.57,25.57,0,0,0-2.6,9l1.9,1.1a33.21,33.21,0,0,1,1.9-8.2Z",
    transform: "translate(0.03 0.03)"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "M447.4,218.3a53,53,0,0,0-1.1,7.9l1.5.8a61.66,61.66,0,0,1,1.1-7.9l-1.5-.8Z",
    transform: "translate(0.03 0.03)"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "M443.7,218.7a12.22,12.22,0,0,0-1.1,6l1.5.8a10,10,0,0,1,1.1-6.7h-1.5Z",
    transform: "translate(0.03 0.03)"
  })), _polygon127 || (_polygon127 = /*#__PURE__*/React.createElement("polygon", {
    points: "450.83 243.03 448.93 249.43 450.03 250.93 451.93 246.43 450.83 243.03"
  })), _polygon128 || (_polygon128 = /*#__PURE__*/React.createElement("polygon", {
    points: "454.93 244.13 453.03 248.63 454.53 249.43 456.43 245.63 454.93 244.13"
  })), _polygon129 || (_polygon129 = /*#__PURE__*/React.createElement("polygon", {
    points: "459.03 237.43 457.93 241.53 459.43 242.33 460.93 237.83 459.03 237.43"
  })), _polygon130 || (_polygon130 = /*#__PURE__*/React.createElement("polygon", {
    points: "464.33 226.53 462.43 233.33 463.93 234.03 465.83 227.33 464.33 226.53"
  })), _polygon131 || (_polygon131 = /*#__PURE__*/React.createElement("polygon", {
    points: "468.43 226.93 466.13 232.93 467.23 234.03 470.23 227.33 468.43 226.93"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "M545.6,171.1A263.71,263.71,0,0,0,370.5,97.7c0,1.5,3.5,2.8,3.9,2.8s-.4,1.9.4,3.7,6,2.6,6,2.6l1.1,3.4h5.2a8.36,8.36,0,0,0-3,6.7h2.3l1.5-3.4,1.9.4a24.55,24.55,0,0,0-1.1,3c0,.4,4.5-1.5,4.5-1.5,1.1-2.3,2.2-8.2,2.2-8.2l3.4,2.3,2.6-3.7.8,1.9,4.5.8,1.9,4.5,1.9.8,3.4-4.1,1.5,1.1a10.92,10.92,0,0,1-4.1,7.1l-1.5-1.1h-1.5l-.4,2.6,3.7.8c.8,1.5,3,1.5,3,1.5l-3,3.4.4,3.7,2.6-1.5,1.5,2.6,2.6-1.5,2.2,3.7,4.5-2.6.8,3,3-1.5a31.94,31.94,0,0,1,1.9-3c1.5-2.3,5.3-3,5.3-3l1.9-1.1,2.6,3.4,3-1.5-2.3-5.6,2.3-1.5,2.2,2.3,2.3-1.1a7.49,7.49,0,0,0,2.6,6.4l6.7-.4.8,3.4a17.59,17.59,0,0,0,7.5,1.1l-1.1-3.7,1.9-1.1,1.1,4.9,1.9-1.1.4-3.7,2.3,2.2.4,3h3.7l1.1,3-3,1.5v2.3l2.6-.4-1.1,3.7h1.5l2.3-3.4.8,2.6,1.9-1.5v-1.9l7.5.8,4.5,3.7a27.71,27.71,0,0,0-4.1,3.7c-1.5,1.9-1.1,8.2-1.1,8.2l1.9,1.1c-.4-2.2-1.1-4.5,0-6.4s2.6-.8,2.6,1.5a40,40,0,0,1-.4,4.9l3,1.1c-2.6,1.9-5.6,7.1-5.6,7.1l1.9.4a12.26,12.26,0,0,1,3.4-3.4l1.9,1.9A16.9,16.9,0,0,1,496,164c-.3,0,1.5.8,1.5.8l2.6-.8c1.1,1.9,0,6.4,0,6.4l-4.1-3h-4.9a8.63,8.63,0,0,0-6-1.1c-3,.4-1.9,4.1-1.9,4.1l-3.4,1.1,1.1,1.5,3-.8,1.5,1.9a45.72,45.72,0,0,0-8.2,2.3l1.1,1.5,3.7-.8,1.5,1.9-7.1,2.6s-3,9-4.9,13.5a79.56,79.56,0,0,0-3.4,11.6c1.5,5.6-1.5,6.4-1.5,6.4l-1.5-.8c1.1-1.1.8-3.7.8-3.7l-1.5-.4-1.9.8-1.9-3.7-3,2.2-.8,1.9,2.6-.8,3.8,5.6-1.1,1.5,6.7-.7,1.5-3s-.8-5.2.4-8.6l4.5-1.1s-3.7,9.7-3.7,14.2l1.9-.8a19.8,19.8,0,0,1,1.9-6.4s6-1.9,9-4.9h6l.8,2.2-3.7.4,1.5,1.1a42,42,0,0,0,9.4-3.4c5.3-2.6,6.4-3.7,9.7-4.1l1.1-1.5-1.9-1.1,2.3-1.9-1.9-3-2.2-.4a4.54,4.54,0,0,0-4.1-2.6l-12.7,4.1v-2.3l3-1.9-2.2-1.5,1.9-1.5v-3.7a3.35,3.35,0,0,1,2.6-2.6,42.77,42.77,0,0,0,6.7-2.3l-1.5-1.1s-7.5,3.4-6.7.8.8-1.1,3.7-2.3,6.7-2.3,6.7-2.3l-.4-10.1-2.3-2.6.4-2.2,1.9.4,1.5,1.5a6.08,6.08,0,0,0,3.4-1.5l1.5,1.1a40.2,40.2,0,0,0-1.1,7.1c0,2.6.4,8.2.4,8.2l1.9.8s-.4-6-.4-8.6.4-5.6,1.5-7.1l2.6,1.1-.8,2.2,1.5.8,3-1.5,1.9,1.1-.4,1.9,2.3.4a47.8,47.8,0,0,0-.4,4.9,27.07,27.07,0,0,0,.4,4.1l1.5-.8s-1.1-5.2.8-7.9l3.8-1.1v1.9s-2.6,3.7-2.6,5.6l3.8-2.2,1.1,2.6,1.9-1.1.7-2.2h2.6l.4,2.6h5.6l4.8-1.8Z",
    transform: "translate(0.03 0.03)"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "M373.3,183.9a52.38,52.38,0,0,0-1.9,9.7l1.5,1.5s.8-5.2,1.1-8.2l1.9.8s-.8,4.9-1.1,6.7l1.1.8s1.1-7.1,2.3-9.4l6.7-.8,2.2-2.3a5.4,5.4,0,0,1,4.1,3.4,7.15,7.15,0,0,1-3.4,1.5,20,20,0,0,1-3.4-.4l-.8,4.5-2.6-1.5s-.4,5.2.4,7.9l1.1,1.1v-6.4s3.8,1.5,6.4-1.1l2.2,3.4,1.1-.8a15.05,15.05,0,0,1-1.5-5.6l2.6.4.8,4.1,4.1-1.9-.8-4.5,2.2-1.5.8,5.6,1.5-.8v-1.9a9,9,0,0,1,4.5,2.3l1.9-.4a17.22,17.22,0,0,0-.4-6H412l.8,1.5h1.5l1.1-3v-2.2l2.6-3,.8,2.6a7.73,7.73,0,0,0-1.9,5.2h6l1.1-2.6a135.06,135.06,0,0,0-9.7-14.6v-1.9h1.9s.4-3,1.1-6.4l1.9,1.9a36.14,36.14,0,0,1-.8,7.5s5.2,7.9,7.5,11.2l2.3-.4s-5.3-8.6-7.1-10.5l-.4-4.1s4.1,3.7,5.6,6.4a4.54,4.54,0,0,1,4.1-1.5l-1.1-2.6s-4.1-9-7.5-13.5l1.5-5.2,5.2-.4a6.76,6.76,0,0,1,1.1,3.7h4.1l.8-3.7s2.6-4.5,2.3-7.1h-2.6l-.4-2.6h-3l-2.3,5.2-2.2.4,1.5-5.6-3.8,1.5-4.1,12.4H418s1.5-7.5,3.7-14.6l-2.3-.4.8-3.7-1.9-1.1-1.5,4.1-1.5.4-1.1,3.8-1.5-2.6s-4.1.8-6.7,1.5l-1.1,1.5a14.54,14.54,0,0,0,4.5,1.1l1.5-1.5,1.1,1.5,3,.4s-1.1,1.9-1.9,3.7a12.26,12.26,0,0,1,.4,4.9c-.4,2.3-3,4.5-3,4.5l-.8-2.6-1.5-.8-.8,3.7-2.2-3a14.75,14.75,0,0,0-3,4.9l-1.9,1.9-.8-2.6-1.5.4v3l-2.3,1.1-.4-4.5-1.5.4-.4,5.2a19.1,19.1,0,0,0-4.1-8.6l-1.5.4a13.1,13.1,0,0,1,1.9,6l-3,1.9-.7,1.9h-3l-1.9,1.5-1.9-1.1a4.69,4.69,0,0,0-2.2,4.5l2.2,2.2-.4,3.4s-3.7,0-4.1,2.3,2.6,1.9,4.9,1.9l1.5,1.5-3,.4-1.9,4.1-2.9-1.7Z",
    transform: "translate(0.03 0.03)"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "M392,148.3s2.3-3,5.6-2.3l3,3.7-2.2,1.5-2.6-.8-1.9,2.6-1.5-.4Z",
    transform: "translate(0.03 0.03)"
  })), _polygon132 || (_polygon132 = /*#__PURE__*/React.createElement("polygon", {
    points: "384.13 154.33 386.83 160.63 387.93 159.53 386.83 154.33 384.13 154.33"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    d: "M515.9,170.4v5.2s1.9,1.5,1.9,1.1-.4-5.6-.4-5.6Z",
    transform: "translate(0.03 0.03)"
  })), _polygon133 || (_polygon133 = /*#__PURE__*/React.createElement("polygon", {
    points: "513.33 197.33 511.83 196.23 511.83 198.83 514.83 200.03 515.93 195.83 513.33 197.33"
  })), _polygon134 || (_polygon134 = /*#__PURE__*/React.createElement("polygon", {
    points: "425.73 155.43 433.23 170.03 435.13 170.03 428.03 155.43 425.73 155.43"
  })), _polygon135 || (_polygon135 = /*#__PURE__*/React.createElement("polygon", {
    points: "430.93 155.83 436.63 168.13 438.43 168.13 432.83 156.23 430.93 155.83"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    d: "M356.8,189.5s-1.5,3.7-3,4.5l.4,1.5,3.4-1.1,1.9,1.5-3.4,1.5,1.1,2.3a12.42,12.42,0,0,1,5.6.7l.8,2.6a5.37,5.37,0,0,1,3.8.8c1.5,1.2-2.3,4.9-2.3,10.5l3.4-.8,1.5.8.4-10.9-4.9-1.9.4-2.2,7.1,2.6.8,5.2,1.9-.4-1.1-6-6.7-4.1-.8-2.6-2.6.8c-.2-.1-1.7-3.8-7.7-5.3Z",
    transform: "translate(0.03 0.03)"
  })), _polygon136 || (_polygon136 = /*#__PURE__*/React.createElement("polygon", {
    points: "377.03 201.13 377.43 206.33 378.93 206.73 378.53 201.53 377.03 201.13"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    d: "M361.3,177.1c0,.4,2.6,7.1,2.6,7.1h1.9l-2.6-6.7Z",
    transform: "translate(0.03 0.03)"
  })), _polygon137 || (_polygon137 = /*#__PURE__*/React.createElement("polygon", {
    points: "364.73 175.23 366.63 182.03 368.13 180.13 366.23 175.63 364.73 175.23"
  })), _polygon138 || (_polygon138 = /*#__PURE__*/React.createElement("polygon", {
    points: "365.13 167.03 365.13 173.03 367.33 172.23 366.63 167.83 365.13 167.03"
  })), _polygon139 || (_polygon139 = /*#__PURE__*/React.createElement("polygon", {
    points: "369.23 167.43 369.23 173.73 370.73 173.03 370.73 167.03 369.23 167.43"
  })), _polygon140 || (_polygon140 = /*#__PURE__*/React.createElement("polygon", {
    points: "430.63 179.43 425.03 190.23 426.83 190.63 432.43 180.53 430.63 179.43"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    d: "M433.9,182.4l-4.5,7.1a6.05,6.05,0,0,1-3.4,4.9l-.8,1.5,5.2-2.6.8-3.7,1.9,1.1,3-4.9-1.5-.4Z",
    transform: "translate(0.03 0.03)"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    d: "M413.3,192.8c-2.6,3.4-7.1,6.4-10.9,8.2l1.1.8s4.9-1.5,7.1-3l1.5.8a16.94,16.94,0,0,1-6.7,4.5l1.9.8a39,39,0,0,0,6.4-4.5,47.35,47.35,0,0,0,5.2-6.7h-2.3l-1.9,1.5-1.4-2.4Z",
    transform: "translate(0.03 0.03)"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    d: "M401.7,197a30.14,30.14,0,0,0,3.7-2.2l1.1,1.1-3.7,2.6Z",
    transform: "translate(0.03 0.03)"
  })), _polygon141 || (_polygon141 = /*#__PURE__*/React.createElement("polygon", {
    points: "411.53 188.73 408.53 192.83 408.93 194.33 411.53 190.63 411.53 188.73"
  })), _polygon142 || (_polygon142 = /*#__PURE__*/React.createElement("polygon", {
    points: "388.33 222.43 390.13 222.43 390.93 225.43 392.03 226.23 392.03 220.93 393.93 219.43 394.33 228.83 392.43 229.93 389.03 228.03 388.33 222.43"
  })), _polygon143 || (_polygon143 = /*#__PURE__*/React.createElement("polygon", {
    points: "380.83 217.93 380.83 219.83 384.13 221.73 384.53 219.43 380.83 217.93"
  })), _polygon144 || (_polygon144 = /*#__PURE__*/React.createElement("polygon", {
    points: "382.63 214.63 385.63 218.33 386.43 216.13 383.83 213.13 382.63 214.63"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    d: "M387.5,212.7l1.5,3.4,2.6-.8s1.1-3.7.8-3.7S389.8,209.3,387.5,212.7Z",
    transform: "translate(0.03 0.03)"
  })), _polygon145 || (_polygon145 = /*#__PURE__*/React.createElement("polygon", {
    points: "387.53 201.83 388.33 208.23 390.13 207.43 390.93 201.53 387.53 201.83"
  })), _polygon146 || (_polygon146 = /*#__PURE__*/React.createElement("polygon", {
    points: "395.03 204.83 394.33 201.53 392.43 204.13 392.03 207.83 393.53 207.13 395.03 204.83"
  })), _polygon147 || (_polygon147 = /*#__PURE__*/React.createElement("polygon", {
    points: "416.03 175.23 412.63 180.53 414.53 180.13 417.53 176.43 416.03 175.23"
  })), _polygon148 || (_polygon148 = /*#__PURE__*/React.createElement("polygon", {
    points: "539.13 281.63 536.13 284.93 536.53 287.23 540.33 284.23 539.13 281.63"
  })), _polygon149 || (_polygon149 = /*#__PURE__*/React.createElement("polygon", {
    points: "546.63 292.03 544.73 295.03 542.93 294.73 542.13 296.93 544.73 298.43 547.43 293.93 546.63 292.03"
  })), _polygon150 || (_polygon150 = /*#__PURE__*/React.createElement("polygon", {
    points: "545.13 312.33 546.23 310.43 545.13 308.53 541.83 313.03 544.73 316.03 545.93 314.53 545.13 312.33"
  })), _polygon151 || (_polygon151 = /*#__PURE__*/React.createElement("polygon", {
    points: "548.93 327.23 547.43 326.93 547.03 323.93 543.63 322.43 544.03 328.43 546.23 329.93 549.63 328.73 548.93 327.23"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    d: "M541,342.2c1.5-1.1,3.4-2.2,4.5-.4a7.17,7.17,0,0,1,.8,5.3H544v-3.8a2.12,2.12,0,0,0-2.2.8Z",
    transform: "translate(0.03 0.03)"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    d: "M539.9,358.3c.8-3.4,1.5-4.1,3-5.6l3.8.4a27.81,27.81,0,0,0-3,6.7l-1.5,1.1a6.57,6.57,0,0,1,1.5-5.6Z",
    transform: "translate(0.03 0.03)"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    d: "M562.3,353.4a29.6,29.6,0,0,1-2.6,3.7l3,3.4,2.3-2.2Z",
    transform: "translate(0.03 0.03)"
  })), _polygon152 || (_polygon152 = /*#__PURE__*/React.createElement("polygon", {
    points: "429.43 258.43 429.13 262.13 432.83 258.43 432.83 254.23 429.43 258.43"
  })), _polygon153 || (_polygon153 = /*#__PURE__*/React.createElement("polygon", {
    points: "435.83 255.73 434.33 261.03 436.63 260.63 438.03 255.43 435.83 255.73"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    d: "M443.7,238.5l-1.9,7.5h1.5s2.6-7.9,2.2-7.9A17.18,17.18,0,0,0,443.7,238.5Z",
    transform: "translate(0.03 0.03)"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    d: "M386,122.1c-1.5,0-2.6,5.2-1.5,12.4l3,1.1,1.5-3.4s-1.9-3.7-1.5-6.4S387.5,122.1,386,122.1Z",
    transform: "translate(0.03 0.03)"
  })), _polygon154 || (_polygon154 = /*#__PURE__*/React.createElement("polygon", {
    points: "398.43 112.73 396.13 118.73 397.63 119.93 399.93 113.93 398.43 112.73"
  })), _polygon155 || (_polygon155 = /*#__PURE__*/React.createElement("polygon", {
    points: "403.63 121.03 406.63 116.53 405.13 115.03 403.23 118.03 402.13 114.63 399.13 120.63 400.63 121.33 402.13 119.93 403.63 121.03"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 407.03,
    y: 126.23,
    width: 1.9,
    height: 3
  })), _polygon156 || (_polygon156 = /*#__PURE__*/React.createElement("polygon", {
    points: "472.53 170.03 468.43 175.63 471.73 175.63 474.43 172.23 472.53 170.03"
  })), _polygon157 || (_polygon157 = /*#__PURE__*/React.createElement("polygon", {
    points: "479.63 162.93 482.23 161.83 482.63 163.33 486.03 162.93 486.33 155.43 482.63 156.23 482.23 158.83 479.63 157.73 479.63 162.93"
  })), _polygon158 || (_polygon158 = /*#__PURE__*/React.createElement("polygon", {
    points: "503.63 163.33 503.93 173.03 505.13 174.93 505.13 164.03 503.63 163.33"
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    d: "M511.4,169.3v6l1.5.8v-5.6c0-.1-1.1-1.2-1.5-1.2Z",
    transform: "translate(0.03 0.03)"
  })), _polygon159 || (_polygon159 = /*#__PURE__*/React.createElement("polygon", {
    points: "494.63 183.53 494.23 185.73 501.33 183.93 502.13 181.63 494.63 183.53"
  })), _polygon160 || (_polygon160 = /*#__PURE__*/React.createElement("polygon", {
    points: "482.23 147.93 481.93 152.83 483.33 152.03 483.73 146.83 482.23 147.93"
  })), _polygon161 || (_polygon161 = /*#__PURE__*/React.createElement("polygon", {
    points: "486.33 144.93 485.63 152.43 487.13 152.83 488.23 143.83 486.33 144.93"
  })), _polygon162 || (_polygon162 = /*#__PURE__*/React.createElement("polygon", {
    points: "441.83 130.73 437.33 133.73 438.03 135.63 442.23 133.03 441.83 130.73"
  })), _polygon163 || (_polygon163 = /*#__PURE__*/React.createElement("polygon", {
    points: "446.73 132.23 442.93 134.83 442.93 137.13 446.73 134.83 446.73 132.23"
  })), _polygon164 || (_polygon164 = /*#__PURE__*/React.createElement("polygon", {
    points: "477.43 210.83 474.43 216.13 474.43 217.93 477.03 213.83 477.43 210.83"
  })), _polygon165 || (_polygon165 = /*#__PURE__*/React.createElement("polygon", {
    points: "479.63 215.33 476.23 220.93 476.63 222.83 480.03 217.93 479.63 215.33"
  })), _polygon166 || (_polygon166 = /*#__PURE__*/React.createElement("polygon", {
    points: "505.83 237.43 502.43 238.53 502.13 242.33 505.43 240.83 505.83 237.43"
  })), _polygon167 || (_polygon167 = /*#__PURE__*/React.createElement("polygon", {
    points: "376.73 130.33 374.03 130.03 372.93 131.53 376.73 132.23 381.13 128.83 380.43 127.73 376.73 130.33"
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    d: "M365.4,121c.4,4.1,2.6,7.9,7.5,6.7v-1.9s-4.1,1.1-5.6-3.7Z",
    transform: "translate(0.03 0.03)"
  })), _polygon168 || (_polygon168 = /*#__PURE__*/React.createElement("polygon", {
    points: "366.93 117.23 368.13 119.13 371.43 120.23 371.43 118.43 366.93 117.23"
  })), _polygon169 || (_polygon169 = /*#__PURE__*/React.createElement("polygon", {
    points: "367.33 112.03 367.33 114.23 371.03 116.13 370.73 113.93 367.33 112.03"
  })), _polygon170 || (_polygon170 = /*#__PURE__*/React.createElement("polygon", {
    points: "367.73 107.93 367.73 109.73 371.03 112.03 371.03 110.13 367.73 107.93"
  })), _polygon171 || (_polygon171 = /*#__PURE__*/React.createElement("polygon", {
    points: "370.73 105.23 370.33 107.13 373.33 109.73 373.33 107.53 370.73 105.23"
  })), _polygon172 || (_polygon172 = /*#__PURE__*/React.createElement("polygon", {
    points: "378.23 112.73 377.83 115.03 381.13 117.63 381.13 115.43 378.23 112.73"
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    d: "M375.2,115.7v1.9l2.3,2.3-3,.4-.4,2.2,5.2-.4v-3.4A48.54,48.54,0,0,0,375.2,115.7Z",
    transform: "translate(0.03 0.03)"
  })), _polygon173 || (_polygon173 = /*#__PURE__*/React.createElement("polygon", {
    points: "357.23 204.13 355.73 207.83 357.63 209.33 360.63 207.13 357.23 204.13"
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    d: "M180.5,454.5l2.6,1.9,1.9-2.6,1.5,1.5-.4,1.5,23.6,9.7,1.5,3-25.1-11.2-3.4.4-2.3-1.5v-2.7Z",
    transform: "translate(0.03 0.03)"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    d: "M152.8,437.3c2.6,3.7,5.6,4.5,8.6,6a63.39,63.39,0,0,1,7.1,4.5l.4-2.3s-4.5-3-7.1-4.5-6-1.5-7.1-3.4l-1.9-.3Z",
    transform: "translate(0.03 0.03)"
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    d: "M133.3,441c1.1-5.2,4.1-7.1,7.9-8.6s7.5-1.1,9.7,1.5l-.4,1.9s-4.5-3-8.2-1.5-5.6,2.6-6.7,5.2Z",
    transform: "translate(0.03 0.03)"
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    d: "M128.1,438l-.4,18-1.5,1.9-1.1-1.9v-7.1s-2.6-.8-1.9-10.9l1.5-1.9v8.6l1.5,1.5.4-6,1.5-2.2Z",
    transform: "translate(0.03 0.03)"
  })), _polygon174 || (_polygon174 = /*#__PURE__*/React.createElement("polygon", {
    points: "131.13 445.13 130.73 454.13 132.23 453.03 132.63 444.43 131.13 445.13"
  })), _polygon175 || (_polygon175 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "575.13 579.93 571.53 601.93 593.23 597.03 596.93 575.03 575.13 579.93"
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M604.3,575a5.32,5.32,0,1,1,.5,7.5A5.26,5.26,0,0,1,604.3,575Z",
    transform: "translate(0.03 0.03)"
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M588.5,560.4a5.32,5.32,0,1,1,.5,7.5A5.45,5.45,0,0,1,588.5,560.4Z",
    transform: "translate(0.03 0.03)"
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M619.1,547.6c5.2-.4,7.9,1.1,10.6,2.2,0,0-2.5,8.6-9.2,10.2,0,0,5.5,1.7,7.4,6.2l-.1,1.1s-3.2-2.2-4.8-.4c-1.4,1.6-1.3,2.9-.1,4.3a11.81,11.81,0,0,1-8.6-1.4c-4-2.3-6.2-4.9-7-7.1-2.4-.2-5.5-1.8-8.6-5.1a12,12,0,0,1-3.4-8.1c1.6.8,2.9.6,4.1-1.1,1.4-2-1.5-4.6-1.5-4.6l1.1-.3c4.8.8,7.7,5.7,7.7,5.7,0-6.9,7.8-11.4,7.8-11.4,1.7,2.4,3.9,4.7,4.6,9.8Z",
    transform: "translate(0.03 0.03)"
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M571.6,609.8a5.3,5.3,0,1,0,7.5,0A5.25,5.25,0,0,0,571.6,609.8Z",
    transform: "translate(0.03 0.03)"
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M556.1,595a5.3,5.3,0,1,0,7.5,0A5.44,5.44,0,0,0,556.1,595Z",
    transform: "translate(0.03 0.03)"
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M545.3,626.4c-.1,5.3,1.6,7.9,2.8,10.4,0,0,8.5-3.1,9.6-9.9,0,0,2.1,5.3,6.6,7l1.1-.2s-2.4-3.1-.7-4.7c1.5-1.5,2.8-1.5,4.3-.4a12.15,12.15,0,0,0-1.9-8.5c-2.5-3.8-5.3-5.9-7.6-6.5-.4-2.3-2.1-5.3-5.6-8.2a12.35,12.35,0,0,0-8.3-2.9c.9,1.6.8,2.9-.9,4.2-1.9,1.5-4.6-1.2-4.6-1.2l-.3,1.1c1.1,4.7,6.2,7.4,6.2,7.4-6.9.4-10.8,8.5-10.8,8.5C537.6,624,540,625.9,545.3,626.4Z",
    transform: "translate(0.03 0.03)"
  })), _polygon176 || (_polygon176 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "149.83 579.93 153.43 601.93 131.63 597.03 128.03 575.03 149.83 579.93"
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M120.6,575a5.32,5.32,0,1,0-.5,7.5A5.35,5.35,0,0,0,120.6,575Z",
    transform: "translate(0.03 0.03)"
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M136.3,560.4a5.32,5.32,0,1,0-.5,7.5A5.35,5.35,0,0,0,136.3,560.4Z",
    transform: "translate(0.03 0.03)"
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M105.7,547.6c-5.2-.4-7.9,1.1-10.6,2.2,0,0,2.5,8.6,9.2,10.2,0,0-5.4,1.7-7.4,6.2l.1,1.1s3.2-2.2,4.8-.4c1.4,1.6,1.3,2.9.1,4.3a11.81,11.81,0,0,0,8.6-1.4c4-2.3,6.2-4.9,7-7.1,2.4-.2,5.5-1.8,8.6-5.1a12.59,12.59,0,0,0,3.4-8.1c-1.6.8-2.9.6-4.2-1.1-1.4-2,1.5-4.6,1.5-4.6l-1.1-.3c-4.8.8-7.7,5.7-7.7,5.7,0-6.9-7.8-11.4-7.8-11.4-1.6,2.4-3.7,4.7-4.5,9.8Z",
    transform: "translate(0.03 0.03)"
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M153.2,609.8a5.3,5.3,0,1,1-7.5,0,5.34,5.34,0,0,1,7.5,0Z",
    transform: "translate(0.03 0.03)"
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M168.8,595a5.3,5.3,0,1,1-7.5,0A5.44,5.44,0,0,1,168.8,595Z",
    transform: "translate(0.03 0.03)"
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M179.6,626.4c.1,5.3-1.6,7.9-2.8,10.4,0,0-8.5-3.1-9.6-9.9,0,0-2,5.3-6.6,7l-1.1-.2s2.4-3.1.7-4.7c-1.5-1.5-2.8-1.5-4.3-.4a12.15,12.15,0,0,1,1.9-8.5c2.5-3.8,5.3-5.9,7.6-6.5.4-2.3,2.1-5.3,5.6-8.2a12.35,12.35,0,0,1,8.3-2.9c-.9,1.6-.8,2.9.9,4.2,1.9,1.5,4.6-1.2,4.6-1.2l.3,1.1c-1.1,4.7-6.2,7.4-6.2,7.4,6.9.4,10.9,8.5,10.9,8.5-2.6,1.5-5,3.4-10.2,3.9Z",
    transform: "translate(0.03 0.03)"
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M66.7,433.9c2.4-.6,6.9-2.8,5.2-10.8-.9-4.4-2.9-9-7.6-8.1-3.4.7-3.7,4.2-3.8,9.1l-.1,5c-.2,7.5-.4,14.7-10.1,16.7-4.9,1-14.2.1-17.1-14.2-2.8-13.6,5.3-19,10.8-20.2l1.8,8.9c-1.9.6-6.4,2.4-4.8,10.4.7,3.5,2.9,7.4,6.9,6.6,3.5-.7,3.6-3.7,3.7-5.6l.4-11.3c.2-6.3,1.6-12.4,9.5-14,13.3-2.7,17.3,10.6,18.1,14.5,3.3,16.1-5.4,20.8-10.9,21.9Z",
    transform: "translate(0.03 0.03)"
  })), _polygon177 || (_polygon177 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "52.53 368.13 53.93 390.03 65.63 389.33 64.03 364.33 72.03 363.83 74.23 398.03 29.13 400.93 27.03 367.73 35.03 367.23 36.53 391.13 46.03 390.53 44.63 368.63 52.53 368.13"
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M75.2,318.4,28.9,330.7,28,341.6l43.8,19.6.8-9.9-9-3.9,1.3-16.6,9.5-2.2Zm-18.9,15-.8,10.4-15.8-6.5v-.1Z",
    transform: "translate(0.03 0.03)"
  })), _polygon178 || (_polygon178 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "32.23 304.33 34.33 295.03 70.43 303.13 75.23 281.13 83.23 282.93 76.33 314.03 32.23 304.33"
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M81.6,195.7c-9.9.4-15.4,8-17.4,11.8-2.8,5.3-7.7,20.4,11.1,30.3s28.4-2.9,31.1-8.3,7.7-20.4-11.1-30.3A28.29,28.29,0,0,0,81.6,195.7Zm.5,10.7a20.47,20.47,0,0,1,8.2,2.4c10.2,5.3,9.7,12.4,7.6,16.5s-7.7,8.6-17.9,3.3-9.7-12.4-7.6-16.5A10.47,10.47,0,0,1,82.1,206.4Z",
    transform: "translate(0.03 0.03)"
  })), _polygon179 || (_polygon179 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "107.63 157.23 94.33 175.63 102.53 181.53 114.23 165.43 120.63 170.13 109.03 186.23 124.43 197.33 118.93 205.03 82.33 178.63 101.13 152.53 107.63 157.23"
  })), _polygon180 || (_polygon180 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "132.03 118.93 160.03 95.23 165.23 101.33 154.83 110.13 178.83 138.43 171.63 144.53 147.63 116.23 137.23 125.03 132.03 118.93"
  })), _polygon181 || (_polygon181 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "176.03 84.23 185.23 98.63 200.13 89.23 190.93 74.73 198.93 69.73 223.13 107.83 215.13 112.93 204.23 95.83 189.43 105.23 200.23 122.33 192.33 127.43 168.13 89.23 176.03 84.23"
  })), _polygon182 || (_polygon182 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "250.33 73.63 230.23 82.63 235.03 93.33 257.93 83.03 261.13 90.33 229.93 104.33 211.43 63.13 241.73 49.63 245.03 56.83 223.13 66.63 227.03 75.33 247.13 66.33 250.33 73.63"
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M303.7,64.3c.5,2.5,2.5,7,10.6,5.6,4.4-.7,9.1-2.6,8.4-7.3-.6-3.5-4.1-3.9-9-4.2l-5-.3c-7.5-.5-14.7-.9-16.3-10.8-.8-5,.4-14.2,14.9-16.6,13.6-2.3,18.8,6.1,19.8,11.5l-8.9,1.5c-.6-1.9-2.1-6.5-10.2-5.2-3.5.6-7.5,2.6-6.9,6.6.6,3.5,3.5,3.8,5.5,3.9l11.3.9c6.3.5,12.3,2,13.7,10,2.2,13.4-11.2,16.8-15.1,17.5-16.3,2.7-20.6-6.2-21.5-11.7l8.7-1.4Z",
    transform: "translate(0.03 0.03)"
  })), _polygon183 || (_polygon183 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "334.03 28.13 370.73 27.03 371.03 34.93 357.33 35.43 358.53 72.53 349.13 72.83 347.93 35.73 334.33 36.13 334.03 28.13"
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M393.5,28.7,372.7,71.9l9.9,1,4.1-8.9,16.6,1.8,1.9,9.6,10.2,1.1L404.3,29.9l-10.8-1.2Zm4.2,11.9h0l3.5,16.7-10.4-1.1Z",
    transform: "translate(0.03 0.03)"
  })), _polygon184 || (_polygon184 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "427.03 32.93 462.63 41.83 460.73 49.63 447.43 46.23 438.43 82.33 429.23 80.03 438.33 44.03 425.03 40.73 427.03 32.93"
  })), _polygon185 || (_polygon185 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "491.93 80.33 471.43 72.23 467.13 83.03 490.33 92.33 487.43 99.73 455.53 87.03 472.23 45.13 503.13 57.33 500.13 64.83 477.93 55.93 474.43 64.73 494.83 72.93 491.93 80.33"
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M551.9,89.1c-5.5.1-11.8,2.7-17.8,10.7-12.8,16.9-1.7,28.4,3,32s18.9,11,31.6-5.9,1.8-28.4-3-32A21.81,21.81,0,0,0,551.9,89.1Zm1.7,10.2a10.69,10.69,0,0,1,6.4,2.2c3.7,2.8,7.2,9,.3,18.2s-13.9,7.5-17.6,4.8-7.2-9-.3-18.2C546.4,101.1,550.3,99.3,553.6,99.3Z",
    transform: "translate(0.03 0.03)"
  })), _polygon186 || (_polygon186 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "608.43 144.93 592.43 128.73 585.13 135.93 599.13 150.03 593.53 155.63 579.53 141.53 566.03 154.93 559.33 148.23 591.43 116.43 614.03 139.23 608.43 144.93"
  })), _polygon187 || (_polygon187 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "610.03 209.53 604.93 201.63 642.83 177.13 647.93 185.03 610.03 209.53"
  })), _polygon188 || (_polygon188 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "647.03 208.83 646.93 208.73 618.23 223.33 614.23 215.53 654.53 195.03 659.03 203.93 639.13 234.13 639.13 234.23 667.23 220.03 671.13 227.83 630.93 248.33 626.63 239.93 647.03 208.83"
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M676.6,241l-42.9,14.1,6.1,18.6c4.7,14.2,19.1,13.4,28.3,10.4,8.1-2.7,19.4-9.7,14.7-24.2Zm-5.5,12.6,2.6,7.8c1.1,3.5,2,9.3-9.5,13.1-6.4,2.1-13.8,2.1-16-4.6l-2.6-7.9,25.5-8.4Z",
    transform: "translate(0.03 0.03)"
  })), _polygon189 || (_polygon189 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "648.23 305.93 646.23 296.73 690.43 287.13 692.43 296.43 648.23 305.93"
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M649.8,309.9l1.1,9.9,9.6,2.1,1.8,16.6-8.9,3.9,1.1,10.2,43.2-20.7-1.2-10.8-46.7-11.2ZM669,324l16.7,3.5v.1l-15.6,6.8Z",
    transform: "translate(0.03 0.03)"
  })), _polygon190 || (_polygon190 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "686.13 366.73 686.13 366.63 654.03 365.33 654.33 356.53 699.43 358.33 699.03 368.33 666.93 384.93 666.93 385.03 698.33 386.33 698.03 395.13 652.93 393.33 653.23 383.93 686.13 366.73"
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M652.7,397.2l-1.9,9.8,8.5,4.8-3.1,16.4-9.7,1.1-1.9,10.1,47.3-7.1,2.1-10.7Zm14.2,19.3,15,8.2v.1L665,426.7l1.9-10.2Z",
    transform: "translate(0.03 0.03)"
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M299.7,656.5l1.2.2c8.4,1.4,11.3-2.5,12.1-5.8l7.1,1.2-7.5,44-8.7-1.5,5.1-30.3-10.5-1.8,1.2-6Z",
    transform: "translate(0.03 0.03)"
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M345.5,654.8c-7.1.1-12.7,4.3-13.1,11.5a9.1,9.1,0,0,0,4.9,9c-7,2.8-7.3,8.7-7.4,10.9-.3,6.1,3.2,13.8,14.7,14.4,11.8.6,15.9-8,16.2-13.6.3-5.8-1.9-8.7-6.1-11.1a9.61,9.61,0,0,0,5.7-8.7c.3-6.1-4.3-11.9-13.5-12.4a6.53,6.53,0,0,0-1.4,0Zm.9,7.6h.7c2.6.1,4.6,2.2,4.4,5.3a4.78,4.78,0,0,1-5.2,4.8,5,5,0,0,1-4.9-5.3c.1-2.8,1.9-4.7,5-4.8Zm-.7,17.9c4.5.2,5.8,3.8,5.6,6.7s-1.9,6.3-6.1,6.1c-3.6-.2-5.8-2.9-5.6-6.8C339.9,681.8,342.8,680.1,345.7,680.3Z",
    transform: "translate(0.03 0.03)"
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M367.9,663.2l1.3-.1c8.5-.5,10.5-5,10.5-8.4l7.2-.4,2.6,44.6-8.8.5-1.8-30.7-10.6.6-.4-6.1Z",
    transform: "translate(0.03 0.03)"
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M416.7,650.5a9.2,9.2,0,0,0-1.9.2c-15.3,2.7-13.8,17.5-12.3,25.9,1.9,11,6.4,21.7,19.8,19.3,8.5-1.5,13.3-9,11.6-18.6-1.1-6.6-6.7-12.8-15.8-11.2-4.9.9-6.7,3.3-7.6,5.1l-.2-.1c-.7-5.8-.5-12.4,5.1-13.4,3.2-.6,5.1.9,5.8,3.3l8.6-1.5c-1.6-4.5-2.7-5.7-5.5-7.6C422.3,650.6,419,650.4,416.7,650.5Zm2,22.8c2.6,0,5.7,1.5,6.5,6.3,1,6-1.4,8.9-4.6,9.4-4.2.7-7.5-2.2-8.3-7-1-5.5,2-8.1,5.3-8.7Z",
    transform: "translate(0.03 0.03)"
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M362.4,626.8c146.2,0,264.7-118.5,264.7-264.7S508.6,97.3,362.4,97.3,97.7,215.9,97.7,362,216.2,626.8,362.4,626.8Z",
    transform: "translate(0.03 0.03)"
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M397.6,218.3a59.41,59.41,0,0,1,.8,13.8l2.2,1.9.4-10.9,3-1.5-.4-2.3-3.4,1.5a9.3,9.3,0,0,1,.8-3.7l-1.5-2.2-1.9,3.4Z",
    transform: "translate(0.03 0.03)"
  })), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M397.6,218.3a59.41,59.41,0,0,1,.8,13.8l2.2,1.9.4-10.9,3-1.5-.4-2.3-3.4,1.5a9.3,9.3,0,0,1,.8-3.7l-1.5-2.2-1.9,3.4Z",
    transform: "translate(0.03 0.03)"
  })), _polygon191 || (_polygon191 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "402.93 224.73 402.53 230.33 406.23 230.33 407.43 223.53 402.93 224.73"
  })), _polygon192 || (_polygon192 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "402.93 224.73 402.53 230.33 406.23 230.33 407.43 223.53 402.93 224.73"
  })), _polygon193 || (_polygon193 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "405.13 176.43 404.73 183.53 410.03 182.73 414.53 173.73 405.13 176.43"
  })), _polygon194 || (_polygon194 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "405.13 176.43 404.73 183.53 410.03 182.73 414.53 173.73 405.13 176.43"
  })), _polygon195 || (_polygon195 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "405.93 171.53 404.73 173.73 413.73 171.53 411.83 170.03 405.93 171.53"
  })), _polygon196 || (_polygon196 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "405.93 171.53 404.73 173.73 413.73 171.53 411.83 170.03 405.93 171.53"
  })), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M407.4,168.5c.4,0,4.1-1.1,4.1-1.1l.4-3h-2.2l-2.2,2.3v1.8Z",
    transform: "translate(0.03 0.03)"
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M407.4,168.5c.4,0,4.1-1.1,4.1-1.1l.4-3h-2.2l-2.2,2.3v1.8Z",
    transform: "translate(0.03 0.03)"
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M416.3,151.3c0,.4-3.8,6.7-3.8,6.7l-.4,4.5s2.6,1.9,2.6,1.5,2.6-10.1,2.6-10.1l-1-2.6Z",
    transform: "translate(0.03 0.03)"
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M416.3,151.3c0,.4-3.8,6.7-3.8,6.7l-.4,4.5s2.6,1.9,2.6,1.5,2.6-10.1,2.6-10.1l-1-2.6Z",
    transform: "translate(0.03 0.03)"
  })), _polygon197 || (_polygon197 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "356.43 609.53 356.83 615.13 353.83 617.73 354.93 611.43 356.43 609.53"
  })), _polygon198 || (_polygon198 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "356.43 609.53 356.83 615.13 353.83 617.73 354.93 611.43 356.43 609.53"
  })), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M252.7,513.3s-.4,10.9-3.4,18.7c0,0,.8,13.5,0,20.2l3-6-.8-3,4.5-20.6,1.5-.8s-1.5,13.5-3.4,19.1l1.9-.4s2.2-6.7,2.2-9.7l1.9-1.5.4-6.7,1.5-1.5-.8-6.4,1.9-1.1-2.6-.4-2.3,1.5-.4-2.2-2.6.8-1.1,6-1.4-6Z",
    transform: "translate(0.03 0.03)"
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M252.7,513.3s-.4,10.9-3.4,18.7c0,0,.8,13.5,0,20.2l3-6-.8-3,4.5-20.6,1.5-.8s-1.5,13.5-3.4,19.1l1.9-.4s2.2-6.7,2.2-9.7l1.9-1.5.4-6.7,1.5-1.5-.8-6.4,1.9-1.1-2.6-.4-2.3,1.5-.4-2.2-2.6.8-1.1,6-1.4-6Z",
    transform: "translate(0.03 0.03)"
  })), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M264,517.4c-.4,6.4-3.4,18-5.6,25.1s-5.2,10.5-6,13.1-1.1,6,0,6.4,3.4-3.7,3-6.7c0,0,4.1-4.9,4.9-8.6s2.3-9,2.3-12l1.5-1.5.4-1.5-.8-2.2.8-2.3s1.1-7.5,1.5-10.1Z",
    transform: "translate(0.03 0.03)"
  })), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M264,517.4c-.4,6.4-3.4,18-5.6,25.1s-5.2,10.5-6,13.1-1.1,6,0,6.4,3.4-3.7,3-6.7c0,0,4.1-4.9,4.9-8.6s2.3-9,2.3-12l1.5-1.5.4-1.5-.8-2.2.8-2.3s1.1-7.5,1.5-10.1Z",
    transform: "translate(0.03 0.03)"
  })), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M264,539.9c-.4,3.8-2.6,7.3-2.6,10.1,0,.4-.4,4.1-.4,4.1l2.3-.8.8-3.8a8.71,8.71,0,0,0,2.2-4.9A5.54,5.54,0,0,0,264,539.9Z",
    transform: "translate(0.03 0.03)"
  })), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M264,539.9c-.4,3.8-2.6,7.3-2.6,10.1,0,.4-.4,4.1-.4,4.1l2.3-.8.8-3.8a8.71,8.71,0,0,0,2.2-4.9A5.54,5.54,0,0,0,264,539.9Z",
    transform: "translate(0.03 0.03)"
  })), _polygon199 || (_polygon199 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "298.03 517.43 298.03 519.33 303.33 521.13 302.53 518.53 298.03 517.43"
  })), _polygon200 || (_polygon200 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "298.03 517.43 298.03 519.33 303.33 521.13 302.53 518.53 298.03 517.43"
  })), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M256.1,504.7l-5.6-.4-5.2,9.4-.8,4.5,3-1.5v2.6l-2.2,1.5a13.33,13.33,0,0,1-.8,4.1c-.8,2.2-3.4,7.1-3.4,12,0,0-3,2.2-3.4,4.9s-.4,9.7-.4,9.7l3-2.3s2.6-6,4.5-9.7,5.6-15.3,6-21,.8-10.9.8-10.9a7.35,7.35,0,0,1,4.1-1.1l.4-1.8Z",
    transform: "translate(0.03 0.03)"
  })), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M256.1,504.7l-5.6-.4-5.2,9.4-.8,4.5,3-1.5v2.6l-2.2,1.5a13.33,13.33,0,0,1-.8,4.1c-.8,2.2-3.4,7.1-3.4,12,0,0-3,2.2-3.4,4.9s-.4,9.7-.4,9.7l3-2.3s2.6-6,4.5-9.7,5.6-15.3,6-21,.8-10.9.8-10.9a7.35,7.35,0,0,1,4.1-1.1l.4-1.8Z",
    transform: "translate(0.03 0.03)"
  })), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M246.8,544a51.73,51.73,0,0,1-4.9,12.4l-.4,6,2.6-1.1s4.1-6.7,4.1-12.7l-1.4-4.6Z",
    transform: "translate(0.03 0.03)"
  })), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M246.8,544a51.73,51.73,0,0,1-4.9,12.4l-.4,6,2.6-1.1s4.1-6.7,4.1-12.7l-1.4-4.6Z",
    transform: "translate(0.03 0.03)"
  })), _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M241.1,566.1l-1.1,3.4-.4,8.6,2.2-.4.8-8.6s3.2-2.4,1.9-3.7C241.9,562.7,241.1,566.1,241.1,566.1Z",
    transform: "translate(0.03 0.03)"
  })), _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M241.1,566.1l-1.1,3.4-.4,8.6,2.2-.4.8-8.6s3.2-2.4,1.9-3.7C241.9,562.7,241.1,566.1,241.1,566.1Z",
    transform: "translate(0.03 0.03)"
  })), _polygon201 || (_polygon201 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "255.73 570.23 255.43 573.23 258.03 573.23 258.43 570.23 255.73 570.23"
  })), _polygon202 || (_polygon202 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "255.73 570.23 255.43 573.23 258.03 573.23 258.43 570.23 255.73 570.23"
  })), _polygon203 || (_polygon203 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "253.13 575.83 252.73 578.83 255.43 578.83 255.73 575.83 253.13 575.83"
  })), _polygon204 || (_polygon204 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "253.13 575.83 252.73 578.83 255.43 578.83 255.73 575.83 253.13 575.83"
  })), _polygon205 || (_polygon205 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "250.53 581.83 250.13 584.83 252.73 584.83 253.13 581.83 250.53 581.83"
  })), _polygon206 || (_polygon206 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "250.53 581.83 250.13 584.83 252.73 584.83 253.13 581.83 250.53 581.83"
  })), _polygon207 || (_polygon207 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "261.03 571.33 260.63 574.33 263.23 574.33 263.63 571.33 261.03 571.33"
  })), _polygon208 || (_polygon208 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "261.03 571.33 260.63 574.33 263.23 574.33 263.63 571.33 261.03 571.33"
  })), _polygon209 || (_polygon209 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "258.43 576.93 258.03 579.93 260.63 579.93 261.03 576.93 258.43 576.93"
  })), _polygon210 || (_polygon210 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "258.43 576.93 258.03 579.93 260.63 579.93 261.03 576.93 258.43 576.93"
  })), _polygon211 || (_polygon211 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "255.73 582.93 255.43 585.93 258.03 585.93 258.43 582.93 255.73 582.93"
  })), _polygon212 || (_polygon212 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "255.73 582.93 255.43 585.93 258.03 585.93 258.43 582.93 255.73 582.93"
  })), _polygon213 || (_polygon213 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "252.43 588.93 252.03 591.93 254.63 591.93 255.03 588.93 252.43 588.93"
  })), _polygon214 || (_polygon214 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "252.43 588.93 252.03 591.93 254.63 591.93 255.03 588.93 252.43 588.93"
  })), _polygon215 || (_polygon215 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "248.23 572.83 247.13 578.03 249.73 578.03 250.93 572.83 248.23 572.83"
  })), _polygon216 || (_polygon216 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "248.23 572.83 247.13 578.03 249.73 578.03 250.93 572.83 248.23 572.83"
  })), _polygon217 || (_polygon217 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "243.83 583.33 243.43 586.33 246.03 586.33 246.43 583.33 243.83 583.33"
  })), _polygon218 || (_polygon218 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "243.83 583.33 243.43 586.33 246.03 586.33 246.43 583.33 243.83 583.33"
  })), _polygon219 || (_polygon219 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "249.03 564.93 248.63 567.93 251.23 567.93 251.63 564.93 249.03 564.93"
  })), _polygon220 || (_polygon220 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "249.03 564.93 248.63 567.93 251.23 567.93 251.63 564.93 249.03 564.93"
  })), _polygon221 || (_polygon221 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "272.63 581.03 270.33 580.73 270.03 590.43 271.13 591.53 273.33 585.53 272.63 581.03"
  })), _polygon222 || (_polygon222 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "272.63 581.03 270.33 580.73 270.03 590.43 271.13 591.53 273.33 585.53 272.63 581.03"
  })), _polygon223 || (_polygon223 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "235.53 578.03 235.23 584.43 237.43 586.73 237.83 579.53 235.53 578.03"
  })), _polygon224 || (_polygon224 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "235.53 578.03 235.23 584.43 237.43 586.73 237.83 579.53 235.53 578.03"
  })), _polygon225 || (_polygon225 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "222.13 535.73 226.23 521.53 225.03 518.93 219.43 536.13 217.93 545.93 219.43 545.53 222.13 535.73"
  })), _polygon226 || (_polygon226 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "222.13 535.73 226.23 521.53 225.03 518.93 219.43 536.13 217.93 545.93 219.43 545.53 222.13 535.73"
  })), _polygon227 || (_polygon227 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "224.33 539.53 226.93 533.53 225.83 529.43 222.13 539.53 221.73 544.73 223.23 545.93 224.33 539.53"
  })), _polygon228 || (_polygon228 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "224.33 539.53 226.93 533.53 225.83 529.43 222.13 539.53 221.73 544.73 223.23 545.93 224.33 539.53"
  })), _polygon229 || (_polygon229 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "233.73 537.63 232.53 534.23 229.53 541.73 229.23 547.73 230.73 548.53 233.73 537.63"
  })), _polygon230 || (_polygon230 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "233.73 537.63 232.53 534.23 229.53 541.73 229.23 547.73 230.73 548.53 233.73 537.63"
  })), _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M229.9,517.4c-1.5,4.9-2.6,10.1-1.5,14.2l2.3-.4a29.79,29.79,0,0,1,2.2-7.1,7.76,7.76,0,0,0,.4-7.5Z",
    transform: "translate(0.03 0.03)"
  })), _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M229.9,517.4c-1.5,4.9-2.6,10.1-1.5,14.2l2.3-.4a29.79,29.79,0,0,1,2.2-7.1,7.76,7.76,0,0,0,.4-7.5Z",
    transform: "translate(0.03 0.03)"
  })), _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M230.3,515.5l3-1.1s3.3-3.4,4.5-6.4c1.7-4.3-2.2-5.9-4.1-3C230.7,509.5,230.3,515.5,230.3,515.5Z",
    transform: "translate(0.03 0.03)"
  })), _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M230.3,515.5l3-1.1s3.3-3.4,4.5-6.4c1.7-4.3-2.2-5.9-4.1-3C230.7,509.5,230.3,515.5,230.3,515.5Z",
    transform: "translate(0.03 0.03)"
  })), _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M232.5,503.9c-1.5,3-3,5.2-3.4,8.6l-2.6.4s-.4-4.5,1.1-7.1,4.9-1.9,4.9-1.9Z",
    transform: "translate(0.03 0.03)"
  })), _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M232.5,503.9c-1.5,3-3,5.2-3.4,8.6l-2.6.4s-.4-4.5,1.1-7.1,4.9-1.9,4.9-1.9Z",
    transform: "translate(0.03 0.03)"
  })), _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M227.3,502.8c-1.9,3.4-3,9-3,13.5a68.39,68.39,0,0,0-2.6,8.2l-2.6.8a39.49,39.49,0,0,1,2.3-8.2s-1.9-4.5-1.1-8.2a24.77,24.77,0,0,1,2.6-6.7Z",
    transform: "translate(0.03 0.03)"
  })), _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M227.3,502.8c-1.9,3.4-3,9-3,13.5a68.39,68.39,0,0,0-2.6,8.2l-2.6.8a39.49,39.49,0,0,1,2.3-8.2s-1.9-4.5-1.1-8.2a24.77,24.77,0,0,1,2.6-6.7Z",
    transform: "translate(0.03 0.03)"
  })), _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M220.2,502.4a16.55,16.55,0,0,0-1.5,12l-1.5,5.6,1.9.8s-1.5,5.2-2.2,8.6l-4.1.7v-2.6l-2.3-.4a83,83,0,0,1,2.3-12.4l2.3-.4s.4-8.2,1.5-12l-1.5,1.1a38.09,38.09,0,0,0-3.4,9.4h-2.6l-.7-4.5,3.7-4.1v-2.6a10.25,10.25,0,0,1,3.4-4.1s9-.4,13.5.4l-2.6,2.3c-.2,0-5.1.4-6.2,2.2Z",
    transform: "translate(0.03 0.03)"
  })), _path303 || (_path303 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M220.2,502.4a16.55,16.55,0,0,0-1.5,12l-1.5,5.6,1.9.8s-1.5,5.2-2.2,8.6l-4.1.7v-2.6l-2.3-.4a83,83,0,0,1,2.3-12.4l2.3-.4s.4-8.2,1.5-12l-1.5,1.1a38.09,38.09,0,0,0-3.4,9.4h-2.6l-.7-4.5,3.7-4.1v-2.6a10.25,10.25,0,0,1,3.4-4.1s9-.4,13.5.4l-2.6,2.3c-.2,0-5.1.4-6.2,2.2Z",
    transform: "translate(0.03 0.03)"
  })), _path304 || (_path304 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M206,490.1h-4.9a16.3,16.3,0,0,0-5.2,10.1l1.5,3.4,3.4-2.6-.4-2.6A32.08,32.08,0,0,1,206,490.1Z",
    transform: "translate(0.03 0.03)"
  })), _path305 || (_path305 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M206,490.1h-4.9a16.3,16.3,0,0,0-5.2,10.1l1.5,3.4,3.4-2.6-.4-2.6A32.08,32.08,0,0,1,206,490.1Z",
    transform: "translate(0.03 0.03)"
  })), _path306 || (_path306 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M197,493.1a30,30,0,0,0-3,6.4l-1.9-2.6a10.49,10.49,0,0,1,3.8-6.7Z",
    transform: "translate(0.03 0.03)"
  })), _path307 || (_path307 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M197,493.1a30,30,0,0,0-3,6.4l-1.9-2.6a10.49,10.49,0,0,1,3.8-6.7Z",
    transform: "translate(0.03 0.03)"
  })), _path308 || (_path308 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M192.5,492.3a30.41,30.41,0,0,0-4.9,11.2H185l-1.9-4.5,1.1-4.1-1.5-1.5a19.64,19.64,0,0,0-2.6,7.9,20.31,20.31,0,0,1-4.9,11.6,67.27,67.27,0,0,1,.8-10.5l-1.9,1.5a94.84,94.84,0,0,0-1.9,11.2l-2.2,1.1s0-8.6,1.1-13.9a71.65,71.65,0,0,1,3-10.9l-1.1-4.1-2.3-1.9,1.1-7.9,7.1,2.2-1.1,2.6-2.6-1.1-.4,1.5,2.3,1.5a9.19,9.19,0,0,0-1.1,4.1l1.1.8a34.11,34.11,0,0,1,2.6-6.7h3.4l4.9,1.9-1.5,1.5H182a61.65,61.65,0,0,0-3.4,7.5l1.5-.4,2.6-4.9,5.6-1.1-1.5,4.5.4,1.9s2.6-4.9,3.7-7.1h4.9l3.4,2.2-1.5,1.1-4.1-.8-1.1,3.6Z",
    transform: "translate(0.03 0.03)"
  })), _path309 || (_path309 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M192.5,492.3a30.41,30.41,0,0,0-4.9,11.2H185l-1.9-4.5,1.1-4.1-1.5-1.5a21.54,21.54,0,0,0-2.6,7.9,20,20,0,0,1-4.9,11.6,67.27,67.27,0,0,1,.8-10.5l-1.9,1.5a94.84,94.84,0,0,0-1.9,11.2l-2.2,1.1s0-8.6,1.1-13.9a71.65,71.65,0,0,1,3-10.9l-1.1-4.1-2.3-1.9,1.1-7.9,7.1,2.2-1.1,2.6-2.6-1.1-.4,1.5,2.3,1.5a9.19,9.19,0,0,0-1.1,4.1l1.1.8a34.11,34.11,0,0,1,2.6-6.7h3.4l4.9,1.9-1.5,1.5H182a61.65,61.65,0,0,0-3.4,7.5l1.5-.4,2.6-4.9,5.6-1.1-1.5,4.5.4,1.9s2.6-4.9,3.7-7.1h4.9l3.4,2.2-1.5,1.1-4.1-.8Z",
    transform: "translate(0.03 0.03)"
  })), _path310 || (_path310 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M169.6,477c-.4,4.5-1.5,14.2-1.5,18.7l-3.8,4.9-.8,4.5-1.9-1.1a104.08,104.08,0,0,1,.7-12.4,87.58,87.58,0,0,0,1.9-17.2l5.4,2.6Z",
    transform: "translate(0.03 0.03)"
  })), _path311 || (_path311 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M169.6,477c-.4,4.5-1.5,14.2-1.5,18.7l-3.8,4.9-.8,4.5-1.9-1.1a104.08,104.08,0,0,1,.7-12.4,87.58,87.58,0,0,0,1.9-17.2l5.4,2.6Z",
    transform: "translate(0.03 0.03)"
  })), _path312 || (_path312 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M162.5,473.6,161,493.4l-3.8,3.7.8-6.7-1.5-1.5s-.8,11.6-1.1,11.6a10.49,10.49,0,0,1-1.9-1.5s-.8-7.5-.4-11.2,1.9-12,1.5-19.1l4.1,3.4-1.5,14.6,1.5,1.5,1.5-15.3Z",
    transform: "translate(0.03 0.03)"
  })), _path313 || (_path313 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M162.5,473.6,161,493.4l-3.8,3.7.8-6.7-1.5-1.5s-.8,11.6-1.1,11.6a10.49,10.49,0,0,1-1.9-1.5s-.8-7.5-.4-11.2,1.9-12,1.5-19.1l4.1,3.4-1.5,14.6,1.5,1.5,1.5-15.3Z",
    transform: "translate(0.03 0.03)"
  })), _polygon231 || (_polygon231 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "152.83 469.53 152.03 480.73 148.33 478.13 147.93 466.53 152.83 469.53"
  })), _polygon232 || (_polygon232 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "152.83 469.53 152.03 480.73 148.33 478.13 147.93 466.53 152.83 469.53"
  })), _polygon233 || (_polygon233 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "141.63 483.73 137.53 478.13 137.53 468.03 139.73 469.53 140.43 461.63 143.13 463.93 142.73 471.43 144.23 472.93 142.33 478.13 141.63 483.73"
  })), _polygon234 || (_polygon234 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "141.63 483.73 137.53 478.13 137.53 468.03 139.73 469.53 140.43 461.63 143.13 463.93 142.73 471.43 144.23 472.93 142.33 478.13 141.63 483.73"
  })), _path314 || (_path314 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M181.6,506.5a52,52,0,0,0-3,13.1l1.9.8,3-6a21.92,21.92,0,0,1-.4-6.4Z",
    transform: "translate(0.03 0.03)"
  })), _path315 || (_path315 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M181.6,506.5a52,52,0,0,0-3,13.1l1.9.8,3-6a21.92,21.92,0,0,1-.4-6.4Z",
    transform: "translate(0.03 0.03)"
  })), _polygon235 || (_polygon235 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "201.83 533.53 203.03 524.53 201.53 523.03 197.03 531.23 196.63 539.93 198.53 542.13 201.83 533.53"
  })), _polygon236 || (_polygon236 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "201.83 533.53 203.03 524.53 201.53 523.03 197.03 531.23 196.63 539.93 198.53 542.13 201.83 533.53"
  })), _path316 || (_path316 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M189.1,517.4c-2.3,3.4-3,7.5-3.4,11.2l1.1,1.9,2.6-9Z",
    transform: "translate(0.03 0.03)"
  })), _path317 || (_path317 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M189.1,517.4c-2.3,3.4-3,7.5-3.4,11.2l1.1,1.9,2.6-9Z",
    transform: "translate(0.03 0.03)"
  })), _path318 || (_path318 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M191,524.9c-2.2,3.4-3.4,9.7-3.4,9.7l3,1.5s0-6,1.5-9Z",
    transform: "translate(0.03 0.03)"
  })), _path319 || (_path319 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M191,524.9c-2.2,3.4-3.4,9.7-3.4,9.7l3,1.5s0-6,1.5-9Z",
    transform: "translate(0.03 0.03)"
  })), _polygon237 || (_polygon237 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "195.53 543.63 193.63 541.43 191.73 544.03 191.73 547.73 195.53 552.23 195.53 543.63"
  })), _polygon238 || (_polygon238 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "195.53 543.63 193.63 541.43 191.73 544.03 191.73 547.73 195.53 552.23 195.53 543.63"
  })), _polygon239 || (_polygon239 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "143.83 456.43 143.83 459.03 152.43 462.73 151.73 460.13 143.83 456.43"
  })), _polygon240 || (_polygon240 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "143.83 456.43 143.83 459.03 152.43 462.73 151.73 460.13 143.83 456.43"
  })), _polygon241 || (_polygon241 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "162.53 464.63 162.93 467.23 168.13 469.53 167.83 466.93 162.53 464.63"
  })), _polygon242 || (_polygon242 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "162.53 464.63 162.93 467.23 168.13 469.53 167.83 466.93 162.53 464.63"
  })), _polygon243 || (_polygon243 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "163.63 461.23 163.63 463.13 169.33 465.43 168.93 463.53 163.63 461.23"
  })), _polygon244 || (_polygon244 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "163.63 461.23 163.63 463.13 169.33 465.43 168.93 463.53 163.63 461.23"
  })), _polygon245 || (_polygon245 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "163.33 456.03 163.33 457.93 168.93 460.13 168.53 458.33 163.33 456.03"
  })), _polygon246 || (_polygon246 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "163.33 456.03 163.33 457.93 168.93 460.13 168.53 458.33 163.33 456.03"
  })), _polygon247 || (_polygon247 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "158.43 453.83 158.03 456.83 160.73 456.83 161.03 453.83 158.43 453.83"
  })), _polygon248 || (_polygon248 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "158.43 453.83 158.03 456.83 160.73 456.83 161.03 453.83 158.43 453.83"
  })), _polygon249 || (_polygon249 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "152.03 450.83 151.73 453.83 154.33 453.83 154.73 450.83 152.03 450.83"
  })), _polygon250 || (_polygon250 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "152.03 450.83 151.73 453.83 154.33 453.83 154.73 450.83 152.03 450.83"
  })), _polygon251 || (_polygon251 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "146.43 447.83 146.13 450.83 148.73 450.83 149.13 447.83 146.43 447.83"
  })), _polygon252 || (_polygon252 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "146.43 447.83 146.13 450.83 148.73 450.83 149.13 447.83 146.43 447.83"
  })), _polygon253 || (_polygon253 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "172.63 453.83 172.33 456.83 174.93 456.83 175.33 453.83 172.63 453.83"
  })), _polygon254 || (_polygon254 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "172.63 453.83 172.33 456.83 174.93 456.83 175.33 453.83 172.63 453.83"
  })), _polygon255 || (_polygon255 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "177.13 456.03 176.83 459.03 179.43 459.03 179.83 456.03 177.13 456.03"
  })), _polygon256 || (_polygon256 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "177.13 456.03 176.83 459.03 179.43 459.03 179.83 456.03 177.13 456.03"
  })), _polygon257 || (_polygon257 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "149.43 500.23 149.13 503.23 151.73 503.23 152.03 500.23 149.43 500.23"
  })), _polygon258 || (_polygon258 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "149.43 500.23 149.13 503.23 151.73 503.23 152.03 500.23 149.43 500.23"
  })), _polygon259 || (_polygon259 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "201.13 513.73 200.73 516.73 203.33 516.73 203.73 513.73 201.13 513.73"
  })), _polygon260 || (_polygon260 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "201.13 513.73 200.73 516.73 203.33 516.73 203.73 513.73 201.13 513.73"
  })), _polygon261 || (_polygon261 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "148.73 481.83 150.23 483.03 150.23 490.13 147.63 489.03 147.63 485.63 148.73 481.83"
  })), _polygon262 || (_polygon262 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "148.73 481.83 150.23 483.03 150.23 490.13 147.63 489.03 147.63 485.63 148.73 481.83"
  })), _path320 || (_path320 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M262.1,491.2l2.3,1.9a14.2,14.2,0,0,0-3.4,4.5,18.59,18.59,0,0,0-.8,5.2l2.3,1.1,1.5-4.1-1.1-1.9,1.5-.4,2.6-3.7,1.5,1.1s-2.3,1.9-2.3,3.7l1.5,1.9,3-6,.4,2.6-1.5,4.1,1.9,1.1s.4-3.7,3-5.6v5.2a21.71,21.71,0,0,1,3.4-3.7l1.5.8-1.5,2.6.8,1.5,2.3-3,.8,3,1.5-1.5h1.5v2.6l1.5,1.1,1.5-2.6,1.9.4-.4,2.6,2.6-3,1.1.4-.8,2.6,3-1.1.8,2.2h1.9l1.1-1.9,1.5.4-.8,2.6,3,1.1,1.5-3,1.5.8-.4,4.1,3.8-3,1.9,1.5-1.1,1.9,1.9,1.1.8-1.9,1.5.4s0,2.3,1.5,2.6,2.2-1.9,2.6-1.9a7.54,7.54,0,0,1,1.5.4v1.9l3-.4.8,1.9,3,1.1,1.5-3,2.3,2.6,1.5-1.1h1.9l.4,1.5h4.1l-1.9,3.4,3,.4,1.5-3.7s1.5-2.6,6.4-2.3l1.9,1.9H351a28.21,28.21,0,0,0,4.1-8.6l-1.5-1.5a10.64,10.64,0,0,0-2.6,3l-.8-1.5,2.6-4.9v-2.6a17.17,17.17,0,0,1,1.9-4.5l1.9-.8v1.9s3,.4,3.8,1.9l-.4,2.2,2.2,1.1v-3.4l-2.6-3.7s-.8-5.6-3.8-5.2-5.6,3.7-7.5,7.5-7.9,12.7-7.9,12.7l-7.5-1.1-2.6-1.1-3,.4-1.1-2.3s-10.9-1.9-16.8-3.4-34.1-11.2-38.9-14.2l-1.5,3-3.4-1.7",
    transform: "translate(0.03 0.03)"
  })), _path321 || (_path321 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M262.1,491.2l2.3,1.9a14.2,14.2,0,0,0-3.4,4.5,18.59,18.59,0,0,0-.8,5.2l2.3,1.1,1.5-4.1-1.1-1.9,1.5-.4,2.6-3.7,1.5,1.1s-2.3,1.9-2.3,3.7l1.5,1.9,3-6,.4,2.6-1.5,4.1,1.9,1.1s.4-3.7,3-5.6v5.2a21.71,21.71,0,0,1,3.4-3.7l1.5.8-1.5,2.6.8,1.5,2.3-3,.8,3,1.5-1.5h1.5v2.6l1.5,1.1,1.5-2.6,1.9.4-.4,2.6,2.6-3,1.1.4-.8,2.6,3-1.1.8,2.2h1.9l1.1-1.9,1.5.4-.8,2.6,3,1.1,1.5-3,1.5.8-.4,4.1,3.8-3,1.9,1.5-1.1,1.9,1.9,1.1.8-1.9,1.5.4s0,2.3,1.5,2.6,2.2-1.9,2.6-1.9a7.54,7.54,0,0,1,1.5.4v1.9l3-.4.8,1.9,3,1.1,1.5-3,2.3,2.6,1.5-1.1h1.9l.4,1.5h4.1l-1.9,3.4,3,.4,1.5-3.7s1.5-2.6,6.4-2.3l1.9,1.9H351a28.21,28.21,0,0,0,4.1-8.6l-1.5-1.5a10.64,10.64,0,0,0-2.6,3l-.8-1.5,2.6-4.9v-2.6a17.17,17.17,0,0,1,1.9-4.5l1.9-.8v1.9s3,.4,3.8,1.9l-.4,2.2,2.2,1.1v-3.4l-2.6-3.7s-.8-5.6-3.8-5.2-5.6,3.7-7.5,7.5-7.9,12.7-7.9,12.7l-7.5-1.1-2.6-1.1-3,.4-1.1-2.3s-10.9-1.9-16.8-3.4-34.1-11.2-38.9-14.2l-1.5,3-3.4-1.7",
    transform: "translate(0.03 0.03)"
  })), _path322 || (_path322 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M268.1,516.7c0,4.1-1.5,14.6-2.6,20.6l2.6,4.1v10.5l2.3,1.9,1.1-11.2,3,1.5.8-2.3,2.2-1.5v-7.1l2.3-3-.4,5.6,2.6-.4V529l1.5-.8v8.2l5.2-.4v-2.6l-3-5.6,1.5-.4,3,5.2h6s3,3.7,0,4.9l-3.4.4,1.1,4.9h1.5l.8-3.4,1.9-.8a13.53,13.53,0,0,0,6.4,1.9c3.4,0,6.4-1.1,6.7-4.5l2.3-1.5s-.4-2.6-2.6-3l7.1-1.1-.4-1.5-18-.4,2.2-1.1h9l-1.9-1.9s-8.2-.4-10.1-.4a5.86,5.86,0,0,0-5.2,2.6c-1.1,1.9-2.6,1.1-3.4-.4l-.8-3s8.2-1.1,10.9-1.1l-1.9-2.2-11.6.4-2.3-.8,6-1.1-1.1-1.5-13.5.8-1.5,2.3.8,1.9a14.47,14.47,0,0,0-2.3,4.9l-1.1-1.9,1.9-5.6-1.5-1.5-2.3,5.6v-7.9l-1.8.1Z",
    transform: "translate(0.03 0.03)"
  })), _path323 || (_path323 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M268.1,516.7c0,4.1-1.5,14.6-2.6,20.6l2.6,4.1v10.5l2.3,1.9,1.1-11.2,3,1.5.8-2.3,2.2-1.5v-7.1l2.3-3-.4,5.6,2.6-.4V529l1.5-.8v8.2l5.2-.4v-2.6l-3-5.6,1.5-.4,3,5.2h6s3,3.7,0,4.9l-3.4.4,1.1,4.9h1.5l.8-3.4,1.9-.8a13.53,13.53,0,0,0,6.4,1.9c3.4,0,6.4-1.1,6.7-4.5l2.3-1.5s-.4-2.6-2.6-3l7.1-1.1-.4-1.5-18-.4,2.2-1.1h9l-1.9-1.9s-8.2-.4-10.1-.4a5.86,5.86,0,0,0-5.2,2.6c-1.1,1.9-2.6,1.1-3.4-.4l-.8-3s8.2-1.1,10.9-1.1l-1.9-2.2-11.6.4-2.3-.8,6-1.1-1.1-1.5-13.5.8-1.5,2.3.8,1.9a14.47,14.47,0,0,0-2.3,4.9l-1.1-1.9,1.9-5.6-1.5-1.5-2.3,5.6v-7.9l-1.8.1Z",
    transform: "translate(0.03 0.03)"
  })), _path324 || (_path324 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M279.7,543.6v5.6a112.84,112.84,0,0,1-4.9,11.2l1.9-.4,4.9-10.9.4-5.2Z",
    transform: "translate(0.03 0.03)"
  })), _path325 || (_path325 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M279.7,543.6v5.6a112.84,112.84,0,0,1-4.9,11.2l1.9-.4,4.9-10.9.4-5.2Z",
    transform: "translate(0.03 0.03)"
  })), _path326 || (_path326 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M283.5,546.2s-.8,8.2-1.5,12a49.3,49.3,0,0,1-6.7,15.3h1.9s5.6-9,7.1-13.5a48.4,48.4,0,0,0,1.9-7.1l1.5-1.9v-2.3l-2.3-.4v-2.6Z",
    transform: "translate(0.03 0.03)"
  })), _path327 || (_path327 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M283.5,546.2s-.8,8.2-1.5,12a49.3,49.3,0,0,1-6.7,15.3h1.9s5.6-9,7.1-13.5a48.4,48.4,0,0,0,1.9-7.1l1.5-1.9v-2.3l-2.3-.4v-2.6Z",
    transform: "translate(0.03 0.03)"
  })), _path328 || (_path328 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M287.2,556.3a47.8,47.8,0,0,1-5.2,13.9v2.2l3.4-.8,2.3,3.4s3-1.9,2.6-4.9-1.5-13.9-1.5-13.9h-1.6Z",
    transform: "translate(0.03 0.03)"
  })), _path329 || (_path329 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M287.2,556.3a47.8,47.8,0,0,1-5.2,13.9v2.2l3.4-.8,2.3,3.4s3-1.9,2.6-4.9-1.5-13.9-1.5-13.9h-1.6Z",
    transform: "translate(0.03 0.03)"
  })), _path330 || (_path330 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M289.4,539.9c.8,7.9,1.5,13.9,1.9,19.1s.8,19.5.8,19.5l2.2-1.5s0-14.2-.4-20.2-2.2-18.4-2.2-18.4Z",
    transform: "translate(0.03 0.03)"
  })), _path331 || (_path331 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M289.4,539.9c.8,7.9,1.5,13.9,1.9,19.1s.8,19.5.8,19.5l2.2-1.5s0-14.2-.4-20.2-2.2-18.4-2.2-18.4Z",
    transform: "translate(0.03 0.03)"
  })), _path332 || (_path332 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M294.3,548.5c0,3.8,2.2,6.7,2.2,11.2l1.9-.8s0-7.5-.4-9.7S294.3,547,294.3,548.5Z",
    transform: "translate(0.03 0.03)"
  })), _path333 || (_path333 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M294.3,548.5c0,3.8,2.2,6.7,2.2,11.2l1.9-.8s0-7.5-.4-9.7S294.3,547,294.3,548.5Z",
    transform: "translate(0.03 0.03)"
  })), _path334 || (_path334 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M301,550c-1.5.4-1.5,5.6-1.1,9.7s2.2,12.4,2.6,19.5a152,152,0,0,1,0,19.1l.7,3s2.6-13.5,2.6-23.2S304,549.2,301,550Z",
    transform: "translate(0.03 0.03)"
  })), _path335 || (_path335 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M301,550c-1.5.4-1.5,5.6-1.1,9.7s2.2,12.4,2.6,19.5a152,152,0,0,1,0,19.1l.7,3s2.6-13.5,2.6-23.2S304,549.2,301,550Z",
    transform: "translate(0.03 0.03)"
  })), _path336 || (_path336 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M311.9,541.7c-3.4-.4-7.5-.4-9.4,3,0,0,1.1,4.9,1.9,7.1a49.08,49.08,0,0,1,2.3,9l1.9-2.6-1.5-5.6a14.61,14.61,0,0,0,2.6,1.9c.4,0,.4-4.5.4-4.5s-1.5-3.7-4.9-4.5a30.54,30.54,0,0,1,4.1-1.1C311.1,544,311.9,541.7,311.9,541.7Z",
    transform: "translate(0.03 0.03)"
  })), _path337 || (_path337 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M311.9,541.7c-3.4-.4-7.5-.4-9.4,3,0,0,1.1,4.9,1.9,7.1a49.08,49.08,0,0,1,2.3,9l1.9-2.6-1.5-5.6a14.61,14.61,0,0,0,2.6,1.9c.4,0,.4-4.5.4-4.5s-1.5-3.7-4.9-4.5a30.54,30.54,0,0,1,4.1-1.1C311.1,544,311.9,541.7,311.9,541.7Z",
    transform: "translate(0.03 0.03)"
  })), _path338 || (_path338 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M311.5,558.6l-2.3,3s.4,9.7,0,14.2c0,0,3-5.2,3-9A61.61,61.61,0,0,0,311.5,558.6Z",
    transform: "translate(0.03 0.03)"
  })), _path339 || (_path339 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M311.5,558.6l-2.3,3s.4,9.7,0,14.2c0,0,3-5.2,3-9A61.61,61.61,0,0,0,311.5,558.6Z",
    transform: "translate(0.03 0.03)"
  })), _polygon263 || (_polygon263 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "311.13 547.73 312.33 553.73 315.33 553.03 313.43 548.13 311.13 547.73"
  })), _polygon264 || (_polygon264 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "311.13 547.73 312.33 553.73 315.33 553.03 313.43 548.13 311.13 547.73"
  })), _path340 || (_path340 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M314.5,546.2l1.9,4.5a16.44,16.44,0,0,0,5.6-1.1,35.59,35.59,0,0,0,4.9-2.6v2.2l2.3-1.1V535.7h-1.9V538s-4.5,0-4.9,2.2,3,4.1,2.6,6a24,24,0,0,1-4.5-.4C319,545.4,315.6,541.4,314.5,546.2Z",
    transform: "translate(0.03 0.03)"
  })), _path341 || (_path341 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M314.5,546.2l1.9,4.5a16.44,16.44,0,0,0,5.6-1.1,35.59,35.59,0,0,0,4.9-2.6v2.2l2.3-1.1V535.7h-1.9V538s-4.5,0-4.9,2.2,3,4.1,2.6,6a24,24,0,0,1-4.5-.4C319,545.4,315.6,541.4,314.5,546.2Z",
    transform: "translate(0.03 0.03)"
  })), _path342 || (_path342 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M321.3,551.8l-3,1.5v5.2l2.6-1.1V560l-2.3,1.9a114.65,114.65,0,0,0,1.5,14.2l2.6-2.2s.8-10.1.4-14.2A36.13,36.13,0,0,0,321.3,551.8Z",
    transform: "translate(0.03 0.03)"
  })), _path343 || (_path343 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M321.3,551.8l-3,1.5v5.2l2.6-1.1V560l-2.3,1.9a114.65,114.65,0,0,0,1.5,14.2l2.6-2.2s.8-10.1.4-14.2A36.13,36.13,0,0,0,321.3,551.8Z",
    transform: "translate(0.03 0.03)"
  })), _path344 || (_path344 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M323.9,552.2c1.1,4.1,1.5,12.4,1.1,18.3l1.9-2.3s1.1-11.6,0-18Z",
    transform: "translate(0.03 0.03)"
  })), _path345 || (_path345 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M323.9,552.2c1.1,4.1,1.5,12.4,1.1,18.3l1.9-2.3s1.1-11.6,0-18Z",
    transform: "translate(0.03 0.03)"
  })), _path346 || (_path346 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M330.6,535.4c0,4.5.4,15,0,21.7l2.3-3s1.1-6,.7-6h-1.5l.4-8.6s1.5.8,2.2,3.8l1.5-1.5s-.8-3-2.3-3.4c0,0,2.4-1.7,1.5-3C332.5,531.2,330.6,535.4,330.6,535.4Z",
    transform: "translate(0.03 0.03)"
  })), _path347 || (_path347 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M330.6,535.4c0,4.5.4,15,0,21.7l2.3-3s1.1-6,.7-6h-1.5l.4-8.6s1.5.8,2.2,3.8l1.5-1.5s-.8-3-2.3-3.4c0,0,2.4-1.7,1.5-3C332.5,531.2,330.6,535.4,330.6,535.4Z",
    transform: "translate(0.03 0.03)"
  })), _path348 || (_path348 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M334.4,546.2l2.3-.8s-.8,13.5-1.5,18.3l-3.7,3.4v-3.4l1.9-2.6Z",
    transform: "translate(0.03 0.03)"
  })), _path349 || (_path349 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M334.4,546.2l2.3-.8s-.8,13.5-1.5,18.3l-3.7,3.4v-3.4l1.9-2.6Z",
    transform: "translate(0.03 0.03)"
  })), _polygon265 || (_polygon265 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "340.03 547.43 338.13 548.83 338.13 554.13 340.43 553.03 340.03 547.43"
  })), _polygon266 || (_polygon266 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "340.03 547.43 338.13 548.83 338.13 554.13 340.43 553.03 340.03 547.43"
  })), _path350 || (_path350 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M341.8,546.6c-.4,0,0,4.5,0,4.5l1.5-.4v-4.9Z",
    transform: "translate(0.03 0.03)"
  })), _path351 || (_path351 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M341.8,546.6c-.4,0,0,4.5,0,4.5l1.5-.4v-4.9Z",
    transform: "translate(0.03 0.03)"
  })), _polygon267 || (_polygon267 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "345.23 544.43 344.83 549.23 346.33 548.53 346.73 543.63 345.23 544.43"
  })), _polygon268 || (_polygon268 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "345.23 544.43 344.83 549.23 346.33 548.53 346.73 543.63 345.23 544.43"
  })), _polygon269 || (_polygon269 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "348.63 542.53 348.23 547.43 353.83 544.73 353.83 540.63 348.63 542.53"
  })), _polygon270 || (_polygon270 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "348.63 542.53 348.23 547.43 353.83 544.73 353.83 540.63 348.63 542.53"
  })), _polygon271 || (_polygon271 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "369.63 543.63 357.93 551.53 357.93 553.73 371.83 545.53 369.63 543.63"
  })), _polygon272 || (_polygon272 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "369.63 543.63 357.93 551.53 357.93 553.73 371.83 545.53 369.63 543.63"
  })), _path352 || (_path352 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M383.4,540.2l-8.6,6.4-.8,2.6s-4.9,3.8-13.1,9l-.4,2.6,19.8-13.1.4-2.3,4.1-2.2,3.7-.4,3-2.3C391.6,540.6,383.8,540.2,383.4,540.2Z",
    transform: "translate(0.03 0.03)"
  })), _path353 || (_path353 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M383.4,540.2l-8.6,6.4-.8,2.6s-4.9,3.8-13.1,9l-.4,2.6,19.8-13.1.4-2.3,4.1-2.2,3.7-.4,3-2.3C391.6,540.6,383.8,540.2,383.4,540.2Z",
    transform: "translate(0.03 0.03)"
  })), _polygon273 || (_polygon273 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "386.83 545.53 379.33 550.73 381.93 551.13 389.03 546.63 386.83 545.53"
  })), _polygon274 || (_polygon274 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "386.83 545.53 379.33 550.73 381.93 551.13 389.03 546.63 386.83 545.53"
  })), _polygon275 || (_polygon275 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "390.13 553.03 398.03 548.53 395.03 548.53 388.33 552.23 381.13 555.23 381.93 557.13 390.13 553.03"
  })), _polygon276 || (_polygon276 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "390.13 553.03 398.03 548.53 395.03 548.53 388.33 552.23 381.13 555.23 381.93 557.13 390.13 553.03"
  })), _polygon277 || (_polygon277 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "363.63 535.43 362.83 533.93 378.93 535.73 380.03 537.63 370.73 537.23 363.63 535.43"
  })), _polygon278 || (_polygon278 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "363.63 535.43 362.83 533.93 378.93 535.73 380.03 537.63 370.73 537.23 363.63 535.43"
  })), _path354 || (_path354 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M349.3,532.4l6.7.4,3.4,1.1.8,2.2a19.28,19.28,0,0,1-5.3-1.1A26.81,26.81,0,0,1,349.3,532.4Z",
    transform: "translate(0.03 0.03)"
  })), _path355 || (_path355 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M349.3,532.4l6.7.4,3.4,1.1.8,2.2a19.28,19.28,0,0,1-5.3-1.1A26.81,26.81,0,0,1,349.3,532.4Z",
    transform: "translate(0.03 0.03)"
  })), _path356 || (_path356 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M337,533.9l1.1,2.6a47.08,47.08,0,0,0,8.6-.8l-1.5-1.5Z",
    transform: "translate(0.03 0.03)"
  })), _path357 || (_path357 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M337,533.9l1.1,2.6a47.08,47.08,0,0,0,8.6-.8l-1.5-1.5Z",
    transform: "translate(0.03 0.03)"
  })), _path358 || (_path358 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M336.6,529.4l.8,3a26.86,26.86,0,0,0,7.5-.4s-.4-1.5-.8-1.5S336.6,529.4,336.6,529.4Z",
    transform: "translate(0.03 0.03)"
  })), _path359 || (_path359 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M336.6,529.4l.8,3a26.86,26.86,0,0,0,7.5-.4s-.4-1.5-.8-1.5S336.6,529.4,336.6,529.4Z",
    transform: "translate(0.03 0.03)"
  })), _path360 || (_path360 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M352.7,576.5l.4,4.1,7.9-6.4,1.5,1.1-5.2,6.4-.4,3.7,9-7.9.8-3.7,1.1,1.5,3-3.4.4-3.7a10.7,10.7,0,0,0-6,.4C362.6,569.8,352.7,576.5,352.7,576.5Z",
    transform: "translate(0.03 0.03)"
  })), _path361 || (_path361 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M352.7,576.5l.4,4.1,7.9-6.4,1.5,1.1-5.2,6.4-.4,3.7,9-7.9.8-3.7,1.1,1.5,3-3.4.4-3.7a10.7,10.7,0,0,0-6,.4C362.6,569.8,352.7,576.5,352.7,576.5Z",
    transform: "translate(0.03 0.03)"
  })), _polygon279 || (_polygon279 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "349.03 577.33 347.83 582.23 347.53 585.93 350.83 583.33 351.93 578.03 349.03 577.33"
  })), _polygon280 || (_polygon280 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "349.03 577.33 347.83 582.23 347.53 585.93 350.83 583.33 351.93 578.03 349.03 577.33"
  })), _path362 || (_path362 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M346,581.4l-.4,6s-2.3,4.1-4.9,4.5-.4-3.4,1.5-5.6S346,581.4,346,581.4Z",
    transform: "translate(0.03 0.03)"
  })), _path363 || (_path363 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M346,581.4l-.4,6s-2.3,4.1-4.9,4.5-.4-3.4,1.5-5.6S346,581.4,346,581.4Z",
    transform: "translate(0.03 0.03)"
  })), _path364 || (_path364 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M360.9,586.7c-3,3.4-7.1,10.1-9,13.5s-.4,3.7,1.9,1.1,6.8-9,6.8-9Z",
    transform: "translate(0.03 0.03)"
  })), _path365 || (_path365 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M360.9,586.7c-3,3.4-7.1,10.1-9,13.5s-.4,3.7,1.9,1.1,6.8-9,6.8-9Z",
    transform: "translate(0.03 0.03)"
  })), _path366 || (_path366 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M368.1,581.4l-3.8,8.2.8,15.7,6-5.6s.8-5.6,0-9.4A68.7,68.7,0,0,0,368.1,581.4Z",
    transform: "translate(0.03 0.03)"
  })), _path367 || (_path367 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M368.1,581.4l-3.8,8.2.8,15.7,6-5.6s.8-5.6,0-9.4A68.7,68.7,0,0,0,368.1,581.4Z",
    transform: "translate(0.03 0.03)"
  })), _path368 || (_path368 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M369.2,579.2c1.5,4.1,3.7,10.1,3.7,15l3.8-8.2s-1.1-8.2-3.4-12.4a3.48,3.48,0,0,0-2.6,1.5A10.66,10.66,0,0,0,369.2,579.2Z",
    transform: "translate(0.03 0.03)"
  })), _path369 || (_path369 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M369.2,579.2c1.5,4.1,3.7,10.1,3.7,15l3.8-8.2s-1.1-8.2-3.4-12.4a3.48,3.48,0,0,0-2.6,1.5A10.66,10.66,0,0,0,369.2,579.2Z",
    transform: "translate(0.03 0.03)"
  })), _polygon281 || (_polygon281 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "373.33 569.83 375.53 575.83 377.43 573.23 374.43 568.33 373.33 569.83"
  })), _polygon282 || (_polygon282 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "373.33 569.83 375.53 575.83 377.43 573.23 374.43 568.33 373.33 569.83"
  })), _polygon283 || (_polygon283 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "376.73 578.43 377.83 582.93 379.63 580.73 378.93 575.43 376.73 578.43"
  })), _polygon284 || (_polygon284 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "376.73 578.43 377.83 582.93 379.63 580.73 378.93 575.43 376.73 578.43"
  })), _path370 || (_path370 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M378.2,585.9v8.2l2.2,1.5,1.9-3s.4-5.6-1.9-8.6Z",
    transform: "translate(0.03 0.03)"
  })), _path371 || (_path371 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M378.2,585.9v8.2l2.2,1.5,1.9-3s.4-5.6-1.9-8.6Z",
    transform: "translate(0.03 0.03)"
  })), _path372 || (_path372 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M371,603.1l-6.7,7.1v6a11.64,11.64,0,0,0,4.1-4.5c1.5-3,3-6.7,3-6.7Z",
    transform: "translate(0.03 0.03)"
  })), _path373 || (_path373 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M371,603.1l-6.7,7.1v6a11.64,11.64,0,0,0,4.1-4.5c1.5-3,3-6.7,3-6.7Z",
    transform: "translate(0.03 0.03)"
  })), _path374 || (_path374 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M375.9,600.1c-1.8,2.4-3,6.4-3.8,8.2s.8,2.3,1.9.8,2.3-5.6,3-7.9S377,598.6,375.9,600.1Z",
    transform: "translate(0.03 0.03)"
  })), _path375 || (_path375 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M375.9,600.1c-1.8,2.4-3,6.4-3.8,8.2s.8,2.3,1.9.8,2.3-5.6,3-7.9S377,598.6,375.9,600.1Z",
    transform: "translate(0.03 0.03)"
  })), _path376 || (_path376 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M385.3,607.6c-2.3,1.9-4.1,7.1-3,8.2s3-1.9,4.1-4.1S387.5,605.7,385.3,607.6Z",
    transform: "translate(0.03 0.03)"
  })), _path377 || (_path377 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M385.3,607.6c-2.3,1.9-4.1,7.1-3,8.2s3-1.9,4.1-4.1S387.5,605.7,385.3,607.6Z",
    transform: "translate(0.03 0.03)"
  })), _polygon285 || (_polygon285 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "375.93 562.33 380.03 559.33 380.43 570.23 378.93 572.13 375.93 567.63 375.93 562.33"
  })), _polygon286 || (_polygon286 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "375.93 562.33 380.03 559.33 380.43 570.23 378.93 572.13 375.93 567.63 375.93 562.33"
  })), _path378 || (_path378 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M382.3,559v8.2l1.5-1.1,1.1-4.5,3,4.5a6.34,6.34,0,0,0,2.6-3.4l2.3-.8s-3,6-2.6,9a33.5,33.5,0,0,0,1.9,6.7,22.7,22.7,0,0,1-1.1,6.7,28.63,28.63,0,0,0-1.9,9.4l1.9-.4a24.42,24.42,0,0,0,2.6-9.7s3.7-3.7,4.5-6,1.1-10.1.8-14.6l1.5,1.1s.4,9.7-.4,15.4l1.1,1.5a14.66,14.66,0,0,0,3.4-9.7,45.91,45.91,0,0,0-1.9-10.1l1.1-1.1,1.9,6.7,2.2-.8a47.11,47.11,0,0,1,1.5,10.1c0,4.5,0,13.5-.8,18.7s-2.6,7.1-2.6,7.1l1.1,2.2s3.7-10.1,3.7-13.8l1.5-2.6s0,4.9-.4,8.6l6-4.5.4-9.7-1.1-3s.8-12.7.4-19.1l1.9-1.9v2.2l2.6-.8v-1.9l2.6-1.5-.8,4.1-4.5,4.1s0,10.9-.4,13.1,2.6,5.6,2.6,5.6l2.6-3,.8-11.6,2.6-1.5s2.6-4.5,2.6-7.9l3-1.5s1.9,6.7,5.2,9.4,4.5,4.9,4.5,7.5,2.6,2.6,4.5,1.9a10.76,10.76,0,0,0,3.4-2.2h3l-.4-6-1.9.4-1.5,3.4-1.5-4.5,3-1.1a68.78,68.78,0,0,0-4.5-9l-1.1.4s-2.2-4.1-4.5-5.6-5.6-1.1-8.2-1.1c0,0,3-2.3,5.6-2.3s2.3-2.6,0-2.2a43.1,43.1,0,0,0-10.8,3.4l-6.4-.4a21,21,0,0,1,5.6-1.9c3.7-.8,5.6-1.1,7.9-2.6l-1.9-1.1s-4.5-.4-6.7.4a97.79,97.79,0,0,0-10.1,4.1h-5.2l.7-1.5s4.1,0,6.7-1.5l-.4-1.5a16.14,16.14,0,0,0-7.5.4L382.3,559Z",
    transform: "translate(0.03 0.03)"
  })), _path379 || (_path379 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M382.3,559v8.2l1.5-1.1,1.1-4.5,3,4.5a6.34,6.34,0,0,0,2.6-3.4l2.3-.8s-3,6-2.6,9a33.5,33.5,0,0,0,1.9,6.7,22.7,22.7,0,0,1-1.1,6.7,28.63,28.63,0,0,0-1.9,9.4l1.9-.4a24.42,24.42,0,0,0,2.6-9.7s3.7-3.7,4.5-6,1.1-10.1.8-14.6l1.5,1.1s.4,9.7-.4,15.4l1.1,1.5a14.66,14.66,0,0,0,3.4-9.7,45.91,45.91,0,0,0-1.9-10.1l1.1-1.1,1.9,6.7,2.2-.8a47.11,47.11,0,0,1,1.5,10.1c0,4.5,0,13.5-.8,18.7s-2.6,7.1-2.6,7.1l1.1,2.2s3.7-10.1,3.7-13.8l1.5-2.6s0,4.9-.4,8.6l6-4.5.4-9.7-1.1-3s.8-12.7.4-19.1l1.9-1.9v2.2l2.6-.8v-1.9l2.6-1.5-.8,4.1-4.5,4.1s0,10.9-.4,13.1,2.6,5.6,2.6,5.6l2.6-3,.8-11.6,2.6-1.5s2.6-4.5,2.6-7.9l3-1.5s1.9,6.7,5.2,9.4,4.5,4.9,4.5,7.5,2.6,2.6,4.5,1.9a10.76,10.76,0,0,0,3.4-2.2h3l-.4-6-1.9.4-1.5,3.4-1.5-4.5,3-1.1a68.78,68.78,0,0,0-4.5-9l-1.1.4s-2.2-4.1-4.5-5.6-5.6-1.1-8.2-1.1c0,0,3-2.3,5.6-2.3s2.3-2.6,0-2.2a43.1,43.1,0,0,0-10.8,3.4l-6.4-.4a21,21,0,0,1,5.6-1.9c3.7-.8,5.6-1.1,7.9-2.6l-1.9-1.1s-4.5-.4-6.7.4a97.79,97.79,0,0,0-10.1,4.1h-5.2l.7-1.5s4.1,0,6.7-1.5l-.4-1.5a16.14,16.14,0,0,0-7.5.4L382.3,559Z",
    transform: "translate(0.03 0.03)"
  })), _path380 || (_path380 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M405.9,572.8c-.4,5.2-.8,9-1.5,13.5a47.5,47.5,0,0,1-5.2,14.6l-.4,4.5,3-4.1H404s3.4-9.4,3.7-15a104.61,104.61,0,0,0-.4-13.9Z",
    transform: "translate(0.03 0.03)"
  })), _path381 || (_path381 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M405.9,572.8c-.4,5.2-.8,9-1.5,13.5a47.5,47.5,0,0,1-5.2,14.6l-.4,4.5,3-4.1H404s3.4-9.4,3.7-15a104.61,104.61,0,0,0-.4-13.9Z",
    transform: "translate(0.03 0.03)"
  })), _path382 || (_path382 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M426.8,581.8l-2.6,3.4s1.5,2.2,1.5,1.9,4.9-3,7.9-5.6c0,0,2.6-9.7,2.6-15.3l-2.6-3.7-.8,4.1.4,2.6s-3,6.7-3,12l-1.5,1.9Z",
    transform: "translate(0.03 0.03)"
  })), _path383 || (_path383 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M426.8,581.8l-2.6,3.4s1.5,2.3,1.5,1.9,4.9-3,7.9-5.6c0,0,2.6-9.7,2.6-15.3l-2.6-3.7-.8,4.1.4,2.6s-3,6.7-3,12l-1.5,1.9Z",
    transform: "translate(0.03 0.03)"
  })), _polygon287 || (_polygon287 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "437.73 569.83 435.43 580.33 438.03 579.23 439.53 572.13 437.73 569.83"
  })), _polygon288 || (_polygon288 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "437.73 569.83 435.43 580.33 438.03 579.23 439.53 572.13 437.73 569.83"
  })), _polygon289 || (_polygon289 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "384.93 584.83 383.83 588.53 383.43 596.83 386.83 593.43 386.83 588.23 384.93 584.83"
  })), _polygon290 || (_polygon290 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "384.93 584.83 383.83 588.53 383.43 596.83 386.83 593.43 386.83 588.23 384.93 584.83"
  })), _polygon291 || (_polygon291 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "389.43 576.53 387.53 573.93 388.63 572.83 388.63 567.63 385.63 570.93 385.63 580.73 388.33 585.53 389.83 583.33 389.43 576.53"
  })), _polygon292 || (_polygon292 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "389.43 576.53 387.53 573.93 388.63 572.83 388.63 567.63 385.63 570.93 385.63 580.73 388.33 585.53 389.83 583.33 389.43 576.53"
  })), _polygon293 || (_polygon293 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "384.53 573.63 383.03 570.63 380.83 573.23 382.33 584.03 383.83 582.53 384.53 573.63"
  })), _polygon294 || (_polygon294 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "384.53 573.63 383.03 570.63 380.83 573.23 382.33 584.03 383.83 582.53 384.53 573.63"
  })), _path384 || (_path384 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M362.8,595.6l-2.2,2.6s0,10.1-.4,14.2l1.1,1.1,2.3-6.7Z",
    transform: "translate(0.03 0.03)"
  })), _path385 || (_path385 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M362.8,595.6l-2.2,2.6s0,10.1-.4,14.2l1.1,1.1,2.3-6.7Z",
    transform: "translate(0.03 0.03)"
  })), _polygon295 || (_polygon295 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "353.43 610.63 353.83 606.13 355.73 604.63 358.33 601.33 357.93 598.33 349.33 609.13 348.23 613.63 349.03 615.93 353.43 610.63"
  })), _polygon296 || (_polygon296 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "353.43 610.63 353.83 606.13 355.73 604.63 358.33 601.33 357.93 598.33 349.33 609.13 348.23 613.63 349.03 615.93 353.43 610.63"
  })), _polygon297 || (_polygon297 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "369.23 613.63 364.33 619.63 365.43 620.73 369.63 618.13 369.23 613.63"
  })), _polygon298 || (_polygon298 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "369.23 613.63 364.33 619.63 365.43 620.73 369.63 618.13 369.23 613.63"
  })), _polygon299 || (_polygon299 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "340.03 581.03 337.73 580.33 335.13 586.73 335.53 590.03 338.93 587.83 340.03 581.03"
  })), _polygon300 || (_polygon300 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "340.03 581.03 337.73 580.33 335.13 586.73 335.53 590.03 338.93 587.83 340.03 581.03"
  })), _polygon301 || (_polygon301 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "341.53 578.03 341.53 581.03 343.33 580.73 343.33 576.93 341.53 578.03"
  })), _polygon302 || (_polygon302 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "341.53 578.03 341.53 581.03 343.33 580.73 343.33 576.93 341.53 578.03"
  })), _path386 || (_path386 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M340.7,596c-1.9,2.3-2.3,5.6-2.3,9l2.3-1.9a7.08,7.08,0,0,1,1.5-4.1Z",
    transform: "translate(0.03 0.03)"
  })), _path387 || (_path387 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M340.7,596c-1.9,2.3-2.3,5.6-2.3,9l2.3-1.9a7.08,7.08,0,0,1,1.5-4.1Z",
    transform: "translate(0.03 0.03)"
  })), _path388 || (_path388 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M326.1,596c-1.5,1.5-3,3.4-2.6,6l1.9,1.5s-.4-3.4,1.5-5.2Z",
    transform: "translate(0.03 0.03)"
  })), _path389 || (_path389 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M326.1,596c-1.5,1.5-3,3.4-2.6,6l1.9,1.5s-.4-3.4,1.5-5.2Z",
    transform: "translate(0.03 0.03)"
  })), _path390 || (_path390 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M302.9,608.7l-.8,4.5,3,1.1.4-4.5C305.5,609.9,303.3,608.7,302.9,608.7Z",
    transform: "translate(0.03 0.03)"
  })), _path391 || (_path391 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M302.9,608.7l-.8,4.5,3,1.1.4-4.5C305.5,609.9,303.3,608.7,302.9,608.7Z",
    transform: "translate(0.03 0.03)"
  })), _path392 || (_path392 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M281.2,575.8l-.4,5.6,4.1-3v-3s-.4-1.9-1.9-1.5A2.86,2.86,0,0,0,281.2,575.8Z",
    transform: "translate(0.03 0.03)"
  })), _path393 || (_path393 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M281.2,575.8l-.4,5.6,4.1-3v-3s-.4-1.9-1.9-1.5A2.86,2.86,0,0,0,281.2,575.8Z",
    transform: "translate(0.03 0.03)"
  })), _polygon303 || (_polygon303 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "283.13 594.53 285.73 593.03 287.63 589.73 289.43 589.73 288.73 584.03 286.43 582.23 285.73 588.93 284.93 585.93 282.03 588.23 283.13 594.53"
  })), _polygon304 || (_polygon304 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "283.13 594.53 285.73 593.03 287.63 589.73 289.43 589.73 288.73 584.03 286.43 582.23 285.73 588.93 284.93 585.93 282.03 588.23 283.13 594.53"
  })), _polygon305 || (_polygon305 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "393.13 597.93 396.53 592.33 396.93 589.33 398.43 587.83 398.03 581.43 395.03 584.83 395.03 590.83 392.83 595.33 393.13 597.93"
  })), _polygon306 || (_polygon306 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "393.13 597.93 396.53 592.33 396.93 589.33 398.43 587.83 398.03 581.43 395.03 584.83 395.03 590.83 392.83 595.33 393.13 597.93"
  })), _polygon307 || (_polygon307 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "390.13 597.93 387.93 603.53 389.03 605.73 391.33 600.53 390.13 597.93"
  })), _polygon308 || (_polygon308 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "390.13 597.93 387.93 603.53 389.03 605.73 391.33 600.53 390.13 597.93"
  })), _polygon309 || (_polygon309 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "393.13 603.53 390.13 608.43 390.93 610.23 393.93 605.43 393.13 603.53"
  })), _polygon310 || (_polygon310 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "393.13 603.53 390.13 608.43 390.93 610.23 393.93 605.43 393.13 603.53"
  })), _polygon311 || (_polygon311 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "338.13 557.13 337.73 562.73 340.43 561.23 341.13 555.63 338.13 557.13"
  })), _polygon312 || (_polygon312 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "338.13 557.13 337.73 562.73 340.43 561.23 341.13 555.63 338.13 557.13"
  })), _polygon313 || (_polygon313 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "346.73 553.73 346.33 557.13 348.63 556.03 349.03 552.23 346.73 553.73"
  })), _polygon314 || (_polygon314 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "346.73 553.73 346.33 557.13 348.63 556.03 349.03 552.23 346.73 553.73"
  })), _polygon315 || (_polygon315 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "358.33 544.73 357.93 547.03 360.93 545.53 360.93 543.23 358.33 544.73"
  })), _polygon316 || (_polygon316 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "358.33 544.73 357.93 547.03 360.93 545.53 360.93 543.23 358.33 544.73"
  })), _polygon317 || (_polygon317 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "363.63 542.13 363.23 544.43 367.33 542.93 367.33 541.03 363.63 542.13"
  })), _polygon318 || (_polygon318 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "363.63 542.13 363.23 544.43 367.33 542.93 367.33 541.03 363.63 542.13"
  })), _polygon319 || (_polygon319 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "373.73 559.33 373.33 562.03 378.93 558.63 378.93 556.73 373.73 559.33"
  })), _polygon320 || (_polygon320 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "373.73 559.33 373.33 562.03 378.93 558.63 378.93 556.73 373.73 559.33"
  })), _polygon321 || (_polygon321 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "368.43 528.63 367.33 532.43 369.63 532.73 371.83 529.03 368.43 528.63"
  })), _polygon322 || (_polygon322 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "368.43 528.63 367.33 532.43 369.63 532.73 371.83 529.03 368.43 528.63"
  })), _polygon323 || (_polygon323 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "374.03 529.43 372.23 532.03 374.43 533.53 375.53 530.53 374.03 529.43"
  })), _polygon324 || (_polygon324 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "374.03 529.43 372.23 532.03 374.43 533.53 375.53 530.53 374.03 529.43"
  })), _path394 || (_path394 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M359.4,528.6l-1.9,1.9L359,532l5.6.4-.4-1.5Z",
    transform: "translate(0.03 0.03)"
  })), _path395 || (_path395 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M359.4,528.6l-1.9,1.9L359,532l5.6.4-.4-1.5Z",
    transform: "translate(0.03 0.03)"
  })), _polygon325 || (_polygon325 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "353.43 525.33 353.13 528.33 355.73 528.33 356.13 525.33 353.43 525.33"
  })), _polygon326 || (_polygon326 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "353.43 525.33 353.13 528.33 355.73 528.33 356.13 525.33 353.43 525.33"
  })), _polygon327 || (_polygon327 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "349.03 521.93 348.63 524.93 351.23 524.93 351.63 521.93 349.03 521.93"
  })), _polygon328 || (_polygon328 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "349.03 521.93 348.63 524.93 351.23 524.93 351.63 521.93 349.03 521.93"
  })), _polygon329 || (_polygon329 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "354.93 519.63 354.63 522.63 357.23 522.63 357.63 519.63 354.93 519.63"
  })), _polygon330 || (_polygon330 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "354.93 519.63 354.63 522.63 357.23 522.63 357.63 519.63 354.93 519.63"
  })), _polygon331 || (_polygon331 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "361.33 523.43 360.93 526.43 363.63 526.43 363.93 523.43 361.33 523.43"
  })), _polygon332 || (_polygon332 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "361.33 523.43 360.93 526.43 363.63 526.43 363.93 523.43 361.33 523.43"
  })), _polygon333 || (_polygon333 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "362.43 515.23 362.13 518.13 364.73 518.13 365.13 515.23 362.43 515.23"
  })), _polygon334 || (_polygon334 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "362.43 515.23 362.13 518.13 364.73 518.13 365.13 515.23 362.43 515.23"
  })), _polygon335 || (_polygon335 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "353.83 514.43 353.43 517.43 356.13 517.43 356.43 514.43 353.83 514.43"
  })), _polygon336 || (_polygon336 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "353.83 514.43 353.43 517.43 356.13 517.43 356.43 514.43 353.83 514.43"
  })), _polygon337 || (_polygon337 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "361.73 507.73 361.33 510.73 363.93 510.73 364.33 507.73 361.73 507.73"
  })), _polygon338 || (_polygon338 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "361.73 507.73 361.33 510.73 363.93 510.73 364.33 507.73 361.73 507.73"
  })), _polygon339 || (_polygon339 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "356.83 502.43 356.43 505.43 359.13 505.43 359.43 502.43 356.83 502.43"
  })), _polygon340 || (_polygon340 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "356.83 502.43 356.43 505.43 359.13 505.43 359.43 502.43 356.83 502.43"
  })), _polygon341 || (_polygon341 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "367.73 515.23 367.33 518.13 369.93 518.13 370.33 515.23 367.73 515.23"
  })), _polygon342 || (_polygon342 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "367.73 515.23 367.33 518.13 369.93 518.13 370.33 515.23 367.73 515.23"
  })), _polygon343 || (_polygon343 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "379.33 524.53 378.93 527.53 381.53 527.53 381.93 524.53 379.33 524.53"
  })), _polygon344 || (_polygon344 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "379.33 524.53 378.93 527.53 381.53 527.53 381.93 524.53 379.33 524.53"
  })), _polygon345 || (_polygon345 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "384.93 530.93 384.53 533.93 387.13 533.93 387.53 530.93 384.93 530.93"
  })), _polygon346 || (_polygon346 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "384.93 530.93 384.53 533.93 387.13 533.93 387.53 530.93 384.93 530.93"
  })), _polygon347 || (_polygon347 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "390.13 531.23 389.83 534.23 392.43 534.23 392.83 531.23 390.13 531.23"
  })), _polygon348 || (_polygon348 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "390.13 531.23 389.83 534.23 392.43 534.23 392.83 531.23 390.13 531.23"
  })), _polygon349 || (_polygon349 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "387.13 525.63 386.83 528.63 389.43 528.63 389.83 525.63 387.13 525.63"
  })), _polygon350 || (_polygon350 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "387.13 525.63 386.83 528.63 389.43 528.63 389.83 525.63 387.13 525.63"
  })), _polygon351 || (_polygon351 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "392.43 525.63 392.03 528.63 394.63 528.63 395.03 525.63 392.43 525.63"
  })), _polygon352 || (_polygon352 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "392.43 525.63 392.03 528.63 394.63 528.63 395.03 525.63 392.43 525.63"
  })), _polygon353 || (_polygon353 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "397.63 526.03 397.23 529.03 399.93 529.03 400.23 526.03 397.63 526.03"
  })), _polygon354 || (_polygon354 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "397.63 526.03 397.23 529.03 399.93 529.03 400.23 526.03 397.63 526.03"
  })), _polygon355 || (_polygon355 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "406.63 531.63 406.23 534.63 408.93 534.63 409.23 531.63 406.63 531.63"
  })), _polygon356 || (_polygon356 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "406.63 531.63 406.23 534.63 408.93 534.63 409.23 531.63 406.63 531.63"
  })), _polygon357 || (_polygon357 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "330.63 520.03 330.23 523.03 332.93 523.03 333.23 520.03 330.63 520.03"
  })), _polygon358 || (_polygon358 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "330.63 520.03 330.23 523.03 332.93 523.03 333.23 520.03 330.63 520.03"
  })), _polygon359 || (_polygon359 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "317.53 516.73 317.13 519.63 319.83 519.63 320.13 516.73 317.53 516.73"
  })), _polygon360 || (_polygon360 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "317.53 516.73 317.13 519.63 319.83 519.63 320.13 516.73 317.53 516.73"
  })), _polygon361 || (_polygon361 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "312.63 515.23 312.33 518.13 314.93 518.13 315.33 515.23 312.63 515.23"
  })), _polygon362 || (_polygon362 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "312.63 515.23 312.33 518.13 314.93 518.13 315.33 515.23 312.63 515.23"
  })), _polygon363 || (_polygon363 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "307.83 513.73 307.43 516.73 310.03 516.73 310.43 513.73 307.83 513.73"
  })), _polygon364 || (_polygon364 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "307.83 513.73 307.43 516.73 310.03 516.73 310.43 513.73 307.83 513.73"
  })), _polygon365 || (_polygon365 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "311.13 519.63 310.83 522.63 313.43 522.63 313.83 519.63 311.13 519.63"
  })), _polygon366 || (_polygon366 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "311.13 519.63 310.83 522.63 313.43 522.63 313.83 519.63 311.13 519.63"
  })), _polygon367 || (_polygon367 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "320.93 530.93 320.53 533.93 323.13 533.93 323.53 530.93 320.93 530.93"
  })), _polygon368 || (_polygon368 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "320.93 530.93 320.53 533.93 323.13 533.93 323.53 530.93 320.93 530.93"
  })), _polygon369 || (_polygon369 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "314.93 536.93 314.53 539.93 317.13 539.93 317.53 536.93 314.93 536.93"
  })), _polygon370 || (_polygon370 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "314.93 536.93 314.53 539.93 317.13 539.93 317.53 536.93 314.93 536.93"
  })), _path396 || (_path396 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M381.5,517l-1.5,1.5s0,2.3-1.1,3.4l2.3,1.9,4.1-3-.4,2.2,6.4,1.5,1.1-1.9a39,39,0,0,0,12.7,2.6l-1.1,3,3,1.5h3.7l3-2.3v3l3.4.4,2.6-2.6s0,4.1-1.1,6.4h1.9a12.09,12.09,0,0,0,3-4.9l1.9-.4a48.33,48.33,0,0,1-1.9,4.5l1.1,1.9s2.6-1.5,4.1-6l1.9.4a11.69,11.69,0,0,1-1.9,4.9l1.9,1.5a7.19,7.19,0,0,0,2.3-4.5l1.1,1.5-.4,2.6,2.3.4,4.9-6s-3.7-3.4-7.1-4.1-10.5-3.7-12.7-3.4a22.9,22.9,0,0,1-3.7.4,7,7,0,0,0-4.9-2.2,107.69,107.69,0,0,1-10.9-.8c-3.4-.4-8.6-1.1-11.2-1.1-.2,0-4.3-2.6-8.8-2.3Z",
    transform: "translate(0.03 0.03)"
  })), _path397 || (_path397 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M381.5,517l-1.5,1.5s0,2.3-1.1,3.4l2.3,1.9,4.1-3-.4,2.2,6.4,1.5,1.1-1.9a39,39,0,0,0,12.7,2.6l-1.1,3,3,1.5h3.7l3-2.3v3l3.4.4,2.6-2.6s0,4.1-1.1,6.4h1.9a12.09,12.09,0,0,0,3-4.9l1.9-.4a48.33,48.33,0,0,1-1.9,4.5l1.1,1.9s2.6-1.5,4.1-6l1.9.4a11.69,11.69,0,0,1-1.9,4.9l1.9,1.5a7.19,7.19,0,0,0,2.3-4.5l1.1,1.5-.4,2.6,2.3.4,4.9-6s-3.7-3.4-7.1-4.1-10.5-3.7-12.7-3.4a22.9,22.9,0,0,1-3.7.4,7,7,0,0,0-4.9-2.2,107.69,107.69,0,0,1-10.9-.8c-3.4-.4-8.6-1.1-11.2-1.1-.2,0-4.3-2.6-8.8-2.3Z",
    transform: "translate(0.03 0.03)"
  })), _polygon371 || (_polygon371 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "423.83 506.93 417.53 514.03 417.83 517.83 425.03 510.33 423.83 506.93"
  })), _polygon372 || (_polygon372 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "423.83 506.93 417.53 514.03 417.83 517.83 425.03 510.33 423.83 506.93"
  })), _polygon373 || (_polygon373 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "427.23 511.83 421.63 517.43 423.13 519.33 429.43 512.93 427.23 511.83"
  })), _polygon374 || (_polygon374 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "427.23 511.83 421.63 517.43 423.13 519.33 429.43 512.93 427.23 511.83"
  })), _polygon375 || (_polygon375 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "432.13 513.73 427.23 519.33 432.13 520.03 436.23 515.53 432.13 513.73"
  })), _polygon376 || (_polygon376 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "432.13 513.73 427.23 519.33 432.13 520.03 436.23 515.53 432.13 513.73"
  })), _polygon377 || (_polygon377 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "438.03 517.43 434.33 520.83 435.13 523.03 439.93 518.53 438.03 517.43"
  })), _polygon378 || (_polygon378 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "438.03 517.43 434.33 520.83 435.13 523.03 439.93 518.53 438.03 517.43"
  })), _polygon379 || (_polygon379 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "443.73 520.43 440.73 523.43 441.43 526.83 445.23 521.93 443.73 520.43"
  })), _polygon380 || (_polygon380 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "443.73 520.43 440.73 523.43 441.43 526.83 445.23 521.93 443.73 520.43"
  })), _polygon381 || (_polygon381 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "409.23 499.13 408.13 497.93 406.23 500.93 406.23 503.23 407.73 503.63 409.23 499.13"
  })), _polygon382 || (_polygon382 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "409.23 499.13 408.13 497.93 406.23 500.93 406.23 503.23 407.73 503.63 409.23 499.13"
  })), _polygon383 || (_polygon383 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "411.53 499.83 410.03 501.73 410.43 503.93 413.33 500.63 411.53 499.83"
  })), _polygon384 || (_polygon384 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "411.53 499.83 410.03 501.73 410.43 503.93 413.33 500.63 411.53 499.83"
  })), _path398 || (_path398 = /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M453.4,527.5l1.1,4.9h4.1l3.4,4.5s6,.4,9.7,1.9a25.53,25.53,0,0,1,7.1,4.9l6.4-3.8s-7.9-4.1-13.8-6.4-12.4-5.2-18-6Z",
    transform: "translate(0.03 0.03)"
  })), _path399 || (_path399 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M453.4,527.5l1.1,4.9h4.1l3.4,4.5s6,.4,9.7,1.9a25.53,25.53,0,0,1,7.1,4.9l6.4-3.8s-7.9-4.1-13.8-6.4-12.4-5.2-18-6Z",
    transform: "translate(0.03 0.03)"
  })), _polygon385 || (_polygon385 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "441.83 533.53 439.53 535.03 439.93 538.03 442.93 535.43 441.83 533.53"
  })), _polygon386 || (_polygon386 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "441.83 533.53 439.53 535.03 439.93 538.03 442.93 535.43 441.83 533.53"
  })), _polygon387 || (_polygon387 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "443.33 530.13 442.23 532.03 444.03 535.43 445.93 533.13 443.33 530.13"
  })), _polygon388 || (_polygon388 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "443.33 530.13 442.23 532.03 444.03 535.43 445.93 533.13 443.33 530.13"
  })), _polygon389 || (_polygon389 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "451.53 535.03 446.73 536.93 447.03 540.63 450.03 539.93 451.53 536.93 451.53 535.03"
  })), _polygon390 || (_polygon390 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "451.53 535.03 446.73 536.93 447.03 540.63 450.03 539.93 451.53 536.93 451.53 535.03"
  })), _polygon391 || (_polygon391 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "412.63 539.93 408.13 539.93 407.73 537.63 414.53 537.63 418.23 541.03 414.53 541.03 412.63 539.93"
  })), _polygon392 || (_polygon392 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "412.63 539.93 408.13 539.93 407.73 537.63 414.53 537.63 418.23 541.03 414.53 541.03 412.63 539.93"
  })), _polygon393 || (_polygon393 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "435.13 541.73 439.93 541.73 440.73 544.43 436.63 544.03 435.13 541.73"
  })), _polygon394 || (_polygon394 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "435.13 541.73 439.93 541.73 440.73 544.43 436.63 544.03 435.13 541.73"
  })), _path400 || (_path400 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M442.5,544.4l.8,2.3h3.4s-.4-2.3-.8-2.3Z",
    transform: "translate(0.03 0.03)"
  })), _path401 || (_path401 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M442.5,544.4l.8,2.3h3.4s-.4-2.3-.8-2.3Z",
    transform: "translate(0.03 0.03)"
  })), _path402 || (_path402 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M442.5,550.3l1.9,1.9a29.53,29.53,0,0,1,7.9-2.3l-1.1-1.9C451.2,548.1,447.8,547,442.5,550.3Z",
    transform: "translate(0.03 0.03)"
  })), _path403 || (_path403 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M442.5,550.3l1.9,1.9a29.53,29.53,0,0,1,7.9-2.3l-1.1-1.9C451.2,548.1,447.8,547,442.5,550.3Z",
    transform: "translate(0.03 0.03)"
  })), _path404 || (_path404 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M446.3,554.1l4.9,7.5,3-2.3v-3.7h-3.8l-1.1-1.1a17.38,17.38,0,0,1,5.3-1.9l-.8-1.5A16.41,16.41,0,0,0,446.3,554.1Z",
    transform: "translate(0.03 0.03)"
  })), _path405 || (_path405 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M446.3,554.1l4.9,7.5,3-2.3v-3.7h-3.8l-1.1-1.1a17.38,17.38,0,0,1,5.3-1.9l-.8-1.5A16.41,16.41,0,0,0,446.3,554.1Z",
    transform: "translate(0.03 0.03)"
  })), _polygon395 || (_polygon395 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "453.83 588.53 454.53 607.23 459.43 603.93 459.43 585.53 453.83 588.53"
  })), _polygon396 || (_polygon396 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "453.83 588.53 454.53 607.23 459.43 603.93 459.43 585.53 453.83 588.53"
  })), _polygon397 || (_polygon397 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "453.83 582.93 453.43 586.33 459.43 583.33 459.43 581.03 453.83 582.93"
  })), _polygon398 || (_polygon398 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "453.83 582.93 453.43 586.33 459.43 583.33 459.43 581.03 453.83 582.93"
  })), _polygon399 || (_polygon399 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "456.83 576.93 454.23 580.73 458.63 579.23 458.63 575.43 456.83 576.93"
  })), _polygon400 || (_polygon400 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "456.83 576.93 454.23 580.73 458.63 579.23 458.63 575.43 456.83 576.93"
  })), _path406 || (_path406 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M462,574.7v4.1a28.38,28.38,0,0,1,3,3.7l-2.2,1.5-1.5,1.9v3.8l1.5-.4s-1.9,7.5-1.9,11.6l3.4-1.5s0-5.2,1.1-7.5l.4,2.6,1.5-1.1s0-8.6-.4-12-1.5-7.5-3-9Z",
    transform: "translate(0.03 0.03)"
  })), _path407 || (_path407 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M462,574.7v4.1a28.38,28.38,0,0,1,3,3.7l-2.2,1.5-1.5,1.9v3.8l1.5-.4s-1.9,7.5-1.9,11.6l3.4-1.5s0-5.2,1.1-7.5l.4,2.6,1.5-1.1s0-8.6-.4-12-1.5-7.5-3-9Z",
    transform: "translate(0.03 0.03)"
  })), _path408 || (_path408 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M468.7,569.1l-.4,12.7,3,6.4,1.1-1.9-.4-2.6.7-1.9v-5.6l5.2,2.3.4-4.9-1.9-.8a15.11,15.11,0,0,1,1.1-5.6l.4-10.5-3,1.9s-2.6,9-1.9,15l-2.2-3.7Z",
    transform: "translate(0.03 0.03)"
  })), _path409 || (_path409 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M468.7,569.1l-.4,12.7,3,6.4,1.1-1.9-.4-2.6.7-1.9v-5.6l5.2,2.3.4-4.9-1.9-.8a15.11,15.11,0,0,1,1.1-5.6l.4-10.5-3,1.9s-2.6,9-1.9,15l-2.2-3.7Z",
    transform: "translate(0.03 0.03)"
  })), _polygon401 || (_polygon401 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "459.43 564.23 456.83 564.63 456.43 572.83 460.53 572.43 461.63 567.93 459.43 564.23"
  })), _polygon402 || (_polygon402 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "459.43 564.23 456.83 564.63 456.43 572.83 460.53 572.43 461.63 567.93 459.43 564.23"
  })), _path410 || (_path410 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M463.5,557.8v10.5l3,4.5.4-12.4-1.5-1.9s3.4-2.2,6-2.2l-.4-1.9A8.51,8.51,0,0,0,463.5,557.8Z",
    transform: "translate(0.03 0.03)"
  })), _path411 || (_path411 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M463.5,557.8v10.5l3,4.5.4-12.4-1.5-1.9s3.4-2.2,6-2.2l-.4-1.9A8.51,8.51,0,0,0,463.5,557.8Z",
    transform: "translate(0.03 0.03)"
  })), _polygon403 || (_polygon403 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "470.63 558.23 469.13 560.53 468.73 565.33 471.43 567.93 473.23 559.03 470.63 558.23"
  })), _polygon404 || (_polygon404 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "470.63 558.23 469.13 560.53 468.73 565.33 471.43 567.93 473.23 559.03 470.63 558.23"
  })), _polygon405 || (_polygon405 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "439.93 591.23 439.53 594.13 442.23 594.13 442.53 591.23 439.93 591.23"
  })), _polygon406 || (_polygon406 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "439.93 591.23 439.53 594.13 442.23 594.13 442.53 591.23 439.93 591.23"
  })), _polygon407 || (_polygon407 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "432.83 593.43 432.43 596.43 435.13 596.43 435.43 593.43 432.83 593.43"
  })), _polygon408 || (_polygon408 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "432.83 593.43 432.43 596.43 435.13 596.43 435.43 593.43 432.83 593.43"
  })), _polygon409 || (_polygon409 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "428.73 591.23 428.33 594.13 430.93 594.13 431.33 591.23 428.73 591.23"
  })), _polygon410 || (_polygon410 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "428.73 591.23 428.33 594.13 430.93 594.13 431.33 591.23 428.73 591.23"
  })), _polygon411 || (_polygon411 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "424.63 596.03 424.23 599.03 426.83 599.03 427.23 596.03 424.63 596.03"
  })), _polygon412 || (_polygon412 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "424.63 596.03 424.23 599.03 426.83 599.03 427.23 596.03 424.63 596.03"
  })), _polygon413 || (_polygon413 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "445.93 591.23 445.53 594.13 448.23 594.13 448.53 591.23 445.93 591.23"
  })), _polygon414 || (_polygon414 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "445.93 591.23 445.53 594.13 448.23 594.13 448.53 591.23 445.93 591.23"
  })), _polygon415 || (_polygon415 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "448.93 584.03 448.53 587.03 451.23 587.03 451.53 584.03 448.93 584.03"
  })), _polygon416 || (_polygon416 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "448.93 584.03 448.53 587.03 451.23 587.03 451.53 584.03 448.93 584.03"
  })), _polygon417 || (_polygon417 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "424.43 600.93 424.03 605.03 425.93 606.53 426.63 601.13 424.43 600.93"
  })), _polygon418 || (_polygon418 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "424.43 600.93 424.03 605.03 425.93 606.53 426.63 601.13 424.43 600.93"
  })), _polygon419 || (_polygon419 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "419.93 604.63 419.13 611.43 421.03 612.93 422.13 604.83 419.93 604.63"
  })), _polygon420 || (_polygon420 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "419.93 604.63 419.13 611.43 421.03 612.93 422.13 604.83 419.93 604.63"
  })), _polygon421 || (_polygon421 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "414.73 611.43 414.33 615.53 416.23 617.03 416.93 611.63 414.73 611.43"
  })), _polygon422 || (_polygon422 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "414.73 611.43 414.33 615.53 416.23 617.03 416.93 611.63 414.73 611.43"
  })), _polygon423 || (_polygon423 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "415.43 603.53 415.03 607.63 416.93 609.13 417.63 603.73 415.43 603.53"
  })), _polygon424 || (_polygon424 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "415.43 603.53 415.03 607.63 416.93 609.13 417.63 603.73 415.43 603.53"
  })), _polygon425 || (_polygon425 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "408.53 606.53 406.23 611.73 407.03 613.63 409.23 608.43 408.53 606.53"
  })), _polygon426 || (_polygon426 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "408.53 606.53 406.23 611.73 407.03 613.63 409.23 608.43 408.53 606.53"
  })), _polygon427 || (_polygon427 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "456.83 554.83 459.03 556.73 465.43 554.53 462.43 553.03 456.83 554.83"
  })), _polygon428 || (_polygon428 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "456.83 554.83 459.03 556.73 465.43 554.53 462.43 553.03 456.83 554.83"
  })), _polygon429 || (_polygon429 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "461.33 558.23 458.63 559.33 458.63 561.63 462.03 564.93 461.33 558.23"
  })), _polygon430 || (_polygon430 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "461.33 558.23 458.63 559.33 458.63 561.63 462.03 564.93 461.33 558.23"
  })), _path412 || (_path412 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M482.2,555.6l-2.2,1.9v19.1l1.9-1.5,3.4-14.2,2.6-1.1s-1.5,8.6-2.6,12.4a33.29,33.29,0,0,0-1.5,9.7l1.9-.7a74.78,74.78,0,0,0,3-10.9,106.76,106.76,0,0,0,1.5-13.5l-4.5,1.5Z",
    transform: "translate(0.03 0.03)"
  })), _path413 || (_path413 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M482.2,555.6l-2.2,1.9v19.1l1.9-1.5,3.4-14.2,2.6-1.1s-1.5,8.6-2.6,12.4a33.29,33.29,0,0,0-1.5,9.7l1.9-.7a74.78,74.78,0,0,0,3-10.9,106.76,106.76,0,0,0,1.5-13.5l-4.5,1.5Z",
    transform: "translate(0.03 0.03)"
  })), _polygon431 || (_polygon431 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "297.33 509.93 302.53 511.83 299.93 514.43 296.93 512.93 297.33 509.93"
  })), _polygon432 || (_polygon432 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "297.33 509.93 302.53 511.83 299.93 514.43 296.93 512.93 297.33 509.93"
  })), _polygon433 || (_polygon433 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "290.63 514.43 290.63 516.73 295.03 518.13 295.03 515.93 290.63 514.43"
  })), _polygon434 || (_polygon434 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "290.63 514.43 290.63 516.73 295.03 518.13 295.03 515.93 290.63 514.43"
  })), _polygon435 || (_polygon435 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "283.53 509.53 283.53 511.43 288.73 513.33 287.93 510.73 283.53 509.53"
  })), _polygon436 || (_polygon436 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "283.53 509.53 283.53 511.43 288.73 513.33 287.93 510.73 283.53 509.53"
  })), _polygon437 || (_polygon437 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "292.43 508.43 292.13 511.43 294.73 511.43 295.03 508.43 292.43 508.43"
  })), _polygon438 || (_polygon438 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "292.43 508.43 292.13 511.43 294.73 511.43 295.03 508.43 292.43 508.43"
  })), _polygon439 || (_polygon439 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "275.63 505.13 275.23 508.03 277.83 508.03 278.23 505.13 275.63 505.13"
  })), _polygon440 || (_polygon440 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "275.63 505.13 275.23 508.03 277.83 508.03 278.23 505.13 275.63 505.13"
  })), _polygon441 || (_polygon441 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "265.53 505.13 265.13 508.03 267.73 508.03 268.13 505.13 265.53 505.13"
  })), _polygon442 || (_polygon442 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "265.53 505.13 265.13 508.03 267.73 508.03 268.13 505.13 265.53 505.13"
  })), _polygon443 || (_polygon443 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "327.63 571.33 327.23 574.33 329.93 574.33 330.23 571.33 327.63 571.33"
  })), _polygon444 || (_polygon444 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "327.63 571.33 327.23 574.33 329.93 574.33 330.23 571.33 327.63 571.33"
  })), _polygon445 || (_polygon445 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "332.53 568.73 332.13 571.73 334.73 571.73 335.13 568.73 332.53 568.73"
  })), _polygon446 || (_polygon446 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "332.53 568.73 332.13 571.73 334.73 571.73 335.13 568.73 332.53 568.73"
  })), _polygon447 || (_polygon447 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "337.73 564.93 337.43 567.93 340.03 567.93 340.43 564.93 337.73 564.93"
  })), _polygon448 || (_polygon448 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "337.73 564.93 337.43 567.93 340.03 567.93 340.43 564.93 337.73 564.93"
  })), _polygon449 || (_polygon449 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "343.73 562.73 343.33 565.73 346.03 565.73 346.33 562.73 343.73 562.73"
  })), _polygon450 || (_polygon450 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "343.73 562.73 343.33 565.73 346.03 565.73 346.33 562.73 343.73 562.73"
  })), _polygon451 || (_polygon451 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "326.53 577.73 326.13 580.73 328.73 580.73 329.13 577.73 326.53 577.73"
  })), _polygon452 || (_polygon452 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "326.53 577.73 326.13 580.73 328.73 580.73 329.13 577.73 326.53 577.73"
  })), _polygon453 || (_polygon453 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "331.43 575.13 331.03 578.03 333.63 578.03 334.03 575.13 331.43 575.13"
  })), _polygon454 || (_polygon454 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "331.43 575.13 331.03 578.03 333.63 578.03 334.03 575.13 331.43 575.13"
  })), _polygon455 || (_polygon455 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "336.63 571.33 336.23 574.33 338.93 574.33 339.23 571.33 336.63 571.33"
  })), _polygon456 || (_polygon456 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "336.63 571.33 336.23 574.33 338.93 574.33 339.23 571.33 336.63 571.33"
  })), _polygon457 || (_polygon457 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "280.83 590.83 279.03 592.63 279.33 597.53 281.23 596.43 280.83 590.83"
  })), _polygon458 || (_polygon458 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "280.83 590.83 279.03 592.63 279.33 597.53 281.23 596.43 280.83 590.83"
  })), _path414 || (_path414 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M278.2,580.3l-1.5,4.9.8,1.5,3-2.2C280.5,584.4,280.1,580.7,278.2,580.3Z",
    transform: "translate(0.03 0.03)"
  })), _path415 || (_path415 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M278.2,580.3l-1.5,4.9.8,1.5,3-2.2C280.5,584.4,280.1,580.7,278.2,580.3Z",
    transform: "translate(0.03 0.03)"
  })), _path416 || (_path416 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M502.4,452.6l2.3-2.3,15.7-1.1.8,1.5s-6.8,3-11.2,3.4l-1.9-1.5a12.16,12.16,0,0,0-3.4,1.1Z",
    transform: "translate(0.03 0.03)"
  })), _path417 || (_path417 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M502.4,452.6l2.3-2.3,15.7-1.1.8,1.5s-6.8,3-11.2,3.4l-1.9-1.5a12.16,12.16,0,0,0-3.4,1.1Z",
    transform: "translate(0.03 0.03)"
  })), _path418 || (_path418 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M508.1,457.5a25.29,25.29,0,0,0,6.4-.8,5,5,0,0,0,3-2.6l6.4-1.1.8,1.1s-3,.7-2.6,2.2,2.6,1.1,2.6,1.1l2.6,3.4s-7.1,1.1-10.9.8v3.7l-1.9-.4-2.6-3,2.2-1.5-.4-1.5-5.2.4-.4-1.8Z",
    transform: "translate(0.03 0.03)"
  })), _path419 || (_path419 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M508.1,457.5a25.29,25.29,0,0,0,6.4-.8,5,5,0,0,0,3-2.6l6.4-1.1.8,1.1s-3,.7-2.6,2.2,2.6,1.1,2.6,1.1l2.6,3.4s-7.1,1.1-10.9.8v3.7l-1.9-.4-2.6-3,2.2-1.5-.4-1.5-5.2.4-.4-1.8Z",
    transform: "translate(0.03 0.03)"
  })), _path420 || (_path420 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M522.6,465.7l-4.5-.4-2.3,2.3s3.8,4.1,6.7,4.5,7.5-2.3,7.5-2.3l2.2.4a19.56,19.56,0,0,1-7.9,3.7l11.6,11.2,1.9.4,2.6,5.2,2.2-1.1.8-2.6,3.4-1.5-1.9-3.4h-1.5a14.77,14.77,0,0,0-1.9-5.6,6.75,6.75,0,0,0-.4-4.5c-1.1-1.9-3.8-1.5-3.8-1.5s-1.9-3.4-4.9-3.7c0,0,1.1-2.3,3-2.3l-1.5-1.1s-4.5.7-5.2,3.4c0,0-3.4,1.1-5.3,1.5S520.4,468,522.6,465.7Z",
    transform: "translate(0.03 0.03)"
  })), _path421 || (_path421 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M522.6,465.7l-4.5-.4-2.3,2.3s3.8,4.1,6.7,4.5,7.5-2.3,7.5-2.3l2.2.4a19.56,19.56,0,0,1-7.9,3.7l11.6,11.2,1.9.4,2.6,5.2,2.2-1.1.8-2.6,3.4-1.5-1.9-3.4h-1.5a14.77,14.77,0,0,0-1.9-5.6,6.75,6.75,0,0,0-.4-4.5c-1.1-1.9-3.8-1.5-3.8-1.5s-1.9-3.4-4.9-3.7c0,0,1.1-2.3,3-2.3l-1.5-1.1s-4.5.8-5.2,3.4c0,0-3.4,1.1-5.3,1.5S520.4,468,522.6,465.7Z",
    transform: "translate(0.03 0.03)"
  })), _path422 || (_path422 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M538,459l-1.1,1.9a32.85,32.85,0,0,1,12.7,10.5l.8-4.9,1.5.4-.8,5.2,2.6,1.9v3.4l6,6,2.6.4,2.3-3.4.8-7.1-1.5-1.5.4-5.2-1.5-1.9-3-.8-2.2-1.9s-2.6-.4-4.5-6.4l-3,1.5.7,5.6h-1.5l-.8-5.2-2.6.4.4,4.9-1.5-.4-.4-3.7Z",
    transform: "translate(0.03 0.03)"
  })), _path423 || (_path423 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M538,459l-1.1,1.9a32.85,32.85,0,0,1,12.7,10.5l.8-4.9,1.5.4-.8,5.2,2.6,1.9v3.4l6,6,2.6.4,2.3-3.4.8-7.1-1.5-1.5.4-5.2-1.5-1.9-3-.8-2.2-1.9s-2.6-.4-4.5-6.4l-3,1.5.7,5.6h-1.5l-.8-5.2-2.6.4.4,4.9-1.5-.4-.4-3.7Z",
    transform: "translate(0.03 0.03)"
  })), _path424 || (_path424 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M567.2,468l-.4,17.2-1.9.4-.4,4.9,2.6.8a4.46,4.46,0,0,0,3,1.1c1.9,0,1.9-3.4,1.5-7.5l-1.9-1.5.4-13.5Z",
    transform: "translate(0.03 0.03)"
  })), _path425 || (_path425 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M567.2,468l-.4,17.2-1.9.4-.4,4.9,2.6.8a4.46,4.46,0,0,0,3,1.1c1.9,0,1.9-3.4,1.5-7.5l-1.9-1.5.4-13.5Z",
    transform: "translate(0.03 0.03)"
  })), _path426 || (_path426 = /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M529,450.8c3-2.2,6.4-4.5,9.7-4.5l2.6-2.2s4.1,5.2.8,7.1-6,2.3-8.3,3.7a13.64,13.64,0,0,1-4.5,1.9v-1.9l1.9-.7v-2.3Z",
    transform: "translate(0.03 0.03)"
  })), _path427 || (_path427 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M529,450.8c3-2.2,6.4-4.5,9.7-4.5l2.6-2.2s4.1,5.2.8,7.1-6,2.3-8.3,3.7a13.64,13.64,0,0,1-4.5,1.9v-1.9l1.9-.7v-2.3Z",
    transform: "translate(0.03 0.03)"
  })), _polygon459 || (_polygon459 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "544.73 445.93 545.53 449.33 547.73 449.33 547.73 445.93 544.73 445.93"
  })), _polygon460 || (_polygon460 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "544.73 445.93 545.53 449.33 547.73 449.33 547.73 445.93 544.73 445.93"
  })), _polygon461 || (_polygon461 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "549.63 443.73 550.03 448.93 552.23 448.93 552.63 443.73 549.63 443.73"
  })), _polygon462 || (_polygon462 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "549.63 443.73 550.03 448.93 552.23 448.93 552.63 443.73 549.63 443.73"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-15",
    x: 555.23,
    y: 438.43,
    width: 2.3,
    height: 10.5
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 555.23,
    y: 438.43,
    width: 2.3,
    height: 10.5
  })), _polygon463 || (_polygon463 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "560.53 439.93 560.13 448.13 562.33 448.13 562.73 439.93 560.53 439.93"
  })), _polygon464 || (_polygon464 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "560.53 439.93 560.13 448.13 562.33 448.13 562.73 439.93 560.53 439.93"
  })), _polygon465 || (_polygon465 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "567.63 439.93 565.03 448.13 567.63 447.83 569.13 444.03 567.63 439.93"
  })), _polygon466 || (_polygon466 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "567.63 439.93 565.03 448.13 567.63 447.83 569.13 444.03 567.63 439.93"
  })), _path428 || (_path428 = /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M572.8,438.4c-1.9,0-2.3,4.5-1.9,8.6a5,5,0,0,1,4.9.8l1.5-2.3-3-1.5S575.1,438.4,572.8,438.4Z",
    transform: "translate(0.03 0.03)"
  })), _path429 || (_path429 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M572.8,438.4c-1.9,0-2.3,4.5-1.9,8.6a5,5,0,0,1,4.9.8l1.5-2.3-3-1.5S575.1,438.4,572.8,438.4Z",
    transform: "translate(0.03 0.03)"
  })), _path430 || (_path430 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M576.6,431.7c-1.5,0-3.4,3.7-.4,4.9l2.6,10.9,3.4,3,1.1-1.5s3,3.4,4.9,3.7a67.27,67.27,0,0,0-.8-10.5l-1.9-1.5a54.94,54.94,0,0,0-4.1-11.6h-1.5s1.1,7.5,2.2,10.1,3,4.9,3.7,8.2l-4.1-3.7-.8-4.1-4.3-7.9Z",
    transform: "translate(0.03 0.03)"
  })), _path431 || (_path431 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M576.6,431.7c-1.5,0-3.4,3.7-.4,4.9l2.6,10.9,3.4,3,1.1-1.5s3,3.4,4.9,3.7a67.27,67.27,0,0,0-.8-10.5l-1.9-1.5a54.94,54.94,0,0,0-4.1-11.6h-1.5s1.1,7.5,2.2,10.1,3,4.9,3.7,8.2l-4.1-3.7-.8-4.1-4.3-7.9Z",
    transform: "translate(0.03 0.03)"
  })), _polygon467 || (_polygon467 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "545.53 529.03 545.93 511.83 544.03 510.33 541.83 525.63 543.63 529.43 545.53 529.03"
  })), _polygon468 || (_polygon468 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "545.53 529.03 545.93 511.83 544.03 510.33 541.83 525.63 543.63 529.43 545.53 529.03"
  })), _path432 || (_path432 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M541.8,500.6c-.4,0-1.9,3.7-1.9,3.7l2.6,1.5.8-3.7Z",
    transform: "translate(0.03 0.03)"
  })), _path433 || (_path433 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M541.8,500.6c-.4,0-1.9,3.7-1.9,3.7l2.6,1.5.8-3.7Z",
    transform: "translate(0.03 0.03)"
  })), _polygon469 || (_polygon469 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "545.13 501.33 545.13 503.93 548.13 502.43 548.13 500.63 545.13 501.33"
  })), _polygon470 || (_polygon470 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "545.13 501.33 545.13 503.93 548.13 502.43 548.13 500.63 545.13 501.33"
  })), _polygon471 || (_polygon471 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "547.73 514.03 547.43 522.63 548.93 520.83 549.63 512.93 547.73 514.03"
  })), _polygon472 || (_polygon472 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "547.73 514.03 547.43 522.63 548.93 520.83 549.63 512.93 547.73 514.03"
  })), _polygon473 || (_polygon473 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "551.53 511.43 551.13 520.03 552.63 518.13 553.43 510.33 551.53 511.43"
  })), _polygon474 || (_polygon474 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "551.53 511.43 551.13 520.03 552.63 518.13 553.43 510.33 551.53 511.43"
  })), _polygon475 || (_polygon475 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "540.33 523.03 539.93 529.83 537.33 529.03 538.03 521.53 540.33 523.03"
  })), _polygon476 || (_polygon476 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "540.33 523.03 539.93 529.83 537.33 529.03 538.03 521.53 540.33 523.03"
  })), _path434 || (_path434 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M533.9,524.5c-.4.4-1.5,5.2-1.5,5.2l2.6,1.1,1.1-5.6Z",
    transform: "translate(0.03 0.03)"
  })), _path435 || (_path435 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M533.9,524.5c-.4.4-1.5,5.2-1.5,5.2l2.6,1.1,1.1-5.6Z",
    transform: "translate(0.03 0.03)"
  })), _path436 || (_path436 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M541,531.2s-.8,6.7-1.1,6.7,2.6-.4,2.6-.4l.8-5.6Z",
    transform: "translate(0.03 0.03)"
  })), _path437 || (_path437 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M541,531.2s-.8,6.7-1.1,6.7,2.6-.4,2.6-.4l.8-5.6Z",
    transform: "translate(0.03 0.03)"
  })), _path438 || (_path438 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M536.5,533.5s-1.9,4.5-1.5,4.5h2.6l.8-4.9Z",
    transform: "translate(0.03 0.03)"
  })), _path439 || (_path439 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M536.5,533.5s-1.9,4.5-1.5,4.5h2.6l.8-4.9Z",
    transform: "translate(0.03 0.03)"
  })), _path440 || (_path440 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M534.3,540.6s-3,6.7-2.6,6.7h2.6l1.9-7.1Z",
    transform: "translate(0.03 0.03)"
  })), _path441 || (_path441 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M534.3,540.6s-3,6.7-2.6,6.7h2.6l1.9-7.1Z",
    transform: "translate(0.03 0.03)"
  })), _path442 || (_path442 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M549.6,523.8s-4.1,13.5-3.8,13.5h2.6l3-13.9Z",
    transform: "translate(0.03 0.03)"
  })), _path443 || (_path443 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M549.6,523.8s-4.1,13.5-3.8,13.5h2.6l3-13.9Z",
    transform: "translate(0.03 0.03)"
  })), _path444 || (_path444 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M554.9,518.9s-4.1,13.5-3.8,13.5h2.6l3-13.9Z",
    transform: "translate(0.03 0.03)"
  })), _path445 || (_path445 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M554.9,518.9s-4.1,13.5-3.8,13.5h2.6l3-13.9Z",
    transform: "translate(0.03 0.03)"
  })), _path446 || (_path446 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M558.6,521.1s-2.6,6.7-2.2,6.7H559l1.5-7.1Z",
    transform: "translate(0.03 0.03)"
  })), _path447 || (_path447 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M558.6,521.1s-2.6,6.7-2.2,6.7H559l1.5-7.1Z",
    transform: "translate(0.03 0.03)"
  })), _polygon477 || (_polygon477 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "523.83 536.53 521.53 536.13 520.43 540.23 523.83 544.03 525.33 542.13 523.83 536.53"
  })), _polygon478 || (_polygon478 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "523.83 536.53 521.53 536.13 520.43 540.23 523.83 544.03 525.33 542.13 523.83 536.53"
  })), _polygon479 || (_polygon479 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "527.13 531.23 526.83 541.43 529.43 539.93 530.13 534.63 527.13 531.23"
  })), _polygon480 || (_polygon480 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "527.13 531.23 526.83 541.43 529.43 539.93 530.13 534.63 527.13 531.23"
  })), _polygon481 || (_polygon481 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "532.43 533.53 531.33 538.03 533.13 538.03 534.63 533.53 532.43 533.53"
  })), _polygon482 || (_polygon482 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "532.43 533.53 531.33 538.03 533.13 538.03 534.63 533.53 532.43 533.53"
  })), _polygon483 || (_polygon483 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "520.83 544.73 519.33 555.63 521.93 554.83 523.03 547.43 520.83 544.73"
  })), _polygon484 || (_polygon484 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "520.83 544.73 519.33 555.63 521.93 554.83 523.03 547.43 520.83 544.73"
  })), _polygon485 || (_polygon485 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "525.63 545.13 524.53 550.73 526.43 551.83 528.33 545.53 525.63 545.13"
  })), _polygon486 || (_polygon486 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "525.63 545.13 524.53 550.73 526.43 551.83 528.33 545.53 525.63 545.13"
  })), _polygon487 || (_polygon487 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "523.83 554.83 520.83 563.13 523.43 562.03 526.43 554.83 523.83 554.83"
  })), _polygon488 || (_polygon488 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "523.83 554.83 520.83 563.13 523.43 562.03 526.43 554.83 523.83 554.83"
  })), _polygon489 || (_polygon489 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "518.93 550.73 517.83 555.23 515.53 556.33 516.73 551.13 518.93 550.73"
  })), _polygon490 || (_polygon490 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "518.93 550.73 517.83 555.23 515.53 556.33 516.73 551.13 518.93 550.73"
  })), _path448 || (_path448 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M531.3,549.6l-2.2,7.1s2.2.4,2.6,0,1.9-7.1,1.9-7.1Z",
    transform: "translate(0.03 0.03)"
  })), _path449 || (_path449 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M531.3,549.6l-2.2,7.1s2.2.4,2.6,0,1.9-7.1,1.9-7.1Z",
    transform: "translate(0.03 0.03)"
  })), _polygon491 || (_polygon491 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "527.93 559.73 526.43 565.33 528.63 565.33 530.93 559.73 527.93 559.73"
  })), _polygon492 || (_polygon492 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "527.93 559.73 526.43 565.33 528.63 565.33 530.93 559.73 527.93 559.73"
  })), _path450 || (_path450 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M536.5,548.8l-1.9,6.4s2.3,0,2.3-.4,1.9-6,1.9-6Z",
    transform: "translate(0.03 0.03)"
  })), _path451 || (_path451 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M536.5,548.8l-1.9,6.4s2.3,0,2.3-.4,1.9-6,1.9-6Z",
    transform: "translate(0.03 0.03)"
  })), _polygon493 || (_polygon493 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "538.83 541.73 537.33 545.53 539.53 545.53 541.03 541.73 538.83 541.73"
  })), _polygon494 || (_polygon494 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "538.83 541.73 537.33 545.53 539.53 545.53 541.03 541.73 538.83 541.73"
  })), _path452 || (_path452 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M515.2,561.6c-3.4,0-3.7,6.7-3.4,12l2.6-.8s-.4-3.7.8-6,2.6-5.2,2.6-5.2Z",
    transform: "translate(0.03 0.03)"
  })), _path453 || (_path453 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M515.2,561.6c-3.4,0-3.7,6.7-3.4,12l2.6-.8s-.4-3.7.8-6,2.6-5.2,2.6-5.2Z",
    transform: "translate(0.03 0.03)"
  })), _polygon495 || (_polygon495 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "550.73 486.03 547.73 487.83 549.23 490.53 551.93 487.53 550.73 486.03"
  })), _polygon496 || (_polygon496 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "550.73 486.03 547.73 487.83 549.23 490.53 551.93 487.53 550.73 486.03"
  })), _path454 || (_path454 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M572.4,471v23.2l-1.5,2.6.4,6.4,2.3-1.9,1.1-11.2,1.5-2.3v-8.6l1.1-1.9-.4-9A10.68,10.68,0,0,0,572.4,471Z",
    transform: "translate(0.03 0.03)"
  })), _path455 || (_path455 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M572.4,471v23.2l-1.5,2.6.4,6.4,2.3-1.9,1.1-11.2,1.5-2.3v-8.6l1.1-1.9-.4-9A10.68,10.68,0,0,0,572.4,471Z",
    transform: "translate(0.03 0.03)"
  })), _path456 || (_path456 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M578.8,468.4l-.4,18,1.9,2.2a14.93,14.93,0,0,0,1.5-7.9C581.4,476.2,580.7,472.1,578.8,468.4Z",
    transform: "translate(0.03 0.03)"
  })), _path457 || (_path457 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M578.8,468.4l-.4,18,1.9,2.2a14.93,14.93,0,0,0,1.5-7.9C581.4,476.2,580.7,472.1,578.8,468.4Z",
    transform: "translate(0.03 0.03)"
  })), _path458 || (_path458 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M582.6,473.6a40.8,40.8,0,0,1,1.1,7.9l2.6-3.4s1.1-3.7-1.5-5.2Z",
    transform: "translate(0.03 0.03)"
  })), _path459 || (_path459 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M582.6,473.6a40.8,40.8,0,0,1,1.1,7.9l2.6-3.4s1.1-3.7-1.5-5.2Z",
    transform: "translate(0.03 0.03)"
  })), _polygon497 || (_polygon497 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "576.63 494.93 576.23 500.23 577.73 500.23 578.43 494.63 576.63 494.93"
  })), _polygon498 || (_polygon498 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "576.63 494.93 576.23 500.23 577.73 500.23 578.43 494.63 576.63 494.93"
  })), _path460 || (_path460 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M580.3,496.4c-.4.4,0,4.1,0,4.1h1.9s.8-3.8.4-4.1S580.3,496.4,580.3,496.4Z",
    transform: "translate(0.03 0.03)"
  })), _path461 || (_path461 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M580.3,496.4c-.4.4,0,4.1,0,4.1h1.9s.8-3.8.4-4.1S580.3,496.4,580.3,496.4Z",
    transform: "translate(0.03 0.03)"
  })), _polygon499 || (_polygon499 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "592.33 439.93 591.93 432.83 590.03 431.73 589.73 448.13 593.03 454.13 593.83 441.43 592.33 439.93"
  })), _polygon500 || (_polygon500 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "592.33 439.93 591.93 432.83 590.03 431.73 589.73 448.13 593.03 454.13 593.83 441.43 592.33 439.93"
  })), _polygon501 || (_polygon501 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "594.23 432.83 594.23 438.43 596.03 440.33 596.43 433.93 594.23 432.83"
  })), _polygon502 || (_polygon502 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "594.23 432.83 594.23 438.43 596.03 440.33 596.43 433.93 594.23 432.83"
  })), _path462 || (_path462 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M595.7,443.7l-.8,13.1s4.5,3.4,7.1,3.7l1.9-3.7.4-8.6,4.5-4.9v-6l-1.9,2.3-.4,2.2-2.3,1.9v-4.1l1.9-3.4a3.4,3.4,0,0,0-3-2.2c-2.2,0-1.1,3-1.1,6v12.7l-1.5,3.4v-21l-2.2-.8.4,21.7-1.5-1.9V443.6l-1.5.1Z",
    transform: "translate(0.03 0.03)"
  })), _path463 || (_path463 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M595.7,443.7l-.8,13.1s4.5,3.4,7.1,3.7l1.9-3.7.4-8.6,4.5-4.9v-6l-1.9,2.3-.4,2.2-2.3,1.9v-4.1l1.9-3.4a3.4,3.4,0,0,0-3-2.2c-2.2,0-1.1,3-1.1,6v12.7l-1.5,3.4v-21l-2.2-.8.4,21.7-1.5-1.9V443.6l-1.5.1Z",
    transform: "translate(0.03 0.03)"
  })), _polygon503 || (_polygon503 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "585.23 421.23 582.23 424.63 584.03 429.83 587.43 428.73 585.23 421.23"
  })), _polygon504 || (_polygon504 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "585.23 421.23 582.23 424.63 584.03 429.83 587.43 428.73 585.23 421.23"
  })), _polygon505 || (_polygon505 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "145.33 465.43 144.63 471.03 146.43 472.53 146.43 466.53 145.33 465.43"
  })), _polygon506 || (_polygon506 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "145.33 465.43 144.63 471.03 146.43 472.53 146.43 466.53 145.33 465.43"
  })), _path464 || (_path464 = /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M539.9,243.4l-.8,6.7-2.3,3.4-.8,18a97.32,97.32,0,0,0-6,10.1l1.9.8,5.6-7.5.8,3-4.1,6,.8,6,2.3,101.8,6.7,8.2,3.4-2.6,1.5,2.2,1.9-2.2v-3.4h-2.2l-3-3,2.3-1.9-.4-3.4h-1.9s.4-3.4-3.4-5.6l1.5-3.4,2.3-.8-2.6-2.2V368l6.4-13.1-1.9-1.9,6-7.1a14.84,14.84,0,0,0-6.4-.8l.8-6,1.5.4L555,338v-1.5l-8.6.4-.8-2.3s1.5-2.6,3.4-1.5a6.63,6.63,0,0,1,2.6,2.6s.8-2.6,3-2.6V331a8.29,8.29,0,0,0-3.4.8l-1.1-1.1,3.4-1.5v-2.3l-2.3-1.1a6.08,6.08,0,0,1,1.5-3.4l-1.9-3-.4-5.2-2.6-2.2,1.1-2.6,2.2-1.1v-3.8s-2.6.8-2.2-1.5,4.1-4.1,4.1-4.1l-1.1-3s-2.6,1.9-4.9,3.8l.8-3,3.7-4.5-3.4-1.9,1.1-2.6.4-3s-1.9,2.2-4.1,2.2a4.33,4.33,0,0,1-3.4-1.9l1.1-3s3.4,1.1,4.9-.4l1.9-3.7-1.9-1.9.8-1.9s-1.5-2.3-3.4-2.6-2.3,1.9-1.9,3.8l-1.9.7s-2.6-1.9-1.5-4.5,3-3,5.2-2.2v-4.5l-1.9-1.9v-3.4s1.5-3,1.1-4.9l-2.6-2.3V241.8l-2.1,1.6Z",
    transform: "translate(0.03 0.03)"
  })), _path465 || (_path465 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M539.9,243.4l-.8,6.7-2.3,3.4-.8,18a97.32,97.32,0,0,0-6,10.1l1.9.8,5.6-7.5.8,3-4.1,6,.8,6,2.3,101.8,6.7,8.2,3.4-2.6,1.5,2.2,1.9-2.2v-3.4h-2.2l-3-3,2.3-1.9-.4-3.4h-1.9s.4-3.4-3.4-5.6l1.5-3.4,2.3-.8-2.6-2.2V368l6.4-13.1-1.9-1.9,6-7.1a14.84,14.84,0,0,0-6.4-.8l.8-6,1.5.4L555,338v-1.5l-8.6.4-.8-2.3s1.5-2.6,3.4-1.5a6.63,6.63,0,0,1,2.6,2.6s.8-2.6,3-2.6V331a8.29,8.29,0,0,0-3.4.8l-1.1-1.1,3.4-1.5v-2.3l-2.3-1.1a6.08,6.08,0,0,1,1.5-3.4l-1.9-3-.4-5.2-2.6-2.2,1.1-2.6,2.2-1.1v-3.8s-2.6.8-2.2-1.5,4.1-4.1,4.1-4.1l-1.1-3s-2.6,1.9-4.9,3.8l.8-3,3.7-4.5-3.4-1.9,1.1-2.6.4-3s-1.9,2.2-4.1,2.2a4.33,4.33,0,0,1-3.4-1.9l1.1-3s3.4,1.1,4.9-.4l1.9-3.7-1.9-1.9.8-1.9s-1.5-2.3-3.4-2.6-2.3,1.9-1.9,3.8l-1.9.7s-2.6-1.9-1.5-4.5,3-3,5.2-2.2v-4.5l-1.9-1.9v-3.4s1.5-3,1.1-4.9l-2.6-2.3V241.8l-2.1,1.6Z",
    transform: "translate(0.03 0.03)"
  })), _path466 || (_path466 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M565,299.9v4.9s8.6,3,11.6,5.6,5.2,4.9,5.2,4.9l.8,3,5.2,5.2.4-9.4a104.89,104.89,0,0,1-4.9-9.7s-4.9-3-8.6-3.7A59.48,59.48,0,0,0,565,299.9Z",
    transform: "translate(0.03 0.03)"
  })), _path467 || (_path467 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M565,299.9v4.9s8.6,3,11.6,5.6,5.2,4.9,5.2,4.9l.8,3,5.2,5.2.4-9.4a104.89,104.89,0,0,1-4.9-9.7s-4.9-3-8.6-3.7A59.48,59.48,0,0,0,565,299.9Z",
    transform: "translate(0.03 0.03)"
  })), _path468 || (_path468 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M567.6,296.5a51,51,0,0,1,11.6,2.6l-7.1-12-4.9,5.6Z",
    transform: "translate(0.03 0.03)"
  })), _path469 || (_path469 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M567.6,296.5a51,51,0,0,1,11.6,2.6l-7.1-12-4.9,5.6Z",
    transform: "translate(0.03 0.03)"
  })), _path470 || (_path470 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M574.3,284.2l8.6,15.4,6.4,2.6s1.9-11.6,1.9-18,0-13.1-.8-17.6Z",
    transform: "translate(0.03 0.03)"
  })), _path471 || (_path471 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M574.3,284.2l8.6,15.4,6.4,2.6s1.9-11.6,1.9-18,0-13.1-.8-17.6Z",
    transform: "translate(0.03 0.03)"
  })), _polygon507 || (_polygon507 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "563.53 281.93 569.13 277.83 563.13 270.03 563.53 281.93"
  })), _polygon508 || (_polygon508 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "563.53 281.93 569.13 277.83 563.13 270.03 563.53 281.93"
  })), _polygon509 || (_polygon509 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "565.73 266.63 570.93 275.93 597.53 250.13 595.73 247.13 565.73 266.63"
  })), _polygon510 || (_polygon510 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "565.73 266.63 570.93 275.93 597.53 250.13 595.73 247.13 565.73 266.63"
  })), _path472 || (_path472 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M496.1,256.1l6.4,7.5a39.12,39.12,0,0,1,4.5,1.1c2.3.8,10.5,5.2,14.6,6.4a50.92,50.92,0,0,0,10.5,1.1l1.9-3V244.5s-3.7-2.2-6.4-1.5-11.6,3.7-17.6,6-13.9,7.1-13.9,7.1Z",
    transform: "translate(0.03 0.03)"
  })), _path473 || (_path473 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M496.1,256.1l6.4,7.5a39.12,39.12,0,0,1,4.5,1.1c2.3.8,10.5,5.2,14.6,6.4a50.92,50.92,0,0,0,10.5,1.1l1.9-3V244.5s-3.7-2.2-6.4-1.5-11.6,3.7-17.6,6-13.9,7.1-13.9,7.1Z",
    transform: "translate(0.03 0.03)"
  })), _path474 || (_path474 = /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M548.9,411.5c-5.3,0-15.7,1.9-15,6s15,3.4,20.6,3l.8-3.4Z",
    transform: "translate(0.03 0.03)"
  })), _path475 || (_path475 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M548.9,411.5c-5.3,0-15.7,1.9-15,6s15,3.4,20.6,3l.8-3.4Z",
    transform: "translate(0.03 0.03)"
  })), _polygon511 || (_polygon511 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "546.63 402.53 553.03 411.53 554.93 409.23 548.53 402.53 546.63 402.53"
  })), _polygon512 || (_polygon512 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "546.63 402.53 553.03 411.53 554.93 409.23 548.53 402.53 546.63 402.53"
  })), _path476 || (_path476 = /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M490.5,252c8.2-3.4,32.2-11.2,40.4-13.9,0,0,8.6-3.7,9.7-6.4a3.9,3.9,0,0,0-3-1.9s-2.6-9.4-1.1-17.2c0,0,5.3-3.4,8.6-3.4l1.1,3s-3,1.1-3.8,3.4l4.5,1.1v1.5s-3.8,1.1-5.6,1.9a5.22,5.22,0,0,0,3.4,2.3l.8,2.6a27.94,27.94,0,0,1-6.4,1.1s-.4,3,3.7,3.4l3.8.8.4,3,3.7.4,2.6,2.2a5.47,5.47,0,0,0-1.9,6.4l-3-.8a19.76,19.76,0,0,0-7.9-2.2,61,61,0,0,0-16.9,3c-5.2,1.9-20.6,7.1-29.6,11.2l-3.5-1.5Z",
    transform: "translate(0.03 0.03)"
  })), _path477 || (_path477 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M490.5,252c8.2-3.4,32.2-11.2,40.4-13.9,0,0,8.6-3.7,9.7-6.4a3.9,3.9,0,0,0-3-1.9s-2.6-9.4-1.1-17.2c0,0,5.3-3.4,8.6-3.4l1.1,3s-3,1.1-3.8,3.4l4.5,1.1v1.5s-3.8,1.1-5.6,1.9a5.22,5.22,0,0,0,3.4,2.3l.8,2.6a27.94,27.94,0,0,1-6.4,1.1s-.4,3,3.7,3.4l3.8.8.4,3,3.7.4,2.6,2.2a5.47,5.47,0,0,0-1.9,6.4l-3-.8a19.76,19.76,0,0,0-7.9-2.2,61,61,0,0,0-16.9,3c-5.2,1.9-20.6,7.1-29.6,11.2l-3.5-1.5Z",
    transform: "translate(0.03 0.03)"
  })), _path478 || (_path478 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M560.1,223.2l.4,12,2.3,2.2,5.2-.8.8-3.7-4.1,2.3.4-3.4,3.7-3.7-.8-2.6C568,225.4,565.3,223.5,560.1,223.2Z",
    transform: "translate(0.03 0.03)"
  })), _path479 || (_path479 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M560.1,223.2l.4,12,2.3,2.2,5.2-.8.8-3.7-4.1,2.3.4-3.4,3.7-3.7-.8-2.6C568,225.4,565.3,223.5,560.1,223.2Z",
    transform: "translate(0.03 0.03)"
  })), _path480 || (_path480 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M558.2,190.6l.7,18,2.2,1.5,7.5-6.4A83.17,83.17,0,0,0,558.2,190.6Z",
    transform: "translate(0.03 0.03)"
  })), _path481 || (_path481 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M558.2,190.6l.7,18,2.2,1.5,7.5-6.4A83.17,83.17,0,0,0,558.2,190.6Z",
    transform: "translate(0.03 0.03)"
  })), _polygon513 || (_polygon513 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "536.53 208.23 536.13 210.43 543.63 208.23 544.03 206.03 536.53 208.23"
  })), _polygon514 || (_polygon514 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "536.53 208.23 536.13 210.43 543.63 208.23 544.03 206.03 536.53 208.23"
  })), _polygon515 || (_polygon515 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "536.53 203.33 536.13 206.03 543.63 203.73 543.63 201.53 536.53 203.33"
  })), _polygon516 || (_polygon516 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "536.53 203.33 536.13 206.03 543.63 203.73 543.63 201.53 536.53 203.33"
  })), _polygon517 || (_polygon517 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "536.93 198.53 536.93 201.53 543.23 199.23 543.23 197.33 536.93 198.53"
  })), _polygon518 || (_polygon518 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "536.93 198.53 536.93 201.53 543.23 199.23 543.23 197.33 536.93 198.53"
  })), _path482 || (_path482 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M570.9,219.4l-.4,3.8s2.3,2.6,1.9,5.6-1.9,5.6-1.9,7.9h3.4l1.1,3,2.3.8,2.6-6h-4.1l2.6-2.3-1.5-4.5,5.2-2.2a37.78,37.78,0,0,0-3.4-6.4l-7.8.3Z",
    transform: "translate(0.03 0.03)"
  })), _path483 || (_path483 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M570.9,219.4l-.4,3.8s2.3,2.6,1.9,5.6-1.9,5.6-1.9,7.9h3.4l1.1,3,2.3.8,2.6-6h-4.1l2.6-2.3-1.5-4.5,5.2-2.2a37.78,37.78,0,0,0-3.4-6.4l-7.8.3Z",
    transform: "translate(0.03 0.03)"
  })), _path484 || (_path484 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M582.6,233.3l-.4,2.6-.4,3.7,5.6,1.5h4.1a61.32,61.32,0,0,0-4.9-9l-4,1.2Z",
    transform: "translate(0.03 0.03)"
  })), _path485 || (_path485 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M582.6,233.3l-.4,2.6-.4,3.7,5.6,1.5h4.1a61.32,61.32,0,0,0-4.9-9l-4,1.2Z",
    transform: "translate(0.03 0.03)"
  })), _polygon519 || (_polygon519 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "582.93 244.93 575.43 248.63 575.83 252.73 584.03 248.23 582.93 244.93"
  })), _polygon520 || (_polygon520 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "582.93 244.93 575.43 248.63 575.83 252.73 584.03 248.23 582.93 244.93"
  })), _polygon521 || (_polygon521 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "576.93 254.63 577.33 256.93 584.83 252.43 584.43 250.53 576.93 254.63"
  })), _polygon522 || (_polygon522 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "576.93 254.63 577.33 256.93 584.83 252.43 584.43 250.53 576.93 254.63"
  })), _polygon523 || (_polygon523 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "566.83 247.53 566.53 250.53 569.13 250.53 569.43 247.53 566.83 247.53"
  })), _polygon524 || (_polygon524 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "566.83 247.53 566.53 250.53 569.13 250.53 569.43 247.53 566.83 247.53"
  })), _polygon525 || (_polygon525 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "566.83 253.93 566.53 256.93 569.13 256.93 569.43 253.93 566.83 253.93"
  })), _polygon526 || (_polygon526 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "566.83 253.93 566.53 256.93 569.13 256.93 569.43 253.93 566.83 253.93"
  })), _polygon527 || (_polygon527 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "566.53 259.53 566.13 262.53 568.73 262.53 569.13 259.53 566.53 259.53"
  })), _polygon528 || (_polygon528 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "566.53 259.53 566.13 262.53 568.73 262.53 569.13 259.53 566.53 259.53"
  })), _polygon529 || (_polygon529 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "562.03 248.23 561.63 251.23 564.23 251.23 564.63 248.23 562.03 248.23"
  })), _polygon530 || (_polygon530 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "562.03 248.23 561.63 251.23 564.23 251.23 564.63 248.23 562.03 248.23"
  })), _polygon531 || (_polygon531 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "561.63 253.93 561.23 256.93 563.83 256.93 564.23 253.93 561.63 253.93"
  })), _polygon532 || (_polygon532 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "561.63 253.93 561.23 256.93 563.83 256.93 564.23 253.93 561.63 253.93"
  })), _polygon533 || (_polygon533 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "567.23 239.33 571.33 238.93 571.73 241.53 567.63 242.33 567.23 239.33"
  })), _polygon534 || (_polygon534 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "567.23 239.33 571.33 238.93 571.73 241.53 567.63 242.33 567.23 239.33"
  })), _polygon535 || (_polygon535 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "551.13 278.93 550.73 281.93 553.43 281.93 553.73 278.93 551.13 278.93"
  })), _polygon536 || (_polygon536 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "551.13 278.93 550.73 281.93 553.43 281.93 553.73 278.93 551.13 278.93"
  })), _polygon537 || (_polygon537 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "551.13 260.63 550.73 263.63 553.43 263.63 553.73 260.63 551.13 260.63"
  })), _polygon538 || (_polygon538 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "551.13 260.63 550.73 263.63 553.43 263.63 553.73 260.63 551.13 260.63"
  })), _polygon539 || (_polygon539 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "551.13 266.23 550.73 269.23 553.43 269.23 553.73 266.23 551.13 266.23"
  })), _polygon540 || (_polygon540 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "551.13 266.23 550.73 269.23 553.43 269.23 553.73 266.23 551.13 266.23"
  })), _polygon541 || (_polygon541 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "546.23 257.23 545.93 260.23 548.53 260.23 548.93 257.23 546.23 257.23"
  })), _polygon542 || (_polygon542 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "546.23 257.23 545.93 260.23 548.53 260.23 548.93 257.23 546.23 257.23"
  })), _path486 || (_path486 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M387.9,256.1l-.4,2.6,4.5-1.1,3,3.8-1.9.4,1.9,4.9,7.9-1.5v-3.4l-3.4-.8,3.4-1.9a13.1,13.1,0,0,1-1.9-6,5,5,0,0,0-1.5-.8c-.4,0-1.1,3.4-1.1,3.4l-1.5.4,1.9-7.9-2.3-.7s-1.9,3.7-1.9,6.4l-6.7,2.2Z",
    transform: "translate(0.03 0.03)"
  })), _path487 || (_path487 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M387.9,256.1l-.4,2.6,4.5-1.1,3,3.8-1.9.4,1.9,4.9,7.9-1.5v-3.4l-3.4-.8,3.4-1.9a13.1,13.1,0,0,1-1.9-6,5,5,0,0,0-1.5-.8c-.4,0-1.1,3.4-1.1,3.4l-1.5.4,1.9-7.9-2.3-.7s-1.9,3.7-1.9,6.4l-6.7,2.2Z",
    transform: "translate(0.03 0.03)"
  })), _polygon543 || (_polygon543 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "394.33 249.03 393.13 252.43 387.93 254.23 387.93 252.03 394.33 249.03"
  })), _polygon544 || (_polygon544 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "394.33 249.03 393.13 252.43 387.93 254.23 387.93 252.03 394.33 249.03"
  })), _polygon545 || (_polygon545 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "383.03 252.43 385.63 252.43 385.33 255.03 382.63 255.73 383.03 252.43"
  })), _polygon546 || (_polygon546 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "383.03 252.43 385.63 252.43 385.33 255.03 382.63 255.73 383.03 252.43"
  })), _polygon547 || (_polygon547 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "378.23 253.13 380.83 253.13 380.43 255.73 377.83 256.53 378.23 253.13"
  })), _polygon548 || (_polygon548 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "378.23 253.13 380.83 253.13 380.43 255.73 377.83 256.53 378.23 253.13"
  })), _polygon549 || (_polygon549 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "383.03 257.23 385.63 257.23 385.33 259.93 382.63 260.63 383.03 257.23"
  })), _polygon550 || (_polygon550 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "383.03 257.23 385.63 257.23 385.33 259.93 382.63 260.63 383.03 257.23"
  })), _polygon551 || (_polygon551 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "383.03 262.53 385.63 262.53 385.33 265.13 382.63 265.83 383.03 262.53"
  })), _polygon552 || (_polygon552 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "383.03 262.53 385.63 262.53 385.33 265.13 382.63 265.83 383.03 262.53"
  })), _polygon553 || (_polygon553 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "401.03 246.03 403.63 246.03 403.23 248.63 400.63 249.43 401.03 246.03"
  })), _polygon554 || (_polygon554 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "401.03 246.03 403.63 246.03 403.23 248.63 400.63 249.43 401.03 246.03"
  })), _polygon555 || (_polygon555 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "403.63 250.93 406.23 250.93 405.93 253.53 403.23 254.23 403.63 250.93"
  })), _polygon556 || (_polygon556 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "403.63 250.93 406.23 250.93 405.93 253.53 403.23 254.23 403.63 250.93"
  })), _polygon557 || (_polygon557 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "406.63 255.43 409.23 255.43 408.93 258.03 406.23 258.73 406.63 255.43"
  })), _polygon558 || (_polygon558 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "406.63 255.43 409.23 255.43 408.93 258.03 406.23 258.73 406.63 255.43"
  })), _polygon559 || (_polygon559 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "397.23 238.93 401.43 239.63 400.23 244.93 396.13 244.93 397.23 238.93"
  })), _polygon560 || (_polygon560 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "397.23 238.93 401.43 239.63 400.23 244.93 396.13 244.93 397.23 238.93"
  })), _polygon561 || (_polygon561 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "391.33 238.13 395.43 238.93 394.33 244.13 390.13 244.13 391.33 238.13"
  })), _polygon562 || (_polygon562 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "391.33 238.13 395.43 238.93 394.33 244.13 390.13 244.13 391.33 238.13"
  })), _path488 || (_path488 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M390.9,247.1a113.71,113.71,0,0,0-10.9,3.7l-2.2-.8a18.78,18.78,0,0,1,6-3,26.22,26.22,0,0,0,5.6-2.3Z",
    transform: "translate(0.03 0.03)"
  })), _path489 || (_path489 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M390.9,247.1a113.71,113.71,0,0,0-10.9,3.7l-2.2-.8a18.78,18.78,0,0,1,6-3,26.22,26.22,0,0,0,5.6-2.3Z",
    transform: "translate(0.03 0.03)"
  })), _polygon563 || (_polygon563 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "385.63 244.53 379.33 246.73 377.03 245.63 385.33 241.93 385.63 244.53"
  })), _polygon564 || (_polygon564 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "385.63 244.53 379.33 246.73 377.03 245.63 385.33 241.93 385.63 244.53"
  })), _polygon565 || (_polygon565 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "374.83 246.43 369.23 248.23 370.73 249.73 376.33 247.53 374.83 246.43"
  })), _polygon566 || (_polygon566 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "374.83 246.43 369.23 248.23 370.73 249.73 376.33 247.53 374.83 246.43"
  })), _path490 || (_path490 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M376.7,253.5l-.8,3-4.9,2.3-2.2-1.5a9.18,9.18,0,0,1,3.4-2.6A34.67,34.67,0,0,1,376.7,253.5Z",
    transform: "translate(0.03 0.03)"
  })), _path491 || (_path491 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M376.7,253.5l-.8,3-4.9,2.3-2.2-1.5a9.18,9.18,0,0,1,3.4-2.6A34.67,34.67,0,0,1,376.7,253.5Z",
    transform: "translate(0.03 0.03)"
  })), _polygon567 || (_polygon567 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "382.63 269.23 385.33 269.23 384.93 271.83 382.33 272.63 382.63 269.23"
  })), _polygon568 || (_polygon568 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "382.63 269.23 385.33 269.23 384.93 271.83 382.33 272.63 382.63 269.23"
  })), _polygon569 || (_polygon569 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "433.23 200.33 435.83 200.33 433.93 204.13 431.33 204.83 433.23 200.33"
  })), _polygon570 || (_polygon570 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "433.23 200.33 435.83 200.33 433.93 204.13 431.33 204.83 433.23 200.33"
  })), _polygon571 || (_polygon571 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "438.83 199.23 441.43 199.23 439.53 203.03 436.93 203.73 438.83 199.23"
  })), _polygon572 || (_polygon572 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "438.83 199.23 441.43 199.23 439.53 203.03 436.93 203.73 438.83 199.23"
  })), _polygon573 || (_polygon573 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "444.43 197.73 447.03 197.73 445.23 201.53 442.53 202.23 444.43 197.73"
  })), _polygon574 || (_polygon574 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "444.43 197.73 447.03 197.73 445.23 201.53 442.53 202.23 444.43 197.73"
  })), _polygon575 || (_polygon575 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "450.83 196.23 453.43 196.23 451.53 200.03 448.93 200.73 450.83 196.23"
  })), _polygon576 || (_polygon576 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "450.83 196.23 453.43 196.23 451.53 200.03 448.93 200.73 450.83 196.23"
  })), _polygon577 || (_polygon577 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "453.43 190.63 456.03 190.63 454.23 193.23 451.53 194.03 453.43 190.63"
  })), _polygon578 || (_polygon578 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "453.43 190.63 456.03 190.63 454.23 193.23 451.53 194.03 453.43 190.63"
  })), _polygon579 || (_polygon579 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "447.03 192.53 449.73 192.53 447.83 195.13 445.23 195.83 447.03 192.53"
  })), _polygon580 || (_polygon580 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "447.03 192.53 449.73 192.53 447.83 195.13 445.23 195.83 447.03 192.53"
  })), _polygon581 || (_polygon581 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "441.43 193.63 444.03 193.63 442.23 196.23 439.53 197.03 441.43 193.63"
  })), _polygon582 || (_polygon582 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "441.43 193.63 444.03 193.63 442.23 196.23 439.53 197.03 441.43 193.63"
  })), _polygon583 || (_polygon583 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "435.83 195.13 438.43 195.13 436.63 197.73 433.93 198.53 435.83 195.13"
  })), _polygon584 || (_polygon584 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "435.83 195.13 438.43 195.13 436.63 197.73 433.93 198.53 435.83 195.13"
  })), _polygon585 || (_polygon585 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "430.93 196.23 433.63 196.23 431.73 198.83 429.13 199.63 430.93 196.23"
  })), _polygon586 || (_polygon586 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "430.93 196.23 433.63 196.23 431.73 198.83 429.13 199.63 430.93 196.23"
  })), _polygon587 || (_polygon587 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "423.53 199.23 426.13 199.23 424.23 201.83 421.63 202.63 423.53 199.23"
  })), _polygon588 || (_polygon588 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "423.53 199.23 426.13 199.23 424.23 201.83 421.63 202.63 423.53 199.23"
  })), _polygon589 || (_polygon589 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "417.53 200.33 420.13 200.33 418.23 203.03 415.63 203.73 417.53 200.33"
  })), _polygon590 || (_polygon590 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "417.53 200.33 420.13 200.33 418.23 203.03 415.63 203.73 417.53 200.33"
  })), _polygon591 || (_polygon591 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "421.23 204.13 423.83 204.13 422.03 206.73 419.33 207.43 421.23 204.13"
  })), _polygon592 || (_polygon592 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "421.23 204.13 423.83 204.13 422.03 206.73 419.33 207.43 421.23 204.13"
  })), _polygon593 || (_polygon593 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "415.23 205.23 417.83 205.23 416.03 207.83 413.33 208.63 415.23 205.23"
  })), _polygon594 || (_polygon594 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "415.23 205.23 417.83 205.23 416.03 207.83 413.33 208.63 415.23 205.23"
  })), _polygon595 || (_polygon595 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "442.23 204.53 444.83 204.53 442.93 208.23 440.33 208.93 442.23 204.53"
  })), _polygon596 || (_polygon596 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "442.23 204.53 444.83 204.53 442.93 208.23 440.33 208.93 442.23 204.53"
  })), _polygon597 || (_polygon597 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "448.53 203.03 451.23 203.03 449.33 206.73 446.73 207.43 448.53 203.03"
  })), _polygon598 || (_polygon598 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "448.53 203.03 451.23 203.03 449.33 206.73 446.73 207.43 448.53 203.03"
  })), _polygon599 || (_polygon599 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "455.33 185.43 457.93 185.43 456.03 188.03 453.43 188.73 455.33 185.43"
  })), _polygon600 || (_polygon600 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "455.33 185.43 457.93 185.43 456.03 188.03 453.43 188.73 455.33 185.43"
  })), _path492 || (_path492 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M384.5,171.1l-3,1.5-1.1,5.3s3.4-.8,7.5-1.5,6.4-.4,8.6-1.5,3.7-4.5,9-6l-1.9-1.5a18.27,18.27,0,0,0-5.6,1.5,5.33,5.33,0,0,0-2.3,3.4l-1.9-1.9a3.11,3.11,0,0,0-2.3,2.2,30.78,30.78,0,0,0-4.5-1.5l-.4-5.2-1.1,1.5Z",
    transform: "translate(0.03 0.03)"
  })), _path493 || (_path493 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M384.5,171.1l-3,1.5-1.1,5.2s3.4-.7,7.5-1.5,6.4-.4,8.6-1.5,3.7-4.5,9-6l-1.9-1.5a18.27,18.27,0,0,0-5.6,1.5,5.33,5.33,0,0,0-2.3,3.4l-1.9-1.9a3.11,3.11,0,0,0-2.3,2.2A30.78,30.78,0,0,0,387,171l-.4-5.2-1.1,1.5Z",
    transform: "translate(0.03 0.03)"
  })), _polygon601 || (_polygon601 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "398.03 180.53 400.63 180.53 398.73 183.13 396.13 183.93 398.03 180.53"
  })), _polygon602 || (_polygon602 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "398.03 180.53 400.63 180.53 398.73 183.13 396.13 183.93 398.03 180.53"
  })), _polygon603 || (_polygon603 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "390.53 164.03 393.13 164.03 393.13 168.53 390.53 169.33 390.53 164.03"
  })), _polygon604 || (_polygon604 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "390.53 164.03 393.13 164.03 393.13 168.53 390.53 169.33 390.53 164.03"
  })), _polygon605 || (_polygon605 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "456.83 194.73 459.43 194.73 457.53 198.53 454.93 199.23 456.83 194.73"
  })), _polygon606 || (_polygon606 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "456.83 194.73 459.43 194.73 457.53 198.53 454.93 199.23 456.83 194.73"
  })), _polygon607 || (_polygon607 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "462.83 193.63 465.43 193.63 463.53 197.33 460.93 198.13 462.83 193.63"
  })), _polygon608 || (_polygon608 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "462.83 193.63 465.43 193.63 463.53 197.33 460.93 198.13 462.83 193.63"
  })), _polygon609 || (_polygon609 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "465.43 188.03 468.03 188.03 466.13 190.63 463.53 191.33 465.43 188.03"
  })), _polygon610 || (_polygon610 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "465.43 188.03 468.03 188.03 466.13 190.63 463.53 191.33 465.43 188.03"
  })), _polygon611 || (_polygon611 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "459.83 189.13 462.43 189.13 460.53 191.73 457.93 192.53 459.83 189.13"
  })), _polygon612 || (_polygon612 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "459.83 189.13 462.43 189.13 460.53 191.73 457.93 192.53 459.83 189.13"
  })), _polygon613 || (_polygon613 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "467.23 182.73 469.93 182.73 468.03 185.43 465.43 186.13 467.23 182.73"
  })), _polygon614 || (_polygon614 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "467.23 182.73 469.93 182.73 468.03 185.43 465.43 186.13 467.23 182.73"
  })), _polygon615 || (_polygon615 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "461.63 183.93 464.33 183.93 462.43 186.53 459.83 187.23 461.63 183.93"
  })), _polygon616 || (_polygon616 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "461.63 183.93 464.33 183.93 462.43 186.53 459.83 187.23 461.63 183.93"
  })), _path494 || (_path494 = /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M548.9,361.7s4.1-9.4,6.7-10.9,7.5-1.1,10.1-1.5,6.4-4.1,6.4-4.1l3,3.4-1.5,1.9-1.5-1.1s-1.9,3.4-3,6-2.2,9.7-2.2,13.5.4,7.5.4,7.5l-2.6,3.7-.4-4.5s-2.6-1.1-3.8,3.7a24.25,24.25,0,0,0-7.9,12l-1.1-2.6s1.1-3.4,2.6-4.9l-.8-3.8.4-2.2,2.3.4a41.38,41.38,0,0,0,5.2-6.4c1.9-3,.8-7.5,0-9.4a20.79,20.79,0,0,0-2.6-4.1s-3.7,4.1-6,6.4l-.4-2.6-2.2,1.1Z",
    transform: "translate(0.03 0.03)"
  })), _path495 || (_path495 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M548.9,361.7s4.1-9.4,6.7-10.9,7.5-1.1,10.1-1.5,6.4-4.1,6.4-4.1l3,3.4-1.5,1.9-1.5-1.1s-1.9,3.4-3,6-2.3,9.7-2.3,13.5.4,7.5.4,7.5l-2.6,3.7-.4-4.5s-2.6-1.1-3.8,3.7a24.25,24.25,0,0,0-7.9,12l-1.1-2.6s1.1-3.4,2.6-4.9l-.8-3.8.4-2.2,2.3.4a41.38,41.38,0,0,0,5.2-6.4c1.9-3,.8-7.5,0-9.4a20.79,20.79,0,0,0-2.6-4.1s-3.7,4.1-6,6.4l-.4-2.6-2.2,1.1Z",
    transform: "translate(0.03 0.03)"
  })), _path496 || (_path496 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M571.7,320.5c-2.6,0-4.9,4.5-5.2,9s.4,16.5,3,15.7,5.3-7.5,5.3-12S574.7,320.5,571.7,320.5Z",
    transform: "translate(0.03 0.03)"
  })), _path497 || (_path497 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M571.7,320.5c-2.6,0-4.9,4.5-5.2,9s.4,16.5,3,15.7,5.3-7.5,5.3-12S574.7,320.5,571.7,320.5Z",
    transform: "translate(0.03 0.03)"
  })), _path498 || (_path498 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M621.9,347.8c-4.5,4.9-13.9,21.7-13.9,38.9s3.8,30.3,4.1,35.2l3-1.1s5.2-20.6,6.4-37.8.4-35.2.4-35.2Z",
    transform: "translate(0.03 0.03)"
  })), _path499 || (_path499 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M621.9,347.8c-4.5,4.9-13.9,21.7-13.9,38.9s3.8,30.3,4.1,35.2l3-1.1s5.2-20.6,6.4-37.8.4-35.2.4-35.2Z",
    transform: "translate(0.03 0.03)"
  })), _path500 || (_path500 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M580.7,328.4l7.5,6.4v18.7s-2.3,4.5-1.9,7.9a17.35,17.35,0,0,0,1.9,6s-9.7,4.9-12.4,7.5-1.1,5.6.4,4.5,5.2-4.5,7.5-5.6v3s-4.1,6.4-5.2,12.7l.8,2.6s4.5-11.2,6.7-14.6l1.5,1.9s-.8,23.2-.8,28.1l-2.6,7.5-2.2-.4,1.5,3.7-2.2,2.6-3.4-1.1s-1.1,6-1.9,9h-2.2s-.4-31.4-.8-43.8-.8-20.2-1.5-28.5c0,0,6.4-3.4,7.9-6.7,1.4-3.5,1.4-21.4,1.4-21.4Z",
    transform: "translate(0.03 0.03)"
  })), _path501 || (_path501 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M580.7,328.4l7.5,6.4v18.7s-2.3,4.5-1.9,7.9a17.35,17.35,0,0,0,1.9,6s-9.7,4.9-12.4,7.5-1.1,5.6.4,4.5,5.2-4.5,7.5-5.6v3s-4.1,6.4-5.2,12.7l.8,2.6s4.5-11.2,6.7-14.6l1.5,1.9s-.8,23.2-.8,28.1l-2.6,7.5-2.2-.4,1.5,3.7-2.2,2.6-3.4-1.1s-1.1,6-1.9,9h-2.2s-.4-31.4-.8-43.8-.8-20.2-1.5-28.5c0,0,6.4-3.4,7.9-6.7,1.4-3.5,1.4-21.4,1.4-21.4Z",
    transform: "translate(0.03 0.03)"
  })), _path502 || (_path502 = /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M591.5,337a36.69,36.69,0,0,1,0,7.1l3.8-2.3.8,4.9-4.1-.4-2.2,9,.4,10.1s7.1-10.1,7.9-15.7a38.91,38.91,0,0,0,.4-8.2l2.6-2.6-2.6-1.9Z",
    transform: "translate(0.03 0.03)"
  })), _path503 || (_path503 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M591.5,337a36.69,36.69,0,0,1,0,7.1l3.8-2.3.8,4.9-4.1-.4-2.2,9,.4,10.1s7.1-10.1,7.9-15.7a38.91,38.91,0,0,0,.4-8.2l2.6-2.6-2.6-1.9Z",
    transform: "translate(0.03 0.03)"
  })), _path504 || (_path504 = /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M596.8,360.9l-8.2,10.5s.4,16.9.4,23.2.4,16.5.7,24l2.2-.4,1.1-3a9.05,9.05,0,0,0,4.1-4.1l.8-3h-2.3l2.6-2.6s.8-4.1-1.1-7.1h-1.9a43.71,43.71,0,0,1-.4-9.4,40.51,40.51,0,0,1,2.3-9.4v-7.1l3.7-6-4-5.6Z",
    transform: "translate(0.03 0.03)"
  })), _path505 || (_path505 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M596.8,360.9l-8.2,10.5s.4,16.9.4,23.2.4,16.5.7,24l2.2-.4,1.1-3a9.05,9.05,0,0,0,4.1-4.1l.8-3h-2.3l2.6-2.6s.8-4.1-1.1-7.1h-1.9a43.71,43.71,0,0,1-.4-9.4,40.51,40.51,0,0,1,2.3-9.4v-7.1l3.7-6-4-5.6Z",
    transform: "translate(0.03 0.03)"
  })), _path506 || (_path506 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M609.5,341.8c-.4.4-1.1,9.4-1.1,9.4l3.4-.4,8.6-8.6V340S609.9,341.5,609.5,341.8Z",
    transform: "translate(0.03 0.03)"
  })), _path507 || (_path507 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M609.5,341.8c-.4.4-1.1,9.4-1.1,9.4l3.4-.4,8.6-8.6V340S609.9,341.5,609.5,341.8Z",
    transform: "translate(0.03 0.03)"
  })), _path508 || (_path508 = /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M592.7,313l-2.6,2.6v10.1l4.5,4.5,4.1-3-2.2-1.1s.4-4.1,2.2-4.5V319a7.86,7.86,0,0,1-3.7-1.9,10.05,10.05,0,0,1-2.3-4.1Z",
    transform: "translate(0.03 0.03)"
  })), _path509 || (_path509 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M592.7,313l-2.6,2.6v10.1l4.5,4.5,4.1-3-2.2-1.1s.4-4.1,2.2-4.5V319a7.86,7.86,0,0,1-3.7-1.9,10.05,10.05,0,0,1-2.3-4.1Z",
    transform: "translate(0.03 0.03)"
  })), _path510 || (_path510 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M606.1,310l.4,16.8s8.6-4.5,10.9-7.9l-1.1-9-10.2.1Z",
    transform: "translate(0.03 0.03)"
  })), _path511 || (_path511 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M606.1,310l.4,16.8s8.6-4.5,10.9-7.9l-1.1-9-10.2.1Z",
    transform: "translate(0.03 0.03)"
  })), _polygon617 || (_polygon617 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "607.63 306.63 615.93 307.43 613.23 299.93 607.63 306.63"
  })), _polygon618 || (_polygon618 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "607.63 306.63 615.93 307.43 613.23 299.93 607.63 306.63"
  })), _path512 || (_path512 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M609.9,332.5l-2.2,2.2s7.5,1.9,12.4,1.1a26.86,26.86,0,0,0-.4-7.5l-4.1.8-.8,2.2Z",
    transform: "translate(0.03 0.03)"
  })), _path513 || (_path513 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M609.9,332.5l-2.2,2.2s7.5,1.9,12.4,1.1a26.86,26.86,0,0,0-.4-7.5l-4.1.8-.8,2.2Z",
    transform: "translate(0.03 0.03)"
  })), _path514 || (_path514 = /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M592.7,298.8l-.8,10.5,1.9,1.5,1.1-4.5,1.1,6.4,1.9-.8v-2.3s2.6-.7,2.6-2.6-1.9-5.6-4.5-8.2Z",
    transform: "translate(0.03 0.03)"
  })), _path515 || (_path515 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M592.7,298.8l-.8,10.5,1.9,1.5,1.1-4.5,1.1,6.4,1.9-.8v-2.3s2.6-.7,2.6-2.6-1.9-5.6-4.5-8.2Z",
    transform: "translate(0.03 0.03)"
  })), _polygon619 || (_polygon619 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "596.83 287.23 599.43 285.73 597.53 283.83 593.43 284.63 593.03 291.73 597.93 291.33 599.03 289.13 596.83 287.23"
  })), _polygon620 || (_polygon620 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "596.83 287.23 599.43 285.73 597.53 283.83 593.43 284.63 593.03 291.73 597.93 291.33 599.03 289.13 596.83 287.23"
  })), _polygon621 || (_polygon621 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "599.03 277.83 599.03 272.63 594.53 274.53 593.83 281.93 598.33 281.23 600.93 279.33 599.03 277.83"
  })), _polygon622 || (_polygon622 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "599.03 277.83 599.03 272.63 594.53 274.53 593.83 281.93 598.33 281.23 600.93 279.33 599.03 277.83"
  })), _path516 || (_path516 = /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M599.8,258.4c-3.4.4-5.6,3.8-6,6a80.05,80.05,0,0,0-.4,8.6l4.1-1.1c0-3-.4-7.1,1.1-7.9a12.3,12.3,0,0,1,3-1.1Z",
    transform: "translate(0.03 0.03)"
  })), _path517 || (_path517 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M599.8,258.4c-3.4.4-5.6,3.8-6,6a80.05,80.05,0,0,0-.4,8.6l4.1-1.1c0-3-.4-7.1,1.1-7.9a12.3,12.3,0,0,1,3-1.1Z",
    transform: "translate(0.03 0.03)"
  })), _path518 || (_path518 = /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M593,294.7s-.8,1.9-.4,1.9,4.5-.4,4.5-.4l2.2-1.9Z",
    transform: "translate(0.03 0.03)"
  })), _path519 || (_path519 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M593,294.7s-.8,1.9-.4,1.9,4.5-.4,4.5-.4l2.2-1.9Z",
    transform: "translate(0.03 0.03)"
  })), _polygon623 || (_polygon623 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "453.03 170.03 454.93 172.23 451.53 175.63 449.73 173.43 453.03 170.03"
  })), _polygon624 || (_polygon624 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "453.03 170.03 454.93 172.23 451.53 175.63 449.73 173.43 453.03 170.03"
  })), _polygon625 || (_polygon625 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "445.93 168.13 447.83 170.43 444.43 173.73 442.53 171.53 445.93 168.13"
  })), _polygon626 || (_polygon626 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "445.93 168.13 447.83 170.43 444.43 173.73 442.53 171.53 445.93 168.13"
  })), _polygon627 || (_polygon627 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "450.83 163.33 452.73 165.53 449.33 168.93 447.43 166.63 450.83 163.33"
  })), _polygon628 || (_polygon628 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "450.83 163.33 452.73 165.53 449.33 168.93 447.43 166.63 450.83 163.33"
  })), _path520 || (_path520 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M455.6,143.1c-.4.4-4.9,6.7-4.9,6.7l5.6,1.1-2.6,6,3,.8s-.4,1.9-.4,2.2,3.4,1.9,3.4,1.9l4.9-1.5.8,3,2.2-.4,4.9-9,.7-4.5-1.5-.8-4.1,2.6-1.1-1.5,1.5-1.9-1.1-1.9-2.2,2.3-1.9-2.3-2.3.4,3.4-3-2.6-.8-4.5,4.1h-1.9l2.6-3Z",
    transform: "translate(0.03 0.03)"
  })), _path521 || (_path521 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M455.6,143.1c-.4.4-4.9,6.7-4.9,6.7l5.6,1.1-2.6,6,3,.8s-.4,1.9-.4,2.2,3.4,1.9,3.4,1.9l4.9-1.5.8,3,2.2-.4,4.9-9,.7-4.5-1.5-.8-4.1,2.6-1.1-1.5,1.5-1.9-1.1-1.9-2.2,2.3-1.9-2.3-2.3.4,3.4-3-2.6-.8-4.5,4.1h-1.9l2.6-3Z",
    transform: "translate(0.03 0.03)"
  })), _polygon629 || (_polygon629 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "460.13 170.43 462.03 172.63 458.63 176.03 456.83 173.73 460.13 170.43"
  })), _polygon630 || (_polygon630 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "460.13 170.43 462.03 172.63 458.63 176.03 456.83 173.73 460.13 170.43"
  })), _polygon631 || (_polygon631 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "457.93 163.33 459.83 165.53 456.43 168.93 454.53 166.63 457.93 163.33"
  })), _polygon632 || (_polygon632 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "457.93 163.33 459.83 165.53 456.43 168.93 454.53 166.63 457.93 163.33"
  })), _polygon633 || (_polygon633 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "470.63 135.63 472.53 137.83 469.13 141.23 467.23 138.93 470.63 135.63"
  })), _polygon634 || (_polygon634 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "470.63 135.63 472.53 137.83 469.13 141.23 467.23 138.93 470.63 135.63"
  })), _polygon635 || (_polygon635 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "465.03 135.23 466.93 137.43 463.53 140.83 461.63 138.63 465.03 135.23"
  })), _polygon636 || (_polygon636 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "465.03 135.23 466.93 137.43 463.53 140.83 461.63 138.63 465.03 135.23"
  })), _polygon637 || (_polygon637 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "458.33 134.83 460.13 137.13 456.83 140.43 454.93 138.23 458.33 134.83"
  })), _polygon638 || (_polygon638 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "458.33 134.83 460.13 137.13 456.83 140.43 454.93 138.23 458.33 134.83"
  })), _path522 || (_path522 = /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M489,255.4s4.1.8,3.7.8,4.9,9.4,9.4,10.9,15.3,4.1,19.5,6.4l-1.9,1.5-3-.8-1.5-1.5-3,.4-1.5-1.1s-2.6.8-3-1.1a8.67,8.67,0,0,1-3.4,0c-1.5-.4-1.1-1.9-1.5-1.9s-3,1.5-3.4,1.1-.4-2.6-.4-2.6a7.68,7.68,0,0,1-2.6-.4c-.7-.4,0-1.9,0-1.9s-5.2.4-2.6-3c0,0-3,0-3.4-1.1s1.5-1.5,1.5-1.5l-.8-1.5-3.4-.4,1.3-2.3Z",
    transform: "translate(0.03 0.03)"
  })), _path523 || (_path523 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M489,255.4s4.1.8,3.7.8,4.9,9.4,9.4,10.9,15.3,4.1,19.5,6.4l-1.9,1.5-3-.8-1.5-1.5-3,.4-1.5-1.1s-2.6.8-3-1.1a8.67,8.67,0,0,1-3.4,0c-1.5-.4-1.1-1.9-1.5-1.9s-3,1.5-3.4,1.1-.4-2.6-.4-2.6a7.68,7.68,0,0,1-2.6-.4c-.7-.4,0-1.9,0-1.9s-5.2.4-2.6-3c0,0-3,0-3.4-1.1s1.5-1.5,1.5-1.5l-.8-1.5-3.4-.4,1.3-2.3Z",
    transform: "translate(0.03 0.03)"
  })), _path524 || (_path524 = /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M524.9,274.1l-1.9,1.5,5.3.8a20,20,0,0,0-.4,3.4l2.3-.8,1.9-4.1Z",
    transform: "translate(0.03 0.03)"
  })), _path525 || (_path525 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M524.9,274.1l-1.9,1.5,5.3.8a20,20,0,0,0-.4,3.4l2.3-.8,1.9-4.1Z",
    transform: "translate(0.03 0.03)"
  })), _polygon639 || (_polygon639 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "477.73 182.03 480.43 182.03 478.53 184.63 475.93 185.43 477.73 182.03"
  })), _polygon640 || (_polygon640 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "477.73 182.03 480.43 182.03 478.53 184.63 475.93 185.43 477.73 182.03"
  })), _polygon641 || (_polygon641 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "476.23 187.63 478.93 187.63 477.03 190.23 474.43 191.03 476.23 187.63"
  })), _polygon642 || (_polygon642 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "476.23 187.63 478.93 187.63 477.03 190.23 474.43 191.03 476.23 187.63"
  })), _polygon643 || (_polygon643 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "474.03 195.13 476.63 195.13 474.73 197.73 472.13 198.53 474.03 195.13"
  })), _polygon644 || (_polygon644 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "474.03 195.13 476.63 195.13 474.73 197.73 472.13 198.53 474.03 195.13"
  })), _polygon645 || (_polygon645 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "481.53 185.73 484.13 185.73 482.23 188.43 479.63 189.13 481.53 185.73"
  })), _polygon646 || (_polygon646 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "481.53 185.73 484.13 185.73 482.23 188.43 479.63 189.13 481.53 185.73"
  })), _polygon647 || (_polygon647 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "479.23 193.23 481.93 193.23 480.03 195.83 477.43 196.63 479.23 193.23"
  })), _polygon648 || (_polygon648 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "479.23 193.23 481.93 193.23 480.03 195.83 477.43 196.63 479.23 193.23"
  })), _polygon649 || (_polygon649 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "483.03 180.13 485.63 180.13 483.73 182.73 481.13 183.53 483.03 180.13"
  })), _polygon650 || (_polygon650 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "483.03 180.13 485.63 180.13 483.73 182.73 481.13 183.53 483.03 180.13"
  })), _polygon651 || (_polygon651 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "488.63 178.63 491.23 178.63 489.33 181.23 486.73 182.03 488.63 178.63"
  })), _polygon652 || (_polygon652 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "488.63 178.63 491.23 178.63 489.33 181.23 486.73 182.03 488.63 178.63"
  })), _polygon653 || (_polygon653 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "487.13 184.23 489.73 184.23 487.83 186.93 485.23 187.63 487.13 184.23"
  })), _polygon654 || (_polygon654 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "487.13 184.23 489.73 184.23 487.83 186.93 485.23 187.63 487.13 184.23"
  })), _polygon655 || (_polygon655 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "484.83 191.73 487.53 191.73 485.63 194.33 483.03 195.13 484.83 191.73"
  })), _polygon656 || (_polygon656 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "484.83 191.73 487.53 191.73 485.63 194.33 483.03 195.13 484.83 191.73"
  })), _polygon657 || (_polygon657 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "488.23 173.73 490.83 173.73 489.03 176.43 486.33 177.13 488.23 173.73"
  })), _polygon658 || (_polygon658 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "488.23 173.73 490.83 173.73 489.03 176.43 486.33 177.13 488.23 173.73"
  })), _polygon659 || (_polygon659 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "477.73 202.23 480.43 202.23 478.53 204.83 475.93 205.63 477.73 202.23"
  })), _polygon660 || (_polygon660 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "477.73 202.23 480.43 202.23 478.53 204.83 475.93 205.63 477.73 202.23"
  })), _polygon661 || (_polygon661 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "484.13 198.83 486.73 198.83 484.83 201.53 482.23 202.23 484.13 198.83"
  })), _polygon662 || (_polygon662 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "484.13 198.83 486.73 198.83 484.83 201.53 482.23 202.23 484.13 198.83"
  })), _polygon663 || (_polygon663 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "493.83 196.63 496.53 196.63 494.63 199.23 492.03 200.03 493.83 196.63"
  })), _polygon664 || (_polygon664 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "493.83 196.63 496.53 196.63 494.63 199.23 492.03 200.03 493.83 196.63"
  })), _polygon665 || (_polygon665 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "500.23 194.03 502.83 194.03 500.93 196.63 498.33 197.33 500.23 194.03"
  })), _polygon666 || (_polygon666 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "500.23 194.03 502.83 194.03 500.93 196.63 498.33 197.33 500.23 194.03"
  })), _polygon667 || (_polygon667 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "489.33 195.53 492.03 195.53 489.33 202.63 486.73 202.63 489.33 195.53"
  })), _polygon668 || (_polygon668 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "489.33 195.53 492.03 195.53 489.33 202.63 486.73 202.63 489.33 195.53"
  })), _polygon669 || (_polygon669 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "484.83 170.83 486.73 173.03 493.53 171.13 491.63 169.63 484.83 170.83"
  })), _polygon670 || (_polygon670 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "484.83 170.83 486.73 173.03 493.53 171.13 491.63 169.63 484.83 170.83"
  })), _path526 || (_path526 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M531.6,190.2l5.6,3.7v1.9l-4.1,3.7-2.6-1.9,3.4-2.6s-4.5-2.6-4.1-2.6S531.6,190.2,531.6,190.2Z",
    transform: "translate(0.03 0.03)"
  })), _path527 || (_path527 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M531.6,190.2l5.6,3.7v1.9l-4.1,3.7-2.6-1.9,3.4-2.6s-4.5-2.6-4.1-2.6S531.6,190.2,531.6,190.2Z",
    transform: "translate(0.03 0.03)"
  })), _path528 || (_path528 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M441.4,152.8c0-.4,2.3,0,2.3,0l3.4,7.9-2.2.4Z",
    transform: "translate(0.03 0.03)"
  })), _path529 || (_path529 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M441.4,152.8c0-.4,2.3,0,2.3,0l3.4,7.9-2.2.4Z",
    transform: "translate(0.03 0.03)"
  })), _path530 || (_path530 = /*#__PURE__*/React.createElement("path", {
    d: "M264.7,486.3s-5.6,2.6-9,3.7l-2.6,1.1v1.5l-4.9,6-6.4-5.6s4.1-3.7,4.5-3.7.7-2.2.7-2.2-4.9,0-8.2-1.5a9.24,9.24,0,0,1-4.5-4.5s-2.3,4.1-5.2,4.9-12.7,2.2-15.7,1.9l-2.3-1.1-1.5-8.2,1.1-4.1-1.5-4.1s-5.6-14.2-8.6-16.8-8.2-9.4-7.9-19.8c0,0-6-4.9-6.4-11.6s3.4-10.1,6-11.2l1.5,1.1s-4.1,4.5-2.6,9.7a12,12,0,0,1,3.7-3s.4-6,3.8-9.7S209.2,399,217,399c0,0,5.6-20.6,17.2-29.2s18.7-10.1,29.6-10.9,39.3,2.6,50.9,3,32.2.4,38.9.4c0,0-1.5-14.6,0-18.7s2.6-8.6,7.5-10.5,6.8-5.2,10.1-5.2,4.5.8,4.9,2.6c.8,3.8-2.6,6-6,6.4s-11.2,0-12.3,4.5-3.4,17.6,1.1,23.6,12,12.7,14.6,24.3,4.1,21.3,7.1,23.6a16.58,16.58,0,0,0,9.7,3.4l1.9,2.3a62.86,62.86,0,0,0,2.6,12,32.66,32.66,0,0,0,9,12.4c3,2.3,4.1,4.1,4.5,7.1l4.5-.4.8,7.5-1.1,1.9s-4.1-.8-4.9,3c0,0-4.9-7.5-7.9-12.4s-6-12.7-14.6-19.5c0,0-11.2,1.1-18.3-1.5s-12.7-5.6-16.8-9l-7-.7s.4,6.7,12.4,10.9c0,0,1.9,8.2,6,11.2a27.76,27.76,0,0,0,10.9,4.9l4.5,9-.4,2.6-1.9.4-2.3-1.1-.4,2.3-3,.4s-.8-3-1.5-7.1c0,0-4.9-1.1-7.5-3.4s-5.6-6.7-7.5-9.4c0,0-15.7-4.9-24.3-6.7,0,0-9.4,13.1-18,19.8a166.34,166.34,0,0,1-14.2,10.1l-1.1,3-2.6,1.5-1.5-.4-.8,2.3-1.9,1.5-1.5-1.1-.4,3-3,1.5-.4,2.3-1.9,1.1-.8-1.9-2.3,1.1v3.7h-3.4l-.4,2.6-3.8,2.6-1.5-1.5-1.5,1.5-2.3.6Z",
    transform: "translate(0.03 0.03)"
  })), _path531 || (_path531 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M239.3,368.4v3.7l2.6-1.1a6.77,6.77,0,0,1,1.9,4.1l-3-1.5-.8,1.5a8.71,8.71,0,0,1,1.1,3.7,11.6,11.6,0,0,0,1.5,4.5l1.9-1.5v-3.7l2.2-2.3a41.46,41.46,0,0,0,1.1,6,6.51,6.51,0,0,0,6.7,4.1l-.4,2.6,3.4,1.1-.7,1.1s-4.5,0-4.1,2.3,2.3,1.1,3,0l1.5,1.1h6s-1.1,3.4-6.4,3.7l-.8,10.9h2.2l-1.5,3.4,5.6,9,5.4.4,3.6,2.7,2.2-.8-3.8-6-4.9-.4-4.5-3.7h1.9l3,2.2h4.5l3.4,2.3,2.3-1.5v-2.6s-4.5-1.5-4.9-1.5-3.4-.4-3.4-.4l-1.1-1.5,6.8.8,1.5-1.5-2.6-3s-6,.4-10.5-1.1l9.4-.4,1.5-1.9,4.5-.4,2.6-3.4,1.9.4s1.1,1.9,4.1,1.5l1.5.8-3,1.5,1.1,1.9s4.1-1.5,5.6-1.5h4.5l-1.1,1.9-5.2,1.9a15.38,15.38,0,0,0-5.2-1.1l-1.1-3.4s-4.1.8-6.4,1.5v1.9l4.1-.4-.8,1.5-3,.8v4.1l1.5.8.8-2.6s3,1.1,5.3.4l1.9-2.6,1.1,1.5-.4,1.9s-6,1.1-4.9,2.6,4.1,0,5.6.8a9,9,0,0,0,6.4.7l-.7,2.6,8.2-2.6s.4-9.7-3.8-14.6-7.9-7.9-8.2-10.9.8-4.9,2.3-5.6c0,0-.4-3.7,1.9-6s6-5.2,6-5.2l-3.8-2.3H292l1.1-1.9H295l-1.1-2.3-2.6-2.2h3.4l4.5,2.2-1.9,2.3,2.3,2.2,3.7-.4s3-1.5,3-3.7c0,0,6-.8,10.1-1.5l1.5-1.9s-16.8-1.5-26.6-2.3-22.5-2.6-31.8-.8-15.4,3.7-20.2,7.1Z",
    transform: "translate(0.03 0.03)"
  })), _path532 || (_path532 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M239.3,368.4v3.7l2.6-1.1a6.77,6.77,0,0,1,1.9,4.1l-3-1.5-.8,1.5a8.71,8.71,0,0,1,1.1,3.7,11.6,11.6,0,0,0,1.5,4.5l1.9-1.5v-3.7l2.2-2.3a41.46,41.46,0,0,0,1.1,6,6.51,6.51,0,0,0,6.7,4.1l-.4,2.6,3.4,1.1-.7,1.1s-4.5,0-4.1,2.3,2.3,1.1,3,0l1.5,1.1h6s-1.1,3.4-6.4,3.7l-.8,10.9h2.2l-1.5,3.4,5.6,9,5.4.4,3.6,2.7,2.2-.8-3.8-6-4.9-.4-4.5-3.7h1.9l3,2.2h4.5l3.4,2.3,2.3-1.5v-2.6s-4.5-1.5-4.9-1.5-3.4-.4-3.4-.4l-1.1-1.5,6.8.8,1.5-1.5-2.6-3s-6,.4-10.5-1.1l9.4-.4,1.5-1.9,4.5-.4,2.6-3.4,1.9.4s1.1,1.9,4.1,1.5l1.5.8-3,1.5,1.1,1.9s4.1-1.5,5.6-1.5h4.5l-1.1,1.9-5.2,1.9a15.38,15.38,0,0,0-5.2-1.1l-1.1-3.4s-4.1.8-6.4,1.5v1.9l4.1-.4-.8,1.5-3,.8v4.1l1.5.8.8-2.6s3,1.1,5.3.4l1.9-2.6,1.1,1.5-.4,1.9s-6,1.1-4.9,2.6,4.1,0,5.6.8a9,9,0,0,0,6.4.7l-.7,2.6,8.2-2.6s.4-9.7-3.8-14.6-7.9-7.9-8.2-10.9.8-4.9,2.3-5.6c0,0-.4-3.7,1.9-6s6-5.2,6-5.2l-3.8-2.3H292l1.1-1.9H295l-1.1-2.3-2.6-2.2h3.4l4.5,2.2-1.9,2.3,2.3,2.2,3.7-.4s3-1.5,3-3.7c0,0,6-.8,10.1-1.5l1.5-1.9s-16.8-1.5-26.6-2.3-22.5-2.6-31.8-.8-15.4,3.7-20.2,7.1Z",
    transform: "translate(0.03 0.03)"
  })), _path533 || (_path533 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M309.6,375.1c2.3,5.2,5.6,10.1,6.4,13.5a66,66,0,0,1,1.1,9l1.5-.4s.4-6-.8-9.4-3-8.6-3.4-8.6,1.5-1.5,1.5-1.5-1.5-4.5-3-5.2l-1.5,1.9-1.8.7Z",
    transform: "translate(0.03 0.03)"
  })), _path534 || (_path534 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M309.6,375.1c2.3,5.2,5.6,10.1,6.4,13.5a66,66,0,0,1,1.1,9l1.5-.4s.4-6-.8-9.4-3-8.6-3.4-8.6,1.5-1.5,1.5-1.5-1.5-4.5-3-5.2l-1.5,1.9-1.8.7Z",
    transform: "translate(0.03 0.03)"
  })), _path535 || (_path535 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M314.4,372.5c3.9,6.1,6.8,14.3,7.2,18.1l-1.5.4-.4,5.3s3.4-2.8,4.2-4.3-.6-4.5-1.1-7.5c-.7-4.2-5.2-13.9-5.2-13.9l-3.2,1.9Z",
    transform: "translate(0.03 0.03)"
  })), _path536 || (_path536 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M314.4,372.5c3.9,6.1,6.8,14.3,7.2,18.1l-1.5.4-.4,5.3s3.4-2.8,4.2-4.3-.6-4.5-1.1-7.5c-.7-4.2-5.2-13.9-5.2-13.9l-3.2,1.9Z",
    transform: "translate(0.03 0.03)"
  })), _path537 || (_path537 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M319.8,368.4l-1.1,2.2s4.9,10.1,5.6,15.8l2.2-1.6A37.72,37.72,0,0,0,319.8,368.4Z",
    transform: "translate(0.03 0.03)"
  })), _path538 || (_path538 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M319.8,368.4l-1.1,2.2s4.9,10.1,5.6,15.8l2.2-1.6A37.72,37.72,0,0,0,319.8,368.4Z",
    transform: "translate(0.03 0.03)"
  })), _path539 || (_path539 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M322.7,368c2.3,5.2,4.5,12,4.5,14.6l3,4.9s1.9-5.2,0-9-6.4-13.1-6.4-13.1Z",
    transform: "translate(0.03 0.03)"
  })), _path540 || (_path540 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M322.7,368c2.3,5.2,4.5,12,4.5,14.6l3,4.9s1.9-5.2,0-9-6.4-13.1-6.4-13.1Z",
    transform: "translate(0.03 0.03)"
  })), _path541 || (_path541 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M328,363.9c-1.9,0-1.5,3.4.4,6.7s3.8,6.7,4.5,11.6l6.4-3.7s-3.4-10.9-4.9-12.4-4.5-1.1-2.2,2.6a62.42,62.42,0,0,1,4.1,9l-1.9,1.5s-2.6-7.9-3.7-10.5-1.2-4.8-2.7-4.8Z",
    transform: "translate(0.03 0.03)"
  })), _path542 || (_path542 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M328,363.9c-1.9,0-1.5,3.4.4,6.7s3.8,6.7,4.5,11.6l6.4-3.8s-3.4-10.9-4.9-12.4-4.5-1.1-2.2,2.6a62.42,62.42,0,0,1,4.1,9l-1.9,1.5s-2.6-7.9-3.7-10.5c-1.2-2.4-1.2-4.7-2.7-4.7Z",
    transform: "translate(0.03 0.03)"
  })), _polygon671 || (_polygon671 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "335.93 364.53 340.73 377.83 342.63 375.93 340.03 364.33 335.93 364.53"
  })), _polygon672 || (_polygon672 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "335.93 364.53 340.73 377.83 342.63 375.93 340.03 364.33 335.93 364.53"
  })), _path543 || (_path543 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M342.2,364.3l1.9,10.9h3l-.8-10.9Z",
    transform: "translate(0.03 0.03)"
  })), _path544 || (_path544 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M342.2,364.3l1.9,10.9h3l-.8-10.9Z",
    transform: "translate(0.03 0.03)"
  })), _polygon673 || (_polygon673 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "352.33 369.23 351.23 364.73 348.63 364.33 349.03 372.93 352.33 377.43 353.83 377.43 352.33 369.23"
  })), _polygon674 || (_polygon674 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "352.33 369.23 351.23 364.73 348.63 364.33 349.03 372.93 352.33 377.43 353.83 377.43 352.33 369.23"
  })), _polygon675 || (_polygon675 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "357.23 372.23 356.43 368.03 354.93 369.23 355.73 377.03 357.93 376.63 360.63 372.53 357.23 372.23"
  })), _polygon676 || (_polygon676 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "357.23 372.23 356.43 368.03 354.93 369.23 355.73 377.03 357.93 376.63 360.63 372.53 357.23 372.23"
  })), _polygon677 || (_polygon677 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "355.73 379.33 357.23 381.13 362.43 380.03 361.33 378.53 355.73 379.33"
  })), _polygon678 || (_polygon678 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "355.73 379.33 357.23 381.13 362.43 380.03 361.33 378.53 355.73 379.33"
  })), _path545 || (_path545 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M357.6,382.6l1.5,1.5,4.1-.4-1.5-1.5C361.7,382.3,357.9,382.6,357.6,382.6Z",
    transform: "translate(0.03 0.03)"
  })), _path546 || (_path546 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M357.6,382.6l1.5,1.5,4.1-.4-1.5-1.5C361.7,382.3,357.9,382.6,357.6,382.6Z",
    transform: "translate(0.03 0.03)"
  })), _path547 || (_path547 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M358.7,386.8v2.6a12.26,12.26,0,0,0,4.9.4,5.17,5.17,0,0,0,3.4-2.6l-1.1-2.3a5.45,5.45,0,0,1-3.4,1.5A21.15,21.15,0,0,0,358.7,386.8Z",
    transform: "translate(0.03 0.03)"
  })), _path548 || (_path548 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M358.7,386.8v2.6a12.26,12.26,0,0,0,4.9.4,5.17,5.17,0,0,0,3.4-2.6l-1.1-2.3a5.45,5.45,0,0,1-3.4,1.5A21.15,21.15,0,0,0,358.7,386.8Z",
    transform: "translate(0.03 0.03)"
  })), _path549 || (_path549 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M361.3,392.7l1.1,3s4.9,0,5.6-4.5l-1.5-1.1a4.16,4.16,0,0,1-2.3,1.9Z",
    transform: "translate(0.03 0.03)"
  })), _path550 || (_path550 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M361.3,392.7l1.1,3s4.9,0,5.6-4.5l-1.5-1.1a4.16,4.16,0,0,1-2.3,1.9Z",
    transform: "translate(0.03 0.03)"
  })), _polygon679 || (_polygon679 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "349.33 378.13 354.93 388.33 357.23 388.33 351.23 378.13 349.33 378.13"
  })), _polygon680 || (_polygon680 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "349.33 378.13 354.93 388.33 357.23 388.33 351.23 378.13 349.33 378.13"
  })), _polygon681 || (_polygon681 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "346.33 378.53 355.33 394.23 356.83 394.23 348.23 378.13 346.33 378.53"
  })), _polygon682 || (_polygon682 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "346.33 378.53 355.33 394.23 356.83 394.23 348.23 378.13 346.33 378.53"
  })), _path551 || (_path551 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M328,390.1s-7.9,9.7-12.4,12.7l1.1,2.4s11.7-10.6,13.9-12.9V390H328Z",
    transform: "translate(0.03 0.03)"
  })), _path552 || (_path552 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M328,390.1s-7.9,9.7-12.4,12.7l1.1,2.4s11.7-10.6,13.9-12.9V390H328Z",
    transform: "translate(0.03 0.03)"
  })), _path553 || (_path553 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M332.1,393.9c-4.5,3.7-11.6,10.5-15.4,13.1l.4,3.1s13.5-10.1,15.7-12l-.7-4.2Z",
    transform: "translate(0.03 0.03)"
  })), _path554 || (_path554 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M332.1,393.9c-4.5,3.7-11.6,10.5-15.4,13.1l.4,3.1s13.5-10.1,15.7-12l-.7-4.2Z",
    transform: "translate(0.03 0.03)"
  })), _path555 || (_path555 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M334,397.9c-4.9,4.1-13.2,10.9-16.5,13.2v4.2l18-13.9Z",
    transform: "translate(0.03 0.03)"
  })), _path556 || (_path556 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M334,397.9c-4.9,4.1-13.2,10.9-16.5,13.2v4.2l18-13.9Z",
    transform: "translate(0.03 0.03)"
  })), _polygon683 || (_polygon683 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "323.13 412.63 320.13 414.53 320.13 418.23 323.53 416.33 323.13 412.63"
  })), _polygon684 || (_polygon684 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "323.13 412.63 320.13 414.53 320.13 418.23 323.53 416.33 323.13 412.63"
  })), _polygon685 || (_polygon685 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "325.73 410.73 325.43 414.53 328.73 413.03 328.73 409.23 325.73 410.73"
  })), _polygon686 || (_polygon686 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "325.73 410.73 325.43 414.53 328.73 413.03 328.73 409.23 325.73 410.73"
  })), _polygon687 || (_polygon687 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "331.03 406.63 330.23 411.53 333.23 410.33 333.63 405.93 331.03 406.63"
  })), _polygon688 || (_polygon688 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "331.03 406.63 330.23 411.53 333.23 410.33 333.63 405.93 331.03 406.63"
  })), _polygon689 || (_polygon689 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "335.53 404.43 334.73 408.53 338.13 407.33 338.13 403.63 335.53 404.43"
  })), _polygon690 || (_polygon690 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "335.53 404.43 334.73 408.53 338.13 407.33 338.13 403.63 335.53 404.43"
  })), _path557 || (_path557 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M333.2,385.8c2.4-2.1,6.9-5.4,10.7-6.7l3.6,4.9a34,34,0,0,0-5.4,3.9c-2.4,2.2-4.3,3.7-4.3,3.7a8.68,8.68,0,0,0,.8,4.3s-.4,1.7-2.3.9c0,0-.2-4.3-.2-6.6l4.5-3.9c1.5-1.3,4.3-2.6,4.3-2.8a13.66,13.66,0,0,0-2.1-1.5,41.43,41.43,0,0,0-4.5,2.6,28.49,28.49,0,0,0-4.1,3.4l-1-2.2Z",
    transform: "translate(0.03 0.03)"
  })), _path558 || (_path558 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M333.2,385.8c2.4-2.1,6.9-5.4,10.7-6.7l3.6,4.9a34,34,0,0,0-5.4,3.9c-2.4,2.2-4.3,3.7-4.3,3.7a8.68,8.68,0,0,0,.8,4.3s-.4,1.7-2.3.9c0,0-.2-4.3-.2-6.6l4.5-3.9c1.5-1.3,4.3-2.6,4.3-2.8a13.66,13.66,0,0,0-2.1-1.5,41.43,41.43,0,0,0-4.5,2.6,28.49,28.49,0,0,0-4.1,3.4l-1-2.2Z",
    transform: "translate(0.03 0.03)"
  })), _path559 || (_path559 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M348,385.6a24.89,24.89,0,0,0-7.5,6.6v1.9a43.25,43.25,0,0,1,7.3-5.6Z",
    transform: "translate(0.03 0.03)"
  })), _path560 || (_path560 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M348,385.6a24.89,24.89,0,0,0-7.5,6.6v1.9a43.25,43.25,0,0,1,7.3-5.6Z",
    transform: "translate(0.03 0.03)"
  })), _path561 || (_path561 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M349.7,389.4a31.76,31.76,0,0,0-5.6,4.3l.4,2.4s3.4-3,5.8-4.9l-.6-1.8Z",
    transform: "translate(0.03 0.03)"
  })), _path562 || (_path562 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M349.7,389.4a31.76,31.76,0,0,0-5.6,4.3l.4,2.4s3.4-3,5.8-4.9l-.6-1.8Z",
    transform: "translate(0.03 0.03)"
  })), _path563 || (_path563 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M351.8,392.6a42.21,42.21,0,0,0-6.8,6.5v4.3a12.94,12.94,0,0,1,3,0l-.2-1.5L347,400a38.89,38.89,0,0,1,6.2-4.9l-1.4-2.5Z",
    transform: "translate(0.03 0.03)"
  })), _path564 || (_path564 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M351.8,392.6a42.21,42.21,0,0,0-6.8,6.5v4.3a12.94,12.94,0,0,1,3,0l-.2-1.5L347,400a38.89,38.89,0,0,1,6.2-4.9l-1.4-2.5Z",
    transform: "translate(0.03 0.03)"
  })), _polygon691 || (_polygon691 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "353.83 396.33 349.13 400.63 350.33 402.53 354.83 398.53 353.83 396.33"
  })), _polygon692 || (_polygon692 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "353.83 396.33 349.13 400.63 350.33 402.53 354.83 398.53 353.83 396.33"
  })), _path565 || (_path565 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M356.1,399.1l-4.7,4.7-2.4.8a3.73,3.73,0,0,0,.8,2.3c.8.7,2.6.2,2.6.2l.8-1.9,2.3.4s2.3-2.1,4.5-2.1l.5-2.2-2.2-.2-2.2-2Z",
    transform: "translate(0.03 0.03)"
  })), _path566 || (_path566 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M356.1,399.1l-4.7,4.7-2.4.8a3.73,3.73,0,0,0,.8,2.3c.8.7,2.6.2,2.6.2l.8-1.9,2.3.4s2.3-2.1,4.5-2.1l.5-2.2-2.2-.2-2.2-2Z",
    transform: "translate(0.03 0.03)"
  })), _path567 || (_path567 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M360,404.5c-.2,0-6.9,5.4-6.9,5.4l1.5,1.7H357a14,14,0,0,1,1.9-3.4,7.82,7.82,0,0,1,2.4-1.9l-1.3-1.8Z",
    transform: "translate(0.03 0.03)"
  })), _path568 || (_path568 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M360,404.5c-.2,0-6.9,5.4-6.9,5.4l1.5,1.7H357a14,14,0,0,1,1.9-3.4,7.82,7.82,0,0,1,2.4-1.9l-1.3-1.8Z",
    transform: "translate(0.03 0.03)"
  })), _path569 || (_path569 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M362.4,407.7l-3.2,2.4s-.6,1.3.6,1.5a5.59,5.59,0,0,0,2,0l2.6-2.8Z",
    transform: "translate(0.03 0.03)"
  })), _path570 || (_path570 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M362.4,407.7l-3.2,2.4s-.6,1.3.6,1.5a5.59,5.59,0,0,0,2,0l2.6-2.8Z",
    transform: "translate(0.03 0.03)"
  })), _path571 || (_path571 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M365.2,410.7l-1.5,1.9s-.2,2.1.9,2.8,3.2-.4,3.2-.4l1.3-2.4a7.07,7.07,0,0,1-2.1-.8c-.8-.5-1.8-1.1-1.8-1.1Z",
    transform: "translate(0.03 0.03)"
  })), _path572 || (_path572 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M365.2,410.7l-1.5,1.9s-.2,2.1.9,2.8,3.2-.4,3.2-.4l1.3-2.4a7.07,7.07,0,0,1-2.1-.8c-.8-.5-1.8-1.1-1.8-1.1Z",
    transform: "translate(0.03 0.03)"
  })), _path573 || (_path573 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M375,411.3c-.7,1.7-1.9,3.7-1.1,4.9s2.6,1.3,3-.6a2.31,2.31,0,0,1,1.1,2.1s2,.9,2.8-.9,0-3.2-1.1-3-2.6.4-2.6.4l.2-1.1h1.3l-.2-1.5c-.1-.1-2.5-2.6-3.4-.3Z",
    transform: "translate(0.03 0.03)"
  })), _path574 || (_path574 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M375,411.3c-.7,1.7-1.9,3.7-1.1,4.9s2.6,1.3,3-.6a2.31,2.31,0,0,1,1.1,2.1s2,.9,2.8-.9,0-3.2-1.1-3-2.6.4-2.6.4l.2-1.1h1.3l-.2-1.5c0-.1-2.5-2.6-3.4-.3Z",
    transform: "translate(0.03 0.03)"
  })), _polygon693 || (_polygon693 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "346.13 406.23 341.23 407.93 342.73 410.03 348.03 408.73 346.13 406.23"
  })), _polygon694 || (_polygon694 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "346.13 406.23 341.23 407.93 342.73 410.03 348.03 408.73 346.13 406.23"
  })), _polygon695 || (_polygon695 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "352.13 410.23 344.23 411.33 346.43 414.53 352.13 412.63 352.13 410.23"
  })), _polygon696 || (_polygon696 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "352.13 410.23 344.23 411.33 346.43 414.53 352.13 412.63 352.13 410.23"
  })), _path575 || (_path575 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M355.1,413.5l-6.3,2.1,5.5,2.9s4.3-2.5,4.1-2.5S355.1,413.5,355.1,413.5Z",
    transform: "translate(0.03 0.03)"
  })), _path576 || (_path576 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M355.1,413.5l-6.3,2.1,5.5,2.9s4.3-2.5,4.1-2.5S355.1,413.5,355.1,413.5Z",
    transform: "translate(0.03 0.03)"
  })), _polygon697 || (_polygon697 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "361.73 418.03 359.63 416.13 356.33 419.03 359.33 420.73 363.53 419.73 361.73 418.03"
  })), _polygon698 || (_polygon698 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "361.73 418.03 359.63 416.13 356.33 419.03 359.33 420.73 363.53 419.73 361.73 418.03"
  })), _polygon699 || (_polygon699 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "365.13 419.33 361.53 422.43 366.63 424.73 369.83 422.03 365.13 419.33"
  })), _polygon700 || (_polygon700 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "365.13 419.33 361.53 422.43 366.63 424.73 369.83 422.03 365.13 419.33"
  })), _polygon701 || (_polygon701 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "364.33 399.73 365.83 397.23 367.53 396.73 367.73 399.93 364.33 399.73"
  })), _polygon702 || (_polygon702 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "364.33 399.73 365.83 397.23 367.53 396.73 367.73 399.93 364.33 399.73"
  })), _polygon703 || (_polygon703 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "367.93 401.03 371.03 399.73 371.23 401.73 368.13 403.03 367.93 401.03"
  })), _polygon704 || (_polygon704 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "367.93 401.03 371.03 399.73 371.23 401.73 368.13 403.03 367.93 401.03"
  })), _path577 || (_path577 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M388.6,421.4l-.9,2.1a13.2,13.2,0,0,0,.2,2.8c.2,0,3.2-.9,3.2-.9a4,4,0,0,0-2.5-4Z",
    transform: "translate(0.03 0.03)"
  })), _path578 || (_path578 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M388.6,421.4l-.9,2.1a13.2,13.2,0,0,0,.2,2.8c.2,0,3.2-.9,3.2-.9a4,4,0,0,0-2.5-4Z",
    transform: "translate(0.03 0.03)"
  })), _path579 || (_path579 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M312.1,400c0-.8-1-7.9-1-7.9l-4.5,2.7,1,10.3,2.7.6,6.5-5-.8-3.2Z",
    transform: "translate(0.03 0.03)"
  })), _path580 || (_path580 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M312.1,400c0-.8-1-7.9-1-7.9l-4.5,2.7,1,10.3,2.7.6,6.5-5-.8-3.2Z",
    transform: "translate(0.03 0.03)"
  })), _path581 || (_path581 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M296,383.6a22.33,22.33,0,0,0,2.1,2.2l7.7-3.9-1.5-1.3Z",
    transform: "translate(0.03 0.03)"
  })), _path582 || (_path582 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M296,383.6a22.33,22.33,0,0,0,2.1,2.2l7.7-3.9-1.5-1.3Z",
    transform: "translate(0.03 0.03)"
  })), _polygon705 || (_polygon705 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "307.63 382.53 304.63 383.83 306.13 385.63 308.93 384.33 307.63 382.53"
  })), _polygon706 || (_polygon706 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "307.63 382.53 304.63 383.83 306.13 385.63 308.93 384.33 307.63 382.53"
  })), _polygon707 || (_polygon707 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "309.53 386.63 306.73 388.13 308.73 390.93 310.43 389.93 309.53 386.63"
  })), _polygon708 || (_polygon708 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "309.53 386.63 306.73 388.13 308.73 390.93 310.43 389.93 309.53 386.63"
  })), _polygon709 || (_polygon709 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "310.63 385.63 311.03 387.93 312.53 386.83 312.13 384.93 310.63 385.63"
  })), _polygon710 || (_polygon710 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "310.63 385.63 311.03 387.93 312.53 386.83 312.13 384.93 310.63 385.63"
  })), _polygon711 || (_polygon711 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "308.93 382.33 310.03 383.63 311.93 382.63 310.83 381.03 308.93 382.33"
  })), _polygon712 || (_polygon712 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "308.93 382.33 310.03 383.63 311.93 382.63 310.83 381.03 308.93 382.33"
  })), _polygon713 || (_polygon713 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "303.53 385.43 302.23 386.23 302.53 387.93 304.63 387.33 303.53 385.43"
  })), _polygon714 || (_polygon714 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "303.53 385.43 302.23 386.23 302.53 387.93 304.63 387.33 303.53 385.43"
  })), _polygon715 || (_polygon715 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "305.33 389.23 303.73 389.93 304.43 392.43 306.33 391.83 305.33 389.23"
  })), _polygon716 || (_polygon716 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "305.33 389.23 303.73 389.93 304.43 392.43 306.33 391.83 305.33 389.23"
  })), _path583 || (_path583 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M300.1,387.3c-.2,0-2.6.9-2.6.9l.9,2.8,3-1.7Z",
    transform: "translate(0.03 0.03)"
  })), _path584 || (_path584 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M300.1,387.3c-.2,0-2.6.9-2.6.9l.9,2.8,3-1.7Z",
    transform: "translate(0.03 0.03)"
  })), _polygon717 || (_polygon717 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "299.73 392.03 301.23 395.63 303.13 394.63 302.03 390.73 299.73 392.03"
  })), _polygon718 || (_polygon718 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "299.73 392.03 301.23 395.63 303.13 394.63 302.03 390.73 299.73 392.03"
  })), _polygon719 || (_polygon719 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "298.03 392.73 294.93 394.83 298.03 398.43 300.33 397.13 298.03 392.73"
  })), _polygon720 || (_polygon720 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "298.03 392.73 294.93 394.83 298.03 398.43 300.33 397.13 298.03 392.73"
  })), _polygon721 || (_polygon721 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "299.43 400.63 301.23 399.73 302.03 401.53 300.13 402.33 299.43 400.63"
  })), _polygon722 || (_polygon722 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "299.43 400.63 301.23 399.73 302.03 401.53 300.13 402.33 299.43 400.63"
  })), _polygon723 || (_polygon723 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "303.13 398.53 303.73 400.43 305.33 399.73 305.23 397.43 303.13 398.53"
  })), _polygon724 || (_polygon724 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "303.13 398.53 303.73 400.43 305.33 399.73 305.23 397.43 303.13 398.53"
  })), _path585 || (_path585 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M301.6,405.3l.6,2.6s1.5-1.1,1.5-1.3-.2-2.4-.2-2.4l-1.9,1.1Z",
    transform: "translate(0.03 0.03)"
  })), _path586 || (_path586 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M301.6,405.3l.6,2.6s1.5-1.1,1.5-1.3-.2-2.4-.2-2.4l-1.9,1.1Z",
    transform: "translate(0.03 0.03)"
  })), _polygon725 || (_polygon725 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "307.83 414.13 304.93 416.73 305.53 428.73 306.83 431.93 308.53 431.13 307.83 414.13"
  })), _polygon726 || (_polygon726 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "307.83 414.13 304.93 416.73 305.53 428.73 306.83 431.93 308.53 431.13 307.83 414.13"
  })), _path587 || (_path587 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M309.5,418v3.4l2.6-.4a19.3,19.3,0,0,0,0-3.4C311.9,417.6,309.5,418,309.5,418Z",
    transform: "translate(0.03 0.03)"
  })), _path588 || (_path588 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M309.5,418v3.4l2.6-.4a19.3,19.3,0,0,0,0-3.4C311.9,417.6,309.5,418,309.5,418Z",
    transform: "translate(0.03 0.03)"
  })), _polygon727 || (_polygon727 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "309.83 422.93 310.03 430.43 311.73 429.23 312.33 422.33 309.83 422.93"
  })), _polygon728 || (_polygon728 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "309.83 422.93 310.03 430.43 311.73 429.23 312.33 422.33 309.83 422.93"
  })), _polygon729 || (_polygon729 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "313.23 415.23 313.23 417.83 315.83 417.13 315.83 414.13 313.23 415.23"
  })), _polygon730 || (_polygon730 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "313.23 415.23 313.23 417.83 315.83 417.13 315.83 414.13 313.23 415.23"
  })), _polygon731 || (_polygon731 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "313.03 410.93 312.83 413.53 315.33 412.43 315.13 409.83 313.03 410.93"
  })), _polygon732 || (_polygon732 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "313.03 410.93 312.83 413.53 315.33 412.43 315.13 409.83 313.03 410.93"
  })), _polygon733 || (_polygon733 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "322.43 425.13 320.13 427.23 320.53 431.33 323.13 428.53 322.43 425.13"
  })), _polygon734 || (_polygon734 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "322.43 425.13 320.13 427.23 320.53 431.33 323.13 428.53 322.43 425.13"
  })), _path589 || (_path589 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M283.6,417.5l.2,3.6,7.7.8-.4-2.1c0-.1-1.9-2.2-7.5-2.3Z",
    transform: "translate(0.03 0.03)"
  })), _path590 || (_path590 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M283.6,417.5l.2,3.6,7.7.8-.4-2.1c0-.1-1.9-2.2-7.5-2.3Z",
    transform: "translate(0.03 0.03)"
  })), _path591 || (_path591 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M293.7,421.8l1.3,1.3a6,6,0,0,1,3.9-1.7l.4-1.7a6.74,6.74,0,0,0-3.4.2,3.73,3.73,0,0,0-2.2,1.9Z",
    transform: "translate(0.03 0.03)"
  })), _path592 || (_path592 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M293.7,421.8l1.3,1.3a6,6,0,0,1,3.9-1.7l.4-1.7a6.74,6.74,0,0,0-3.4.2,3.73,3.73,0,0,0-2.2,1.9Z",
    transform: "translate(0.03 0.03)"
  })), _path593 || (_path593 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M300.3,423.3c-2.6,0-4.7.7-5.3,3l2.1,2.2H299a1.79,1.79,0,0,1,1.5-2.2Z",
    transform: "translate(0.03 0.03)"
  })), _path594 || (_path594 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M300.3,423.3c-2.6,0-4.7.7-5.3,3l2.1,2.2H299a1.79,1.79,0,0,1,1.5-2.2Z",
    transform: "translate(0.03 0.03)"
  })), _path595 || (_path595 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M303.5,433.2c-1.5,0-1.9,1.5-1.9,3.2l1.1.6s.2,5.1.7,6,2.3.8,2.3.8-.4-1.9-1.1-2.1v-6.9C304.6,434.7,304.8,433.2,303.5,433.2Z",
    transform: "translate(0.03 0.03)"
  })), _path596 || (_path596 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M303.5,433.2c-1.5,0-1.9,1.5-1.9,3.2l1.1.6s.2,5.1.7,6,2.3.8,2.3.8-.4-1.9-1.1-2.1v-6.9C304.6,434.7,304.8,433.2,303.5,433.2Z",
    transform: "translate(0.03 0.03)"
  })), _path597 || (_path597 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M307.8,434.9c-1.7.3-1.9,1.7-1.7,3a12,12,0,0,0,1.1,3h1.7a13.5,13.5,0,0,0,.6-3C309.5,436.8,308.9,434.7,307.8,434.9Z",
    transform: "translate(0.03 0.03)"
  })), _path598 || (_path598 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M307.8,434.9c-1.7.3-1.9,1.7-1.7,3a12,12,0,0,0,1.1,3h1.7a13.5,13.5,0,0,0,.6-3C309.5,436.8,308.9,434.7,307.8,434.9Z",
    transform: "translate(0.03 0.03)"
  })), _path599 || (_path599 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M279.3,419.9a5.73,5.73,0,0,0-4.7,2.8l2.2,1.7h5.8l1.1-1.3c.1,0-2.3-3.2-4.4-3.2Z",
    transform: "translate(0.03 0.03)"
  })), _path600 || (_path600 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M279.3,419.9a5.73,5.73,0,0,0-4.7,2.8l2.2,1.7h5.8l1.1-1.3c.1,0-2.3-3.2-4.4-3.2Z",
    transform: "translate(0.03 0.03)"
  })), _polygon735 || (_polygon735 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "277.53 416.93 276.13 419.03 281.43 418.83 281.43 417.63 277.53 416.93"
  })), _polygon736 || (_polygon736 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "277.53 416.93 276.13 419.03 281.43 418.83 281.43 417.63 277.53 416.93"
  })), _path601 || (_path601 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M278,428.9h6.5s1.9-1.5.8-2.6a3.46,3.46,0,0,0-4.1-.4C279.9,426.6,278.2,427.4,278,428.9Z",
    transform: "translate(0.03 0.03)"
  })), _path602 || (_path602 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M278,428.9h6.5s1.9-1.5.8-2.6a3.46,3.46,0,0,0-4.1-.4C279.9,426.6,278.2,427.4,278,428.9Z",
    transform: "translate(0.03 0.03)"
  })), _path603 || (_path603 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M291.1,426.8c-2.9,1-3.1,4.5-3.1,6l6.3-1C294.2,431.8,294.4,425.7,291.1,426.8Z",
    transform: "translate(0.03 0.03)"
  })), _path604 || (_path604 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M291.1,426.8c-2.9,1-3.1,4.5-3.1,6l6.3-1C294.2,431.8,294.4,425.7,291.1,426.8Z",
    transform: "translate(0.03 0.03)"
  })), _path605 || (_path605 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M282.7,443.1c.6-2.2,2.4-2.8,4.5-2.8h4.1l1.5-.8,1.5,1.3h5.2s1.7-1.7,2.6-.4.6,3.2.2,4.5-1.9,1.7-2.2.2a7.28,7.28,0,0,0-1.1-2.4l-.8.4a9.58,9.58,0,0,1-2.3,3l-.6-1.5h-1.1l-.4,1.7s-1.7.2-1.9-1.1a19.52,19.52,0,0,1-.2-2.6l-2.3.8a6.79,6.79,0,0,0-3-.9,3,3,0,0,0-2.2.8l-1.5-.2Z",
    transform: "translate(0.03 0.03)"
  })), _path606 || (_path606 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M282.7,443.1c.6-2.2,2.4-2.8,4.5-2.8h4.1l1.5-.8,1.5,1.3h5.2s1.7-1.7,2.6-.4.6,3.2.2,4.5-1.9,1.7-2.2.2a7.28,7.28,0,0,0-1.1-2.4l-.8.4a9.58,9.58,0,0,1-2.3,3l-.6-1.5h-1.1l-.4,1.7s-1.7.2-1.9-1.1a19.52,19.52,0,0,1-.2-2.6l-2.3.8a6.79,6.79,0,0,0-3-.9,3,3,0,0,0-2.2.8l-1.5-.2Z",
    transform: "translate(0.03 0.03)"
  })), _path607 || (_path607 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M293,437.9c.2-1.7.8-3,2.6-3a2.74,2.74,0,0,1,3,3,3.85,3.85,0,0,1-2.6,1.3A5.52,5.52,0,0,1,293,437.9Z",
    transform: "translate(0.03 0.03)"
  })), _path608 || (_path608 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M293,437.9c.2-1.7.8-3,2.6-3a2.74,2.74,0,0,1,3,3,3.85,3.85,0,0,1-2.6,1.3A5.52,5.52,0,0,1,293,437.9Z",
    transform: "translate(0.03 0.03)"
  })), _path609 || (_path609 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M262.1,423.2c5.5.2,10.8,2.3,10.8,4.5s-4.8,1.9-6.5.9l-.2,1.1a11,11,0,0,1,3.2,2.2c1.5,1.5,5.7-.6,7.5-.4,0,0,3.2.6.6,2.4-3.6,2.6-7.5,2.6-10.1.9,0,0-2.6-.2-3,1.1s-.3,8.8-.3,8.8l-2.5,1.7s.4-11.5.4-15.1c.1-3.2.1-8.1.1-8.1Z",
    transform: "translate(0.03 0.03)"
  })), _path610 || (_path610 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M262.1,423.2c5.5.2,10.8,2.3,10.8,4.5s-4.8,1.9-6.5.9l-.2,1.1a11,11,0,0,1,3.2,2.2c1.5,1.5,5.7-.6,7.5-.4,0,0,3.2.6.6,2.4-3.6,2.6-7.5,2.6-10.1.9,0,0-2.6-.2-3,1.1s-.3,8.8-.3,8.8l-2.5,1.8s.4-11.5.4-15.1c.1-3.3.1-8.2.1-8.2Z",
    transform: "translate(0.03 0.03)"
  })), _polygon737 || (_polygon737 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "266.23 437.13 267.93 437.33 267.93 440.53 266.23 439.93 266.23 437.13"
  })), _polygon738 || (_polygon738 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "266.23 437.13 267.93 437.33 267.93 440.53 266.23 439.93 266.23 437.13"
  })), _path611 || (_path611 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M270.5,437.9a5.85,5.85,0,0,0,4.5-.5c1.1-.8,5.6-3.9,8.4-4.3a3.39,3.39,0,0,1,2.2,1.3s4.9-.4,4.9,1.1-1.5,1.1-3.4,1.3a12.53,12.53,0,0,0-4.1.9l-1.7-1.1a5,5,0,0,0-3.6.8c-1.7,1.2-3.3,2.8-4.9,2.8a2.26,2.26,0,0,1-2.3-2.3Z",
    transform: "translate(0.03 0.03)"
  })), _path612 || (_path612 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M270.5,437.9a5.85,5.85,0,0,0,4.5-.5c1.1-.8,5.6-3.9,8.4-4.3a3.39,3.39,0,0,1,2.2,1.3s4.9-.4,4.9,1.1-1.5,1.1-3.4,1.3a12.53,12.53,0,0,0-4.1.9l-1.7-1.1a5,5,0,0,0-3.6.8c-1.7,1.2-3.3,2.8-4.9,2.8a2.26,2.26,0,0,1-2.3-2.3Z",
    transform: "translate(0.03 0.03)"
  })), _path613 || (_path613 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M274.5,443.5c0-.9,1.3-2.1,3-2.1s3.4,1.1,3.4,2.6a2.8,2.8,0,0,1-2.1,2.6,4.82,4.82,0,0,0-1.7-2.3A14.27,14.27,0,0,0,274.5,443.5Z",
    transform: "translate(0.03 0.03)"
  })), _path614 || (_path614 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M274.5,443.5c0-.9,1.3-2.1,3-2.1s3.4,1.1,3.4,2.6a2.8,2.8,0,0,1-2.1,2.6,4.82,4.82,0,0,0-1.7-2.3A14.27,14.27,0,0,0,274.5,443.5Z",
    transform: "translate(0.03 0.03)"
  })), _path615 || (_path615 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M282,449.2c-.2-2.1,2.4-2.9,4.3-3.3s3.8-.8,4.9.2,1.9,1.1,1.9,2.4c0,0-1.7.2-2.1,1.3a9.08,9.08,0,0,0-.4,2.6l-1.1-.2s0-2.6-1.3-3.2-2.6-1.1-4.3-.2l-1.9.4Z",
    transform: "translate(0.03 0.03)"
  })), _path616 || (_path616 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M282,449.2c-.2-2.1,2.4-2.9,4.3-3.3s3.8-.8,4.9.2,1.9,1.1,1.9,2.4c0,0-1.7.2-2.1,1.3a9.08,9.08,0,0,0-.4,2.6l-1.1-.2s0-2.6-1.3-3.2-2.6-1.1-4.3-.2l-1.9.4Z",
    transform: "translate(0.03 0.03)"
  })), _path617 || (_path617 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M282,451.7a3.4,3.4,0,0,0-3-3,2.47,2.47,0,0,0-2.6,1.9l-.9-1.7-.9.2v6.2l.8-.2s.4-1.7,1.1-1.9a3.5,3.5,0,0,0,2.4.8C280.5,454,282,452.6,282,451.7Z",
    transform: "translate(0.03 0.03)"
  })), _path618 || (_path618 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M282,451.7a3.4,3.4,0,0,0-3-3,2.47,2.47,0,0,0-2.6,1.9l-.9-1.7-.9.2v6.2l.8-.2s.4-1.7,1.1-1.9a3.5,3.5,0,0,0,2.4.8C280.5,454,282,452.6,282,451.7Z",
    transform: "translate(0.03 0.03)"
  })), _polygon739 || (_polygon739 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "283.83 452.63 281.83 455.33 281.63 464.13 283.53 462.03 283.83 452.63"
  })), _polygon740 || (_polygon740 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "283.83 452.63 281.83 455.33 281.63 464.13 283.53 462.03 283.83 452.63"
  })), _polygon741 || (_polygon741 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "287.43 451.03 285.33 453.63 285.13 459.63 287.03 457.53 287.43 451.03"
  })), _polygon742 || (_polygon742 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "287.43 451.03 285.33 453.63 285.13 459.63 287.03 457.53 287.43 451.03"
  })), _polygon743 || (_polygon743 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "287.43 459.73 282.53 464.83 282.13 470.33 286.83 465.83 287.43 459.73"
  })), _polygon744 || (_polygon744 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "287.43 459.73 282.53 464.83 282.13 470.33 286.83 465.83 287.43 459.73"
  })), _polygon745 || (_polygon745 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "289.23 459.03 289.13 463.13 292.83 459.23 293.23 455.13 289.23 459.03"
  })), _polygon746 || (_polygon746 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "289.23 459.03 289.13 463.13 292.83 459.23 293.23 455.13 289.23 459.03"
  })), _polygon747 || (_polygon747 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "272.43 461.33 272.23 468.13 278.83 463.73 279.63 456.83 272.43 461.33"
  })), _polygon748 || (_polygon748 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "272.43 461.33 272.23 468.13 278.83 463.73 279.63 456.83 272.43 461.33"
  })), _path619 || (_path619 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M246.4,461.8l-.6,5s5.9-6.2,8.4-7l1.8-7s-4.5,1.3-6,2.6-3.6,6.4-3.6,6.4Z",
    transform: "translate(0.03 0.03)"
  })), _path620 || (_path620 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M246.4,461.8l-.6,5s5.9-6.2,8.4-6.9l1.8-7s-4.5,1.3-6,2.6-3.6,6.3-3.6,6.3Z",
    transform: "translate(0.03 0.03)"
  })), _path621 || (_path621 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M250.1,448.7a13.1,13.1,0,0,1,0,2.8c-.2,0,4.1-2.4,5.1-3.2l.4-4.3s-4.6,2.3-5.5,4.7Z",
    transform: "translate(0.03 0.03)"
  })), _path622 || (_path622 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M250.1,448.7a13.1,13.1,0,0,1,0,2.8c-.2,0,4.1-2.4,5.1-3.2l.4-4.3s-4.6,2.3-5.5,4.7Z",
    transform: "translate(0.03 0.03)"
  })), _path623 || (_path623 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M252.4,440.9v1.5l1.9.2A4.87,4.87,0,0,1,256,440l.2-3.2C256.1,436.7,253.1,436.7,252.4,440.9Z",
    transform: "translate(0.03 0.03)"
  })), _path624 || (_path624 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M252.4,440.9v1.5l1.9.2A4.87,4.87,0,0,1,256,440l.2-3.2C256.1,436.7,253.1,436.7,252.4,440.9Z",
    transform: "translate(0.03 0.03)"
  })), _polygon749 || (_polygon749 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "260.43 430.43 258.73 431.33 258.43 436.53 260.43 435.43 260.43 430.43"
  })), _polygon750 || (_polygon750 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "260.43 430.43 258.73 431.33 258.43 436.53 260.43 435.43 260.43 430.43"
  })), _polygon751 || (_polygon751 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "257.33 440.03 257.03 447.53 259.83 446.73 260.43 438.63 257.33 440.03"
  })), _polygon752 || (_polygon752 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "257.33 440.03 257.03 447.53 259.83 446.73 260.43 438.63 257.33 440.03"
  })), _path625 || (_path625 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M225.8,383.4l-1.7,3.6-.4,3,1.3.4.6-1.9s2.2-1.3,2.4-4.9l-2.2-.2Z",
    transform: "translate(0.03 0.03)"
  })), _path626 || (_path626 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M225.8,383.4l-1.7,3.6-.4,3,1.3.4.6-1.9s2.2-1.3,2.4-4.9l-2.2-.2Z",
    transform: "translate(0.03 0.03)"
  })), _path627 || (_path627 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M228,388.3c0,.2-.4,1.9-.4,1.9h1.9l.2-2.1Z",
    transform: "translate(0.03 0.03)"
  })), _path628 || (_path628 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M228,388.3c0,.2-.4,1.9-.4,1.9h1.9l.2-2.1Z",
    transform: "translate(0.03 0.03)"
  })), _polygon753 || (_polygon753 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "229.23 384.33 229.03 386.63 231.03 386.43 231.43 384.33 229.23 384.33"
  })), _polygon754 || (_polygon754 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "229.23 384.33 229.03 386.63 231.03 386.43 231.43 384.33 229.23 384.33"
  })), _polygon755 || (_polygon755 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "233.33 388.13 232.53 390.73 234.63 392.23 236.73 389.43 233.33 388.13"
  })), _polygon756 || (_polygon756 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "233.33 388.13 232.53 390.73 234.63 392.23 236.73 389.43 233.33 388.13"
  })), _polygon757 || (_polygon757 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "238.53 389.93 236.73 392.63 239.13 393.33 241.93 391.43 238.53 389.93"
  })), _polygon758 || (_polygon758 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "238.53 389.93 236.73 392.63 239.13 393.33 241.93 391.43 238.53 389.93"
  })), _polygon759 || (_polygon759 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "243.83 392.63 241.13 394.43 243.23 395.73 246.03 394.23 243.83 392.63"
  })), _polygon760 || (_polygon760 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "243.83 392.63 241.13 394.43 243.23 395.73 246.03 394.23 243.83 392.63"
  })), _polygon761 || (_polygon761 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "247.53 395.23 244.73 396.73 246.03 398.43 249.63 397.23 247.53 395.23"
  })), _polygon762 || (_polygon762 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "247.53 395.23 244.73 396.73 246.03 398.43 249.63 397.23 247.53 395.23"
  })), _polygon763 || (_polygon763 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "250.33 398.93 248.13 399.53 248.83 401.43 251.13 400.83 250.33 398.93"
  })), _polygon764 || (_polygon764 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "250.33 398.93 248.13 399.53 248.83 401.43 251.13 400.83 250.33 398.93"
  })), _path629 || (_path629 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M208,405.3l1.1,1.3a42.7,42.7,0,0,1,7.5-1.7c3.6-.4,5.2-.9,9-.8l-.2-2.2a5.74,5.74,0,0,0-3.2-.8l-.4,1.3-2.8.4-1.7-.8a8.84,8.84,0,0,0-4.9.4,25.84,25.84,0,0,0-4.4,2.9Z",
    transform: "translate(0.03 0.03)"
  })), _path630 || (_path630 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M208,405.3l1.1,1.3a42.7,42.7,0,0,1,7.5-1.7c3.6-.4,5.2-.9,9-.8l-.2-2.2a5.74,5.74,0,0,0-3.2-.8l-.4,1.3-2.8.4-1.7-.8a8.84,8.84,0,0,0-4.9.4,25.84,25.84,0,0,0-4.4,2.9Z",
    transform: "translate(0.03 0.03)"
  })), _path631 || (_path631 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M205.4,408.7c-3.2,2.8-5.6,5.1-6.7,8.8s-2.3,8.2-2.3,11l1.7.6a74,74,0,0,1,3.4-9.5,53.05,53.05,0,0,1,6.9-10.7Z",
    transform: "translate(0.03 0.03)"
  })), _path632 || (_path632 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M205.4,408.7c-3.2,2.8-5.6,5.1-6.7,8.8s-2.3,8.2-2.3,11l1.7.6a74,74,0,0,1,3.4-9.5,53.05,53.05,0,0,1,6.9-10.7Z",
    transform: "translate(0.03 0.03)"
  })), _polygon765 || (_polygon765 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "208.03 412.23 205.73 416.33 209.83 416.33 212.23 412.43 208.03 412.23"
  })), _polygon766 || (_polygon766 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "208.03 412.23 205.73 416.33 209.83 416.33 212.23 412.43 208.03 412.23"
  })), _polygon767 || (_polygon767 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "204.13 417.53 202.83 420.33 205.83 420.13 207.83 417.53 204.13 417.53"
  })), _polygon768 || (_polygon768 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "204.13 417.53 202.83 420.33 205.83 420.13 207.83 417.53 204.13 417.53"
  })), _polygon769 || (_polygon769 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "202.23 422.33 201.33 424.43 204.13 424.63 205.23 422.13 202.23 422.33"
  })), _polygon770 || (_polygon770 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "202.23 422.33 201.33 424.43 204.13 424.63 205.23 422.13 202.23 422.33"
  })), _polygon771 || (_polygon771 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "214.83 421.73 208.63 421.93 207.83 424.43 213.13 424.73 215.63 423.43 214.83 421.73"
  })), _polygon772 || (_polygon772 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "214.83 421.73 208.63 421.93 207.83 424.43 213.13 424.73 215.63 423.43 214.83 421.73"
  })), _polygon773 || (_polygon773 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "200.53 430.93 200.03 433.43 202.23 433.43 203.13 430.73 200.53 430.93"
  })), _polygon774 || (_polygon774 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "200.53 430.93 200.03 433.43 202.23 433.43 203.13 430.73 200.53 430.93"
  })), _polygon775 || (_polygon775 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "201.13 435.03 200.03 439.23 201.83 438.83 202.83 435.03 201.13 435.03"
  })), _polygon776 || (_polygon776 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "201.13 435.03 200.03 439.23 201.83 438.83 202.83 435.03 201.13 435.03"
  })), _polygon777 || (_polygon777 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "204.83 434.43 204.13 438.03 205.63 438.03 206.53 434.23 204.83 434.43"
  })), _polygon778 || (_polygon778 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "204.83 434.43 204.13 438.03 205.63 438.03 206.53 434.23 204.83 434.43"
  })), _polygon779 || (_polygon779 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "208.63 434.03 207.63 437.33 210.33 437.13 211.23 433.63 208.63 434.03"
  })), _polygon780 || (_polygon780 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "208.63 434.03 207.63 437.33 210.33 437.13 211.23 433.63 208.63 434.03"
  })), _polygon781 || (_polygon781 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "205.63 430.43 204.83 432.83 206.73 432.63 207.63 430.23 205.63 430.43"
  })), _polygon782 || (_polygon782 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "205.63 430.43 204.83 432.83 206.73 432.63 207.63 430.23 205.63 430.43"
  })), _polygon783 || (_polygon783 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "196.63 432.03 195.93 435.03 198.13 434.73 198.53 431.13 196.63 432.03"
  })), _polygon784 || (_polygon784 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "196.63 432.03 195.93 435.03 198.13 434.73 198.53 431.13 196.63 432.03"
  })), _polygon785 || (_polygon785 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "197.43 436.13 196.63 439.23 198.13 439.23 199.03 435.93 197.43 436.13"
  })), _polygon786 || (_polygon786 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "197.43 436.13 196.63 439.23 198.13 439.23 199.03 435.93 197.43 436.13"
  })), _path633 || (_path633 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M209.7,430.2l-1.1,2.1a27,27,0,0,1,8,.9l2.6-1.9a7,7,0,0,0-4.7-1.7C211.9,429.8,209.7,430.2,209.7,430.2Z",
    transform: "translate(0.03 0.03)"
  })), _path634 || (_path634 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M209.7,430.2l-1.1,2.1a27,27,0,0,1,8,.9l2.6-1.9a7,7,0,0,0-4.7-1.7C211.9,429.8,209.7,430.2,209.7,430.2Z",
    transform: "translate(0.03 0.03)"
  })), _path635 || (_path635 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M217.2,426.6l-1.3,1.5a8.75,8.75,0,0,1,4.5,1.7l1.7-1.7s-1.5-2-4.9-1.5Z",
    transform: "translate(0.03 0.03)"
  })), _path636 || (_path636 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M217.2,426.6l-1.3,1.5a8.75,8.75,0,0,1,4.5,1.7l1.7-1.7s-1.5-2-4.9-1.5Z",
    transform: "translate(0.03 0.03)"
  })), _polygon787 || (_polygon787 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "220.73 432.63 215.53 436.43 217.83 436.93 223.03 433.43 220.73 432.63"
  })), _polygon788 || (_polygon788 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "220.73 432.63 215.53 436.43 217.83 436.93 223.03 433.43 220.73 432.63"
  })), _path637 || (_path637 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M227.7,432.8a10.5,10.5,0,0,0-5,2.3c-1.7,1.1-4.7,2.8-6.2,5.1a10.41,10.41,0,0,0-1.9,5.6s2.6-1.1,2.8-1.1,1.5-3.7,3.2-5.2,3.9-3.7,6.9-4.9l.2-1.8Z",
    transform: "translate(0.03 0.03)"
  })), _path638 || (_path638 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M227.7,432.8a10.5,10.5,0,0,0-5,2.3c-1.7,1.1-4.7,2.8-6.2,5.1a10.41,10.41,0,0,0-1.9,5.6s2.6-1.1,2.8-1.1,1.5-3.7,3.2-5.2,3.9-3.7,6.9-4.9l.2-1.8Z",
    transform: "translate(0.03 0.03)"
  })), _path639 || (_path639 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M233.1,414.9c1.5,1.3,3.8,5,3.8,6.8s-3.2,3.1-4.7,4.4l2.3,5.3s6.3-1,7.5-7.4c.5-2.9-1-8.8-5.9-10.6l-3,1.5Z",
    transform: "translate(0.03 0.03)"
  })), _path640 || (_path640 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M233.1,414.9c1.5,1.3,3.8,5,3.8,6.8s-3.2,3.1-4.7,4.4l2.3,5.3s6.3-1,7.5-7.4c.5-2.9-1-8.8-5.9-10.6l-3,1.5Z",
    transform: "translate(0.03 0.03)"
  })), _path641 || (_path641 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M242.5,414.8l1.5,2.8,7.8-6.7a17.07,17.07,0,0,0-2.1-3.9l-7.2,7.8Z",
    transform: "translate(0.03 0.03)"
  })), _path642 || (_path642 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M242.5,414.8l1.5,2.8,7.8-6.7a17.07,17.07,0,0,0-2.1-3.9l-7.2,7.8Z",
    transform: "translate(0.03 0.03)"
  })), _polygon789 || (_polygon789 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "248.63 405.53 241.53 412.63 240.03 410.93 247.13 403.43 248.63 405.53"
  })), _polygon790 || (_polygon790 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "248.63 405.53 241.53 412.63 240.03 410.93 247.13 403.43 248.63 405.53"
  })), _path643 || (_path643 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M244.8,402.3l-6.3,7.3-2.8-2.1,5.9-7.4a2.69,2.69,0,0,1,2.1.6,5,5,0,0,1,1.1,1.6Z",
    transform: "translate(0.03 0.03)"
  })), _path644 || (_path644 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M244.8,402.3l-6.3,7.3-2.8-2.1,5.9-7.4a2.69,2.69,0,0,1,2.1.6,5,5,0,0,1,1.1,1.6Z",
    transform: "translate(0.03 0.03)"
  })), _path645 || (_path645 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M231.2,405.3l2.4,1.5,6.7-7.5s-1.1-.8-2-1.3a4.86,4.86,0,0,0-2.3-.6l-4.8,7.9Z",
    transform: "translate(0.03 0.03)"
  })), _path646 || (_path646 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M231.2,405.3l2.4,1.5,6.7-7.5s-1.1-.8-2-1.3a6.67,6.67,0,0,0-2.3-.6l-4.8,7.9Z",
    transform: "translate(0.03 0.03)"
  })), _path647 || (_path647 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M217.7,406.6a47.64,47.64,0,0,1,6.5-.4l-1.1,2.2h-5.4v-1.8Z",
    transform: "translate(0.03 0.03)"
  })), _path648 || (_path648 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M217.7,406.6a47.64,47.64,0,0,1,6.5-.4l-1.1,2.2h-5.4v-1.8Z",
    transform: "translate(0.03 0.03)"
  })), _polygon791 || (_polygon791 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "216.43 410.53 214.83 412.63 221.03 412.63 222.93 410.33 216.43 410.53"
  })), _polygon792 || (_polygon792 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "216.43 410.53 214.83 412.63 221.03 412.63 222.93 410.33 216.43 410.53"
  })), _polygon793 || (_polygon793 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "213.13 414.63 211.83 416.53 219.23 416.33 221.33 414.53 213.13 414.63"
  })), _polygon794 || (_polygon794 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "213.13 414.63 211.83 416.53 219.23 416.33 221.33 414.53 213.13 414.63"
  })), _polygon795 || (_polygon795 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "219.13 421.83 218.13 424.43 220.93 425.23 222.43 423.33 219.13 421.83"
  })), _polygon796 || (_polygon796 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "219.13 421.83 218.13 424.43 220.93 425.23 222.43 423.33 219.13 421.83"
  })), _path649 || (_path649 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M223.2,414.7l-3.6,5.1a15.3,15.3,0,0,1,3.8,1.9l3-6.1A27.71,27.71,0,0,0,223.2,414.7Z",
    transform: "translate(0.03 0.03)"
  })), _path650 || (_path650 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M223.2,414.7l-3.6,5.1a15.3,15.3,0,0,1,3.8,1.9l3-6.1A27.71,27.71,0,0,0,223.2,414.7Z",
    transform: "translate(0.03 0.03)"
  })), _polygon797 || (_polygon797 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "225.63 420.33 223.23 424.73 227.53 427.83 228.93 422.43 225.63 420.33"
  })), _polygon798 || (_polygon798 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "225.63 420.33 223.23 424.73 227.53 427.83 228.93 422.43 225.63 420.33"
  })), _path651 || (_path651 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M226.4,410.5l-1.7,2.2a6.11,6.11,0,0,1,2.8,1.9l1.5-2.1A8.7,8.7,0,0,0,226.4,410.5Z",
    transform: "translate(0.03 0.03)"
  })), _path652 || (_path652 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M226.4,410.5l-1.7,2.2a6.11,6.11,0,0,1,2.8,1.9l1.5-2.1A8.7,8.7,0,0,0,226.4,410.5Z",
    transform: "translate(0.03 0.03)"
  })), _path653 || (_path653 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M229.7,415.6l-1.9,2.8a5.49,5.49,0,0,1,1.7,1.5l2.2-2.1a1.56,1.56,0,0,0-.4-1.7,3.33,3.33,0,0,0-1.6-.5Z",
    transform: "translate(0.03 0.03)"
  })), _path654 || (_path654 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M229.7,415.6l-1.9,2.8a5.49,5.49,0,0,1,1.7,1.5l2.2-2.1a1.56,1.56,0,0,0-.4-1.7,3.33,3.33,0,0,0-1.6-.5Z",
    transform: "translate(0.03 0.03)"
  })), _path655 || (_path655 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M231.7,433.8l-4.8,2.1s1.5,2.5,2.6,4.2l2.9-.8s.5-3.8-.7-5.5Z",
    transform: "translate(0.03 0.03)"
  })), _path656 || (_path656 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M231.7,433.8l-4.8,2.1s1.5,2.5,2.6,4.2l2.9-.8s.5-3.8-.7-5.5Z",
    transform: "translate(0.03 0.03)"
  })), _path657 || (_path657 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M225.2,437.1l-1.9,1.5a36.12,36.12,0,0,1,3,4.5l1.9-.4S227.3,438.7,225.2,437.1Z",
    transform: "translate(0.03 0.03)"
  })), _path658 || (_path658 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M225.2,437.1l-1.9,1.5a36.12,36.12,0,0,1,3,4.5l1.9-.4S227.3,438.7,225.2,437.1Z",
    transform: "translate(0.03 0.03)"
  })), _path659 || (_path659 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M221.7,440.9l-.9,1.1a16.66,16.66,0,0,1,3.6,3.7l-1.5.8a6.09,6.09,0,0,0-2.3-1.5l-.8,1.7a4.92,4.92,0,0,0,3,3,12.05,12.05,0,0,0,5.2-.2l.2-1.9a19.63,19.63,0,0,0-2.4-3.6,13.43,13.43,0,0,0-4.1-3.1Z",
    transform: "translate(0.03 0.03)"
  })), _path660 || (_path660 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M221.7,440.9l-.9,1.1a16.66,16.66,0,0,1,3.6,3.7l-1.5.8a6.09,6.09,0,0,0-2.3-1.5l-.8,1.7a4.92,4.92,0,0,0,3,3,12.05,12.05,0,0,0,5.2-.2l.2-1.9a19.63,19.63,0,0,0-2.4-3.6,13.43,13.43,0,0,0-4.1-3.1Z",
    transform: "translate(0.03 0.03)"
  })), _path661 || (_path661 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M217.7,449.1a6.42,6.42,0,0,0-2.1,6.2c.6,2.6,5.1,8.4,6,10.7s1.5,3.9,1.5,3.9l2.2-.4a12.29,12.29,0,0,1,2.1-4.9l-1.3-1.3-1.3.2s-3.9-4.9-4.9-7.1l1.1-.4v-1.5l-1.9-.2s-1.9-1.5-.9-3.2l-.5-2Z",
    transform: "translate(0.03 0.03)"
  })), _path662 || (_path662 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M217.7,449.1a6.42,6.42,0,0,0-2.1,6.2c.6,2.6,5.1,8.4,6,10.7s1.5,3.9,1.5,3.9l2.2-.4a12.29,12.29,0,0,1,2.1-4.9l-1.3-1.3-1.3.2s-3.9-4.9-4.9-7.1l1.1-.4v-1.5l-1.9-.2s-1.9-1.5-.9-3.2l-.5-2Z",
    transform: "translate(0.03 0.03)"
  })), _path663 || (_path663 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M220.4,485.8h-1.7l-2.6-2.6s-1.2-4.1-.1-5.5a21.56,21.56,0,0,1,4.9-4.6,10.56,10.56,0,0,1,5.7-1.5,10.15,10.15,0,0,1,4.4,1.6c1.1.7,1.9,3.5,1.9,3.5s.8,3.4-.2,4.8a10.67,10.67,0,0,1-4,3.5,17.33,17.33,0,0,1-6,1.2l.4-1.5s4.9-1.7,6.1-3.2,1.3-3.6-.8-4.1a8.14,8.14,0,0,0-4.3.7,13.73,13.73,0,0,0-3.8,3.8Z",
    transform: "translate(0.03 0.03)"
  })), _path664 || (_path664 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M220.4,485.8h-1.7l-2.6-2.6s-1.2-4.1-.1-5.5a21.56,21.56,0,0,1,4.9-4.6,10.56,10.56,0,0,1,5.7-1.5,10.15,10.15,0,0,1,4.4,1.6c1.1.7,1.9,3.5,1.9,3.5s.8,3.4-.2,4.8a10.67,10.67,0,0,1-4,3.5,17.33,17.33,0,0,1-6,1.2l.4-1.5s4.9-1.7,6.1-3.2,1.3-3.6-.8-4.1a8.14,8.14,0,0,0-4.3.7,13.73,13.73,0,0,0-3.8,3.8Z",
    transform: "translate(0.03 0.03)"
  })), _polygon799 || (_polygon799 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "233.63 467.53 229.33 470.53 232.73 473.23 236.23 470.43 233.63 467.53"
  })), _polygon800 || (_polygon800 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "233.63 467.53 229.33 470.53 232.73 473.23 236.23 470.43 233.63 467.53"
  })), _path665 || (_path665 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M227.8,445l1.5,2.5s4.8-1.5,5.6-5.1l-2.8-.5s-.4,1.5-1.1,1.9A9.48,9.48,0,0,1,227.8,445Z",
    transform: "translate(0.03 0.03)"
  })), _path666 || (_path666 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M227.8,445l1.5,2.5s4.8-1.5,5.6-5.1l-2.8-.5s-.4,1.5-1.1,1.9A9.48,9.48,0,0,1,227.8,445Z",
    transform: "translate(0.03 0.03)"
  })), _path667 || (_path667 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M236.1,443.3c-.8,2.1-1.1,3.2-2.3,4.1s-2.8,2.5-4.3,2.9l-.3,2.3a8.56,8.56,0,0,0,5.2-1.5c2.3-1.7,4.8-3.2,5-4.9l-3.3-2.9Z",
    transform: "translate(0.03 0.03)"
  })), _path668 || (_path668 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M236.1,443.3c-.8,2.1-1.1,3.2-2.3,4.1s-2.8,2.5-4.3,2.9l-.3,2.3a8.56,8.56,0,0,0,5.2-1.5c2.3-1.7,4.8-3.2,5-4.9l-3.3-2.9Z",
    transform: "translate(0.03 0.03)"
  })), _path669 || (_path669 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M238,433c-.2,2.8-.7,4.9-3,6.6v1.1a4.13,4.13,0,0,0,3.9-.7,12.49,12.49,0,0,0,2.8-3.7L238,433Z",
    transform: "translate(0.03 0.03)"
  })), _path670 || (_path670 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M238,433c-.2,2.8-.8,4.9-3,6.6v1.1a4.13,4.13,0,0,0,3.9-.7,12.49,12.49,0,0,0,2.8-3.7L238,433Z",
    transform: "translate(0.03 0.03)"
  })), _polygon801 || (_polygon801 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "241.13 430.63 241.13 432.63 247.13 437.13 247.93 432.83 241.13 430.63"
  })), _polygon802 || (_polygon802 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "241.13 430.63 241.13 432.63 247.13 437.13 247.93 432.83 241.13 430.63"
  })), _polygon803 || (_polygon803 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "243.43 427.03 242.33 429.13 248.53 431.33 249.53 429.03 243.43 427.03"
  })), _polygon804 || (_polygon804 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "243.43 427.03 242.33 429.13 248.53 431.33 249.53 429.03 243.43 427.03"
  })), _path671 || (_path671 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M245.3,422.5a20.73,20.73,0,0,1-1.1,2.8l4.7,1.8a9.81,9.81,0,0,0,1.1-4.5Z",
    transform: "translate(0.03 0.03)"
  })), _path672 || (_path672 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M245.3,422.5a20.73,20.73,0,0,1-1.1,2.8l4.7,1.8a9.81,9.81,0,0,0,1.1-4.5Z",
    transform: "translate(0.03 0.03)"
  })), _path673 || (_path673 = /*#__PURE__*/React.createElement("path", {
    d: "M269.6,399.1l1.3,1.9s3.8,0,5.2-.8a5.14,5.14,0,0,0,2.6-4.3l1.7-.2s.9,2.8,2.1,3.2a12.08,12.08,0,0,0,3.9,0l.2,1.5-1.3,1.1.6,1.1s2.6-.8,2.8-2.6-.6-2.3-2.1-2.3-3.4.2-3.4.2-1.5-.9-1.3-3.9l-1.5-.2a11.64,11.64,0,0,0-1.5.6c.2,0-3.5.6-4.5-1.3l-.8.6s.6,1.7,3.2,1.7c0,0-.4,3-2.2,3.4a17.43,17.43,0,0,1-5,.3Z",
    transform: "translate(0.03 0.03)"
  })), _path674 || (_path674 = /*#__PURE__*/React.createElement("path", {
    d: "M260.2,379.5c-2.3.2-5.2,1.3-6.2,3l.2.9a8.13,8.13,0,0,1,5.8-2.1l.2-1.8Z",
    transform: "translate(0.03 0.03)"
  })), _polygon805 || (_polygon805 = /*#__PURE__*/React.createElement("polygon", {
    points: "264.93 380.23 263.23 381.33 262.93 383.83 264.53 383.03 264.93 380.23"
  })), _path675 || (_path675 = /*#__PURE__*/React.createElement("path", {
    d: "M266.2,379.6l-.4,3.4,2.3.2,1.3-3.6a3.91,3.91,0,0,0-3.2,0Z",
    transform: "translate(0.03 0.03)"
  })), _path676 || (_path676 = /*#__PURE__*/React.createElement("path", {
    d: "M264.4,388.8c2.2-1.3,4.1-2.1,6.4-1.9l-.9,1.3-1.3.8s.4,1.5,1.7,1.1a5.47,5.47,0,0,0,2.3-1.7l1.3,1.1a10.75,10.75,0,0,1-3.6,1.7c-1.5.2-3.4-.6-3-2.2l-2.6.6Z",
    transform: "translate(0.03 0.03)"
  })), _path677 || (_path677 = /*#__PURE__*/React.createElement("path", {
    d: "M289.1,413.3c1.9.6,5.4.9,5.1-2.2l2.2-.6-.2-.6-1.5-.9-2.1.6-.4.9,1.1-.2s-.4,2.1-1.1,2.2a9.84,9.84,0,0,1-2.8-.2Z",
    transform: "translate(0.03 0.03)"
  })), _path678 || (_path678 = /*#__PURE__*/React.createElement("path", {
    d: "M279,389c1.1-1.1,2.8-2.6,4.7-1.1l-1.7,1.3s.9,1.7,2.4,1.7a1.92,1.92,0,0,0,1.9-1.1l1.7.2s-1.3,2.8-3.4,2.6-3.7-1.7-3.9-3.2l-2.1.4.4-.8Z",
    transform: "translate(0.03 0.03)"
  })), _path679 || (_path679 = /*#__PURE__*/React.createElement("path", {
    d: "M283.1,376.5a4.73,4.73,0,0,1-1.5,3.9l.6.9a17.44,17.44,0,0,1,5,.4v-1.1l-.9-.9-.4-1.5a3.5,3.5,0,0,1-1.9-1.9Z",
    transform: "translate(0.03 0.03)"
  })), _polygon806 || (_polygon806 = /*#__PURE__*/React.createElement("polygon", {
    points: "285.13 375.13 286.43 376.53 290.23 376.33 289.43 375.13 285.13 375.13"
  })), _path680 || (_path680 = /*#__PURE__*/React.createElement("path", {
    d: "M284.6,370.7l1.1.8,4.9.2s-.6-.4-.6-.6a49,49,0,0,0-5.4-.4Z",
    transform: "translate(0.03 0.03)"
  })), _path681 || (_path681 = /*#__PURE__*/React.createElement("path", {
    d: "M277.5,370.5a4.24,4.24,0,0,0-3.4,2.6c-.4,1.1-.9,2.8-2.6,3.2l-.8.9a29.5,29.5,0,0,0,5.1-.4c1.5-.4,2-1.1,1.9-3.4l-.2-2.9Z",
    transform: "translate(0.03 0.03)"
  })), _path682 || (_path682 = /*#__PURE__*/React.createElement("path", {
    d: "M274.7,365.4a3.19,3.19,0,0,0,2.8,2.8,5,5,0,0,0,3-.8,1.09,1.09,0,0,1-.2,1.5l-.2,2.1.9.6s.6-3,1.5-3.9l-.6-2.2-1.5.2s-1.3,1.3-2.4,1.1-2.4-.9-2.4-2.1Z",
    transform: "translate(0.03 0.03)"
  })), _path683 || (_path683 = /*#__PURE__*/React.createElement("path", {
    d: "M257.2,367.3a3.48,3.48,0,0,1,3.9-2.2c2,.2,2.3,1.5,4.1,1.7s3,.2,3,.2l-.9,1.1a17.07,17.07,0,0,0-4.5.6l-1.1-.2s.8-1.9-.8-1.9-2.3.4-2.6,1.1Z",
    transform: "translate(0.03 0.03)"
  })), _path684 || (_path684 = /*#__PURE__*/React.createElement("path", {
    d: "M246.4,375a2.88,2.88,0,0,1,3-2.4,2.91,2.91,0,0,0,3-2.3l.8.8a11.49,11.49,0,0,1,.6,4.5l-1.1.2s-.8-2.6-1.7-2.2-2.6.8-2.8,1.7l-1.8-.3Z",
    transform: "translate(0.03 0.03)"
  })), _polygon807 || (_polygon807 = /*#__PURE__*/React.createElement("polygon", {
    points: "256.53 370.73 256.73 375.93 255.23 374.43 254.43 370.33 256.53 370.73"
  })), _path685 || (_path685 = /*#__PURE__*/React.createElement("path", {
    d: "M244.7,372a5.63,5.63,0,0,0,3.7-1.1,4.31,4.31,0,0,1,2.4-1.5l.8-.8a5.13,5.13,0,0,0-4.1.8c-1.7,1.3-2.2,1.7-3.2,1.9Z",
    transform: "translate(0.03 0.03)"
  })), _path686 || (_path686 = /*#__PURE__*/React.createElement("path", {
    d: "M260.8,371.4l-.6,4.1.9.8a27.44,27.44,0,0,0,.9-3.9c-.2,0-1.2-1-1.2-1Z",
    transform: "translate(0.03 0.03)"
  })), _path687 || (_path687 = /*#__PURE__*/React.createElement("path", {
    d: "M263.8,372.2l-.9,2.4s1.3.8,1.3.6.9-2.6.9-2.6l-1.3-.4Z",
    transform: "translate(0.03 0.03)"
  })), _polygon808 || (_polygon808 = /*#__PURE__*/React.createElement("polygon", {
    points: "274.53 378.93 273.33 380.83 277.53 380.43 278.43 378.93 274.53 378.93"
  })), _path688 || (_path688 = /*#__PURE__*/React.createElement("path", {
    d: "M276.9,384.7l-.2.9a3.8,3.8,0,0,0,2.4.8,3.63,3.63,0,0,0,3.2-2.2l-.8-.6a3.73,3.73,0,0,1-2.3,1.3,14.54,14.54,0,0,1-2.3-.2Z",
    transform: "translate(0.03 0.03)"
  })), _path689 || (_path689 = /*#__PURE__*/React.createElement("path", {
    d: "M471.2,435.8c0-4.1-2-12-2-12h1.5a27.23,27.23,0,0,1,1.5,4.5c1.9-2.2,9-24.3,9.7-29.6s1.1-14.2,1.9-21.3,6-24,7.1-28.1a32.2,32.2,0,0,0,1.1-7.5l-1.9-1.9-1.1-2.6-5.2,1.9-4.5-3.7-4.5,1.1-5.6-.4-2.3,4.5s-.7,1.9-2.2,1.5a3.78,3.78,0,0,1-2.2-1.9l1.1-2.6-1.1-.4-.8-3.4-2.6-1.9,2.3-4.5L464,326l.4-2.2-2.6-3.7-.8-4.5a87.21,87.21,0,0,1,4.9-7.9l1.5-1.1-.7-11.6a59.81,59.81,0,0,1-8.2-3.4l1.5-9a65.53,65.53,0,0,1,8.6,5.2l1.9-1.1,3,1.5s-1.1,6.7-1.9,10.1-2.3,7.5-2.3,11.6l1.5,1.5v3l-1.9,1.1-.4,2.2s3.8,1.5,5.6,3.4a82.31,82.31,0,0,0,7.1,5.6l2.6-.8s0-9,1.5-12,6.4-5.6,6.4-5.6.8-6,2.2-8.6c0,0-4.5-.4-4.1-2.3s1.5-1.9,3.7-2.3l4.1-3.7s3.8-1.5,6-.4,4.1,3,4.1,5.6c0,0,4.2,1.9,4.1,3.7-.1,2.2-3.8,1.5-3.8,1.5l-.4,3-1.5,1.9v3.7l2.3.4,2.6,1.5s4.5,1.5,5.2,5.2-.8,16.1-.8,19.5a33.11,33.11,0,0,1-1.9,10.5l1.5,2.6s2.3,6,1.5,11.6l-1.9,12s1.1,15.3,2.6,21.7,10.9,34.4,10.9,43.8a89.69,89.69,0,0,0,1.1,10.9s-5.3,1.1-8.6,0l-2.3-5.6s-3.4-2.3-3.4-5.6a27.06,27.06,0,0,0-2.2-9.7c-1.1-2.6,0-4.9-1.1-8.6s-3.8-8.2-4.1-13.5a100.15,100.15,0,0,0-1.5-12.4c-.7-3.4-4.1-8.6-5.2-13.5l-2.6,4.5s-3.4,15-5.2,21-4.9,16.8-5.2,22.8l-2.6,4.5a20.15,20.15,0,0,0-6.4,1.1l-4.5,1.5-3.1-.8Z",
    transform: "translate(0.03 0.03)"
  })), _path690 || (_path690 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M481.8,422a2.89,2.89,0,0,0-1,0s.8-3.1.8-3.2l3.3-4.2h-2.2s-.4-3.4,2.6-4.1l1.5-3-3-1.1s1.9-4.1,4.5-5.6V398l1.9-1.5a18.76,18.76,0,0,1-3.4-3,17.24,17.24,0,0,1,4.1-4.9l-.8-2.2-3-.4s1.9-5.6,4.9-5.6c.4,0,.4-2.6.4-2.6s-3.7-2.6-6-2.6c0,0-1.9,13.1-2.3,21-.2,4.5-3.4,14.2-5.6,21s-4.9,13.1-4.9,13.1l.6,5.4,4.1-1.2a33.19,33.19,0,0,1,.2-9.4,6.36,6.36,0,0,0,2.1-.2l1.2-2.9Z",
    transform: "translate(0.03 0.03)"
  })), _path691 || (_path691 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M481.8,422a2.89,2.89,0,0,0-1,0s.8-3.1.8-3.2l3.3-4.2h-2.2s-.4-3.4,2.6-4.1l1.5-3-3-1.1s1.9-4.1,4.5-5.6V398l1.9-1.5a18.76,18.76,0,0,1-3.4-3,17.24,17.24,0,0,1,4.1-4.9l-.8-2.2-3-.4s1.9-5.6,4.9-5.6c.4,0,.4-2.6.4-2.6s-3.7-2.6-6-2.6c0,0-1.9,13.1-2.3,21-.2,4.5-3.4,14.2-5.6,21s-4.9,13.1-4.9,13.1l.6,5.4,4.1-1.2a33.19,33.19,0,0,1,.2-9.4,6.36,6.36,0,0,0,2.1-.2l1.2-2.9Z",
    transform: "translate(0.03 0.03)"
  })), _path692 || (_path692 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M503.8,384.1c.8,3.2,3.4,7.7,4.1,10.1s1.3,9.5,1.5,12.7,1.9,8.6,3.4,12.5.6,5.4.9,7.3,2.4,4.5,2.8,7.1,1.9,6,3.6,6.4l.2-9.5a14.17,14.17,0,0,0-2.8-.9l-.9-1.5,1.9-.2.8-1.7-.4-1.7s-2.3.2-3.4-.9l1.1-1.5h2.3l-.6-2.6a7.37,7.37,0,0,0-2.6-1.1l-.4-.8s2.6-.8,2.3-2.3-1.3-1.7-2.4-1.9l.4-.9,1.3-1.3s-.6-2.4-2.4-1.5l-1.3.6a5.06,5.06,0,0,1,.9-2.4,7,7,0,0,1,2.3-1.3l-1.1-1.9-2-.4.2-1.5,1.9-1.3s-.6-2.4-1.9-2.4-1.9,2.3-1.9,2.3l-1.1-.8s0-2.1.9-2.6,2.4-1.3,2.4-1.3l-.2-1.1s-3.4,0-3.6-1.1,1.7-1.3,1.7-1.3l.9-1.1,1.1-.6s-.6-1.7-1.7-2.1-2.4.8-2.4.8V389l1.9-1.3s-1.7-2.4-3.4-3a16.84,16.84,0,0,0-4.3-.6Z",
    transform: "translate(0.03 0.03)"
  })), _path693 || (_path693 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M503.8,384.1c.8,3.2,3.4,7.7,4.1,10.1s1.3,9.5,1.5,12.7,1.9,8.6,3.4,12.5.6,5.4.9,7.3,2.4,4.5,2.8,7.1,1.9,6,3.6,6.4l.2-9.5a14.17,14.17,0,0,0-2.8-.9l-.9-1.5,1.9-.2.8-1.7-.4-1.7s-2.3.2-3.4-.9l1.1-1.5h2.3l-.6-2.6a7.37,7.37,0,0,0-2.6-1.1l-.4-.8s2.6-.8,2.3-2.3-1.3-1.7-2.4-1.9l.4-.9,1.3-1.3s-.6-2.4-2.4-1.5l-1.3.6a5.06,5.06,0,0,1,.9-2.4,7,7,0,0,1,2.3-1.3l-1.1-1.9-2-.4.2-1.5,1.9-1.3s-.6-2.4-1.9-2.4-1.9,2.3-1.9,2.3l-1.1-.8s0-2.1.9-2.6,2.4-1.3,2.4-1.3l-.2-1.1s-3.4,0-3.6-1.1,1.7-1.3,1.7-1.3l.9-1.1,1.1-.6s-.6-1.7-1.7-2.1-2.4.8-2.4.8V389l1.9-1.3s-1.7-2.4-3.4-3a16.84,16.84,0,0,0-4.3-.6Z",
    transform: "translate(0.03 0.03)"
  })), _path694 || (_path694 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M523.6,433.7c-1.3,0-2.2,1.1-2.2,3.6s.5,8.4.5,8.4a8.73,8.73,0,0,0,2.8-1.1v-4.5l.9.4s.4-6.8-2-6.8Z",
    transform: "translate(0.03 0.03)"
  })), _path695 || (_path695 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M523.6,433.7c-1.3,0-2.2,1.1-2.2,3.6s.5,8.4.5,8.4a8.73,8.73,0,0,0,2.8-1.1v-4.5l.9.4s.4-6.8-2-6.8Z",
    transform: "translate(0.03 0.03)"
  })), _path696 || (_path696 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M486.7,374l3.6,1.1,1.1-2.2-.8-1.1s-.4-2.6-.6-3.7-1.9-3-2.8,0A15.59,15.59,0,0,0,486.7,374Z",
    transform: "translate(0.03 0.03)"
  })), _path697 || (_path697 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M486.7,374l3.6,1.1,1.1-2.2-.8-1.1s-.4-2.6-.6-3.7-1.9-3-2.8,0A15.59,15.59,0,0,0,486.7,374Z",
    transform: "translate(0.03 0.03)"
  })), _path698 || (_path698 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M490.5,358.7a22.37,22.37,0,0,0-2.1,5.4l4.1.2v-1.9l-2-3.7Z",
    transform: "translate(0.03 0.03)"
  })), _path699 || (_path699 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M490.5,358.7a22.37,22.37,0,0,0-2.1,5.4l4.1.2v-1.9l-2-3.7Z",
    transform: "translate(0.03 0.03)"
  })), _polygon809 || (_polygon809 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "496.63 354.93 496.63 353.43 491.83 353.23 491.23 356.13 493.33 357.63 494.83 357.23 496.63 354.93"
  })), _polygon810 || (_polygon810 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "496.63 354.93 496.63 353.43 491.83 353.23 491.23 356.13 493.33 357.63 494.83 357.23 496.63 354.93"
  })), _polygon811 || (_polygon811 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "493.13 348.23 492.13 350.43 495.33 350.83 495.33 349.93 493.13 348.23"
  })), _polygon812 || (_polygon812 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "493.13 348.23 492.13 350.43 495.33 350.83 495.33 349.93 493.13 348.23"
  })), _path700 || (_path700 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M492.9,367.1a9.88,9.88,0,0,0-1.5.9l.4,2.4,7.3-.8-1.2-4.4-5,1.9Z",
    transform: "translate(0.03 0.03)"
  })), _path701 || (_path701 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M492.9,367.1a9.88,9.88,0,0,0-1.5.9l.4,2.4,7.3-.8-1.2-4.4-5,1.9Z",
    transform: "translate(0.03 0.03)"
  })), _polygon813 || (_polygon813 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "498.13 360.73 496.53 360.93 494.23 362.03 494.23 365.23 496.13 365.03 498.13 363.23 498.13 360.73"
  })), _polygon814 || (_polygon814 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "498.13 360.73 496.53 360.93 494.23 362.03 494.23 365.23 496.13 365.03 498.13 363.23 498.13 360.73"
  })), _polygon815 || (_polygon815 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "500.93 357.03 501.93 356.23 501.73 354.63 500.43 354.93 499.13 356.13 499.13 357.63 500.83 358.53 500.93 357.03"
  })), _polygon816 || (_polygon816 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "500.93 357.03 501.93 356.23 501.73 354.63 500.43 354.93 499.13 356.13 499.13 357.63 500.83 358.53 500.93 357.03"
  })), _polygon817 || (_polygon817 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "501.73 352.73 501.73 350.43 500.43 350.43 499.13 351.93 499.13 354.03 500.23 354.03 501.73 352.73"
  })), _polygon818 || (_polygon818 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "501.73 352.73 501.73 350.43 500.43 350.43 499.13 351.93 499.13 354.03 500.23 354.03 501.73 352.73"
  })), _polygon819 || (_polygon819 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "508.53 360.23 506.83 359.13 503.93 363.93 505.23 364.93 506.93 364.93 508.53 360.23"
  })), _polygon820 || (_polygon820 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "508.53 360.23 506.83 359.13 503.93 363.93 505.23 364.93 506.93 364.93 508.53 360.23"
  })), _polygon821 || (_polygon821 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "510.13 360.53 509.03 365.43 510.93 366.53 511.63 361.53 510.13 360.53"
  })), _polygon822 || (_polygon822 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "510.13 360.53 509.03 365.43 510.93 366.53 511.63 361.53 510.13 360.53"
  })), _polygon823 || (_polygon823 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "513.13 367.93 511.83 368.23 510.53 369.73 510.53 371.83 512.73 371.83 513.13 367.93"
  })), _polygon824 || (_polygon824 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "513.13 367.93 511.83 368.23 510.53 369.73 510.53 371.83 512.73 371.83 513.13 367.93"
  })), _polygon825 || (_polygon825 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "509.73 374.83 509.73 372.23 508.13 372.73 506.43 374.23 506.03 376.63 507.93 376.53 509.73 374.83"
  })), _polygon826 || (_polygon826 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "509.73 374.83 509.73 372.23 508.13 372.73 506.43 374.23 506.03 376.63 507.93 376.53 509.73 374.83"
  })), _polygon827 || (_polygon827 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "511.03 375.73 509.53 377.23 510.93 384.93 512.73 383.83 511.03 375.73"
  })), _polygon828 || (_polygon828 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "511.03 375.73 509.53 377.23 510.93 384.93 512.73 383.83 511.03 375.73"
  })), _polygon829 || (_polygon829 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "494.83 393.73 491.83 396.13 491.03 400.03 493.63 398.73 494.83 393.73"
  })), _polygon830 || (_polygon830 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "494.83 393.73 491.83 396.13 491.03 400.03 493.63 398.73 494.83 393.73"
  })), _polygon831 || (_polygon831 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "498.73 371.33 495.63 371.93 493.63 379.13 494.83 380.23 497.73 380.83 498.73 371.33"
  })), _polygon832 || (_polygon832 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "498.73 371.33 495.63 371.93 493.63 379.13 494.83 380.23 497.73 380.83 498.73 371.33"
  })), _polygon833 || (_polygon833 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "493.93 381.73 497.03 382.13 495.23 389.53 493.33 386.93 493.93 381.73"
  })), _polygon834 || (_polygon834 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "493.93 381.73 497.03 382.13 495.23 389.53 493.33 386.93 493.93 381.73"
  })), _polygon835 || (_polygon835 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "506.93 366.23 501.73 367.13 501.53 370.13 507.33 369.03 506.93 366.23"
  })), _polygon836 || (_polygon836 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "506.93 366.23 501.73 367.13 501.53 370.13 507.33 369.03 506.93 366.23"
  })), _path702 || (_path702 = /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M470.4,335.3l4.3.2s10.3-2.6,12.7-3.6,5.4-.4,7.3-1.3l3.2-1.5.2-2.3-6.7-.8s-3.9,1.5-6.6,2.3-11.2,3-11.2,3l-5.4-3s-2.4-.6-3.2.4a2.37,2.37,0,0,0,.8,3.4c1.4,1,4.8,3.2,4.6,3.2Z",
    transform: "translate(0.03 0.03)"
  })), _path703 || (_path703 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M470.4,335.3l4.3.2s10.3-2.6,12.7-3.6,5.4-.4,7.3-1.3l3.2-1.5.2-2.3-6.7-.8s-3.9,1.5-6.6,2.3-11.2,3-11.2,3l-5.4-3s-2.4-.6-3.2.4a2.37,2.37,0,0,0,.8,3.4c1.4,1,4.8,3.2,4.6,3.2Z",
    transform: "translate(0.03 0.03)"
  })), _path704 || (_path704 = /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M481.7,334.9l2.4,2.6,3.9-1.7s.6-3.2.6-2.8-6.9,1.9-6.9,1.9Z",
    transform: "translate(0.03 0.03)"
  })), _path705 || (_path705 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M481.7,334.9l2.4,2.6,3.9-1.7s.6-3.2.6-2.8-6.9,1.9-6.9,1.9Z",
    transform: "translate(0.03 0.03)"
  })), _polygon837 || (_polygon837 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-21",
    points: "491.83 334.73 490.83 337.53 492.13 339.83 493.53 336.03 491.83 334.73"
  })), _polygon838 || (_polygon838 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "491.83 334.73 490.83 337.53 492.13 339.83 493.53 336.03 491.83 334.73"
  })), _polygon839 || (_polygon839 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "506.23 301.83 497.23 300.33 496.53 304.43 502.13 305.93 505.83 305.13 506.23 301.83"
  })), _polygon840 || (_polygon840 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "506.23 301.83 497.23 300.33 496.53 304.43 502.13 305.93 505.83 305.13 506.23 301.83"
  })), _path706 || (_path706 = /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M495.3,306.6l-2.6,3.7s-.7,7.9,4.1,10.5l3.7-2.6s-3-.4-4.9-4.1l1.1-1.1,1.9,2.2,2.6-2.2-2.3-1.5,4.5-1.9-.8-1.5a24,24,0,0,1-4.5-.4A13.76,13.76,0,0,1,495.3,306.6Z",
    transform: "translate(0.03 0.03)"
  })), _path707 || (_path707 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M495.3,306.6l-2.6,3.7s-.8,7.9,4.1,10.5l3.7-2.6s-3-.4-4.9-4.1l1.1-1.1,1.9,2.2,2.6-2.2-2.3-1.5,4.5-1.9-.8-1.5a24,24,0,0,1-4.5-.4A13.76,13.76,0,0,1,495.3,306.6Z",
    transform: "translate(0.03 0.03)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.81834785e309f0f780d013864566f554.svg";
export { ForwardRef as ReactComponent };